/*! jQuery v3.7.1 | (c) OpenJS Foundation and other contributors | jquery.org/license */
!function(e,t){"use strict";"object"==typeof module&&"object"==typeof module.exports?module.exports=e.document?t(e,!0):function(e){if(!e.document)throw new Error("jQuery requires a window with a document");return t(e)}:t(e)}("undefined"!=typeof window?window:this,function(ie,e){"use strict";var oe=[],r=Object.getPrototypeOf,ae=oe.slice,g=oe.flat?function(e){return oe.flat.call(e)}:function(e){return oe.concat.apply([],e)},s=oe.push,se=oe.indexOf,n={},i=n.toString,ue=n.hasOwnProperty,o=ue.toString,a=o.call(Object),le={},v=function(e){return"function"==typeof e&&"number"!=typeof e.nodeType&&"function"!=typeof e.item},y=function(e){return null!=e&&e===e.window},C=ie.document,u={type:!0,src:!0,nonce:!0,noModule:!0};function m(e,t,n){var r,i,o=(n=n||C).createElement("script");if(o.text=e,t)for(r in u)(i=t[r]||t.getAttribute&&t.getAttribute(r))&&o.setAttribute(r,i);n.head.appendChild(o).parentNode.removeChild(o)}function x(e){return null==e?e+"":"object"==typeof e||"function"==typeof e?n[i.call(e)]||"object":typeof e}var t="3.7.1",l=/HTML$/i,ce=function(e,t){return new ce.fn.init(e,t)};function c(e){var t=!!e&&"length"in e&&e.length,n=x(e);return!v(e)&&!y(e)&&("array"===n||0===t||"number"==typeof t&&0<t&&t-1 in e)}function fe(e,t){return e.nodeName&&e.nodeName.toLowerCase()===t.toLowerCase()}ce.fn=ce.prototype={jquery:t,constructor:ce,length:0,toArray:function(){return ae.call(this)},get:function(e){return null==e?ae.call(this):e<0?this[e+this.length]:this[e]},pushStack:function(e){var t=ce.merge(this.constructor(),e);return t.prevObject=this,t},each:function(e){return ce.each(this,e)},map:function(n){return this.pushStack(ce.map(this,function(e,t){return n.call(e,t,e)}))},slice:function(){return this.pushStack(ae.apply(this,arguments))},first:function(){return this.eq(0)},last:function(){return this.eq(-1)},even:function(){return this.pushStack(ce.grep(this,function(e,t){return(t+1)%2}))},odd:function(){return this.pushStack(ce.grep(this,function(e,t){return t%2}))},eq:function(e){var t=this.length,n=+e+(e<0?t:0);return this.pushStack(0<=n&&n<t?[this[n]]:[])},end:function(){return this.prevObject||this.constructor()},push:s,sort:oe.sort,splice:oe.splice},ce.extend=ce.fn.extend=function(){var e,t,n,r,i,o,a=arguments[0]||{},s=1,u=arguments.length,l=!1;for("boolean"==typeof a&&(l=a,a=arguments[s]||{},s++),"object"==typeof a||v(a)||(a={}),s===u&&(a=this,s--);s<u;s++)if(null!=(e=arguments[s]))for(t in e)r=e[t],"__proto__"!==t&&a!==r&&(l&&r&&(ce.isPlainObject(r)||(i=Array.isArray(r)))?(n=a[t],o=i&&!Array.isArray(n)?[]:i||ce.isPlainObject(n)?n:{},i=!1,a[t]=ce.extend(l,o,r)):void 0!==r&&(a[t]=r));return a},ce.extend({expando:"jQuery"+(t+Math.random()).replace(/\D/g,""),isReady:!0,error:function(e){throw new Error(e)},noop:function(){},isPlainObject:function(e){var t,n;return!(!e||"[object Object]"!==i.call(e))&&(!(t=r(e))||"function"==typeof(n=ue.call(t,"constructor")&&t.constructor)&&o.call(n)===a)},isEmptyObject:function(e){var t;for(t in e)return!1;return!0},globalEval:function(e,t,n){m(e,{nonce:t&&t.nonce},n)},each:function(e,t){var n,r=0;if(c(e)){for(n=e.length;r<n;r++)if(!1===t.call(e[r],r,e[r]))break}else for(r in e)if(!1===t.call(e[r],r,e[r]))break;return e},text:function(e){var t,n="",r=0,i=e.nodeType;if(!i)while(t=e[r++])n+=ce.text(t);return 1===i||11===i?e.textContent:9===i?e.documentElement.textContent:3===i||4===i?e.nodeValue:n},makeArray:function(e,t){var n=t||[];return null!=e&&(c(Object(e))?ce.merge(n,"string"==typeof e?[e]:e):s.call(n,e)),n},inArray:function(e,t,n){return null==t?-1:se.call(t,e,n)},isXMLDoc:function(e){var t=e&&e.namespaceURI,n=e&&(e.ownerDocument||e).documentElement;return!l.test(t||n&&n.nodeName||"HTML")},merge:function(e,t){for(var n=+t.length,r=0,i=e.length;r<n;r++)e[i++]=t[r];return e.length=i,e},grep:function(e,t,n){for(var r=[],i=0,o=e.length,a=!n;i<o;i++)!t(e[i],i)!==a&&r.push(e[i]);return r},map:function(e,t,n){var r,i,o=0,a=[];if(c(e))for(r=e.length;o<r;o++)null!=(i=t(e[o],o,n))&&a.push(i);else for(o in e)null!=(i=t(e[o],o,n))&&a.push(i);return g(a)},guid:1,support:le}),"function"==typeof Symbol&&(ce.fn[Symbol.iterator]=oe[Symbol.iterator]),ce.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "),function(e,t){n["[object "+t+"]"]=t.toLowerCase()});var pe=oe.pop,de=oe.sort,he=oe.splice,ge="[\\x20\\t\\r\\n\\f]",ve=new RegExp("^"+ge+"+|((?:^|[^\\\\])(?:\\\\.)*)"+ge+"+$","g");ce.contains=function(e,t){var n=t&&t.parentNode;return e===n||!(!n||1!==n.nodeType||!(e.contains?e.contains(n):e.compareDocumentPosition&&16&e.compareDocumentPosition(n)))};var f=/([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;function p(e,t){return t?"\0"===e?"\ufffd":e.slice(0,-1)+"\\"+e.charCodeAt(e.length-1).toString(16)+" ":"\\"+e}ce.escapeSelector=function(e){return(e+"").replace(f,p)};var ye=C,me=s;!function(){var e,b,w,o,a,T,r,C,d,i,k=me,S=ce.expando,E=0,n=0,s=W(),c=W(),u=W(),h=W(),l=function(e,t){return e===t&&(a=!0),0},f="checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",t="(?:\\\\[\\da-fA-F]{1,6}"+ge+"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",p="\\["+ge+"*("+t+")(?:"+ge+"*([*^$|!~]?=)"+ge+"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|("+t+"))|)"+ge+"*\\]",g=":("+t+")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|"+p+")*)|.*)\\)|)",v=new RegExp(ge+"+","g"),y=new RegExp("^"+ge+"*,"+ge+"*"),m=new RegExp("^"+ge+"*([>+~]|"+ge+")"+ge+"*"),x=new RegExp(ge+"|>"),j=new RegExp(g),A=new RegExp("^"+t+"$"),D={ID:new RegExp("^#("+t+")"),CLASS:new RegExp("^\\.("+t+")"),TAG:new RegExp("^("+t+"|[*])"),ATTR:new RegExp("^"+p),PSEUDO:new RegExp("^"+g),CHILD:new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\("+ge+"*(even|odd|(([+-]|)(\\d*)n|)"+ge+"*(?:([+-]|)"+ge+"*(\\d+)|))"+ge+"*\\)|)","i"),bool:new RegExp("^(?:"+f+")$","i"),needsContext:new RegExp("^"+ge+"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\("+ge+"*((?:-\\d)?\\d*)"+ge+"*\\)|)(?=[^-]|$)","i")},N=/^(?:input|select|textarea|button)$/i,q=/^h\d$/i,L=/^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,H=/[+~]/,O=new RegExp("\\\\[\\da-fA-F]{1,6}"+ge+"?|\\\\([^\\r\\n\\f])","g"),P=function(e,t){var n="0x"+e.slice(1)-65536;return t||(n<0?String.fromCharCode(n+65536):String.fromCharCode(n>>10|55296,1023&n|56320))},M=function(){V()},R=J(function(e){return!0===e.disabled&&fe(e,"fieldset")},{dir:"parentNode",next:"legend"});try{k.apply(oe=ae.call(ye.childNodes),ye.childNodes),oe[ye.childNodes.length].nodeType}catch(e){k={apply:function(e,t){me.apply(e,ae.call(t))},call:function(e){me.apply(e,ae.call(arguments,1))}}}function I(t,e,n,r){var i,o,a,s,u,l,c,f=e&&e.ownerDocument,p=e?e.nodeType:9;if(n=n||[],"string"!=typeof t||!t||1!==p&&9!==p&&11!==p)return n;if(!r&&(V(e),e=e||T,C)){if(11!==p&&(u=L.exec(t)))if(i=u[1]){if(9===p){if(!(a=e.getElementById(i)))return n;if(a.id===i)return k.call(n,a),n}else if(f&&(a=f.getElementById(i))&&I.contains(e,a)&&a.id===i)return k.call(n,a),n}else{if(u[2])return k.apply(n,e.getElementsByTagName(t)),n;if((i=u[3])&&e.getElementsByClassName)return k.apply(n,e.getElementsByClassName(i)),n}if(!(h[t+" "]||d&&d.test(t))){if(c=t,f=e,1===p&&(x.test(t)||m.test(t))){(f=H.test(t)&&U(e.parentNode)||e)==e&&le.scope||((s=e.getAttribute("id"))?s=ce.escapeSelector(s):e.setAttribute("id",s=S)),o=(l=Y(t)).length;while(o--)l[o]=(s?"#"+s:":scope")+" "+Q(l[o]);c=l.join(",")}try{return k.apply(n,f.querySelectorAll(c)),n}catch(e){h(t,!0)}finally{s===S&&e.removeAttribute("id")}}}return re(t.replace(ve,"$1"),e,n,r)}function W(){var r=[];return function e(t,n){return r.push(t+" ")>b.cacheLength&&delete e[r.shift()],e[t+" "]=n}}function F(e){return e[S]=!0,e}function $(e){var t=T.createElement("fieldset");try{return!!e(t)}catch(e){return!1}finally{t.parentNode&&t.parentNode.removeChild(t),t=null}}function B(t){return function(e){return fe(e,"input")&&e.type===t}}function _(t){return function(e){return(fe(e,"input")||fe(e,"button"))&&e.type===t}}function z(t){return function(e){return"form"in e?e.parentNode&&!1===e.disabled?"label"in e?"label"in e.parentNode?e.parentNode.disabled===t:e.disabled===t:e.isDisabled===t||e.isDisabled!==!t&&R(e)===t:e.disabled===t:"label"in e&&e.disabled===t}}function X(a){return F(function(o){return o=+o,F(function(e,t){var n,r=a([],e.length,o),i=r.length;while(i--)e[n=r[i]]&&(e[n]=!(t[n]=e[n]))})})}function U(e){return e&&"undefined"!=typeof e.getElementsByTagName&&e}function V(e){var t,n=e?e.ownerDocument||e:ye;return n!=T&&9===n.nodeType&&n.documentElement&&(r=(T=n).documentElement,C=!ce.isXMLDoc(T),i=r.matches||r.webkitMatchesSelector||r.msMatchesSelector,r.msMatchesSelector&&ye!=T&&(t=T.defaultView)&&t.top!==t&&t.addEventListener("unload",M),le.getById=$(function(e){return r.appendChild(e).id=ce.expando,!T.getElementsByName||!T.getElementsByName(ce.expando).length}),le.disconnectedMatch=$(function(e){return i.call(e,"*")}),le.scope=$(function(){return T.querySelectorAll(":scope")}),le.cssHas=$(function(){try{return T.querySelector(":has(*,:jqfake)"),!1}catch(e){return!0}}),le.getById?(b.filter.ID=function(e){var t=e.replace(O,P);return function(e){return e.getAttribute("id")===t}},b.find.ID=function(e,t){if("undefined"!=typeof t.getElementById&&C){var n=t.getElementById(e);return n?[n]:[]}}):(b.filter.ID=function(e){var n=e.replace(O,P);return function(e){var t="undefined"!=typeof e.getAttributeNode&&e.getAttributeNode("id");return t&&t.value===n}},b.find.ID=function(e,t){if("undefined"!=typeof t.getElementById&&C){var n,r,i,o=t.getElementById(e);if(o){if((n=o.getAttributeNode("id"))&&n.value===e)return[o];i=t.getElementsByName(e),r=0;while(o=i[r++])if((n=o.getAttributeNode("id"))&&n.value===e)return[o]}return[]}}),b.find.TAG=function(e,t){return"undefined"!=typeof t.getElementsByTagName?t.getElementsByTagName(e):t.querySelectorAll(e)},b.find.CLASS=function(e,t){if("undefined"!=typeof t.getElementsByClassName&&C)return t.getElementsByClassName(e)},d=[],$(function(e){var t;r.appendChild(e).innerHTML="<a id='"+S+"' href='' disabled='disabled'></a><select id='"+S+"-\r\\' disabled='disabled'><option selected=''></option></select>",e.querySelectorAll("[selected]").length||d.push("\\["+ge+"*(?:value|"+f+")"),e.querySelectorAll("[id~="+S+"-]").length||d.push("~="),e.querySelectorAll("a#"+S+"+*").length||d.push(".#.+[+~]"),e.querySelectorAll(":checked").length||d.push(":checked"),(t=T.createElement("input")).setAttribute("type","hidden"),e.appendChild(t).setAttribute("name","D"),r.appendChild(e).disabled=!0,2!==e.querySelectorAll(":disabled").length&&d.push(":enabled",":disabled"),(t=T.createElement("input")).setAttribute("name",""),e.appendChild(t),e.querySelectorAll("[name='']").length||d.push("\\["+ge+"*name"+ge+"*="+ge+"*(?:''|\"\")")}),le.cssHas||d.push(":has"),d=d.length&&new RegExp(d.join("|")),l=function(e,t){if(e===t)return a=!0,0;var n=!e.compareDocumentPosition-!t.compareDocumentPosition;return n||(1&(n=(e.ownerDocument||e)==(t.ownerDocument||t)?e.compareDocumentPosition(t):1)||!le.sortDetached&&t.compareDocumentPosition(e)===n?e===T||e.ownerDocument==ye&&I.contains(ye,e)?-1:t===T||t.ownerDocument==ye&&I.contains(ye,t)?1:o?se.call(o,e)-se.call(o,t):0:4&n?-1:1)}),T}for(e in I.matches=function(e,t){return I(e,null,null,t)},I.matchesSelector=function(e,t){if(V(e),C&&!h[t+" "]&&(!d||!d.test(t)))try{var n=i.call(e,t);if(n||le.disconnectedMatch||e.document&&11!==e.document.nodeType)return n}catch(e){h(t,!0)}return 0<I(t,T,null,[e]).length},I.contains=function(e,t){return(e.ownerDocument||e)!=T&&V(e),ce.contains(e,t)},I.attr=function(e,t){(e.ownerDocument||e)!=T&&V(e);var n=b.attrHandle[t.toLowerCase()],r=n&&ue.call(b.attrHandle,t.toLowerCase())?n(e,t,!C):void 0;return void 0!==r?r:e.getAttribute(t)},I.error=function(e){throw new Error("Syntax error, unrecognized expression: "+e)},ce.uniqueSort=function(e){var t,n=[],r=0,i=0;if(a=!le.sortStable,o=!le.sortStable&&ae.call(e,0),de.call(e,l),a){while(t=e[i++])t===e[i]&&(r=n.push(i));while(r--)he.call(e,n[r],1)}return o=null,e},ce.fn.uniqueSort=function(){return this.pushStack(ce.uniqueSort(ae.apply(this)))},(b=ce.expr={cacheLength:50,createPseudo:F,match:D,attrHandle:{},find:{},relative:{">":{dir:"parentNode",first:!0}," ":{dir:"parentNode"},"+":{dir:"previousSibling",first:!0},"~":{dir:"previousSibling"}},preFilter:{ATTR:function(e){return e[1]=e[1].replace(O,P),e[3]=(e[3]||e[4]||e[5]||"").replace(O,P),"~="===e[2]&&(e[3]=" "+e[3]+" "),e.slice(0,4)},CHILD:function(e){return e[1]=e[1].toLowerCase(),"nth"===e[1].slice(0,3)?(e[3]||I.error(e[0]),e[4]=+(e[4]?e[5]+(e[6]||1):2*("even"===e[3]||"odd"===e[3])),e[5]=+(e[7]+e[8]||"odd"===e[3])):e[3]&&I.error(e[0]),e},PSEUDO:function(e){var t,n=!e[6]&&e[2];return D.CHILD.test(e[0])?null:(e[3]?e[2]=e[4]||e[5]||"":n&&j.test(n)&&(t=Y(n,!0))&&(t=n.indexOf(")",n.length-t)-n.length)&&(e[0]=e[0].slice(0,t),e[2]=n.slice(0,t)),e.slice(0,3))}},filter:{TAG:function(e){var t=e.replace(O,P).toLowerCase();return"*"===e?function(){return!0}:function(e){return fe(e,t)}},CLASS:function(e){var t=s[e+" "];return t||(t=new RegExp("(^|"+ge+")"+e+"("+ge+"|$)"))&&s(e,function(e){return t.test("string"==typeof e.className&&e.className||"undefined"!=typeof e.getAttribute&&e.getAttribute("class")||"")})},ATTR:function(n,r,i){return function(e){var t=I.attr(e,n);return null==t?"!="===r:!r||(t+="","="===r?t===i:"!="===r?t!==i:"^="===r?i&&0===t.indexOf(i):"*="===r?i&&-1<t.indexOf(i):"$="===r?i&&t.slice(-i.length)===i:"~="===r?-1<(" "+t.replace(v," ")+" ").indexOf(i):"|="===r&&(t===i||t.slice(0,i.length+1)===i+"-"))}},CHILD:function(d,e,t,h,g){var v="nth"!==d.slice(0,3),y="last"!==d.slice(-4),m="of-type"===e;return 1===h&&0===g?function(e){return!!e.parentNode}:function(e,t,n){var r,i,o,a,s,u=v!==y?"nextSibling":"previousSibling",l=e.parentNode,c=m&&e.nodeName.toLowerCase(),f=!n&&!m,p=!1;if(l){if(v){while(u){o=e;while(o=o[u])if(m?fe(o,c):1===o.nodeType)return!1;s=u="only"===d&&!s&&"nextSibling"}return!0}if(s=[y?l.firstChild:l.lastChild],y&&f){p=(a=(r=(i=l[S]||(l[S]={}))[d]||[])[0]===E&&r[1])&&r[2],o=a&&l.childNodes[a];while(o=++a&&o&&o[u]||(p=a=0)||s.pop())if(1===o.nodeType&&++p&&o===e){i[d]=[E,a,p];break}}else if(f&&(p=a=(r=(i=e[S]||(e[S]={}))[d]||[])[0]===E&&r[1]),!1===p)while(o=++a&&o&&o[u]||(p=a=0)||s.pop())if((m?fe(o,c):1===o.nodeType)&&++p&&(f&&((i=o[S]||(o[S]={}))[d]=[E,p]),o===e))break;return(p-=g)===h||p%h==0&&0<=p/h}}},PSEUDO:function(e,o){var t,a=b.pseudos[e]||b.setFilters[e.toLowerCase()]||I.error("unsupported pseudo: "+e);return a[S]?a(o):1<a.length?(t=[e,e,"",o],b.setFilters.hasOwnProperty(e.toLowerCase())?F(function(e,t){var n,r=a(e,o),i=r.length;while(i--)e[n=se.call(e,r[i])]=!(t[n]=r[i])}):function(e){return a(e,0,t)}):a}},pseudos:{not:F(function(e){var r=[],i=[],s=ne(e.replace(ve,"$1"));return s[S]?F(function(e,t,n,r){var i,o=s(e,null,r,[]),a=e.length;while(a--)(i=o[a])&&(e[a]=!(t[a]=i))}):function(e,t,n){return r[0]=e,s(r,null,n,i),r[0]=null,!i.pop()}}),has:F(function(t){return function(e){return 0<I(t,e).length}}),contains:F(function(t){return t=t.replace(O,P),function(e){return-1<(e.textContent||ce.text(e)).indexOf(t)}}),lang:F(function(n){return A.test(n||"")||I.error("unsupported lang: "+n),n=n.replace(O,P).toLowerCase(),function(e){var t;do{if(t=C?e.lang:e.getAttribute("xml:lang")||e.getAttribute("lang"))return(t=t.toLowerCase())===n||0===t.indexOf(n+"-")}while((e=e.parentNode)&&1===e.nodeType);return!1}}),target:function(e){var t=ie.location&&ie.location.hash;return t&&t.slice(1)===e.id},root:function(e){return e===r},focus:function(e){return e===function(){try{return T.activeElement}catch(e){}}()&&T.hasFocus()&&!!(e.type||e.href||~e.tabIndex)},enabled:z(!1),disabled:z(!0),checked:function(e){return fe(e,"input")&&!!e.checked||fe(e,"option")&&!!e.selected},selected:function(e){return e.parentNode&&e.parentNode.selectedIndex,!0===e.selected},empty:function(e){for(e=e.firstChild;e;e=e.nextSibling)if(e.nodeType<6)return!1;return!0},parent:function(e){return!b.pseudos.empty(e)},header:function(e){return q.test(e.nodeName)},input:function(e){return N.test(e.nodeName)},button:function(e){return fe(e,"input")&&"button"===e.type||fe(e,"button")},text:function(e){var t;return fe(e,"input")&&"text"===e.type&&(null==(t=e.getAttribute("type"))||"text"===t.toLowerCase())},first:X(function(){return[0]}),last:X(function(e,t){return[t-1]}),eq:X(function(e,t,n){return[n<0?n+t:n]}),even:X(function(e,t){for(var n=0;n<t;n+=2)e.push(n);return e}),odd:X(function(e,t){for(var n=1;n<t;n+=2)e.push(n);return e}),lt:X(function(e,t,n){var r;for(r=n<0?n+t:t<n?t:n;0<=--r;)e.push(r);return e}),gt:X(function(e,t,n){for(var r=n<0?n+t:n;++r<t;)e.push(r);return e})}}).pseudos.nth=b.pseudos.eq,{radio:!0,checkbox:!0,file:!0,password:!0,image:!0})b.pseudos[e]=B(e);for(e in{submit:!0,reset:!0})b.pseudos[e]=_(e);function G(){}function Y(e,t){var n,r,i,o,a,s,u,l=c[e+" "];if(l)return t?0:l.slice(0);a=e,s=[],u=b.preFilter;while(a){for(o in n&&!(r=y.exec(a))||(r&&(a=a.slice(r[0].length)||a),s.push(i=[])),n=!1,(r=m.exec(a))&&(n=r.shift(),i.push({value:n,type:r[0].replace(ve," ")}),a=a.slice(n.length)),b.filter)!(r=D[o].exec(a))||u[o]&&!(r=u[o](r))||(n=r.shift(),i.push({value:n,type:o,matches:r}),a=a.slice(n.length));if(!n)break}return t?a.length:a?I.error(e):c(e,s).slice(0)}function Q(e){for(var t=0,n=e.length,r="";t<n;t++)r+=e[t].value;return r}function J(a,e,t){var s=e.dir,u=e.next,l=u||s,c=t&&"parentNode"===l,f=n++;return e.first?function(e,t,n){while(e=e[s])if(1===e.nodeType||c)return a(e,t,n);return!1}:function(e,t,n){var r,i,o=[E,f];if(n){while(e=e[s])if((1===e.nodeType||c)&&a(e,t,n))return!0}else while(e=e[s])if(1===e.nodeType||c)if(i=e[S]||(e[S]={}),u&&fe(e,u))e=e[s]||e;else{if((r=i[l])&&r[0]===E&&r[1]===f)return o[2]=r[2];if((i[l]=o)[2]=a(e,t,n))return!0}return!1}}function K(i){return 1<i.length?function(e,t,n){var r=i.length;while(r--)if(!i[r](e,t,n))return!1;return!0}:i[0]}function Z(e,t,n,r,i){for(var o,a=[],s=0,u=e.length,l=null!=t;s<u;s++)(o=e[s])&&(n&&!n(o,r,i)||(a.push(o),l&&t.push(s)));return a}function ee(d,h,g,v,y,e){return v&&!v[S]&&(v=ee(v)),y&&!y[S]&&(y=ee(y,e)),F(function(e,t,n,r){var i,o,a,s,u=[],l=[],c=t.length,f=e||function(e,t,n){for(var r=0,i=t.length;r<i;r++)I(e,t[r],n);return n}(h||"*",n.nodeType?[n]:n,[]),p=!d||!e&&h?f:Z(f,u,d,n,r);if(g?g(p,s=y||(e?d:c||v)?[]:t,n,r):s=p,v){i=Z(s,l),v(i,[],n,r),o=i.length;while(o--)(a=i[o])&&(s[l[o]]=!(p[l[o]]=a))}if(e){if(y||d){if(y){i=[],o=s.length;while(o--)(a=s[o])&&i.push(p[o]=a);y(null,s=[],i,r)}o=s.length;while(o--)(a=s[o])&&-1<(i=y?se.call(e,a):u[o])&&(e[i]=!(t[i]=a))}}else s=Z(s===t?s.splice(c,s.length):s),y?y(null,t,s,r):k.apply(t,s)})}function te(e){for(var i,t,n,r=e.length,o=b.relative[e[0].type],a=o||b.relative[" "],s=o?1:0,u=J(function(e){return e===i},a,!0),l=J(function(e){return-1<se.call(i,e)},a,!0),c=[function(e,t,n){var r=!o&&(n||t!=w)||((i=t).nodeType?u(e,t,n):l(e,t,n));return i=null,r}];s<r;s++)if(t=b.relative[e[s].type])c=[J(K(c),t)];else{if((t=b.filter[e[s].type].apply(null,e[s].matches))[S]){for(n=++s;n<r;n++)if(b.relative[e[n].type])break;return ee(1<s&&K(c),1<s&&Q(e.slice(0,s-1).concat({value:" "===e[s-2].type?"*":""})).replace(ve,"$1"),t,s<n&&te(e.slice(s,n)),n<r&&te(e=e.slice(n)),n<r&&Q(e))}c.push(t)}return K(c)}function ne(e,t){var n,v,y,m,x,r,i=[],o=[],a=u[e+" "];if(!a){t||(t=Y(e)),n=t.length;while(n--)(a=te(t[n]))[S]?i.push(a):o.push(a);(a=u(e,(v=o,m=0<(y=i).length,x=0<v.length,r=function(e,t,n,r,i){var o,a,s,u=0,l="0",c=e&&[],f=[],p=w,d=e||x&&b.find.TAG("*",i),h=E+=null==p?1:Math.random()||.1,g=d.length;for(i&&(w=t==T||t||i);l!==g&&null!=(o=d[l]);l++){if(x&&o){a=0,t||o.ownerDocument==T||(V(o),n=!C);while(s=v[a++])if(s(o,t||T,n)){k.call(r,o);break}i&&(E=h)}m&&((o=!s&&o)&&u--,e&&c.push(o))}if(u+=l,m&&l!==u){a=0;while(s=y[a++])s(c,f,t,n);if(e){if(0<u)while(l--)c[l]||f[l]||(f[l]=pe.call(r));f=Z(f)}k.apply(r,f),i&&!e&&0<f.length&&1<u+y.length&&ce.uniqueSort(r)}return i&&(E=h,w=p),c},m?F(r):r))).selector=e}return a}function re(e,t,n,r){var i,o,a,s,u,l="function"==typeof e&&e,c=!r&&Y(e=l.selector||e);if(n=n||[],1===c.length){if(2<(o=c[0]=c[0].slice(0)).length&&"ID"===(a=o[0]).type&&9===t.nodeType&&C&&b.relative[o[1].type]){if(!(t=(b.find.ID(a.matches[0].replace(O,P),t)||[])[0]))return n;l&&(t=t.parentNode),e=e.slice(o.shift().value.length)}i=D.needsContext.test(e)?0:o.length;while(i--){if(a=o[i],b.relative[s=a.type])break;if((u=b.find[s])&&(r=u(a.matches[0].replace(O,P),H.test(o[0].type)&&U(t.parentNode)||t))){if(o.splice(i,1),!(e=r.length&&Q(o)))return k.apply(n,r),n;break}}}return(l||ne(e,c))(r,t,!C,n,!t||H.test(e)&&U(t.parentNode)||t),n}G.prototype=b.filters=b.pseudos,b.setFilters=new G,le.sortStable=S.split("").sort(l).join("")===S,V(),le.sortDetached=$(function(e){return 1&e.compareDocumentPosition(T.createElement("fieldset"))}),ce.find=I,ce.expr[":"]=ce.expr.pseudos,ce.unique=ce.uniqueSort,I.compile=ne,I.select=re,I.setDocument=V,I.tokenize=Y,I.escape=ce.escapeSelector,I.getText=ce.text,I.isXML=ce.isXMLDoc,I.selectors=ce.expr,I.support=ce.support,I.uniqueSort=ce.uniqueSort}();var d=function(e,t,n){var r=[],i=void 0!==n;while((e=e[t])&&9!==e.nodeType)if(1===e.nodeType){if(i&&ce(e).is(n))break;r.push(e)}return r},h=function(e,t){for(var n=[];e;e=e.nextSibling)1===e.nodeType&&e!==t&&n.push(e);return n},b=ce.expr.match.needsContext,w=/^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;function T(e,n,r){return v(n)?ce.grep(e,function(e,t){return!!n.call(e,t,e)!==r}):n.nodeType?ce.grep(e,function(e){return e===n!==r}):"string"!=typeof n?ce.grep(e,function(e){return-1<se.call(n,e)!==r}):ce.filter(n,e,r)}ce.filter=function(e,t,n){var r=t[0];return n&&(e=":not("+e+")"),1===t.length&&1===r.nodeType?ce.find.matchesSelector(r,e)?[r]:[]:ce.find.matches(e,ce.grep(t,function(e){return 1===e.nodeType}))},ce.fn.extend({find:function(e){var t,n,r=this.length,i=this;if("string"!=typeof e)return this.pushStack(ce(e).filter(function(){for(t=0;t<r;t++)if(ce.contains(i[t],this))return!0}));for(n=this.pushStack([]),t=0;t<r;t++)ce.find(e,i[t],n);return 1<r?ce.uniqueSort(n):n},filter:function(e){return this.pushStack(T(this,e||[],!1))},not:function(e){return this.pushStack(T(this,e||[],!0))},is:function(e){return!!T(this,"string"==typeof e&&b.test(e)?ce(e):e||[],!1).length}});var k,S=/^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;(ce.fn.init=function(e,t,n){var r,i;if(!e)return this;if(n=n||k,"string"==typeof e){if(!(r="<"===e[0]&&">"===e[e.length-1]&&3<=e.length?[null,e,null]:S.exec(e))||!r[1]&&t)return!t||t.jquery?(t||n).find(e):this.constructor(t).find(e);if(r[1]){if(t=t instanceof ce?t[0]:t,ce.merge(this,ce.parseHTML(r[1],t&&t.nodeType?t.ownerDocument||t:C,!0)),w.test(r[1])&&ce.isPlainObject(t))for(r in t)v(this[r])?this[r](t[r]):this.attr(r,t[r]);return this}return(i=C.getElementById(r[2]))&&(this[0]=i,this.length=1),this}return e.nodeType?(this[0]=e,this.length=1,this):v(e)?void 0!==n.ready?n.ready(e):e(ce):ce.makeArray(e,this)}).prototype=ce.fn,k=ce(C);var E=/^(?:parents|prev(?:Until|All))/,j={children:!0,contents:!0,next:!0,prev:!0};function A(e,t){while((e=e[t])&&1!==e.nodeType);return e}ce.fn.extend({has:function(e){var t=ce(e,this),n=t.length;return this.filter(function(){for(var e=0;e<n;e++)if(ce.contains(this,t[e]))return!0})},closest:function(e,t){var n,r=0,i=this.length,o=[],a="string"!=typeof e&&ce(e);if(!b.test(e))for(;r<i;r++)for(n=this[r];n&&n!==t;n=n.parentNode)if(n.nodeType<11&&(a?-1<a.index(n):1===n.nodeType&&ce.find.matchesSelector(n,e))){o.push(n);break}return this.pushStack(1<o.length?ce.uniqueSort(o):o)},index:function(e){return e?"string"==typeof e?se.call(ce(e),this[0]):se.call(this,e.jquery?e[0]:e):this[0]&&this[0].parentNode?this.first().prevAll().length:-1},add:function(e,t){return this.pushStack(ce.uniqueSort(ce.merge(this.get(),ce(e,t))))},addBack:function(e){return this.add(null==e?this.prevObject:this.prevObject.filter(e))}}),ce.each({parent:function(e){var t=e.parentNode;return t&&11!==t.nodeType?t:null},parents:function(e){return d(e,"parentNode")},parentsUntil:function(e,t,n){return d(e,"parentNode",n)},next:function(e){return A(e,"nextSibling")},prev:function(e){return A(e,"previousSibling")},nextAll:function(e){return d(e,"nextSibling")},prevAll:function(e){return d(e,"previousSibling")},nextUntil:function(e,t,n){return d(e,"nextSibling",n)},prevUntil:function(e,t,n){return d(e,"previousSibling",n)},siblings:function(e){return h((e.parentNode||{}).firstChild,e)},children:function(e){return h(e.firstChild)},contents:function(e){return null!=e.contentDocument&&r(e.contentDocument)?e.contentDocument:(fe(e,"template")&&(e=e.content||e),ce.merge([],e.childNodes))}},function(r,i){ce.fn[r]=function(e,t){var n=ce.map(this,i,e);return"Until"!==r.slice(-5)&&(t=e),t&&"string"==typeof t&&(n=ce.filter(t,n)),1<this.length&&(j[r]||ce.uniqueSort(n),E.test(r)&&n.reverse()),this.pushStack(n)}});var D=/[^\x20\t\r\n\f]+/g;function N(e){return e}function q(e){throw e}function L(e,t,n,r){var i;try{e&&v(i=e.promise)?i.call(e).done(t).fail(n):e&&v(i=e.then)?i.call(e,t,n):t.apply(void 0,[e].slice(r))}catch(e){n.apply(void 0,[e])}}ce.Callbacks=function(r){var e,n;r="string"==typeof r?(e=r,n={},ce.each(e.match(D)||[],function(e,t){n[t]=!0}),n):ce.extend({},r);var i,t,o,a,s=[],u=[],l=-1,c=function(){for(a=a||r.once,o=i=!0;u.length;l=-1){t=u.shift();while(++l<s.length)!1===s[l].apply(t[0],t[1])&&r.stopOnFalse&&(l=s.length,t=!1)}r.memory||(t=!1),i=!1,a&&(s=t?[]:"")},f={add:function(){return s&&(t&&!i&&(l=s.length-1,u.push(t)),function n(e){ce.each(e,function(e,t){v(t)?r.unique&&f.has(t)||s.push(t):t&&t.length&&"string"!==x(t)&&n(t)})}(arguments),t&&!i&&c()),this},remove:function(){return ce.each(arguments,function(e,t){var n;while(-1<(n=ce.inArray(t,s,n)))s.splice(n,1),n<=l&&l--}),this},has:function(e){return e?-1<ce.inArray(e,s):0<s.length},empty:function(){return s&&(s=[]),this},disable:function(){return a=u=[],s=t="",this},disabled:function(){return!s},lock:function(){return a=u=[],t||i||(s=t=""),this},locked:function(){return!!a},fireWith:function(e,t){return a||(t=[e,(t=t||[]).slice?t.slice():t],u.push(t),i||c()),this},fire:function(){return f.fireWith(this,arguments),this},fired:function(){return!!o}};return f},ce.extend({Deferred:function(e){var o=[["notify","progress",ce.Callbacks("memory"),ce.Callbacks("memory"),2],["resolve","done",ce.Callbacks("once memory"),ce.Callbacks("once memory"),0,"resolved"],["reject","fail",ce.Callbacks("once memory"),ce.Callbacks("once memory"),1,"rejected"]],i="pending",a={state:function(){return i},always:function(){return s.done(arguments).fail(arguments),this},"catch":function(e){return a.then(null,e)},pipe:function(){var i=arguments;return ce.Deferred(function(r){ce.each(o,function(e,t){var n=v(i[t[4]])&&i[t[4]];s[t[1]](function(){var e=n&&n.apply(this,arguments);e&&v(e.promise)?e.promise().progress(r.notify).done(r.resolve).fail(r.reject):r[t[0]+"With"](this,n?[e]:arguments)})}),i=null}).promise()},then:function(t,n,r){var u=0;function l(i,o,a,s){return function(){var n=this,r=arguments,e=function(){var e,t;if(!(i<u)){if((e=a.apply(n,r))===o.promise())throw new TypeError("Thenable self-resolution");t=e&&("object"==typeof e||"function"==typeof e)&&e.then,v(t)?s?t.call(e,l(u,o,N,s),l(u,o,q,s)):(u++,t.call(e,l(u,o,N,s),l(u,o,q,s),l(u,o,N,o.notifyWith))):(a!==N&&(n=void 0,r=[e]),(s||o.resolveWith)(n,r))}},t=s?e:function(){try{e()}catch(e){ce.Deferred.exceptionHook&&ce.Deferred.exceptionHook(e,t.error),u<=i+1&&(a!==q&&(n=void 0,r=[e]),o.rejectWith(n,r))}};i?t():(ce.Deferred.getErrorHook?t.error=ce.Deferred.getErrorHook():ce.Deferred.getStackHook&&(t.error=ce.Deferred.getStackHook()),ie.setTimeout(t))}}return ce.Deferred(function(e){o[0][3].add(l(0,e,v(r)?r:N,e.notifyWith)),o[1][3].add(l(0,e,v(t)?t:N)),o[2][3].add(l(0,e,v(n)?n:q))}).promise()},promise:function(e){return null!=e?ce.extend(e,a):a}},s={};return ce.each(o,function(e,t){var n=t[2],r=t[5];a[t[1]]=n.add,r&&n.add(function(){i=r},o[3-e][2].disable,o[3-e][3].disable,o[0][2].lock,o[0][3].lock),n.add(t[3].fire),s[t[0]]=function(){return s[t[0]+"With"](this===s?void 0:this,arguments),this},s[t[0]+"With"]=n.fireWith}),a.promise(s),e&&e.call(s,s),s},when:function(e){var n=arguments.length,t=n,r=Array(t),i=ae.call(arguments),o=ce.Deferred(),a=function(t){return function(e){r[t]=this,i[t]=1<arguments.length?ae.call(arguments):e,--n||o.resolveWith(r,i)}};if(n<=1&&(L(e,o.done(a(t)).resolve,o.reject,!n),"pending"===o.state()||v(i[t]&&i[t].then)))return o.then();while(t--)L(i[t],a(t),o.reject);return o.promise()}});var H=/^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;ce.Deferred.exceptionHook=function(e,t){ie.console&&ie.console.warn&&e&&H.test(e.name)&&ie.console.warn("jQuery.Deferred exception: "+e.message,e.stack,t)},ce.readyException=function(e){ie.setTimeout(function(){throw e})};var O=ce.Deferred();function P(){C.removeEventListener("DOMContentLoaded",P),ie.removeEventListener("load",P),ce.ready()}ce.fn.ready=function(e){return O.then(e)["catch"](function(e){ce.readyException(e)}),this},ce.extend({isReady:!1,readyWait:1,ready:function(e){(!0===e?--ce.readyWait:ce.isReady)||(ce.isReady=!0)!==e&&0<--ce.readyWait||O.resolveWith(C,[ce])}}),ce.ready.then=O.then,"complete"===C.readyState||"loading"!==C.readyState&&!C.documentElement.doScroll?ie.setTimeout(ce.ready):(C.addEventListener("DOMContentLoaded",P),ie.addEventListener("load",P));var M=function(e,t,n,r,i,o,a){var s=0,u=e.length,l=null==n;if("object"===x(n))for(s in i=!0,n)M(e,t,s,n[s],!0,o,a);else if(void 0!==r&&(i=!0,v(r)||(a=!0),l&&(a?(t.call(e,r),t=null):(l=t,t=function(e,t,n){return l.call(ce(e),n)})),t))for(;s<u;s++)t(e[s],n,a?r:r.call(e[s],s,t(e[s],n)));return i?e:l?t.call(e):u?t(e[0],n):o},R=/^-ms-/,I=/-([a-z])/g;function W(e,t){return t.toUpperCase()}function F(e){return e.replace(R,"ms-").replace(I,W)}var $=function(e){return 1===e.nodeType||9===e.nodeType||!+e.nodeType};function B(){this.expando=ce.expando+B.uid++}B.uid=1,B.prototype={cache:function(e){var t=e[this.expando];return t||(t={},$(e)&&(e.nodeType?e[this.expando]=t:Object.defineProperty(e,this.expando,{value:t,configurable:!0}))),t},set:function(e,t,n){var r,i=this.cache(e);if("string"==typeof t)i[F(t)]=n;else for(r in t)i[F(r)]=t[r];return i},get:function(e,t){return void 0===t?this.cache(e):e[this.expando]&&e[this.expando][F(t)]},access:function(e,t,n){return void 0===t||t&&"string"==typeof t&&void 0===n?this.get(e,t):(this.set(e,t,n),void 0!==n?n:t)},remove:function(e,t){var n,r=e[this.expando];if(void 0!==r){if(void 0!==t){n=(t=Array.isArray(t)?t.map(F):(t=F(t))in r?[t]:t.match(D)||[]).length;while(n--)delete r[t[n]]}(void 0===t||ce.isEmptyObject(r))&&(e.nodeType?e[this.expando]=void 0:delete e[this.expando])}},hasData:function(e){var t=e[this.expando];return void 0!==t&&!ce.isEmptyObject(t)}};var _=new B,z=new B,X=/^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,U=/[A-Z]/g;function V(e,t,n){var r,i;if(void 0===n&&1===e.nodeType)if(r="data-"+t.replace(U,"-$&").toLowerCase(),"string"==typeof(n=e.getAttribute(r))){try{n="true"===(i=n)||"false"!==i&&("null"===i?null:i===+i+""?+i:X.test(i)?JSON.parse(i):i)}catch(e){}z.set(e,t,n)}else n=void 0;return n}ce.extend({hasData:function(e){return z.hasData(e)||_.hasData(e)},data:function(e,t,n){return z.access(e,t,n)},removeData:function(e,t){z.remove(e,t)},_data:function(e,t,n){return _.access(e,t,n)},_removeData:function(e,t){_.remove(e,t)}}),ce.fn.extend({data:function(n,e){var t,r,i,o=this[0],a=o&&o.attributes;if(void 0===n){if(this.length&&(i=z.get(o),1===o.nodeType&&!_.get(o,"hasDataAttrs"))){t=a.length;while(t--)a[t]&&0===(r=a[t].name).indexOf("data-")&&(r=F(r.slice(5)),V(o,r,i[r]));_.set(o,"hasDataAttrs",!0)}return i}return"object"==typeof n?this.each(function(){z.set(this,n)}):M(this,function(e){var t;if(o&&void 0===e)return void 0!==(t=z.get(o,n))?t:void 0!==(t=V(o,n))?t:void 0;this.each(function(){z.set(this,n,e)})},null,e,1<arguments.length,null,!0)},removeData:function(e){return this.each(function(){z.remove(this,e)})}}),ce.extend({queue:function(e,t,n){var r;if(e)return t=(t||"fx")+"queue",r=_.get(e,t),n&&(!r||Array.isArray(n)?r=_.access(e,t,ce.makeArray(n)):r.push(n)),r||[]},dequeue:function(e,t){t=t||"fx";var n=ce.queue(e,t),r=n.length,i=n.shift(),o=ce._queueHooks(e,t);"inprogress"===i&&(i=n.shift(),r--),i&&("fx"===t&&n.unshift("inprogress"),delete o.stop,i.call(e,function(){ce.dequeue(e,t)},o)),!r&&o&&o.empty.fire()},_queueHooks:function(e,t){var n=t+"queueHooks";return _.get(e,n)||_.access(e,n,{empty:ce.Callbacks("once memory").add(function(){_.remove(e,[t+"queue",n])})})}}),ce.fn.extend({queue:function(t,n){var e=2;return"string"!=typeof t&&(n=t,t="fx",e--),arguments.length<e?ce.queue(this[0],t):void 0===n?this:this.each(function(){var e=ce.queue(this,t,n);ce._queueHooks(this,t),"fx"===t&&"inprogress"!==e[0]&&ce.dequeue(this,t)})},dequeue:function(e){return this.each(function(){ce.dequeue(this,e)})},clearQueue:function(e){return this.queue(e||"fx",[])},promise:function(e,t){var n,r=1,i=ce.Deferred(),o=this,a=this.length,s=function(){--r||i.resolveWith(o,[o])};"string"!=typeof e&&(t=e,e=void 0),e=e||"fx";while(a--)(n=_.get(o[a],e+"queueHooks"))&&n.empty&&(r++,n.empty.add(s));return s(),i.promise(t)}});var G=/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,Y=new RegExp("^(?:([+-])=|)("+G+")([a-z%]*)$","i"),Q=["Top","Right","Bottom","Left"],J=C.documentElement,K=function(e){return ce.contains(e.ownerDocument,e)},Z={composed:!0};J.getRootNode&&(K=function(e){return ce.contains(e.ownerDocument,e)||e.getRootNode(Z)===e.ownerDocument});var ee=function(e,t){return"none"===(e=t||e).style.display||""===e.style.display&&K(e)&&"none"===ce.css(e,"display")};function te(e,t,n,r){var i,o,a=20,s=r?function(){return r.cur()}:function(){return ce.css(e,t,"")},u=s(),l=n&&n[3]||(ce.cssNumber[t]?"":"px"),c=e.nodeType&&(ce.cssNumber[t]||"px"!==l&&+u)&&Y.exec(ce.css(e,t));if(c&&c[3]!==l){u/=2,l=l||c[3],c=+u||1;while(a--)ce.style(e,t,c+l),(1-o)*(1-(o=s()/u||.5))<=0&&(a=0),c/=o;c*=2,ce.style(e,t,c+l),n=n||[]}return n&&(c=+c||+u||0,i=n[1]?c+(n[1]+1)*n[2]:+n[2],r&&(r.unit=l,r.start=c,r.end=i)),i}var ne={};function re(e,t){for(var n,r,i,o,a,s,u,l=[],c=0,f=e.length;c<f;c++)(r=e[c]).style&&(n=r.style.display,t?("none"===n&&(l[c]=_.get(r,"display")||null,l[c]||(r.style.display="")),""===r.style.display&&ee(r)&&(l[c]=(u=a=o=void 0,a=(i=r).ownerDocument,s=i.nodeName,(u=ne[s])||(o=a.body.appendChild(a.createElement(s)),u=ce.css(o,"display"),o.parentNode.removeChild(o),"none"===u&&(u="block"),ne[s]=u)))):"none"!==n&&(l[c]="none",_.set(r,"display",n)));for(c=0;c<f;c++)null!=l[c]&&(e[c].style.display=l[c]);return e}ce.fn.extend({show:function(){return re(this,!0)},hide:function(){return re(this)},toggle:function(e){return"boolean"==typeof e?e?this.show():this.hide():this.each(function(){ee(this)?ce(this).show():ce(this).hide()})}});var xe,be,we=/^(?:checkbox|radio)$/i,Te=/<([a-z][^\/\0>\x20\t\r\n\f]*)/i,Ce=/^$|^module$|\/(?:java|ecma)script/i;xe=C.createDocumentFragment().appendChild(C.createElement("div")),(be=C.createElement("input")).setAttribute("type","radio"),be.setAttribute("checked","checked"),be.setAttribute("name","t"),xe.appendChild(be),le.checkClone=xe.cloneNode(!0).cloneNode(!0).lastChild.checked,xe.innerHTML="<textarea>x</textarea>",le.noCloneChecked=!!xe.cloneNode(!0).lastChild.defaultValue,xe.innerHTML="<option></option>",le.option=!!xe.lastChild;var ke={thead:[1,"<table>","</table>"],col:[2,"<table><colgroup>","</colgroup></table>"],tr:[2,"<table><tbody>","</tbody></table>"],td:[3,"<table><tbody><tr>","</tr></tbody></table>"],_default:[0,"",""]};function Se(e,t){var n;return n="undefined"!=typeof e.getElementsByTagName?e.getElementsByTagName(t||"*"):"undefined"!=typeof e.querySelectorAll?e.querySelectorAll(t||"*"):[],void 0===t||t&&fe(e,t)?ce.merge([e],n):n}function Ee(e,t){for(var n=0,r=e.length;n<r;n++)_.set(e[n],"globalEval",!t||_.get(t[n],"globalEval"))}ke.tbody=ke.tfoot=ke.colgroup=ke.caption=ke.thead,ke.th=ke.td,le.option||(ke.optgroup=ke.option=[1,"<select multiple='multiple'>","</select>"]);var je=/<|&#?\w+;/;function Ae(e,t,n,r,i){for(var o,a,s,u,l,c,f=t.createDocumentFragment(),p=[],d=0,h=e.length;d<h;d++)if((o=e[d])||0===o)if("object"===x(o))ce.merge(p,o.nodeType?[o]:o);else if(je.test(o)){a=a||f.appendChild(t.createElement("div")),s=(Te.exec(o)||["",""])[1].toLowerCase(),u=ke[s]||ke._default,a.innerHTML=u[1]+ce.htmlPrefilter(o)+u[2],c=u[0];while(c--)a=a.lastChild;ce.merge(p,a.childNodes),(a=f.firstChild).textContent=""}else p.push(t.createTextNode(o));f.textContent="",d=0;while(o=p[d++])if(r&&-1<ce.inArray(o,r))i&&i.push(o);else if(l=K(o),a=Se(f.appendChild(o),"script"),l&&Ee(a),n){c=0;while(o=a[c++])Ce.test(o.type||"")&&n.push(o)}return f}var De=/^([^.]*)(?:\.(.+)|)/;function Ne(){return!0}function qe(){return!1}function Le(e,t,n,r,i,o){var a,s;if("object"==typeof t){for(s in"string"!=typeof n&&(r=r||n,n=void 0),t)Le(e,s,n,r,t[s],o);return e}if(null==r&&null==i?(i=n,r=n=void 0):null==i&&("string"==typeof n?(i=r,r=void 0):(i=r,r=n,n=void 0)),!1===i)i=qe;else if(!i)return e;return 1===o&&(a=i,(i=function(e){return ce().off(e),a.apply(this,arguments)}).guid=a.guid||(a.guid=ce.guid++)),e.each(function(){ce.event.add(this,t,i,r,n)})}function He(e,r,t){t?(_.set(e,r,!1),ce.event.add(e,r,{namespace:!1,handler:function(e){var t,n=_.get(this,r);if(1&e.isTrigger&&this[r]){if(n)(ce.event.special[r]||{}).delegateType&&e.stopPropagation();else if(n=ae.call(arguments),_.set(this,r,n),this[r](),t=_.get(this,r),_.set(this,r,!1),n!==t)return e.stopImmediatePropagation(),e.preventDefault(),t}else n&&(_.set(this,r,ce.event.trigger(n[0],n.slice(1),this)),e.stopPropagation(),e.isImmediatePropagationStopped=Ne)}})):void 0===_.get(e,r)&&ce.event.add(e,r,Ne)}ce.event={global:{},add:function(t,e,n,r,i){var o,a,s,u,l,c,f,p,d,h,g,v=_.get(t);if($(t)){n.handler&&(n=(o=n).handler,i=o.selector),i&&ce.find.matchesSelector(J,i),n.guid||(n.guid=ce.guid++),(u=v.events)||(u=v.events=Object.create(null)),(a=v.handle)||(a=v.handle=function(e){return"undefined"!=typeof ce&&ce.event.triggered!==e.type?ce.event.dispatch.apply(t,arguments):void 0}),l=(e=(e||"").match(D)||[""]).length;while(l--)d=g=(s=De.exec(e[l])||[])[1],h=(s[2]||"").split(".").sort(),d&&(f=ce.event.special[d]||{},d=(i?f.delegateType:f.bindType)||d,f=ce.event.special[d]||{},c=ce.extend({type:d,origType:g,data:r,handler:n,guid:n.guid,selector:i,needsContext:i&&ce.expr.match.needsContext.test(i),namespace:h.join(".")},o),(p=u[d])||((p=u[d]=[]).delegateCount=0,f.setup&&!1!==f.setup.call(t,r,h,a)||t.addEventListener&&t.addEventListener(d,a)),f.add&&(f.add.call(t,c),c.handler.guid||(c.handler.guid=n.guid)),i?p.splice(p.delegateCount++,0,c):p.push(c),ce.event.global[d]=!0)}},remove:function(e,t,n,r,i){var o,a,s,u,l,c,f,p,d,h,g,v=_.hasData(e)&&_.get(e);if(v&&(u=v.events)){l=(t=(t||"").match(D)||[""]).length;while(l--)if(d=g=(s=De.exec(t[l])||[])[1],h=(s[2]||"").split(".").sort(),d){f=ce.event.special[d]||{},p=u[d=(r?f.delegateType:f.bindType)||d]||[],s=s[2]&&new RegExp("(^|\\.)"+h.join("\\.(?:.*\\.|)")+"(\\.|$)"),a=o=p.length;while(o--)c=p[o],!i&&g!==c.origType||n&&n.guid!==c.guid||s&&!s.test(c.namespace)||r&&r!==c.selector&&("**"!==r||!c.selector)||(p.splice(o,1),c.selector&&p.delegateCount--,f.remove&&f.remove.call(e,c));a&&!p.length&&(f.teardown&&!1!==f.teardown.call(e,h,v.handle)||ce.removeEvent(e,d,v.handle),delete u[d])}else for(d in u)ce.event.remove(e,d+t[l],n,r,!0);ce.isEmptyObject(u)&&_.remove(e,"handle events")}},dispatch:function(e){var t,n,r,i,o,a,s=new Array(arguments.length),u=ce.event.fix(e),l=(_.get(this,"events")||Object.create(null))[u.type]||[],c=ce.event.special[u.type]||{};for(s[0]=u,t=1;t<arguments.length;t++)s[t]=arguments[t];if(u.delegateTarget=this,!c.preDispatch||!1!==c.preDispatch.call(this,u)){a=ce.event.handlers.call(this,u,l),t=0;while((i=a[t++])&&!u.isPropagationStopped()){u.currentTarget=i.elem,n=0;while((o=i.handlers[n++])&&!u.isImmediatePropagationStopped())u.rnamespace&&!1!==o.namespace&&!u.rnamespace.test(o.namespace)||(u.handleObj=o,u.data=o.data,void 0!==(r=((ce.event.special[o.origType]||{}).handle||o.handler).apply(i.elem,s))&&!1===(u.result=r)&&(u.preventDefault(),u.stopPropagation()))}return c.postDispatch&&c.postDispatch.call(this,u),u.result}},handlers:function(e,t){var n,r,i,o,a,s=[],u=t.delegateCount,l=e.target;if(u&&l.nodeType&&!("click"===e.type&&1<=e.button))for(;l!==this;l=l.parentNode||this)if(1===l.nodeType&&("click"!==e.type||!0!==l.disabled)){for(o=[],a={},n=0;n<u;n++)void 0===a[i=(r=t[n]).selector+" "]&&(a[i]=r.needsContext?-1<ce(i,this).index(l):ce.find(i,this,null,[l]).length),a[i]&&o.push(r);o.length&&s.push({elem:l,handlers:o})}return l=this,u<t.length&&s.push({elem:l,handlers:t.slice(u)}),s},addProp:function(t,e){Object.defineProperty(ce.Event.prototype,t,{enumerable:!0,configurable:!0,get:v(e)?function(){if(this.originalEvent)return e(this.originalEvent)}:function(){if(this.originalEvent)return this.originalEvent[t]},set:function(e){Object.defineProperty(this,t,{enumerable:!0,configurable:!0,writable:!0,value:e})}})},fix:function(e){return e[ce.expando]?e:new ce.Event(e)},special:{load:{noBubble:!0},click:{setup:function(e){var t=this||e;return we.test(t.type)&&t.click&&fe(t,"input")&&He(t,"click",!0),!1},trigger:function(e){var t=this||e;return we.test(t.type)&&t.click&&fe(t,"input")&&He(t,"click"),!0},_default:function(e){var t=e.target;return we.test(t.type)&&t.click&&fe(t,"input")&&_.get(t,"click")||fe(t,"a")}},beforeunload:{postDispatch:function(e){void 0!==e.result&&e.originalEvent&&(e.originalEvent.returnValue=e.result)}}}},ce.removeEvent=function(e,t,n){e.removeEventListener&&e.removeEventListener(t,n)},ce.Event=function(e,t){if(!(this instanceof ce.Event))return new ce.Event(e,t);e&&e.type?(this.originalEvent=e,this.type=e.type,this.isDefaultPrevented=e.defaultPrevented||void 0===e.defaultPrevented&&!1===e.returnValue?Ne:qe,this.target=e.target&&3===e.target.nodeType?e.target.parentNode:e.target,this.currentTarget=e.currentTarget,this.relatedTarget=e.relatedTarget):this.type=e,t&&ce.extend(this,t),this.timeStamp=e&&e.timeStamp||Date.now(),this[ce.expando]=!0},ce.Event.prototype={constructor:ce.Event,isDefaultPrevented:qe,isPropagationStopped:qe,isImmediatePropagationStopped:qe,isSimulated:!1,preventDefault:function(){var e=this.originalEvent;this.isDefaultPrevented=Ne,e&&!this.isSimulated&&e.preventDefault()},stopPropagation:function(){var e=this.originalEvent;this.isPropagationStopped=Ne,e&&!this.isSimulated&&e.stopPropagation()},stopImmediatePropagation:function(){var e=this.originalEvent;this.isImmediatePropagationStopped=Ne,e&&!this.isSimulated&&e.stopImmediatePropagation(),this.stopPropagation()}},ce.each({altKey:!0,bubbles:!0,cancelable:!0,changedTouches:!0,ctrlKey:!0,detail:!0,eventPhase:!0,metaKey:!0,pageX:!0,pageY:!0,shiftKey:!0,view:!0,"char":!0,code:!0,charCode:!0,key:!0,keyCode:!0,button:!0,buttons:!0,clientX:!0,clientY:!0,offsetX:!0,offsetY:!0,pointerId:!0,pointerType:!0,screenX:!0,screenY:!0,targetTouches:!0,toElement:!0,touches:!0,which:!0},ce.event.addProp),ce.each({focus:"focusin",blur:"focusout"},function(r,i){function o(e){if(C.documentMode){var t=_.get(this,"handle"),n=ce.event.fix(e);n.type="focusin"===e.type?"focus":"blur",n.isSimulated=!0,t(e),n.target===n.currentTarget&&t(n)}else ce.event.simulate(i,e.target,ce.event.fix(e))}ce.event.special[r]={setup:function(){var e;if(He(this,r,!0),!C.documentMode)return!1;(e=_.get(this,i))||this.addEventListener(i,o),_.set(this,i,(e||0)+1)},trigger:function(){return He(this,r),!0},teardown:function(){var e;if(!C.documentMode)return!1;(e=_.get(this,i)-1)?_.set(this,i,e):(this.removeEventListener(i,o),_.remove(this,i))},_default:function(e){return _.get(e.target,r)},delegateType:i},ce.event.special[i]={setup:function(){var e=this.ownerDocument||this.document||this,t=C.documentMode?this:e,n=_.get(t,i);n||(C.documentMode?this.addEventListener(i,o):e.addEventListener(r,o,!0)),_.set(t,i,(n||0)+1)},teardown:function(){var e=this.ownerDocument||this.document||this,t=C.documentMode?this:e,n=_.get(t,i)-1;n?_.set(t,i,n):(C.documentMode?this.removeEventListener(i,o):e.removeEventListener(r,o,!0),_.remove(t,i))}}}),ce.each({mouseenter:"mouseover",mouseleave:"mouseout",pointerenter:"pointerover",pointerleave:"pointerout"},function(e,i){ce.event.special[e]={delegateType:i,bindType:i,handle:function(e){var t,n=e.relatedTarget,r=e.handleObj;return n&&(n===this||ce.contains(this,n))||(e.type=r.origType,t=r.handler.apply(this,arguments),e.type=i),t}}}),ce.fn.extend({on:function(e,t,n,r){return Le(this,e,t,n,r)},one:function(e,t,n,r){return Le(this,e,t,n,r,1)},off:function(e,t,n){var r,i;if(e&&e.preventDefault&&e.handleObj)return r=e.handleObj,ce(e.delegateTarget).off(r.namespace?r.origType+"."+r.namespace:r.origType,r.selector,r.handler),this;if("object"==typeof e){for(i in e)this.off(i,t,e[i]);return this}return!1!==t&&"function"!=typeof t||(n=t,t=void 0),!1===n&&(n=qe),this.each(function(){ce.event.remove(this,e,n,t)})}});var Oe=/<script|<style|<link/i,Pe=/checked\s*(?:[^=]|=\s*.checked.)/i,Me=/^\s*<!\[CDATA\[|\]\]>\s*$/g;function Re(e,t){return fe(e,"table")&&fe(11!==t.nodeType?t:t.firstChild,"tr")&&ce(e).children("tbody")[0]||e}function Ie(e){return e.type=(null!==e.getAttribute("type"))+"/"+e.type,e}function We(e){return"true/"===(e.type||"").slice(0,5)?e.type=e.type.slice(5):e.removeAttribute("type"),e}function Fe(e,t){var n,r,i,o,a,s;if(1===t.nodeType){if(_.hasData(e)&&(s=_.get(e).events))for(i in _.remove(t,"handle events"),s)for(n=0,r=s[i].length;n<r;n++)ce.event.add(t,i,s[i][n]);z.hasData(e)&&(o=z.access(e),a=ce.extend({},o),z.set(t,a))}}function $e(n,r,i,o){r=g(r);var e,t,a,s,u,l,c=0,f=n.length,p=f-1,d=r[0],h=v(d);if(h||1<f&&"string"==typeof d&&!le.checkClone&&Pe.test(d))return n.each(function(e){var t=n.eq(e);h&&(r[0]=d.call(this,e,t.html())),$e(t,r,i,o)});if(f&&(t=(e=Ae(r,n[0].ownerDocument,!1,n,o)).firstChild,1===e.childNodes.length&&(e=t),t||o)){for(s=(a=ce.map(Se(e,"script"),Ie)).length;c<f;c++)u=e,c!==p&&(u=ce.clone(u,!0,!0),s&&ce.merge(a,Se(u,"script"))),i.call(n[c],u,c);if(s)for(l=a[a.length-1].ownerDocument,ce.map(a,We),c=0;c<s;c++)u=a[c],Ce.test(u.type||"")&&!_.access(u,"globalEval")&&ce.contains(l,u)&&(u.src&&"module"!==(u.type||"").toLowerCase()?ce._evalUrl&&!u.noModule&&ce._evalUrl(u.src,{nonce:u.nonce||u.getAttribute("nonce")},l):m(u.textContent.replace(Me,""),u,l))}return n}function Be(e,t,n){for(var r,i=t?ce.filter(t,e):e,o=0;null!=(r=i[o]);o++)n||1!==r.nodeType||ce.cleanData(Se(r)),r.parentNode&&(n&&K(r)&&Ee(Se(r,"script")),r.parentNode.removeChild(r));return e}ce.extend({htmlPrefilter:function(e){return e},clone:function(e,t,n){var r,i,o,a,s,u,l,c=e.cloneNode(!0),f=K(e);if(!(le.noCloneChecked||1!==e.nodeType&&11!==e.nodeType||ce.isXMLDoc(e)))for(a=Se(c),r=0,i=(o=Se(e)).length;r<i;r++)s=o[r],u=a[r],void 0,"input"===(l=u.nodeName.toLowerCase())&&we.test(s.type)?u.checked=s.checked:"input"!==l&&"textarea"!==l||(u.defaultValue=s.defaultValue);if(t)if(n)for(o=o||Se(e),a=a||Se(c),r=0,i=o.length;r<i;r++)Fe(o[r],a[r]);else Fe(e,c);return 0<(a=Se(c,"script")).length&&Ee(a,!f&&Se(e,"script")),c},cleanData:function(e){for(var t,n,r,i=ce.event.special,o=0;void 0!==(n=e[o]);o++)if($(n)){if(t=n[_.expando]){if(t.events)for(r in t.events)i[r]?ce.event.remove(n,r):ce.removeEvent(n,r,t.handle);n[_.expando]=void 0}n[z.expando]&&(n[z.expando]=void 0)}}}),ce.fn.extend({detach:function(e){return Be(this,e,!0)},remove:function(e){return Be(this,e)},text:function(e){return M(this,function(e){return void 0===e?ce.text(this):this.empty().each(function(){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||(this.textContent=e)})},null,e,arguments.length)},append:function(){return $e(this,arguments,function(e){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||Re(this,e).appendChild(e)})},prepend:function(){return $e(this,arguments,function(e){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var t=Re(this,e);t.insertBefore(e,t.firstChild)}})},before:function(){return $e(this,arguments,function(e){this.parentNode&&this.parentNode.insertBefore(e,this)})},after:function(){return $e(this,arguments,function(e){this.parentNode&&this.parentNode.insertBefore(e,this.nextSibling)})},empty:function(){for(var e,t=0;null!=(e=this[t]);t++)1===e.nodeType&&(ce.cleanData(Se(e,!1)),e.textContent="");return this},clone:function(e,t){return e=null!=e&&e,t=null==t?e:t,this.map(function(){return ce.clone(this,e,t)})},html:function(e){return M(this,function(e){var t=this[0]||{},n=0,r=this.length;if(void 0===e&&1===t.nodeType)return t.innerHTML;if("string"==typeof e&&!Oe.test(e)&&!ke[(Te.exec(e)||["",""])[1].toLowerCase()]){e=ce.htmlPrefilter(e);try{for(;n<r;n++)1===(t=this[n]||{}).nodeType&&(ce.cleanData(Se(t,!1)),t.innerHTML=e);t=0}catch(e){}}t&&this.empty().append(e)},null,e,arguments.length)},replaceWith:function(){var n=[];return $e(this,arguments,function(e){var t=this.parentNode;ce.inArray(this,n)<0&&(ce.cleanData(Se(this)),t&&t.replaceChild(e,this))},n)}}),ce.each({appendTo:"append",prependTo:"prepend",insertBefore:"before",insertAfter:"after",replaceAll:"replaceWith"},function(e,a){ce.fn[e]=function(e){for(var t,n=[],r=ce(e),i=r.length-1,o=0;o<=i;o++)t=o===i?this:this.clone(!0),ce(r[o])[a](t),s.apply(n,t.get());return this.pushStack(n)}});var _e=new RegExp("^("+G+")(?!px)[a-z%]+$","i"),ze=/^--/,Xe=function(e){var t=e.ownerDocument.defaultView;return t&&t.opener||(t=ie),t.getComputedStyle(e)},Ue=function(e,t,n){var r,i,o={};for(i in t)o[i]=e.style[i],e.style[i]=t[i];for(i in r=n.call(e),t)e.style[i]=o[i];return r},Ve=new RegExp(Q.join("|"),"i");function Ge(e,t,n){var r,i,o,a,s=ze.test(t),u=e.style;return(n=n||Xe(e))&&(a=n.getPropertyValue(t)||n[t],s&&a&&(a=a.replace(ve,"$1")||void 0),""!==a||K(e)||(a=ce.style(e,t)),!le.pixelBoxStyles()&&_e.test(a)&&Ve.test(t)&&(r=u.width,i=u.minWidth,o=u.maxWidth,u.minWidth=u.maxWidth=u.width=a,a=n.width,u.width=r,u.minWidth=i,u.maxWidth=o)),void 0!==a?a+"":a}function Ye(e,t){return{get:function(){if(!e())return(this.get=t).apply(this,arguments);delete this.get}}}!function(){function e(){if(l){u.style.cssText="position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0",l.style.cssText="position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%",J.appendChild(u).appendChild(l);var e=ie.getComputedStyle(l);n="1%"!==e.top,s=12===t(e.marginLeft),l.style.right="60%",o=36===t(e.right),r=36===t(e.width),l.style.position="absolute",i=12===t(l.offsetWidth/3),J.removeChild(u),l=null}}function t(e){return Math.round(parseFloat(e))}var n,r,i,o,a,s,u=C.createElement("div"),l=C.createElement("div");l.style&&(l.style.backgroundClip="content-box",l.cloneNode(!0).style.backgroundClip="",le.clearCloneStyle="content-box"===l.style.backgroundClip,ce.extend(le,{boxSizingReliable:function(){return e(),r},pixelBoxStyles:function(){return e(),o},pixelPosition:function(){return e(),n},reliableMarginLeft:function(){return e(),s},scrollboxSize:function(){return e(),i},reliableTrDimensions:function(){var e,t,n,r;return null==a&&(e=C.createElement("table"),t=C.createElement("tr"),n=C.createElement("div"),e.style.cssText="position:absolute;left:-11111px;border-collapse:separate",t.style.cssText="box-sizing:content-box;border:1px solid",t.style.height="1px",n.style.height="9px",n.style.display="block",J.appendChild(e).appendChild(t).appendChild(n),r=ie.getComputedStyle(t),a=parseInt(r.height,10)+parseInt(r.borderTopWidth,10)+parseInt(r.borderBottomWidth,10)===t.offsetHeight,J.removeChild(e)),a}}))}();var Qe=["Webkit","Moz","ms"],Je=C.createElement("div").style,Ke={};function Ze(e){var t=ce.cssProps[e]||Ke[e];return t||(e in Je?e:Ke[e]=function(e){var t=e[0].toUpperCase()+e.slice(1),n=Qe.length;while(n--)if((e=Qe[n]+t)in Je)return e}(e)||e)}var et=/^(none|table(?!-c[ea]).+)/,tt={position:"absolute",visibility:"hidden",display:"block"},nt={letterSpacing:"0",fontWeight:"400"};function rt(e,t,n){var r=Y.exec(t);return r?Math.max(0,r[2]-(n||0))+(r[3]||"px"):t}function it(e,t,n,r,i,o){var a="width"===t?1:0,s=0,u=0,l=0;if(n===(r?"border":"content"))return 0;for(;a<4;a+=2)"margin"===n&&(l+=ce.css(e,n+Q[a],!0,i)),r?("content"===n&&(u-=ce.css(e,"padding"+Q[a],!0,i)),"margin"!==n&&(u-=ce.css(e,"border"+Q[a]+"Width",!0,i))):(u+=ce.css(e,"padding"+Q[a],!0,i),"padding"!==n?u+=ce.css(e,"border"+Q[a]+"Width",!0,i):s+=ce.css(e,"border"+Q[a]+"Width",!0,i));return!r&&0<=o&&(u+=Math.max(0,Math.ceil(e["offset"+t[0].toUpperCase()+t.slice(1)]-o-u-s-.5))||0),u+l}function ot(e,t,n){var r=Xe(e),i=(!le.boxSizingReliable()||n)&&"border-box"===ce.css(e,"boxSizing",!1,r),o=i,a=Ge(e,t,r),s="offset"+t[0].toUpperCase()+t.slice(1);if(_e.test(a)){if(!n)return a;a="auto"}return(!le.boxSizingReliable()&&i||!le.reliableTrDimensions()&&fe(e,"tr")||"auto"===a||!parseFloat(a)&&"inline"===ce.css(e,"display",!1,r))&&e.getClientRects().length&&(i="border-box"===ce.css(e,"boxSizing",!1,r),(o=s in e)&&(a=e[s])),(a=parseFloat(a)||0)+it(e,t,n||(i?"border":"content"),o,r,a)+"px"}function at(e,t,n,r,i){return new at.prototype.init(e,t,n,r,i)}ce.extend({cssHooks:{opacity:{get:function(e,t){if(t){var n=Ge(e,"opacity");return""===n?"1":n}}}},cssNumber:{animationIterationCount:!0,aspectRatio:!0,borderImageSlice:!0,columnCount:!0,flexGrow:!0,flexShrink:!0,fontWeight:!0,gridArea:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnStart:!0,gridRow:!0,gridRowEnd:!0,gridRowStart:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,scale:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,stopOpacity:!0,strokeMiterlimit:!0,strokeOpacity:!0},cssProps:{},style:function(e,t,n,r){if(e&&3!==e.nodeType&&8!==e.nodeType&&e.style){var i,o,a,s=F(t),u=ze.test(t),l=e.style;if(u||(t=Ze(s)),a=ce.cssHooks[t]||ce.cssHooks[s],void 0===n)return a&&"get"in a&&void 0!==(i=a.get(e,!1,r))?i:l[t];"string"===(o=typeof n)&&(i=Y.exec(n))&&i[1]&&(n=te(e,t,i),o="number"),null!=n&&n==n&&("number"!==o||u||(n+=i&&i[3]||(ce.cssNumber[s]?"":"px")),le.clearCloneStyle||""!==n||0!==t.indexOf("background")||(l[t]="inherit"),a&&"set"in a&&void 0===(n=a.set(e,n,r))||(u?l.setProperty(t,n):l[t]=n))}},css:function(e,t,n,r){var i,o,a,s=F(t);return ze.test(t)||(t=Ze(s)),(a=ce.cssHooks[t]||ce.cssHooks[s])&&"get"in a&&(i=a.get(e,!0,n)),void 0===i&&(i=Ge(e,t,r)),"normal"===i&&t in nt&&(i=nt[t]),""===n||n?(o=parseFloat(i),!0===n||isFinite(o)?o||0:i):i}}),ce.each(["height","width"],function(e,u){ce.cssHooks[u]={get:function(e,t,n){if(t)return!et.test(ce.css(e,"display"))||e.getClientRects().length&&e.getBoundingClientRect().width?ot(e,u,n):Ue(e,tt,function(){return ot(e,u,n)})},set:function(e,t,n){var r,i=Xe(e),o=!le.scrollboxSize()&&"absolute"===i.position,a=(o||n)&&"border-box"===ce.css(e,"boxSizing",!1,i),s=n?it(e,u,n,a,i):0;return a&&o&&(s-=Math.ceil(e["offset"+u[0].toUpperCase()+u.slice(1)]-parseFloat(i[u])-it(e,u,"border",!1,i)-.5)),s&&(r=Y.exec(t))&&"px"!==(r[3]||"px")&&(e.style[u]=t,t=ce.css(e,u)),rt(0,t,s)}}}),ce.cssHooks.marginLeft=Ye(le.reliableMarginLeft,function(e,t){if(t)return(parseFloat(Ge(e,"marginLeft"))||e.getBoundingClientRect().left-Ue(e,{marginLeft:0},function(){return e.getBoundingClientRect().left}))+"px"}),ce.each({margin:"",padding:"",border:"Width"},function(i,o){ce.cssHooks[i+o]={expand:function(e){for(var t=0,n={},r="string"==typeof e?e.split(" "):[e];t<4;t++)n[i+Q[t]+o]=r[t]||r[t-2]||r[0];return n}},"margin"!==i&&(ce.cssHooks[i+o].set=rt)}),ce.fn.extend({css:function(e,t){return M(this,function(e,t,n){var r,i,o={},a=0;if(Array.isArray(t)){for(r=Xe(e),i=t.length;a<i;a++)o[t[a]]=ce.css(e,t[a],!1,r);return o}return void 0!==n?ce.style(e,t,n):ce.css(e,t)},e,t,1<arguments.length)}}),((ce.Tween=at).prototype={constructor:at,init:function(e,t,n,r,i,o){this.elem=e,this.prop=n,this.easing=i||ce.easing._default,this.options=t,this.start=this.now=this.cur(),this.end=r,this.unit=o||(ce.cssNumber[n]?"":"px")},cur:function(){var e=at.propHooks[this.prop];return e&&e.get?e.get(this):at.propHooks._default.get(this)},run:function(e){var t,n=at.propHooks[this.prop];return this.options.duration?this.pos=t=ce.easing[this.easing](e,this.options.duration*e,0,1,this.options.duration):this.pos=t=e,this.now=(this.end-this.start)*t+this.start,this.options.step&&this.options.step.call(this.elem,this.now,this),n&&n.set?n.set(this):at.propHooks._default.set(this),this}}).init.prototype=at.prototype,(at.propHooks={_default:{get:function(e){var t;return 1!==e.elem.nodeType||null!=e.elem[e.prop]&&null==e.elem.style[e.prop]?e.elem[e.prop]:(t=ce.css(e.elem,e.prop,""))&&"auto"!==t?t:0},set:function(e){ce.fx.step[e.prop]?ce.fx.step[e.prop](e):1!==e.elem.nodeType||!ce.cssHooks[e.prop]&&null==e.elem.style[Ze(e.prop)]?e.elem[e.prop]=e.now:ce.style(e.elem,e.prop,e.now+e.unit)}}}).scrollTop=at.propHooks.scrollLeft={set:function(e){e.elem.nodeType&&e.elem.parentNode&&(e.elem[e.prop]=e.now)}},ce.easing={linear:function(e){return e},swing:function(e){return.5-Math.cos(e*Math.PI)/2},_default:"swing"},ce.fx=at.prototype.init,ce.fx.step={};var st,ut,lt,ct,ft=/^(?:toggle|show|hide)$/,pt=/queueHooks$/;function dt(){ut&&(!1===C.hidden&&ie.requestAnimationFrame?ie.requestAnimationFrame(dt):ie.setTimeout(dt,ce.fx.interval),ce.fx.tick())}function ht(){return ie.setTimeout(function(){st=void 0}),st=Date.now()}function gt(e,t){var n,r=0,i={height:e};for(t=t?1:0;r<4;r+=2-t)i["margin"+(n=Q[r])]=i["padding"+n]=e;return t&&(i.opacity=i.width=e),i}function vt(e,t,n){for(var r,i=(yt.tweeners[t]||[]).concat(yt.tweeners["*"]),o=0,a=i.length;o<a;o++)if(r=i[o].call(n,t,e))return r}function yt(o,e,t){var n,a,r=0,i=yt.prefilters.length,s=ce.Deferred().always(function(){delete u.elem}),u=function(){if(a)return!1;for(var e=st||ht(),t=Math.max(0,l.startTime+l.duration-e),n=1-(t/l.duration||0),r=0,i=l.tweens.length;r<i;r++)l.tweens[r].run(n);return s.notifyWith(o,[l,n,t]),n<1&&i?t:(i||s.notifyWith(o,[l,1,0]),s.resolveWith(o,[l]),!1)},l=s.promise({elem:o,props:ce.extend({},e),opts:ce.extend(!0,{specialEasing:{},easing:ce.easing._default},t),originalProperties:e,originalOptions:t,startTime:st||ht(),duration:t.duration,tweens:[],createTween:function(e,t){var n=ce.Tween(o,l.opts,e,t,l.opts.specialEasing[e]||l.opts.easing);return l.tweens.push(n),n},stop:function(e){var t=0,n=e?l.tweens.length:0;if(a)return this;for(a=!0;t<n;t++)l.tweens[t].run(1);return e?(s.notifyWith(o,[l,1,0]),s.resolveWith(o,[l,e])):s.rejectWith(o,[l,e]),this}}),c=l.props;for(!function(e,t){var n,r,i,o,a;for(n in e)if(i=t[r=F(n)],o=e[n],Array.isArray(o)&&(i=o[1],o=e[n]=o[0]),n!==r&&(e[r]=o,delete e[n]),(a=ce.cssHooks[r])&&"expand"in a)for(n in o=a.expand(o),delete e[r],o)n in e||(e[n]=o[n],t[n]=i);else t[r]=i}(c,l.opts.specialEasing);r<i;r++)if(n=yt.prefilters[r].call(l,o,c,l.opts))return v(n.stop)&&(ce._queueHooks(l.elem,l.opts.queue).stop=n.stop.bind(n)),n;return ce.map(c,vt,l),v(l.opts.start)&&l.opts.start.call(o,l),l.progress(l.opts.progress).done(l.opts.done,l.opts.complete).fail(l.opts.fail).always(l.opts.always),ce.fx.timer(ce.extend(u,{elem:o,anim:l,queue:l.opts.queue})),l}ce.Animation=ce.extend(yt,{tweeners:{"*":[function(e,t){var n=this.createTween(e,t);return te(n.elem,e,Y.exec(t),n),n}]},tweener:function(e,t){v(e)?(t=e,e=["*"]):e=e.match(D);for(var n,r=0,i=e.length;r<i;r++)n=e[r],yt.tweeners[n]=yt.tweeners[n]||[],yt.tweeners[n].unshift(t)},prefilters:[function(e,t,n){var r,i,o,a,s,u,l,c,f="width"in t||"height"in t,p=this,d={},h=e.style,g=e.nodeType&&ee(e),v=_.get(e,"fxshow");for(r in n.queue||(null==(a=ce._queueHooks(e,"fx")).unqueued&&(a.unqueued=0,s=a.empty.fire,a.empty.fire=function(){a.unqueued||s()}),a.unqueued++,p.always(function(){p.always(function(){a.unqueued--,ce.queue(e,"fx").length||a.empty.fire()})})),t)if(i=t[r],ft.test(i)){if(delete t[r],o=o||"toggle"===i,i===(g?"hide":"show")){if("show"!==i||!v||void 0===v[r])continue;g=!0}d[r]=v&&v[r]||ce.style(e,r)}if((u=!ce.isEmptyObject(t))||!ce.isEmptyObject(d))for(r in f&&1===e.nodeType&&(n.overflow=[h.overflow,h.overflowX,h.overflowY],null==(l=v&&v.display)&&(l=_.get(e,"display")),"none"===(c=ce.css(e,"display"))&&(l?c=l:(re([e],!0),l=e.style.display||l,c=ce.css(e,"display"),re([e]))),("inline"===c||"inline-block"===c&&null!=l)&&"none"===ce.css(e,"float")&&(u||(p.done(function(){h.display=l}),null==l&&(c=h.display,l="none"===c?"":c)),h.display="inline-block")),n.overflow&&(h.overflow="hidden",p.always(function(){h.overflow=n.overflow[0],h.overflowX=n.overflow[1],h.overflowY=n.overflow[2]})),u=!1,d)u||(v?"hidden"in v&&(g=v.hidden):v=_.access(e,"fxshow",{display:l}),o&&(v.hidden=!g),g&&re([e],!0),p.done(function(){for(r in g||re([e]),_.remove(e,"fxshow"),d)ce.style(e,r,d[r])})),u=vt(g?v[r]:0,r,p),r in v||(v[r]=u.start,g&&(u.end=u.start,u.start=0))}],prefilter:function(e,t){t?yt.prefilters.unshift(e):yt.prefilters.push(e)}}),ce.speed=function(e,t,n){var r=e&&"object"==typeof e?ce.extend({},e):{complete:n||!n&&t||v(e)&&e,duration:e,easing:n&&t||t&&!v(t)&&t};return ce.fx.off?r.duration=0:"number"!=typeof r.duration&&(r.duration in ce.fx.speeds?r.duration=ce.fx.speeds[r.duration]:r.duration=ce.fx.speeds._default),null!=r.queue&&!0!==r.queue||(r.queue="fx"),r.old=r.complete,r.complete=function(){v(r.old)&&r.old.call(this),r.queue&&ce.dequeue(this,r.queue)},r},ce.fn.extend({fadeTo:function(e,t,n,r){return this.filter(ee).css("opacity",0).show().end().animate({opacity:t},e,n,r)},animate:function(t,e,n,r){var i=ce.isEmptyObject(t),o=ce.speed(e,n,r),a=function(){var e=yt(this,ce.extend({},t),o);(i||_.get(this,"finish"))&&e.stop(!0)};return a.finish=a,i||!1===o.queue?this.each(a):this.queue(o.queue,a)},stop:function(i,e,o){var a=function(e){var t=e.stop;delete e.stop,t(o)};return"string"!=typeof i&&(o=e,e=i,i=void 0),e&&this.queue(i||"fx",[]),this.each(function(){var e=!0,t=null!=i&&i+"queueHooks",n=ce.timers,r=_.get(this);if(t)r[t]&&r[t].stop&&a(r[t]);else for(t in r)r[t]&&r[t].stop&&pt.test(t)&&a(r[t]);for(t=n.length;t--;)n[t].elem!==this||null!=i&&n[t].queue!==i||(n[t].anim.stop(o),e=!1,n.splice(t,1));!e&&o||ce.dequeue(this,i)})},finish:function(a){return!1!==a&&(a=a||"fx"),this.each(function(){var e,t=_.get(this),n=t[a+"queue"],r=t[a+"queueHooks"],i=ce.timers,o=n?n.length:0;for(t.finish=!0,ce.queue(this,a,[]),r&&r.stop&&r.stop.call(this,!0),e=i.length;e--;)i[e].elem===this&&i[e].queue===a&&(i[e].anim.stop(!0),i.splice(e,1));for(e=0;e<o;e++)n[e]&&n[e].finish&&n[e].finish.call(this);delete t.finish})}}),ce.each(["toggle","show","hide"],function(e,r){var i=ce.fn[r];ce.fn[r]=function(e,t,n){return null==e||"boolean"==typeof e?i.apply(this,arguments):this.animate(gt(r,!0),e,t,n)}}),ce.each({slideDown:gt("show"),slideUp:gt("hide"),slideToggle:gt("toggle"),fadeIn:{opacity:"show"},fadeOut:{opacity:"hide"},fadeToggle:{opacity:"toggle"}},function(e,r){ce.fn[e]=function(e,t,n){return this.animate(r,e,t,n)}}),ce.timers=[],ce.fx.tick=function(){var e,t=0,n=ce.timers;for(st=Date.now();t<n.length;t++)(e=n[t])()||n[t]!==e||n.splice(t--,1);n.length||ce.fx.stop(),st=void 0},ce.fx.timer=function(e){ce.timers.push(e),ce.fx.start()},ce.fx.interval=13,ce.fx.start=function(){ut||(ut=!0,dt())},ce.fx.stop=function(){ut=null},ce.fx.speeds={slow:600,fast:200,_default:400},ce.fn.delay=function(r,e){return r=ce.fx&&ce.fx.speeds[r]||r,e=e||"fx",this.queue(e,function(e,t){var n=ie.setTimeout(e,r);t.stop=function(){ie.clearTimeout(n)}})},lt=C.createElement("input"),ct=C.createElement("select").appendChild(C.createElement("option")),lt.type="checkbox",le.checkOn=""!==lt.value,le.optSelected=ct.selected,(lt=C.createElement("input")).value="t",lt.type="radio",le.radioValue="t"===lt.value;var mt,xt=ce.expr.attrHandle;ce.fn.extend({attr:function(e,t){return M(this,ce.attr,e,t,1<arguments.length)},removeAttr:function(e){return this.each(function(){ce.removeAttr(this,e)})}}),ce.extend({attr:function(e,t,n){var r,i,o=e.nodeType;if(3!==o&&8!==o&&2!==o)return"undefined"==typeof e.getAttribute?ce.prop(e,t,n):(1===o&&ce.isXMLDoc(e)||(i=ce.attrHooks[t.toLowerCase()]||(ce.expr.match.bool.test(t)?mt:void 0)),void 0!==n?null===n?void ce.removeAttr(e,t):i&&"set"in i&&void 0!==(r=i.set(e,n,t))?r:(e.setAttribute(t,n+""),n):i&&"get"in i&&null!==(r=i.get(e,t))?r:null==(r=ce.find.attr(e,t))?void 0:r)},attrHooks:{type:{set:function(e,t){if(!le.radioValue&&"radio"===t&&fe(e,"input")){var n=e.value;return e.setAttribute("type",t),n&&(e.value=n),t}}}},removeAttr:function(e,t){var n,r=0,i=t&&t.match(D);if(i&&1===e.nodeType)while(n=i[r++])e.removeAttribute(n)}}),mt={set:function(e,t,n){return!1===t?ce.removeAttr(e,n):e.setAttribute(n,n),n}},ce.each(ce.expr.match.bool.source.match(/\w+/g),function(e,t){var a=xt[t]||ce.find.attr;xt[t]=function(e,t,n){var r,i,o=t.toLowerCase();return n||(i=xt[o],xt[o]=r,r=null!=a(e,t,n)?o:null,xt[o]=i),r}});var bt=/^(?:input|select|textarea|button)$/i,wt=/^(?:a|area)$/i;function Tt(e){return(e.match(D)||[]).join(" ")}function Ct(e){return e.getAttribute&&e.getAttribute("class")||""}function kt(e){return Array.isArray(e)?e:"string"==typeof e&&e.match(D)||[]}ce.fn.extend({prop:function(e,t){return M(this,ce.prop,e,t,1<arguments.length)},removeProp:function(e){return this.each(function(){delete this[ce.propFix[e]||e]})}}),ce.extend({prop:function(e,t,n){var r,i,o=e.nodeType;if(3!==o&&8!==o&&2!==o)return 1===o&&ce.isXMLDoc(e)||(t=ce.propFix[t]||t,i=ce.propHooks[t]),void 0!==n?i&&"set"in i&&void 0!==(r=i.set(e,n,t))?r:e[t]=n:i&&"get"in i&&null!==(r=i.get(e,t))?r:e[t]},propHooks:{tabIndex:{get:function(e){var t=ce.find.attr(e,"tabindex");return t?parseInt(t,10):bt.test(e.nodeName)||wt.test(e.nodeName)&&e.href?0:-1}}},propFix:{"for":"htmlFor","class":"className"}}),le.optSelected||(ce.propHooks.selected={get:function(e){var t=e.parentNode;return t&&t.parentNode&&t.parentNode.selectedIndex,null},set:function(e){var t=e.parentNode;t&&(t.selectedIndex,t.parentNode&&t.parentNode.selectedIndex)}}),ce.each(["tabIndex","readOnly","maxLength","cellSpacing","cellPadding","rowSpan","colSpan","useMap","frameBorder","contentEditable"],function(){ce.propFix[this.toLowerCase()]=this}),ce.fn.extend({addClass:function(t){var e,n,r,i,o,a;return v(t)?this.each(function(e){ce(this).addClass(t.call(this,e,Ct(this)))}):(e=kt(t)).length?this.each(function(){if(r=Ct(this),n=1===this.nodeType&&" "+Tt(r)+" "){for(o=0;o<e.length;o++)i=e[o],n.indexOf(" "+i+" ")<0&&(n+=i+" ");a=Tt(n),r!==a&&this.setAttribute("class",a)}}):this},removeClass:function(t){var e,n,r,i,o,a;return v(t)?this.each(function(e){ce(this).removeClass(t.call(this,e,Ct(this)))}):arguments.length?(e=kt(t)).length?this.each(function(){if(r=Ct(this),n=1===this.nodeType&&" "+Tt(r)+" "){for(o=0;o<e.length;o++){i=e[o];while(-1<n.indexOf(" "+i+" "))n=n.replace(" "+i+" "," ")}a=Tt(n),r!==a&&this.setAttribute("class",a)}}):this:this.attr("class","")},toggleClass:function(t,n){var e,r,i,o,a=typeof t,s="string"===a||Array.isArray(t);return v(t)?this.each(function(e){ce(this).toggleClass(t.call(this,e,Ct(this),n),n)}):"boolean"==typeof n&&s?n?this.addClass(t):this.removeClass(t):(e=kt(t),this.each(function(){if(s)for(o=ce(this),i=0;i<e.length;i++)r=e[i],o.hasClass(r)?o.removeClass(r):o.addClass(r);else void 0!==t&&"boolean"!==a||((r=Ct(this))&&_.set(this,"__className__",r),this.setAttribute&&this.setAttribute("class",r||!1===t?"":_.get(this,"__className__")||""))}))},hasClass:function(e){var t,n,r=0;t=" "+e+" ";while(n=this[r++])if(1===n.nodeType&&-1<(" "+Tt(Ct(n))+" ").indexOf(t))return!0;return!1}});var St=/\r/g;ce.fn.extend({val:function(n){var r,e,i,t=this[0];return arguments.length?(i=v(n),this.each(function(e){var t;1===this.nodeType&&(null==(t=i?n.call(this,e,ce(this).val()):n)?t="":"number"==typeof t?t+="":Array.isArray(t)&&(t=ce.map(t,function(e){return null==e?"":e+""})),(r=ce.valHooks[this.type]||ce.valHooks[this.nodeName.toLowerCase()])&&"set"in r&&void 0!==r.set(this,t,"value")||(this.value=t))})):t?(r=ce.valHooks[t.type]||ce.valHooks[t.nodeName.toLowerCase()])&&"get"in r&&void 0!==(e=r.get(t,"value"))?e:"string"==typeof(e=t.value)?e.replace(St,""):null==e?"":e:void 0}}),ce.extend({valHooks:{option:{get:function(e){var t=ce.find.attr(e,"value");return null!=t?t:Tt(ce.text(e))}},select:{get:function(e){var t,n,r,i=e.options,o=e.selectedIndex,a="select-one"===e.type,s=a?null:[],u=a?o+1:i.length;for(r=o<0?u:a?o:0;r<u;r++)if(((n=i[r]).selected||r===o)&&!n.disabled&&(!n.parentNode.disabled||!fe(n.parentNode,"optgroup"))){if(t=ce(n).val(),a)return t;s.push(t)}return s},set:function(e,t){var n,r,i=e.options,o=ce.makeArray(t),a=i.length;while(a--)((r=i[a]).selected=-1<ce.inArray(ce.valHooks.option.get(r),o))&&(n=!0);return n||(e.selectedIndex=-1),o}}}}),ce.each(["radio","checkbox"],function(){ce.valHooks[this]={set:function(e,t){if(Array.isArray(t))return e.checked=-1<ce.inArray(ce(e).val(),t)}},le.checkOn||(ce.valHooks[this].get=function(e){return null===e.getAttribute("value")?"on":e.value})});var Et=ie.location,jt={guid:Date.now()},At=/\?/;ce.parseXML=function(e){var t,n;if(!e||"string"!=typeof e)return null;try{t=(new ie.DOMParser).parseFromString(e,"text/xml")}catch(e){}return n=t&&t.getElementsByTagName("parsererror")[0],t&&!n||ce.error("Invalid XML: "+(n?ce.map(n.childNodes,function(e){return e.textContent}).join("\n"):e)),t};var Dt=/^(?:focusinfocus|focusoutblur)$/,Nt=function(e){e.stopPropagation()};ce.extend(ce.event,{trigger:function(e,t,n,r){var i,o,a,s,u,l,c,f,p=[n||C],d=ue.call(e,"type")?e.type:e,h=ue.call(e,"namespace")?e.namespace.split("."):[];if(o=f=a=n=n||C,3!==n.nodeType&&8!==n.nodeType&&!Dt.test(d+ce.event.triggered)&&(-1<d.indexOf(".")&&(d=(h=d.split(".")).shift(),h.sort()),u=d.indexOf(":")<0&&"on"+d,(e=e[ce.expando]?e:new ce.Event(d,"object"==typeof e&&e)).isTrigger=r?2:3,e.namespace=h.join("."),e.rnamespace=e.namespace?new RegExp("(^|\\.)"+h.join("\\.(?:.*\\.|)")+"(\\.|$)"):null,e.result=void 0,e.target||(e.target=n),t=null==t?[e]:ce.makeArray(t,[e]),c=ce.event.special[d]||{},r||!c.trigger||!1!==c.trigger.apply(n,t))){if(!r&&!c.noBubble&&!y(n)){for(s=c.delegateType||d,Dt.test(s+d)||(o=o.parentNode);o;o=o.parentNode)p.push(o),a=o;a===(n.ownerDocument||C)&&p.push(a.defaultView||a.parentWindow||ie)}i=0;while((o=p[i++])&&!e.isPropagationStopped())f=o,e.type=1<i?s:c.bindType||d,(l=(_.get(o,"events")||Object.create(null))[e.type]&&_.get(o,"handle"))&&l.apply(o,t),(l=u&&o[u])&&l.apply&&$(o)&&(e.result=l.apply(o,t),!1===e.result&&e.preventDefault());return e.type=d,r||e.isDefaultPrevented()||c._default&&!1!==c._default.apply(p.pop(),t)||!$(n)||u&&v(n[d])&&!y(n)&&((a=n[u])&&(n[u]=null),ce.event.triggered=d,e.isPropagationStopped()&&f.addEventListener(d,Nt),n[d](),e.isPropagationStopped()&&f.removeEventListener(d,Nt),ce.event.triggered=void 0,a&&(n[u]=a)),e.result}},simulate:function(e,t,n){var r=ce.extend(new ce.Event,n,{type:e,isSimulated:!0});ce.event.trigger(r,null,t)}}),ce.fn.extend({trigger:function(e,t){return this.each(function(){ce.event.trigger(e,t,this)})},triggerHandler:function(e,t){var n=this[0];if(n)return ce.event.trigger(e,t,n,!0)}});var qt=/\[\]$/,Lt=/\r?\n/g,Ht=/^(?:submit|button|image|reset|file)$/i,Ot=/^(?:input|select|textarea|keygen)/i;function Pt(n,e,r,i){var t;if(Array.isArray(e))ce.each(e,function(e,t){r||qt.test(n)?i(n,t):Pt(n+"["+("object"==typeof t&&null!=t?e:"")+"]",t,r,i)});else if(r||"object"!==x(e))i(n,e);else for(t in e)Pt(n+"["+t+"]",e[t],r,i)}ce.param=function(e,t){var n,r=[],i=function(e,t){var n=v(t)?t():t;r[r.length]=encodeURIComponent(e)+"="+encodeURIComponent(null==n?"":n)};if(null==e)return"";if(Array.isArray(e)||e.jquery&&!ce.isPlainObject(e))ce.each(e,function(){i(this.name,this.value)});else for(n in e)Pt(n,e[n],t,i);return r.join("&")},ce.fn.extend({serialize:function(){return ce.param(this.serializeArray())},serializeArray:function(){return this.map(function(){var e=ce.prop(this,"elements");return e?ce.makeArray(e):this}).filter(function(){var e=this.type;return this.name&&!ce(this).is(":disabled")&&Ot.test(this.nodeName)&&!Ht.test(e)&&(this.checked||!we.test(e))}).map(function(e,t){var n=ce(this).val();return null==n?null:Array.isArray(n)?ce.map(n,function(e){return{name:t.name,value:e.replace(Lt,"\r\n")}}):{name:t.name,value:n.replace(Lt,"\r\n")}}).get()}});var Mt=/%20/g,Rt=/#.*$/,It=/([?&])_=[^&]*/,Wt=/^(.*?):[ \t]*([^\r\n]*)$/gm,Ft=/^(?:GET|HEAD)$/,$t=/^\/\//,Bt={},_t={},zt="*/".concat("*"),Xt=C.createElement("a");function Ut(o){return function(e,t){"string"!=typeof e&&(t=e,e="*");var n,r=0,i=e.toLowerCase().match(D)||[];if(v(t))while(n=i[r++])"+"===n[0]?(n=n.slice(1)||"*",(o[n]=o[n]||[]).unshift(t)):(o[n]=o[n]||[]).push(t)}}function Vt(t,i,o,a){var s={},u=t===_t;function l(e){var r;return s[e]=!0,ce.each(t[e]||[],function(e,t){var n=t(i,o,a);return"string"!=typeof n||u||s[n]?u?!(r=n):void 0:(i.dataTypes.unshift(n),l(n),!1)}),r}return l(i.dataTypes[0])||!s["*"]&&l("*")}function Gt(e,t){var n,r,i=ce.ajaxSettings.flatOptions||{};for(n in t)void 0!==t[n]&&((i[n]?e:r||(r={}))[n]=t[n]);return r&&ce.extend(!0,e,r),e}Xt.href=Et.href,ce.extend({active:0,lastModified:{},etag:{},ajaxSettings:{url:Et.href,type:"GET",isLocal:/^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(Et.protocol),global:!0,processData:!0,async:!0,contentType:"application/x-www-form-urlencoded; charset=UTF-8",accepts:{"*":zt,text:"text/plain",html:"text/html",xml:"application/xml, text/xml",json:"application/json, text/javascript"},contents:{xml:/\bxml\b/,html:/\bhtml/,json:/\bjson\b/},responseFields:{xml:"responseXML",text:"responseText",json:"responseJSON"},converters:{"* text":String,"text html":!0,"text json":JSON.parse,"text xml":ce.parseXML},flatOptions:{url:!0,context:!0}},ajaxSetup:function(e,t){return t?Gt(Gt(e,ce.ajaxSettings),t):Gt(ce.ajaxSettings,e)},ajaxPrefilter:Ut(Bt),ajaxTransport:Ut(_t),ajax:function(e,t){"object"==typeof e&&(t=e,e=void 0),t=t||{};var c,f,p,n,d,r,h,g,i,o,v=ce.ajaxSetup({},t),y=v.context||v,m=v.context&&(y.nodeType||y.jquery)?ce(y):ce.event,x=ce.Deferred(),b=ce.Callbacks("once memory"),w=v.statusCode||{},a={},s={},u="canceled",T={readyState:0,getResponseHeader:function(e){var t;if(h){if(!n){n={};while(t=Wt.exec(p))n[t[1].toLowerCase()+" "]=(n[t[1].toLowerCase()+" "]||[]).concat(t[2])}t=n[e.toLowerCase()+" "]}return null==t?null:t.join(", ")},getAllResponseHeaders:function(){return h?p:null},setRequestHeader:function(e,t){return null==h&&(e=s[e.toLowerCase()]=s[e.toLowerCase()]||e,a[e]=t),this},overrideMimeType:function(e){return null==h&&(v.mimeType=e),this},statusCode:function(e){var t;if(e)if(h)T.always(e[T.status]);else for(t in e)w[t]=[w[t],e[t]];return this},abort:function(e){var t=e||u;return c&&c.abort(t),l(0,t),this}};if(x.promise(T),v.url=((e||v.url||Et.href)+"").replace($t,Et.protocol+"//"),v.type=t.method||t.type||v.method||v.type,v.dataTypes=(v.dataType||"*").toLowerCase().match(D)||[""],null==v.crossDomain){r=C.createElement("a");try{r.href=v.url,r.href=r.href,v.crossDomain=Xt.protocol+"//"+Xt.host!=r.protocol+"//"+r.host}catch(e){v.crossDomain=!0}}if(v.data&&v.processData&&"string"!=typeof v.data&&(v.data=ce.param(v.data,v.traditional)),Vt(Bt,v,t,T),h)return T;for(i in(g=ce.event&&v.global)&&0==ce.active++&&ce.event.trigger("ajaxStart"),v.type=v.type.toUpperCase(),v.hasContent=!Ft.test(v.type),f=v.url.replace(Rt,""),v.hasContent?v.data&&v.processData&&0===(v.contentType||"").indexOf("application/x-www-form-urlencoded")&&(v.data=v.data.replace(Mt,"+")):(o=v.url.slice(f.length),v.data&&(v.processData||"string"==typeof v.data)&&(f+=(At.test(f)?"&":"?")+v.data,delete v.data),!1===v.cache&&(f=f.replace(It,"$1"),o=(At.test(f)?"&":"?")+"_="+jt.guid+++o),v.url=f+o),v.ifModified&&(ce.lastModified[f]&&T.setRequestHeader("If-Modified-Since",ce.lastModified[f]),ce.etag[f]&&T.setRequestHeader("If-None-Match",ce.etag[f])),(v.data&&v.hasContent&&!1!==v.contentType||t.contentType)&&T.setRequestHeader("Content-Type",v.contentType),T.setRequestHeader("Accept",v.dataTypes[0]&&v.accepts[v.dataTypes[0]]?v.accepts[v.dataTypes[0]]+("*"!==v.dataTypes[0]?", "+zt+"; q=0.01":""):v.accepts["*"]),v.headers)T.setRequestHeader(i,v.headers[i]);if(v.beforeSend&&(!1===v.beforeSend.call(y,T,v)||h))return T.abort();if(u="abort",b.add(v.complete),T.done(v.success),T.fail(v.error),c=Vt(_t,v,t,T)){if(T.readyState=1,g&&m.trigger("ajaxSend",[T,v]),h)return T;v.async&&0<v.timeout&&(d=ie.setTimeout(function(){T.abort("timeout")},v.timeout));try{h=!1,c.send(a,l)}catch(e){if(h)throw e;l(-1,e)}}else l(-1,"No Transport");function l(e,t,n,r){var i,o,a,s,u,l=t;h||(h=!0,d&&ie.clearTimeout(d),c=void 0,p=r||"",T.readyState=0<e?4:0,i=200<=e&&e<300||304===e,n&&(s=function(e,t,n){var r,i,o,a,s=e.contents,u=e.dataTypes;while("*"===u[0])u.shift(),void 0===r&&(r=e.mimeType||t.getResponseHeader("Content-Type"));if(r)for(i in s)if(s[i]&&s[i].test(r)){u.unshift(i);break}if(u[0]in n)o=u[0];else{for(i in n){if(!u[0]||e.converters[i+" "+u[0]]){o=i;break}a||(a=i)}o=o||a}if(o)return o!==u[0]&&u.unshift(o),n[o]}(v,T,n)),!i&&-1<ce.inArray("script",v.dataTypes)&&ce.inArray("json",v.dataTypes)<0&&(v.converters["text script"]=function(){}),s=function(e,t,n,r){var i,o,a,s,u,l={},c=e.dataTypes.slice();if(c[1])for(a in e.converters)l[a.toLowerCase()]=e.converters[a];o=c.shift();while(o)if(e.responseFields[o]&&(n[e.responseFields[o]]=t),!u&&r&&e.dataFilter&&(t=e.dataFilter(t,e.dataType)),u=o,o=c.shift())if("*"===o)o=u;else if("*"!==u&&u!==o){if(!(a=l[u+" "+o]||l["* "+o]))for(i in l)if((s=i.split(" "))[1]===o&&(a=l[u+" "+s[0]]||l["* "+s[0]])){!0===a?a=l[i]:!0!==l[i]&&(o=s[0],c.unshift(s[1]));break}if(!0!==a)if(a&&e["throws"])t=a(t);else try{t=a(t)}catch(e){return{state:"parsererror",error:a?e:"No conversion from "+u+" to "+o}}}return{state:"success",data:t}}(v,s,T,i),i?(v.ifModified&&((u=T.getResponseHeader("Last-Modified"))&&(ce.lastModified[f]=u),(u=T.getResponseHeader("etag"))&&(ce.etag[f]=u)),204===e||"HEAD"===v.type?l="nocontent":304===e?l="notmodified":(l=s.state,o=s.data,i=!(a=s.error))):(a=l,!e&&l||(l="error",e<0&&(e=0))),T.status=e,T.statusText=(t||l)+"",i?x.resolveWith(y,[o,l,T]):x.rejectWith(y,[T,l,a]),T.statusCode(w),w=void 0,g&&m.trigger(i?"ajaxSuccess":"ajaxError",[T,v,i?o:a]),b.fireWith(y,[T,l]),g&&(m.trigger("ajaxComplete",[T,v]),--ce.active||ce.event.trigger("ajaxStop")))}return T},getJSON:function(e,t,n){return ce.get(e,t,n,"json")},getScript:function(e,t){return ce.get(e,void 0,t,"script")}}),ce.each(["get","post"],function(e,i){ce[i]=function(e,t,n,r){return v(t)&&(r=r||n,n=t,t=void 0),ce.ajax(ce.extend({url:e,type:i,dataType:r,data:t,success:n},ce.isPlainObject(e)&&e))}}),ce.ajaxPrefilter(function(e){var t;for(t in e.headers)"content-type"===t.toLowerCase()&&(e.contentType=e.headers[t]||"")}),ce._evalUrl=function(e,t,n){return ce.ajax({url:e,type:"GET",dataType:"script",cache:!0,async:!1,global:!1,converters:{"text script":function(){}},dataFilter:function(e){ce.globalEval(e,t,n)}})},ce.fn.extend({wrapAll:function(e){var t;return this[0]&&(v(e)&&(e=e.call(this[0])),t=ce(e,this[0].ownerDocument).eq(0).clone(!0),this[0].parentNode&&t.insertBefore(this[0]),t.map(function(){var e=this;while(e.firstElementChild)e=e.firstElementChild;return e}).append(this)),this},wrapInner:function(n){return v(n)?this.each(function(e){ce(this).wrapInner(n.call(this,e))}):this.each(function(){var e=ce(this),t=e.contents();t.length?t.wrapAll(n):e.append(n)})},wrap:function(t){var n=v(t);return this.each(function(e){ce(this).wrapAll(n?t.call(this,e):t)})},unwrap:function(e){return this.parent(e).not("body").each(function(){ce(this).replaceWith(this.childNodes)}),this}}),ce.expr.pseudos.hidden=function(e){return!ce.expr.pseudos.visible(e)},ce.expr.pseudos.visible=function(e){return!!(e.offsetWidth||e.offsetHeight||e.getClientRects().length)},ce.ajaxSettings.xhr=function(){try{return new ie.XMLHttpRequest}catch(e){}};var Yt={0:200,1223:204},Qt=ce.ajaxSettings.xhr();le.cors=!!Qt&&"withCredentials"in Qt,le.ajax=Qt=!!Qt,ce.ajaxTransport(function(i){var o,a;if(le.cors||Qt&&!i.crossDomain)return{send:function(e,t){var n,r=i.xhr();if(r.open(i.type,i.url,i.async,i.username,i.password),i.xhrFields)for(n in i.xhrFields)r[n]=i.xhrFields[n];for(n in i.mimeType&&r.overrideMimeType&&r.overrideMimeType(i.mimeType),i.crossDomain||e["X-Requested-With"]||(e["X-Requested-With"]="XMLHttpRequest"),e)r.setRequestHeader(n,e[n]);o=function(e){return function(){o&&(o=a=r.onload=r.onerror=r.onabort=r.ontimeout=r.onreadystatechange=null,"abort"===e?r.abort():"error"===e?"number"!=typeof r.status?t(0,"error"):t(r.status,r.statusText):t(Yt[r.status]||r.status,r.statusText,"text"!==(r.responseType||"text")||"string"!=typeof r.responseText?{binary:r.response}:{text:r.responseText},r.getAllResponseHeaders()))}},r.onload=o(),a=r.onerror=r.ontimeout=o("error"),void 0!==r.onabort?r.onabort=a:r.onreadystatechange=function(){4===r.readyState&&ie.setTimeout(function(){o&&a()})},o=o("abort");try{r.send(i.hasContent&&i.data||null)}catch(e){if(o)throw e}},abort:function(){o&&o()}}}),ce.ajaxPrefilter(function(e){e.crossDomain&&(e.contents.script=!1)}),ce.ajaxSetup({accepts:{script:"text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"},contents:{script:/\b(?:java|ecma)script\b/},converters:{"text script":function(e){return ce.globalEval(e),e}}}),ce.ajaxPrefilter("script",function(e){void 0===e.cache&&(e.cache=!1),e.crossDomain&&(e.type="GET")}),ce.ajaxTransport("script",function(n){var r,i;if(n.crossDomain||n.scriptAttrs)return{send:function(e,t){r=ce("<script>").attr(n.scriptAttrs||{}).prop({charset:n.scriptCharset,src:n.url}).on("load error",i=function(e){r.remove(),i=null,e&&t("error"===e.type?404:200,e.type)}),C.head.appendChild(r[0])},abort:function(){i&&i()}}});var Jt,Kt=[],Zt=/(=)\?(?=&|$)|\?\?/;ce.ajaxSetup({jsonp:"callback",jsonpCallback:function(){var e=Kt.pop()||ce.expando+"_"+jt.guid++;return this[e]=!0,e}}),ce.ajaxPrefilter("json jsonp",function(e,t,n){var r,i,o,a=!1!==e.jsonp&&(Zt.test(e.url)?"url":"string"==typeof e.data&&0===(e.contentType||"").indexOf("application/x-www-form-urlencoded")&&Zt.test(e.data)&&"data");if(a||"jsonp"===e.dataTypes[0])return r=e.jsonpCallback=v(e.jsonpCallback)?e.jsonpCallback():e.jsonpCallback,a?e[a]=e[a].replace(Zt,"$1"+r):!1!==e.jsonp&&(e.url+=(At.test(e.url)?"&":"?")+e.jsonp+"="+r),e.converters["script json"]=function(){return o||ce.error(r+" was not called"),o[0]},e.dataTypes[0]="json",i=ie[r],ie[r]=function(){o=arguments},n.always(function(){void 0===i?ce(ie).removeProp(r):ie[r]=i,e[r]&&(e.jsonpCallback=t.jsonpCallback,Kt.push(r)),o&&v(i)&&i(o[0]),o=i=void 0}),"script"}),le.createHTMLDocument=((Jt=C.implementation.createHTMLDocument("").body).innerHTML="<form></form><form></form>",2===Jt.childNodes.length),ce.parseHTML=function(e,t,n){return"string"!=typeof e?[]:("boolean"==typeof t&&(n=t,t=!1),t||(le.createHTMLDocument?((r=(t=C.implementation.createHTMLDocument("")).createElement("base")).href=C.location.href,t.head.appendChild(r)):t=C),o=!n&&[],(i=w.exec(e))?[t.createElement(i[1])]:(i=Ae([e],t,o),o&&o.length&&ce(o).remove(),ce.merge([],i.childNodes)));var r,i,o},ce.fn.load=function(e,t,n){var r,i,o,a=this,s=e.indexOf(" ");return-1<s&&(r=Tt(e.slice(s)),e=e.slice(0,s)),v(t)?(n=t,t=void 0):t&&"object"==typeof t&&(i="POST"),0<a.length&&ce.ajax({url:e,type:i||"GET",dataType:"html",data:t}).done(function(e){o=arguments,a.html(r?ce("<div>").append(ce.parseHTML(e)).find(r):e)}).always(n&&function(e,t){a.each(function(){n.apply(this,o||[e.responseText,t,e])})}),this},ce.expr.pseudos.animated=function(t){return ce.grep(ce.timers,function(e){return t===e.elem}).length},ce.offset={setOffset:function(e,t,n){var r,i,o,a,s,u,l=ce.css(e,"position"),c=ce(e),f={};"static"===l&&(e.style.position="relative"),s=c.offset(),o=ce.css(e,"top"),u=ce.css(e,"left"),("absolute"===l||"fixed"===l)&&-1<(o+u).indexOf("auto")?(a=(r=c.position()).top,i=r.left):(a=parseFloat(o)||0,i=parseFloat(u)||0),v(t)&&(t=t.call(e,n,ce.extend({},s))),null!=t.top&&(f.top=t.top-s.top+a),null!=t.left&&(f.left=t.left-s.left+i),"using"in t?t.using.call(e,f):c.css(f)}},ce.fn.extend({offset:function(t){if(arguments.length)return void 0===t?this:this.each(function(e){ce.offset.setOffset(this,t,e)});var e,n,r=this[0];return r?r.getClientRects().length?(e=r.getBoundingClientRect(),n=r.ownerDocument.defaultView,{top:e.top+n.pageYOffset,left:e.left+n.pageXOffset}):{top:0,left:0}:void 0},position:function(){if(this[0]){var e,t,n,r=this[0],i={top:0,left:0};if("fixed"===ce.css(r,"position"))t=r.getBoundingClientRect();else{t=this.offset(),n=r.ownerDocument,e=r.offsetParent||n.documentElement;while(e&&(e===n.body||e===n.documentElement)&&"static"===ce.css(e,"position"))e=e.parentNode;e&&e!==r&&1===e.nodeType&&((i=ce(e).offset()).top+=ce.css(e,"borderTopWidth",!0),i.left+=ce.css(e,"borderLeftWidth",!0))}return{top:t.top-i.top-ce.css(r,"marginTop",!0),left:t.left-i.left-ce.css(r,"marginLeft",!0)}}},offsetParent:function(){return this.map(function(){var e=this.offsetParent;while(e&&"static"===ce.css(e,"position"))e=e.offsetParent;return e||J})}}),ce.each({scrollLeft:"pageXOffset",scrollTop:"pageYOffset"},function(t,i){var o="pageYOffset"===i;ce.fn[t]=function(e){return M(this,function(e,t,n){var r;if(y(e)?r=e:9===e.nodeType&&(r=e.defaultView),void 0===n)return r?r[i]:e[t];r?r.scrollTo(o?r.pageXOffset:n,o?n:r.pageYOffset):e[t]=n},t,e,arguments.length)}}),ce.each(["top","left"],function(e,n){ce.cssHooks[n]=Ye(le.pixelPosition,function(e,t){if(t)return t=Ge(e,n),_e.test(t)?ce(e).position()[n]+"px":t})}),ce.each({Height:"height",Width:"width"},function(a,s){ce.each({padding:"inner"+a,content:s,"":"outer"+a},function(r,o){ce.fn[o]=function(e,t){var n=arguments.length&&(r||"boolean"!=typeof e),i=r||(!0===e||!0===t?"margin":"border");return M(this,function(e,t,n){var r;return y(e)?0===o.indexOf("outer")?e["inner"+a]:e.document.documentElement["client"+a]:9===e.nodeType?(r=e.documentElement,Math.max(e.body["scroll"+a],r["scroll"+a],e.body["offset"+a],r["offset"+a],r["client"+a])):void 0===n?ce.css(e,t,i):ce.style(e,t,n,i)},s,n?e:void 0,n)}})}),ce.each(["ajaxStart","ajaxStop","ajaxComplete","ajaxError","ajaxSuccess","ajaxSend"],function(e,t){ce.fn[t]=function(e){return this.on(t,e)}}),ce.fn.extend({bind:function(e,t,n){return this.on(e,null,t,n)},unbind:function(e,t){return this.off(e,null,t)},delegate:function(e,t,n,r){return this.on(t,e,n,r)},undelegate:function(e,t,n){return 1===arguments.length?this.off(e,"**"):this.off(t,e||"**",n)},hover:function(e,t){return this.on("mouseenter",e).on("mouseleave",t||e)}}),ce.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "),function(e,n){ce.fn[n]=function(e,t){return 0<arguments.length?this.on(n,null,e,t):this.trigger(n)}});var en=/^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;ce.proxy=function(e,t){var n,r,i;if("string"==typeof t&&(n=e[t],t=e,e=n),v(e))return r=ae.call(arguments,2),(i=function(){return e.apply(t||this,r.concat(ae.call(arguments)))}).guid=e.guid=e.guid||ce.guid++,i},ce.holdReady=function(e){e?ce.readyWait++:ce.ready(!0)},ce.isArray=Array.isArray,ce.parseJSON=JSON.parse,ce.nodeName=fe,ce.isFunction=v,ce.isWindow=y,ce.camelCase=F,ce.type=x,ce.now=Date.now,ce.isNumeric=function(e){var t=ce.type(e);return("number"===t||"string"===t)&&!isNaN(e-parseFloat(e))},ce.trim=function(e){return null==e?"":(e+"").replace(en,"$1")},"function"==typeof define&&define.amd&&define("jquery",[],function(){return ce});var tn=ie.jQuery,nn=ie.$;return ce.noConflict=function(e){return ie.$===ce&&(ie.$=nn),e&&ie.jQuery===ce&&(ie.jQuery=tn),ce},"undefined"==typeof e&&(ie.jQuery=ie.$=ce),ce});

/**!

 @license
 handlebars v4.7.8

Copyright (C) 2011-2019 by Yehuda Katz

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.

*/
!function(a,b){"object"==typeof exports&&"object"==typeof module?module.exports=b():"function"==typeof define&&define.amd?define([],b):"object"==typeof exports?exports.Handlebars=b():a.Handlebars=b()}(this,function(){return function(a){function b(d){if(c[d])return c[d].exports;var e=c[d]={exports:{},id:d,loaded:!1};return a[d].call(e.exports,e,e.exports,b),e.loaded=!0,e.exports}var c={};return b.m=a,b.c=c,b.p="",b(0)}([function(a,b,c){"use strict";function d(){var a=r();return a.compile=function(b,c){return k.compile(b,c,a)},a.precompile=function(b,c){return k.precompile(b,c,a)},a.AST=i["default"],a.Compiler=k.Compiler,a.JavaScriptCompiler=m["default"],a.Parser=j.parser,a.parse=j.parse,a.parseWithoutProcessing=j.parseWithoutProcessing,a}var e=c(1)["default"];b.__esModule=!0;var f=c(2),g=e(f),h=c(84),i=e(h),j=c(85),k=c(90),l=c(91),m=e(l),n=c(88),o=e(n),p=c(83),q=e(p),r=g["default"].create,s=d();s.create=d,q["default"](s),s.Visitor=o["default"],s["default"]=s,b["default"]=s,a.exports=b["default"]},function(a,b){"use strict";b["default"]=function(a){return a&&a.__esModule?a:{"default":a}},b.__esModule=!0},function(a,b,c){"use strict";function d(){var a=new h.HandlebarsEnvironment;return n.extend(a,h),a.SafeString=j["default"],a.Exception=l["default"],a.Utils=n,a.escapeExpression=n.escapeExpression,a.VM=p,a.template=function(b){return p.template(b,a)},a}var e=c(3)["default"],f=c(1)["default"];b.__esModule=!0;var g=c(4),h=e(g),i=c(77),j=f(i),k=c(6),l=f(k),m=c(5),n=e(m),o=c(78),p=e(o),q=c(83),r=f(q),s=d();s.create=d,r["default"](s),s["default"]=s,b["default"]=s,a.exports=b["default"]},function(a,b){"use strict";b["default"]=function(a){if(a&&a.__esModule)return a;var b={};if(null!=a)for(var c in a)Object.prototype.hasOwnProperty.call(a,c)&&(b[c]=a[c]);return b["default"]=a,b},b.__esModule=!0},function(a,b,c){"use strict";function d(a,b,c){this.helpers=a||{},this.partials=b||{},this.decorators=c||{},i.registerDefaultHelpers(this),j.registerDefaultDecorators(this)}var e=c(1)["default"];b.__esModule=!0,b.HandlebarsEnvironment=d;var f=c(5),g=c(6),h=e(g),i=c(10),j=c(70),k=c(72),l=e(k),m=c(73),n="4.7.8";b.VERSION=n;var o=8;b.COMPILER_REVISION=o;var p=7;b.LAST_COMPATIBLE_COMPILER_REVISION=p;var q={1:"<= 1.0.rc.2",2:"== 1.0.0-rc.3",3:"== 1.0.0-rc.4",4:"== 1.x.x",5:"== 2.0.0-alpha.x",6:">= 2.0.0-beta.1",7:">= 4.0.0 <4.3.0",8:">= 4.3.0"};b.REVISION_CHANGES=q;var r="[object Object]";d.prototype={constructor:d,logger:l["default"],log:l["default"].log,registerHelper:function(a,b){if(f.toString.call(a)===r){if(b)throw new h["default"]("Arg not supported with multiple helpers");f.extend(this.helpers,a)}else this.helpers[a]=b},unregisterHelper:function(a){delete this.helpers[a]},registerPartial:function(a,b){if(f.toString.call(a)===r)f.extend(this.partials,a);else{if("undefined"==typeof b)throw new h["default"]('Attempting to register a partial called "'+a+'" as undefined');this.partials[a]=b}},unregisterPartial:function(a){delete this.partials[a]},registerDecorator:function(a,b){if(f.toString.call(a)===r){if(b)throw new h["default"]("Arg not supported with multiple decorators");f.extend(this.decorators,a)}else this.decorators[a]=b},unregisterDecorator:function(a){delete this.decorators[a]},resetLoggedPropertyAccesses:function(){m.resetLoggedProperties()}};var s=l["default"].log;b.log=s,b.createFrame=f.createFrame,b.logger=l["default"]},function(a,b){"use strict";function c(a){return k[a]}function d(a){for(var b=1;b<arguments.length;b++)for(var c in arguments[b])Object.prototype.hasOwnProperty.call(arguments[b],c)&&(a[c]=arguments[b][c]);return a}function e(a,b){for(var c=0,d=a.length;c<d;c++)if(a[c]===b)return c;return-1}function f(a){if("string"!=typeof a){if(a&&a.toHTML)return a.toHTML();if(null==a)return"";if(!a)return a+"";a=""+a}return m.test(a)?a.replace(l,c):a}function g(a){return!a&&0!==a||!(!p(a)||0!==a.length)}function h(a){var b=d({},a);return b._parent=a,b}function i(a,b){return a.path=b,a}function j(a,b){return(a?a+".":"")+b}b.__esModule=!0,b.extend=d,b.indexOf=e,b.escapeExpression=f,b.isEmpty=g,b.createFrame=h,b.blockParams=i,b.appendContextPath=j;var k={"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#x27;","`":"&#x60;","=":"&#x3D;"},l=/[&<>"'`=]/g,m=/[&<>"'`=]/,n=Object.prototype.toString;b.toString=n;var o=function(a){return"function"==typeof a};o(/x/)&&(b.isFunction=o=function(a){return"function"==typeof a&&"[object Function]"===n.call(a)}),b.isFunction=o;var p=Array.isArray||function(a){return!(!a||"object"!=typeof a)&&"[object Array]"===n.call(a)};b.isArray=p},function(a,b,c){"use strict";function d(a,b){var c=b&&b.loc,g=void 0,h=void 0,i=void 0,j=void 0;c&&(g=c.start.line,h=c.end.line,i=c.start.column,j=c.end.column,a+=" - "+g+":"+i);for(var k=Error.prototype.constructor.call(this,a),l=0;l<f.length;l++)this[f[l]]=k[f[l]];Error.captureStackTrace&&Error.captureStackTrace(this,d);try{c&&(this.lineNumber=g,this.endLineNumber=h,e?(Object.defineProperty(this,"column",{value:i,enumerable:!0}),Object.defineProperty(this,"endColumn",{value:j,enumerable:!0})):(this.column=i,this.endColumn=j))}catch(m){}}var e=c(7)["default"];b.__esModule=!0;var f=["description","fileName","lineNumber","endLineNumber","message","name","number","stack"];d.prototype=new Error,b["default"]=d,a.exports=b["default"]},function(a,b,c){a.exports={"default":c(8),__esModule:!0}},function(a,b,c){var d=c(9);a.exports=function(a,b,c){return d.setDesc(a,b,c)}},function(a,b){var c=Object;a.exports={create:c.create,getProto:c.getPrototypeOf,isEnum:{}.propertyIsEnumerable,getDesc:c.getOwnPropertyDescriptor,setDesc:c.defineProperty,setDescs:c.defineProperties,getKeys:c.keys,getNames:c.getOwnPropertyNames,getSymbols:c.getOwnPropertySymbols,each:[].forEach}},function(a,b,c){"use strict";function d(a){h["default"](a),j["default"](a),l["default"](a),n["default"](a),p["default"](a),r["default"](a),t["default"](a)}function e(a,b,c){a.helpers[b]&&(a.hooks[b]=a.helpers[b],c||delete a.helpers[b])}var f=c(1)["default"];b.__esModule=!0,b.registerDefaultHelpers=d,b.moveHelperToHooks=e;var g=c(11),h=f(g),i=c(12),j=f(i),k=c(65),l=f(k),m=c(66),n=f(m),o=c(67),p=f(o),q=c(68),r=f(q),s=c(69),t=f(s)},function(a,b,c){"use strict";b.__esModule=!0;var d=c(5);b["default"]=function(a){a.registerHelper("blockHelperMissing",function(b,c){var e=c.inverse,f=c.fn;if(b===!0)return f(this);if(b===!1||null==b)return e(this);if(d.isArray(b))return b.length>0?(c.ids&&(c.ids=[c.name]),a.helpers.each(b,c)):e(this);if(c.data&&c.ids){var g=d.createFrame(c.data);g.contextPath=d.appendContextPath(c.data.contextPath,c.name),c={data:g}}return f(b,c)})},a.exports=b["default"]},function(a,b,c){"use strict";var d=c(13)["default"],e=c(43)["default"],f=c(55)["default"],g=c(60)["default"],h=c(1)["default"];b.__esModule=!0;var i=c(5),j=c(6),k=h(j);b["default"]=function(a){a.registerHelper("each",function(a,b){function c(b,c,d){n&&(n.key=b,n.index=c,n.first=0===c,n.last=!!d,o&&(n.contextPath=o+b)),m+=h(a[b],{data:n,blockParams:i.blockParams([a[b],b],[o+b,null])})}if(!b)throw new k["default"]("Must pass iterator to #each");var h=b.fn,j=b.inverse,l=0,m="",n=void 0,o=void 0;if(b.data&&b.ids&&(o=i.appendContextPath(b.data.contextPath,b.ids[0])+"."),i.isFunction(a)&&(a=a.call(this)),b.data&&(n=i.createFrame(b.data)),a&&"object"==typeof a)if(i.isArray(a))for(var p=a.length;l<p;l++)l in a&&c(l,l,l===a.length-1);else if("function"==typeof d&&a[e]){for(var q=[],r=f(a),s=r.next();!s.done;s=r.next())q.push(s.value);a=q;for(var p=a.length;l<p;l++)c(l,l,l===a.length-1)}else!function(){var b=void 0;g(a).forEach(function(a){void 0!==b&&c(b,l-1),b=a,l++}),void 0!==b&&c(b,l-1,!0)}();return 0===l&&(m=j(this)),m})},a.exports=b["default"]},function(a,b,c){a.exports={"default":c(14),__esModule:!0}},function(a,b,c){c(15),c(42),a.exports=c(21).Symbol},function(a,b,c){"use strict";var d=c(9),e=c(16),f=c(17),g=c(18),h=c(20),i=c(24),j=c(19),k=c(27),l=c(28),m=c(30),n=c(29),o=c(31),p=c(36),q=c(37),r=c(38),s=c(39),t=c(32),u=c(26),v=d.getDesc,w=d.setDesc,x=d.create,y=p.get,z=e.Symbol,A=e.JSON,B=A&&A.stringify,C=!1,D=n("_hidden"),E=d.isEnum,F=k("symbol-registry"),G=k("symbols"),H="function"==typeof z,I=Object.prototype,J=g&&j(function(){return 7!=x(w({},"a",{get:function(){return w(this,"a",{value:7}).a}})).a})?function(a,b,c){var d=v(I,b);d&&delete I[b],w(a,b,c),d&&a!==I&&w(I,b,d)}:w,K=function(a){var b=G[a]=x(z.prototype);return b._k=a,g&&C&&J(I,a,{configurable:!0,set:function(b){f(this,D)&&f(this[D],a)&&(this[D][a]=!1),J(this,a,u(1,b))}}),b},L=function(a){return"symbol"==typeof a},M=function(a,b,c){return c&&f(G,b)?(c.enumerable?(f(a,D)&&a[D][b]&&(a[D][b]=!1),c=x(c,{enumerable:u(0,!1)})):(f(a,D)||w(a,D,u(1,{})),a[D][b]=!0),J(a,b,c)):w(a,b,c)},N=function(a,b){s(a);for(var c,d=q(b=t(b)),e=0,f=d.length;f>e;)M(a,c=d[e++],b[c]);return a},O=function(a,b){return void 0===b?x(a):N(x(a),b)},P=function(a){var b=E.call(this,a);return!(b||!f(this,a)||!f(G,a)||f(this,D)&&this[D][a])||b},Q=function(a,b){var c=v(a=t(a),b);return!c||!f(G,b)||f(a,D)&&a[D][b]||(c.enumerable=!0),c},R=function(a){for(var b,c=y(t(a)),d=[],e=0;c.length>e;)f(G,b=c[e++])||b==D||d.push(b);return d},S=function(a){for(var b,c=y(t(a)),d=[],e=0;c.length>e;)f(G,b=c[e++])&&d.push(G[b]);return d},T=function(a){if(void 0!==a&&!L(a)){for(var b,c,d=[a],e=1,f=arguments;f.length>e;)d.push(f[e++]);return b=d[1],"function"==typeof b&&(c=b),!c&&r(b)||(b=function(a,b){if(c&&(b=c.call(this,a,b)),!L(b))return b}),d[1]=b,B.apply(A,d)}},U=j(function(){var a=z();return"[null]"!=B([a])||"{}"!=B({a:a})||"{}"!=B(Object(a))});H||(z=function(){if(L(this))throw TypeError("Symbol is not a constructor");return K(m(arguments.length>0?arguments[0]:void 0))},i(z.prototype,"toString",function(){return this._k}),L=function(a){return a instanceof z},d.create=O,d.isEnum=P,d.getDesc=Q,d.setDesc=M,d.setDescs=N,d.getNames=p.get=R,d.getSymbols=S,g&&!c(41)&&i(I,"propertyIsEnumerable",P,!0));var V={"for":function(a){return f(F,a+="")?F[a]:F[a]=z(a)},keyFor:function(a){return o(F,a)},useSetter:function(){C=!0},useSimple:function(){C=!1}};d.each.call("hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","),function(a){var b=n(a);V[a]=H?b:K(b)}),C=!0,h(h.G+h.W,{Symbol:z}),h(h.S,"Symbol",V),h(h.S+h.F*!H,"Object",{create:O,defineProperty:M,defineProperties:N,getOwnPropertyDescriptor:Q,getOwnPropertyNames:R,getOwnPropertySymbols:S}),A&&h(h.S+h.F*(!H||U),"JSON",{stringify:T}),l(z,"Symbol"),l(Math,"Math",!0),l(e.JSON,"JSON",!0)},function(a,b){var c=a.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=c)},function(a,b){var c={}.hasOwnProperty;a.exports=function(a,b){return c.call(a,b)}},function(a,b,c){a.exports=!c(19)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(a,b){a.exports=function(a){try{return!!a()}catch(b){return!0}}},function(a,b,c){var d=c(16),e=c(21),f=c(22),g="prototype",h=function(a,b,c){var i,j,k,l=a&h.F,m=a&h.G,n=a&h.S,o=a&h.P,p=a&h.B,q=a&h.W,r=m?e:e[b]||(e[b]={}),s=m?d:n?d[b]:(d[b]||{})[g];m&&(c=b);for(i in c)j=!l&&s&&i in s,j&&i in r||(k=j?s[i]:c[i],r[i]=m&&"function"!=typeof s[i]?c[i]:p&&j?f(k,d):q&&s[i]==k?function(a){var b=function(b){return this instanceof a?new a(b):a(b)};return b[g]=a[g],b}(k):o&&"function"==typeof k?f(Function.call,k):k,o&&((r[g]||(r[g]={}))[i]=k))};h.F=1,h.G=2,h.S=4,h.P=8,h.B=16,h.W=32,a.exports=h},function(a,b){var c=a.exports={version:"1.2.6"};"number"==typeof __e&&(__e=c)},function(a,b,c){var d=c(23);a.exports=function(a,b,c){if(d(a),void 0===b)return a;switch(c){case 1:return function(c){return a.call(b,c)};case 2:return function(c,d){return a.call(b,c,d)};case 3:return function(c,d,e){return a.call(b,c,d,e)}}return function(){return a.apply(b,arguments)}}},function(a,b){a.exports=function(a){if("function"!=typeof a)throw TypeError(a+" is not a function!");return a}},function(a,b,c){a.exports=c(25)},function(a,b,c){var d=c(9),e=c(26);a.exports=c(18)?function(a,b,c){return d.setDesc(a,b,e(1,c))}:function(a,b,c){return a[b]=c,a}},function(a,b){a.exports=function(a,b){return{enumerable:!(1&a),configurable:!(2&a),writable:!(4&a),value:b}}},function(a,b,c){var d=c(16),e="__core-js_shared__",f=d[e]||(d[e]={});a.exports=function(a){return f[a]||(f[a]={})}},function(a,b,c){var d=c(9).setDesc,e=c(17),f=c(29)("toStringTag");a.exports=function(a,b,c){a&&!e(a=c?a:a.prototype,f)&&d(a,f,{configurable:!0,value:b})}},function(a,b,c){var d=c(27)("wks"),e=c(30),f=c(16).Symbol;a.exports=function(a){return d[a]||(d[a]=f&&f[a]||(f||e)("Symbol."+a))}},function(a,b){var c=0,d=Math.random();a.exports=function(a){return"Symbol(".concat(void 0===a?"":a,")_",(++c+d).toString(36))}},function(a,b,c){var d=c(9),e=c(32);a.exports=function(a,b){for(var c,f=e(a),g=d.getKeys(f),h=g.length,i=0;h>i;)if(f[c=g[i++]]===b)return c}},function(a,b,c){var d=c(33),e=c(35);a.exports=function(a){return d(e(a))}},function(a,b,c){var d=c(34);a.exports=Object("z").propertyIsEnumerable(0)?Object:function(a){return"String"==d(a)?a.split(""):Object(a)}},function(a,b){var c={}.toString;a.exports=function(a){return c.call(a).slice(8,-1)}},function(a,b){a.exports=function(a){if(void 0==a)throw TypeError("Can't call method on  "+a);return a}},function(a,b,c){var d=c(32),e=c(9).getNames,f={}.toString,g="object"==typeof window&&Object.getOwnPropertyNames?Object.getOwnPropertyNames(window):[],h=function(a){try{return e(a)}catch(b){return g.slice()}};a.exports.get=function(a){return g&&"[object Window]"==f.call(a)?h(a):e(d(a))}},function(a,b,c){var d=c(9);a.exports=function(a){var b=d.getKeys(a),c=d.getSymbols;if(c)for(var e,f=c(a),g=d.isEnum,h=0;f.length>h;)g.call(a,e=f[h++])&&b.push(e);return b}},function(a,b,c){var d=c(34);a.exports=Array.isArray||function(a){return"Array"==d(a)}},function(a,b,c){var d=c(40);a.exports=function(a){if(!d(a))throw TypeError(a+" is not an object!");return a}},function(a,b){a.exports=function(a){return"object"==typeof a?null!==a:"function"==typeof a}},function(a,b){a.exports=!0},function(a,b){},function(a,b,c){a.exports={"default":c(44),__esModule:!0}},function(a,b,c){c(45),c(51),a.exports=c(29)("iterator")},function(a,b,c){"use strict";var d=c(46)(!0);c(48)(String,"String",function(a){this._t=String(a),this._i=0},function(){var a,b=this._t,c=this._i;return c>=b.length?{value:void 0,done:!0}:(a=d(b,c),this._i+=a.length,{value:a,done:!1})})},function(a,b,c){var d=c(47),e=c(35);a.exports=function(a){return function(b,c){var f,g,h=String(e(b)),i=d(c),j=h.length;return i<0||i>=j?a?"":void 0:(f=h.charCodeAt(i),f<55296||f>56319||i+1===j||(g=h.charCodeAt(i+1))<56320||g>57343?a?h.charAt(i):f:a?h.slice(i,i+2):(f-55296<<10)+(g-56320)+65536)}}},function(a,b){var c=Math.ceil,d=Math.floor;a.exports=function(a){return isNaN(a=+a)?0:(a>0?d:c)(a)}},function(a,b,c){"use strict";var d=c(41),e=c(20),f=c(24),g=c(25),h=c(17),i=c(49),j=c(50),k=c(28),l=c(9).getProto,m=c(29)("iterator"),n=!([].keys&&"next"in[].keys()),o="@@iterator",p="keys",q="values",r=function(){return this};a.exports=function(a,b,c,s,t,u,v){j(c,b,s);var w,x,y=function(a){if(!n&&a in C)return C[a];switch(a){case p:return function(){return new c(this,a)};case q:return function(){return new c(this,a)}}return function(){return new c(this,a)}},z=b+" Iterator",A=t==q,B=!1,C=a.prototype,D=C[m]||C[o]||t&&C[t],E=D||y(t);if(D){var F=l(E.call(new a));k(F,z,!0),!d&&h(C,o)&&g(F,m,r),A&&D.name!==q&&(B=!0,E=function(){return D.call(this)})}if(d&&!v||!n&&!B&&C[m]||g(C,m,E),i[b]=E,i[z]=r,t)if(w={values:A?E:y(q),keys:u?E:y(p),entries:A?y("entries"):E},v)for(x in w)x in C||f(C,x,w[x]);else e(e.P+e.F*(n||B),b,w);return w}},function(a,b){a.exports={}},function(a,b,c){"use strict";var d=c(9),e=c(26),f=c(28),g={};c(25)(g,c(29)("iterator"),function(){return this}),a.exports=function(a,b,c){a.prototype=d.create(g,{next:e(1,c)}),f(a,b+" Iterator")}},function(a,b,c){c(52);var d=c(49);d.NodeList=d.HTMLCollection=d.Array},function(a,b,c){"use strict";var d=c(53),e=c(54),f=c(49),g=c(32);a.exports=c(48)(Array,"Array",function(a,b){this._t=g(a),this._i=0,this._k=b},function(){var a=this._t,b=this._k,c=this._i++;return!a||c>=a.length?(this._t=void 0,e(1)):"keys"==b?e(0,c):"values"==b?e(0,a[c]):e(0,[c,a[c]])},"values"),f.Arguments=f.Array,d("keys"),d("values"),d("entries")},function(a,b){a.exports=function(){}},function(a,b){a.exports=function(a,b){return{value:b,done:!!a}}},function(a,b,c){a.exports={"default":c(56),__esModule:!0}},function(a,b,c){c(51),c(45),a.exports=c(57)},function(a,b,c){var d=c(39),e=c(58);a.exports=c(21).getIterator=function(a){var b=e(a);if("function"!=typeof b)throw TypeError(a+" is not iterable!");return d(b.call(a))}},function(a,b,c){var d=c(59),e=c(29)("iterator"),f=c(49);a.exports=c(21).getIteratorMethod=function(a){if(void 0!=a)return a[e]||a["@@iterator"]||f[d(a)]}},function(a,b,c){var d=c(34),e=c(29)("toStringTag"),f="Arguments"==d(function(){return arguments}());a.exports=function(a){var b,c,g;return void 0===a?"Undefined":null===a?"Null":"string"==typeof(c=(b=Object(a))[e])?c:f?d(b):"Object"==(g=d(b))&&"function"==typeof b.callee?"Arguments":g}},function(a,b,c){a.exports={"default":c(61),__esModule:!0}},function(a,b,c){c(62),a.exports=c(21).Object.keys},function(a,b,c){var d=c(63);c(64)("keys",function(a){return function(b){return a(d(b))}})},function(a,b,c){var d=c(35);a.exports=function(a){return Object(d(a))}},function(a,b,c){var d=c(20),e=c(21),f=c(19);a.exports=function(a,b){var c=(e.Object||{})[a]||Object[a],g={};g[a]=b(c),d(d.S+d.F*f(function(){c(1)}),"Object",g)}},function(a,b,c){"use strict";var d=c(1)["default"];b.__esModule=!0;var e=c(6),f=d(e);b["default"]=function(a){a.registerHelper("helperMissing",function(){if(1!==arguments.length)throw new f["default"]('Missing helper: "'+arguments[arguments.length-1].name+'"')})},a.exports=b["default"]},function(a,b,c){"use strict";var d=c(1)["default"];b.__esModule=!0;var e=c(5),f=c(6),g=d(f);b["default"]=function(a){a.registerHelper("if",function(a,b){if(2!=arguments.length)throw new g["default"]("#if requires exactly one argument");return e.isFunction(a)&&(a=a.call(this)),!b.hash.includeZero&&!a||e.isEmpty(a)?b.inverse(this):b.fn(this)}),a.registerHelper("unless",function(b,c){if(2!=arguments.length)throw new g["default"]("#unless requires exactly one argument");return a.helpers["if"].call(this,b,{fn:c.inverse,inverse:c.fn,hash:c.hash})})},a.exports=b["default"]},function(a,b){"use strict";b.__esModule=!0,b["default"]=function(a){a.registerHelper("log",function(){for(var b=[void 0],c=arguments[arguments.length-1],d=0;d<arguments.length-1;d++)b.push(arguments[d]);var e=1;null!=c.hash.level?e=c.hash.level:c.data&&null!=c.data.level&&(e=c.data.level),b[0]=e,a.log.apply(a,b)})},a.exports=b["default"]},function(a,b){"use strict";b.__esModule=!0,b["default"]=function(a){a.registerHelper("lookup",function(a,b,c){return a?c.lookupProperty(a,b):a})},a.exports=b["default"]},function(a,b,c){"use strict";var d=c(1)["default"];b.__esModule=!0;var e=c(5),f=c(6),g=d(f);b["default"]=function(a){a.registerHelper("with",function(a,b){if(2!=arguments.length)throw new g["default"]("#with requires exactly one argument");e.isFunction(a)&&(a=a.call(this));var c=b.fn;if(e.isEmpty(a))return b.inverse(this);var d=b.data;return b.data&&b.ids&&(d=e.createFrame(b.data),d.contextPath=e.appendContextPath(b.data.contextPath,b.ids[0])),c(a,{data:d,blockParams:e.blockParams([a],[d&&d.contextPath])})})},a.exports=b["default"]},function(a,b,c){"use strict";function d(a){g["default"](a)}var e=c(1)["default"];b.__esModule=!0,b.registerDefaultDecorators=d;var f=c(71),g=e(f)},function(a,b,c){"use strict";b.__esModule=!0;var d=c(5);b["default"]=function(a){a.registerDecorator("inline",function(a,b,c,e){var f=a;return b.partials||(b.partials={},f=function(e,f){var g=c.partials;c.partials=d.extend({},g,b.partials);var h=a(e,f);return c.partials=g,h}),b.partials[e.args[0]]=e.fn,f})},a.exports=b["default"]},function(a,b,c){"use strict";b.__esModule=!0;var d=c(5),e={methodMap:["debug","info","warn","error"],level:"info",lookupLevel:function(a){if("string"==typeof a){var b=d.indexOf(e.methodMap,a.toLowerCase());a=b>=0?b:parseInt(a,10)}return a},log:function(a){if(a=e.lookupLevel(a),"undefined"!=typeof console&&e.lookupLevel(e.level)<=a){var b=e.methodMap[a];console[b]||(b="log");for(var c=arguments.length,d=Array(c>1?c-1:0),f=1;f<c;f++)d[f-1]=arguments[f];console[b].apply(console,d)}}};b["default"]=e,a.exports=b["default"]},function(a,b,c){"use strict";function d(a){var b=i(null);b.constructor=!1,b.__defineGetter__=!1,b.__defineSetter__=!1,b.__lookupGetter__=!1;var c=i(null);return c.__proto__=!1,{properties:{whitelist:l.createNewLookupObject(c,a.allowedProtoProperties),defaultValue:a.allowProtoPropertiesByDefault},methods:{whitelist:l.createNewLookupObject(b,a.allowedProtoMethods),defaultValue:a.allowProtoMethodsByDefault}}}function e(a,b,c){return"function"==typeof a?f(b.methods,c):f(b.properties,c)}function f(a,b){return void 0!==a.whitelist[b]?a.whitelist[b]===!0:void 0!==a.defaultValue?a.defaultValue:(g(b),!1)}function g(a){o[a]!==!0&&(o[a]=!0,n["default"].log("error",'Handlebars: Access has been denied to resolve the property "'+a+'" because it is not an "own property" of its parent.\nYou can add a runtime option to disable the check or this warning:\nSee https://handlebarsjs.com/api-reference/runtime-options.html#options-to-control-prototype-access for details'))}function h(){j(o).forEach(function(a){delete o[a]})}var i=c(74)["default"],j=c(60)["default"],k=c(1)["default"];b.__esModule=!0,b.createProtoAccessControl=d,b.resultIsAllowed=e,b.resetLoggedProperties=h;var l=c(76),m=c(72),n=k(m),o=i(null)},function(a,b,c){a.exports={"default":c(75),__esModule:!0}},function(a,b,c){var d=c(9);a.exports=function(a,b){return d.create(a,b)}},function(a,b,c){"use strict";function d(){for(var a=arguments.length,b=Array(a),c=0;c<a;c++)b[c]=arguments[c];return f.extend.apply(void 0,[e(null)].concat(b))}var e=c(74)["default"];b.__esModule=!0,b.createNewLookupObject=d;var f=c(5)},function(a,b){"use strict";function c(a){this.string=a}b.__esModule=!0,c.prototype.toString=c.prototype.toHTML=function(){return""+this.string},b["default"]=c,a.exports=b["default"]},function(a,b,c){"use strict";function d(a){var b=a&&a[0]||1,c=v.COMPILER_REVISION;if(!(b>=v.LAST_COMPATIBLE_COMPILER_REVISION&&b<=v.COMPILER_REVISION)){if(b<v.LAST_COMPATIBLE_COMPILER_REVISION){var d=v.REVISION_CHANGES[c],e=v.REVISION_CHANGES[b];throw new u["default"]("Template was precompiled with an older version of Handlebars than the current runtime. Please update your precompiler to a newer version ("+d+") or downgrade your runtime to an older version ("+e+").")}throw new u["default"]("Template was precompiled with a newer version of Handlebars than the current runtime. Please update your runtime to a newer version ("+a[1]+").")}}function e(a,b){function c(c,d,e){e.hash&&(d=s.extend({},d,e.hash),e.ids&&(e.ids[0]=!0)),c=b.VM.resolvePartial.call(this,c,d,e);var f=s.extend({},e,{hooks:this.hooks,protoAccessControl:this.protoAccessControl}),g=b.VM.invokePartial.call(this,c,d,f);if(null==g&&b.compile&&(e.partials[e.name]=b.compile(c,a.compilerOptions,b),g=e.partials[e.name](d,f)),null!=g){if(e.indent){for(var h=g.split("\n"),i=0,j=h.length;i<j&&(h[i]||i+1!==j);i++)h[i]=e.indent+h[i];g=h.join("\n")}return g}throw new u["default"]("The partial "+e.name+" could not be compiled when running in runtime-only mode")}function d(b){function c(b){return""+a.main(g,b,g.helpers,g.partials,f,i,h)}var e=arguments.length<=1||void 0===arguments[1]?{}:arguments[1],f=e.data;d._setup(e),!e.partial&&a.useData&&(f=j(b,f));var h=void 0,i=a.useBlockParams?[]:void 0;return a.useDepths&&(h=e.depths?b!=e.depths[0]?[b].concat(e.depths):e.depths:[b]),(c=k(a.main,c,g,e.depths||[],f,i))(b,e)}if(!b)throw new u["default"]("No environment passed to template");if(!a||!a.main)throw new u["default"]("Unknown template object: "+typeof a);a.main.decorator=a.main_d,b.VM.checkRevision(a.compiler);var e=a.compiler&&7===a.compiler[0],g={strict:function(a,b,c){if(!(a&&b in a))throw new u["default"]('"'+b+'" not defined in '+a,{loc:c});return g.lookupProperty(a,b)},lookupProperty:function(a,b){var c=a[b];return null==c?c:Object.prototype.hasOwnProperty.call(a,b)?c:y.resultIsAllowed(c,g.protoAccessControl,b)?c:void 0},lookup:function(a,b){for(var c=a.length,d=0;d<c;d++){var e=a[d]&&g.lookupProperty(a[d],b);if(null!=e)return a[d][b]}},lambda:function(a,b){return"function"==typeof a?a.call(b):a},escapeExpression:s.escapeExpression,invokePartial:c,fn:function(b){var c=a[b];return c.decorator=a[b+"_d"],c},programs:[],program:function(a,b,c,d,e){var g=this.programs[a],h=this.fn(a);return b||e||d||c?g=f(this,a,h,b,c,d,e):g||(g=this.programs[a]=f(this,a,h)),g},data:function(a,b){for(;a&&b--;)a=a._parent;return a},mergeIfNeeded:function(a,b){var c=a||b;return a&&b&&a!==b&&(c=s.extend({},b,a)),c},nullContext:n({}),noop:b.VM.noop,compilerInfo:a.compiler};return d.isTop=!0,d._setup=function(c){if(c.partial)g.protoAccessControl=c.protoAccessControl,g.helpers=c.helpers,g.partials=c.partials,g.decorators=c.decorators,g.hooks=c.hooks;else{var d=s.extend({},b.helpers,c.helpers);l(d,g),g.helpers=d,a.usePartial&&(g.partials=g.mergeIfNeeded(c.partials,b.partials)),(a.usePartial||a.useDecorators)&&(g.decorators=s.extend({},b.decorators,c.decorators)),g.hooks={},g.protoAccessControl=y.createProtoAccessControl(c);var f=c.allowCallsToHelperMissing||e;w.moveHelperToHooks(g,"helperMissing",f),w.moveHelperToHooks(g,"blockHelperMissing",f)}},d._child=function(b,c,d,e){if(a.useBlockParams&&!d)throw new u["default"]("must pass block params");if(a.useDepths&&!e)throw new u["default"]("must pass parent depths");return f(g,b,a[b],c,0,d,e)},d}function f(a,b,c,d,e,f,g){function h(b){var e=arguments.length<=1||void 0===arguments[1]?{}:arguments[1],h=g;return!g||b==g[0]||b===a.nullContext&&null===g[0]||(h=[b].concat(g)),c(a,b,a.helpers,a.partials,e.data||d,f&&[e.blockParams].concat(f),h)}return h=k(c,h,a,g,d,f),h.program=b,h.depth=g?g.length:0,h.blockParams=e||0,h}function g(a,b,c){return a?a.call||c.name||(c.name=a,a=c.partials[a]):a="@partial-block"===c.name?c.data["partial-block"]:c.partials[c.name],a}function h(a,b,c){var d=c.data&&c.data["partial-block"];c.partial=!0,c.ids&&(c.data.contextPath=c.ids[0]||c.data.contextPath);var e=void 0;if(c.fn&&c.fn!==i&&!function(){c.data=v.createFrame(c.data);var a=c.fn;e=c.data["partial-block"]=function(b){var c=arguments.length<=1||void 0===arguments[1]?{}:arguments[1];return c.data=v.createFrame(c.data),c.data["partial-block"]=d,a(b,c)},a.partials&&(c.partials=s.extend({},c.partials,a.partials))}(),void 0===a&&e&&(a=e),void 0===a)throw new u["default"]("The partial "+c.name+" could not be found");if(a instanceof Function)return a(b,c)}function i(){return""}function j(a,b){return b&&"root"in b||(b=b?v.createFrame(b):{},b.root=a),b}function k(a,b,c,d,e,f){if(a.decorator){var g={};b=a.decorator(b,g,c,d&&d[0],e,f,d),s.extend(b,g)}return b}function l(a,b){o(a).forEach(function(c){var d=a[c];a[c]=m(d,b)})}function m(a,b){var c=b.lookupProperty;return x.wrapHelper(a,function(a){return s.extend({lookupProperty:c},a)})}var n=c(79)["default"],o=c(60)["default"],p=c(3)["default"],q=c(1)["default"];b.__esModule=!0,b.checkRevision=d,b.template=e,b.wrapProgram=f,b.resolvePartial=g,b.invokePartial=h,b.noop=i;var r=c(5),s=p(r),t=c(6),u=q(t),v=c(4),w=c(10),x=c(82),y=c(73)},function(a,b,c){a.exports={"default":c(80),__esModule:!0}},function(a,b,c){c(81),a.exports=c(21).Object.seal},function(a,b,c){var d=c(40);c(64)("seal",function(a){return function(b){return a&&d(b)?a(b):b}})},function(a,b){"use strict";function c(a,b){if("function"!=typeof a)return a;var c=function(){var c=arguments[arguments.length-1];return arguments[arguments.length-1]=b(c),a.apply(this,arguments)};return c}b.__esModule=!0,b.wrapHelper=c},function(a,b){"use strict";b.__esModule=!0,b["default"]=function(a){!function(){"object"!=typeof globalThis&&(Object.prototype.__defineGetter__("__magic__",function(){return this}),__magic__.globalThis=__magic__,delete Object.prototype.__magic__)}();var b=globalThis.Handlebars;a.noConflict=function(){return globalThis.Handlebars===a&&(globalThis.Handlebars=b),a}},a.exports=b["default"]},function(a,b){"use strict";b.__esModule=!0;var c={helpers:{helperExpression:function(a){return"SubExpression"===a.type||("MustacheStatement"===a.type||"BlockStatement"===a.type)&&!!(a.params&&a.params.length||a.hash)},scopedId:function(a){return/^\.|this\b/.test(a.original)},simpleId:function(a){return 1===a.parts.length&&!c.helpers.scopedId(a)&&!a.depth}}};b["default"]=c,a.exports=b["default"]},function(a,b,c){"use strict";function d(a,b){if("Program"===a.type)return a;i["default"].yy=o,o.locInfo=function(a){return new o.SourceLocation(b&&b.srcName,a)};var c=i["default"].parse(a);return c}function e(a,b){var c=d(a,b),e=new k["default"](b);return e.accept(c)}var f=c(1)["default"],g=c(3)["default"];b.__esModule=!0,b.parseWithoutProcessing=d,b.parse=e;var h=c(86),i=f(h),j=c(87),k=f(j),l=c(89),m=g(l),n=c(5);b.parser=i["default"];var o={};n.extend(o,m)},function(a,b){"use strict";b.__esModule=!0;var c=function(){function a(){this.yy={}}var b={trace:function(){},yy:{},symbols_:{error:2,root:3,program:4,EOF:5,program_repetition0:6,statement:7,mustache:8,block:9,rawBlock:10,partial:11,partialBlock:12,content:13,COMMENT:14,CONTENT:15,openRawBlock:16,rawBlock_repetition0:17,END_RAW_BLOCK:18,OPEN_RAW_BLOCK:19,helperName:20,openRawBlock_repetition0:21,openRawBlock_option0:22,CLOSE_RAW_BLOCK:23,openBlock:24,block_option0:25,closeBlock:26,openInverse:27,block_option1:28,OPEN_BLOCK:29,openBlock_repetition0:30,openBlock_option0:31,openBlock_option1:32,CLOSE:33,OPEN_INVERSE:34,openInverse_repetition0:35,openInverse_option0:36,openInverse_option1:37,openInverseChain:38,OPEN_INVERSE_CHAIN:39,openInverseChain_repetition0:40,openInverseChain_option0:41,openInverseChain_option1:42,inverseAndProgram:43,INVERSE:44,inverseChain:45,inverseChain_option0:46,OPEN_ENDBLOCK:47,OPEN:48,mustache_repetition0:49,mustache_option0:50,OPEN_UNESCAPED:51,mustache_repetition1:52,mustache_option1:53,CLOSE_UNESCAPED:54,OPEN_PARTIAL:55,partialName:56,partial_repetition0:57,partial_option0:58,openPartialBlock:59,OPEN_PARTIAL_BLOCK:60,openPartialBlock_repetition0:61,openPartialBlock_option0:62,param:63,sexpr:64,OPEN_SEXPR:65,sexpr_repetition0:66,sexpr_option0:67,CLOSE_SEXPR:68,hash:69,hash_repetition_plus0:70,hashSegment:71,ID:72,EQUALS:73,blockParams:74,OPEN_BLOCK_PARAMS:75,blockParams_repetition_plus0:76,CLOSE_BLOCK_PARAMS:77,path:78,dataName:79,STRING:80,NUMBER:81,BOOLEAN:82,UNDEFINED:83,NULL:84,DATA:85,pathSegments:86,SEP:87,$accept:0,$end:1},terminals_:{2:"error",5:"EOF",14:"COMMENT",15:"CONTENT",18:"END_RAW_BLOCK",19:"OPEN_RAW_BLOCK",23:"CLOSE_RAW_BLOCK",29:"OPEN_BLOCK",33:"CLOSE",34:"OPEN_INVERSE",39:"OPEN_INVERSE_CHAIN",44:"INVERSE",47:"OPEN_ENDBLOCK",48:"OPEN",51:"OPEN_UNESCAPED",54:"CLOSE_UNESCAPED",55:"OPEN_PARTIAL",60:"OPEN_PARTIAL_BLOCK",65:"OPEN_SEXPR",68:"CLOSE_SEXPR",72:"ID",73:"EQUALS",75:"OPEN_BLOCK_PARAMS",77:"CLOSE_BLOCK_PARAMS",80:"STRING",81:"NUMBER",82:"BOOLEAN",83:"UNDEFINED",84:"NULL",85:"DATA",87:"SEP"},productions_:[0,[3,2],[4,1],[7,1],[7,1],[7,1],[7,1],[7,1],[7,1],[7,1],[13,1],[10,3],[16,5],[9,4],[9,4],[24,6],[27,6],[38,6],[43,2],[45,3],[45,1],[26,3],[8,5],[8,5],[11,5],[12,3],[59,5],[63,1],[63,1],[64,5],[69,1],[71,3],[74,3],[20,1],[20,1],[20,1],[20,1],[20,1],[20,1],[20,1],[56,1],[56,1],[79,2],[78,1],[86,3],[86,1],[6,0],[6,2],[17,0],[17,2],[21,0],[21,2],[22,0],[22,1],[25,0],[25,1],[28,0],[28,1],[30,0],[30,2],[31,0],[31,1],[32,0],[32,1],[35,0],[35,2],[36,0],[36,1],[37,0],[37,1],[40,0],[40,2],[41,0],[41,1],[42,0],[42,1],[46,0],[46,1],[49,0],[49,2],[50,0],[50,1],[52,0],[52,2],[53,0],[53,1],[57,0],[57,2],[58,0],[58,1],[61,0],[61,2],[62,0],[62,1],[66,0],[66,2],[67,0],[67,1],[70,1],[70,2],[76,1],[76,2]],performAction:function(a,b,c,d,e,f,g){
var h=f.length-1;switch(e){case 1:return f[h-1];case 2:this.$=d.prepareProgram(f[h]);break;case 3:this.$=f[h];break;case 4:this.$=f[h];break;case 5:this.$=f[h];break;case 6:this.$=f[h];break;case 7:this.$=f[h];break;case 8:this.$=f[h];break;case 9:this.$={type:"CommentStatement",value:d.stripComment(f[h]),strip:d.stripFlags(f[h],f[h]),loc:d.locInfo(this._$)};break;case 10:this.$={type:"ContentStatement",original:f[h],value:f[h],loc:d.locInfo(this._$)};break;case 11:this.$=d.prepareRawBlock(f[h-2],f[h-1],f[h],this._$);break;case 12:this.$={path:f[h-3],params:f[h-2],hash:f[h-1]};break;case 13:this.$=d.prepareBlock(f[h-3],f[h-2],f[h-1],f[h],!1,this._$);break;case 14:this.$=d.prepareBlock(f[h-3],f[h-2],f[h-1],f[h],!0,this._$);break;case 15:this.$={open:f[h-5],path:f[h-4],params:f[h-3],hash:f[h-2],blockParams:f[h-1],strip:d.stripFlags(f[h-5],f[h])};break;case 16:this.$={path:f[h-4],params:f[h-3],hash:f[h-2],blockParams:f[h-1],strip:d.stripFlags(f[h-5],f[h])};break;case 17:this.$={path:f[h-4],params:f[h-3],hash:f[h-2],blockParams:f[h-1],strip:d.stripFlags(f[h-5],f[h])};break;case 18:this.$={strip:d.stripFlags(f[h-1],f[h-1]),program:f[h]};break;case 19:var i=d.prepareBlock(f[h-2],f[h-1],f[h],f[h],!1,this._$),j=d.prepareProgram([i],f[h-1].loc);j.chained=!0,this.$={strip:f[h-2].strip,program:j,chain:!0};break;case 20:this.$=f[h];break;case 21:this.$={path:f[h-1],strip:d.stripFlags(f[h-2],f[h])};break;case 22:this.$=d.prepareMustache(f[h-3],f[h-2],f[h-1],f[h-4],d.stripFlags(f[h-4],f[h]),this._$);break;case 23:this.$=d.prepareMustache(f[h-3],f[h-2],f[h-1],f[h-4],d.stripFlags(f[h-4],f[h]),this._$);break;case 24:this.$={type:"PartialStatement",name:f[h-3],params:f[h-2],hash:f[h-1],indent:"",strip:d.stripFlags(f[h-4],f[h]),loc:d.locInfo(this._$)};break;case 25:this.$=d.preparePartialBlock(f[h-2],f[h-1],f[h],this._$);break;case 26:this.$={path:f[h-3],params:f[h-2],hash:f[h-1],strip:d.stripFlags(f[h-4],f[h])};break;case 27:this.$=f[h];break;case 28:this.$=f[h];break;case 29:this.$={type:"SubExpression",path:f[h-3],params:f[h-2],hash:f[h-1],loc:d.locInfo(this._$)};break;case 30:this.$={type:"Hash",pairs:f[h],loc:d.locInfo(this._$)};break;case 31:this.$={type:"HashPair",key:d.id(f[h-2]),value:f[h],loc:d.locInfo(this._$)};break;case 32:this.$=d.id(f[h-1]);break;case 33:this.$=f[h];break;case 34:this.$=f[h];break;case 35:this.$={type:"StringLiteral",value:f[h],original:f[h],loc:d.locInfo(this._$)};break;case 36:this.$={type:"NumberLiteral",value:Number(f[h]),original:Number(f[h]),loc:d.locInfo(this._$)};break;case 37:this.$={type:"BooleanLiteral",value:"true"===f[h],original:"true"===f[h],loc:d.locInfo(this._$)};break;case 38:this.$={type:"UndefinedLiteral",original:void 0,value:void 0,loc:d.locInfo(this._$)};break;case 39:this.$={type:"NullLiteral",original:null,value:null,loc:d.locInfo(this._$)};break;case 40:this.$=f[h];break;case 41:this.$=f[h];break;case 42:this.$=d.preparePath(!0,f[h],this._$);break;case 43:this.$=d.preparePath(!1,f[h],this._$);break;case 44:f[h-2].push({part:d.id(f[h]),original:f[h],separator:f[h-1]}),this.$=f[h-2];break;case 45:this.$=[{part:d.id(f[h]),original:f[h]}];break;case 46:this.$=[];break;case 47:f[h-1].push(f[h]);break;case 48:this.$=[];break;case 49:f[h-1].push(f[h]);break;case 50:this.$=[];break;case 51:f[h-1].push(f[h]);break;case 58:this.$=[];break;case 59:f[h-1].push(f[h]);break;case 64:this.$=[];break;case 65:f[h-1].push(f[h]);break;case 70:this.$=[];break;case 71:f[h-1].push(f[h]);break;case 78:this.$=[];break;case 79:f[h-1].push(f[h]);break;case 82:this.$=[];break;case 83:f[h-1].push(f[h]);break;case 86:this.$=[];break;case 87:f[h-1].push(f[h]);break;case 90:this.$=[];break;case 91:f[h-1].push(f[h]);break;case 94:this.$=[];break;case 95:f[h-1].push(f[h]);break;case 98:this.$=[f[h]];break;case 99:f[h-1].push(f[h]);break;case 100:this.$=[f[h]];break;case 101:f[h-1].push(f[h])}},table:[{3:1,4:2,5:[2,46],6:3,14:[2,46],15:[2,46],19:[2,46],29:[2,46],34:[2,46],48:[2,46],51:[2,46],55:[2,46],60:[2,46]},{1:[3]},{5:[1,4]},{5:[2,2],7:5,8:6,9:7,10:8,11:9,12:10,13:11,14:[1,12],15:[1,20],16:17,19:[1,23],24:15,27:16,29:[1,21],34:[1,22],39:[2,2],44:[2,2],47:[2,2],48:[1,13],51:[1,14],55:[1,18],59:19,60:[1,24]},{1:[2,1]},{5:[2,47],14:[2,47],15:[2,47],19:[2,47],29:[2,47],34:[2,47],39:[2,47],44:[2,47],47:[2,47],48:[2,47],51:[2,47],55:[2,47],60:[2,47]},{5:[2,3],14:[2,3],15:[2,3],19:[2,3],29:[2,3],34:[2,3],39:[2,3],44:[2,3],47:[2,3],48:[2,3],51:[2,3],55:[2,3],60:[2,3]},{5:[2,4],14:[2,4],15:[2,4],19:[2,4],29:[2,4],34:[2,4],39:[2,4],44:[2,4],47:[2,4],48:[2,4],51:[2,4],55:[2,4],60:[2,4]},{5:[2,5],14:[2,5],15:[2,5],19:[2,5],29:[2,5],34:[2,5],39:[2,5],44:[2,5],47:[2,5],48:[2,5],51:[2,5],55:[2,5],60:[2,5]},{5:[2,6],14:[2,6],15:[2,6],19:[2,6],29:[2,6],34:[2,6],39:[2,6],44:[2,6],47:[2,6],48:[2,6],51:[2,6],55:[2,6],60:[2,6]},{5:[2,7],14:[2,7],15:[2,7],19:[2,7],29:[2,7],34:[2,7],39:[2,7],44:[2,7],47:[2,7],48:[2,7],51:[2,7],55:[2,7],60:[2,7]},{5:[2,8],14:[2,8],15:[2,8],19:[2,8],29:[2,8],34:[2,8],39:[2,8],44:[2,8],47:[2,8],48:[2,8],51:[2,8],55:[2,8],60:[2,8]},{5:[2,9],14:[2,9],15:[2,9],19:[2,9],29:[2,9],34:[2,9],39:[2,9],44:[2,9],47:[2,9],48:[2,9],51:[2,9],55:[2,9],60:[2,9]},{20:25,72:[1,35],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{20:36,72:[1,35],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{4:37,6:3,14:[2,46],15:[2,46],19:[2,46],29:[2,46],34:[2,46],39:[2,46],44:[2,46],47:[2,46],48:[2,46],51:[2,46],55:[2,46],60:[2,46]},{4:38,6:3,14:[2,46],15:[2,46],19:[2,46],29:[2,46],34:[2,46],44:[2,46],47:[2,46],48:[2,46],51:[2,46],55:[2,46],60:[2,46]},{15:[2,48],17:39,18:[2,48]},{20:41,56:40,64:42,65:[1,43],72:[1,35],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{4:44,6:3,14:[2,46],15:[2,46],19:[2,46],29:[2,46],34:[2,46],47:[2,46],48:[2,46],51:[2,46],55:[2,46],60:[2,46]},{5:[2,10],14:[2,10],15:[2,10],18:[2,10],19:[2,10],29:[2,10],34:[2,10],39:[2,10],44:[2,10],47:[2,10],48:[2,10],51:[2,10],55:[2,10],60:[2,10]},{20:45,72:[1,35],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{20:46,72:[1,35],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{20:47,72:[1,35],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{20:41,56:48,64:42,65:[1,43],72:[1,35],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{33:[2,78],49:49,65:[2,78],72:[2,78],80:[2,78],81:[2,78],82:[2,78],83:[2,78],84:[2,78],85:[2,78]},{23:[2,33],33:[2,33],54:[2,33],65:[2,33],68:[2,33],72:[2,33],75:[2,33],80:[2,33],81:[2,33],82:[2,33],83:[2,33],84:[2,33],85:[2,33]},{23:[2,34],33:[2,34],54:[2,34],65:[2,34],68:[2,34],72:[2,34],75:[2,34],80:[2,34],81:[2,34],82:[2,34],83:[2,34],84:[2,34],85:[2,34]},{23:[2,35],33:[2,35],54:[2,35],65:[2,35],68:[2,35],72:[2,35],75:[2,35],80:[2,35],81:[2,35],82:[2,35],83:[2,35],84:[2,35],85:[2,35]},{23:[2,36],33:[2,36],54:[2,36],65:[2,36],68:[2,36],72:[2,36],75:[2,36],80:[2,36],81:[2,36],82:[2,36],83:[2,36],84:[2,36],85:[2,36]},{23:[2,37],33:[2,37],54:[2,37],65:[2,37],68:[2,37],72:[2,37],75:[2,37],80:[2,37],81:[2,37],82:[2,37],83:[2,37],84:[2,37],85:[2,37]},{23:[2,38],33:[2,38],54:[2,38],65:[2,38],68:[2,38],72:[2,38],75:[2,38],80:[2,38],81:[2,38],82:[2,38],83:[2,38],84:[2,38],85:[2,38]},{23:[2,39],33:[2,39],54:[2,39],65:[2,39],68:[2,39],72:[2,39],75:[2,39],80:[2,39],81:[2,39],82:[2,39],83:[2,39],84:[2,39],85:[2,39]},{23:[2,43],33:[2,43],54:[2,43],65:[2,43],68:[2,43],72:[2,43],75:[2,43],80:[2,43],81:[2,43],82:[2,43],83:[2,43],84:[2,43],85:[2,43],87:[1,50]},{72:[1,35],86:51},{23:[2,45],33:[2,45],54:[2,45],65:[2,45],68:[2,45],72:[2,45],75:[2,45],80:[2,45],81:[2,45],82:[2,45],83:[2,45],84:[2,45],85:[2,45],87:[2,45]},{52:52,54:[2,82],65:[2,82],72:[2,82],80:[2,82],81:[2,82],82:[2,82],83:[2,82],84:[2,82],85:[2,82]},{25:53,38:55,39:[1,57],43:56,44:[1,58],45:54,47:[2,54]},{28:59,43:60,44:[1,58],47:[2,56]},{13:62,15:[1,20],18:[1,61]},{33:[2,86],57:63,65:[2,86],72:[2,86],80:[2,86],81:[2,86],82:[2,86],83:[2,86],84:[2,86],85:[2,86]},{33:[2,40],65:[2,40],72:[2,40],80:[2,40],81:[2,40],82:[2,40],83:[2,40],84:[2,40],85:[2,40]},{33:[2,41],65:[2,41],72:[2,41],80:[2,41],81:[2,41],82:[2,41],83:[2,41],84:[2,41],85:[2,41]},{20:64,72:[1,35],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{26:65,47:[1,66]},{30:67,33:[2,58],65:[2,58],72:[2,58],75:[2,58],80:[2,58],81:[2,58],82:[2,58],83:[2,58],84:[2,58],85:[2,58]},{33:[2,64],35:68,65:[2,64],72:[2,64],75:[2,64],80:[2,64],81:[2,64],82:[2,64],83:[2,64],84:[2,64],85:[2,64]},{21:69,23:[2,50],65:[2,50],72:[2,50],80:[2,50],81:[2,50],82:[2,50],83:[2,50],84:[2,50],85:[2,50]},{33:[2,90],61:70,65:[2,90],72:[2,90],80:[2,90],81:[2,90],82:[2,90],83:[2,90],84:[2,90],85:[2,90]},{20:74,33:[2,80],50:71,63:72,64:75,65:[1,43],69:73,70:76,71:77,72:[1,78],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{72:[1,79]},{23:[2,42],33:[2,42],54:[2,42],65:[2,42],68:[2,42],72:[2,42],75:[2,42],80:[2,42],81:[2,42],82:[2,42],83:[2,42],84:[2,42],85:[2,42],87:[1,50]},{20:74,53:80,54:[2,84],63:81,64:75,65:[1,43],69:82,70:76,71:77,72:[1,78],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{26:83,47:[1,66]},{47:[2,55]},{4:84,6:3,14:[2,46],15:[2,46],19:[2,46],29:[2,46],34:[2,46],39:[2,46],44:[2,46],47:[2,46],48:[2,46],51:[2,46],55:[2,46],60:[2,46]},{47:[2,20]},{20:85,72:[1,35],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{4:86,6:3,14:[2,46],15:[2,46],19:[2,46],29:[2,46],34:[2,46],47:[2,46],48:[2,46],51:[2,46],55:[2,46],60:[2,46]},{26:87,47:[1,66]},{47:[2,57]},{5:[2,11],14:[2,11],15:[2,11],19:[2,11],29:[2,11],34:[2,11],39:[2,11],44:[2,11],47:[2,11],48:[2,11],51:[2,11],55:[2,11],60:[2,11]},{15:[2,49],18:[2,49]},{20:74,33:[2,88],58:88,63:89,64:75,65:[1,43],69:90,70:76,71:77,72:[1,78],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{65:[2,94],66:91,68:[2,94],72:[2,94],80:[2,94],81:[2,94],82:[2,94],83:[2,94],84:[2,94],85:[2,94]},{5:[2,25],14:[2,25],15:[2,25],19:[2,25],29:[2,25],34:[2,25],39:[2,25],44:[2,25],47:[2,25],48:[2,25],51:[2,25],55:[2,25],60:[2,25]},{20:92,72:[1,35],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{20:74,31:93,33:[2,60],63:94,64:75,65:[1,43],69:95,70:76,71:77,72:[1,78],75:[2,60],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{20:74,33:[2,66],36:96,63:97,64:75,65:[1,43],69:98,70:76,71:77,72:[1,78],75:[2,66],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{20:74,22:99,23:[2,52],63:100,64:75,65:[1,43],69:101,70:76,71:77,72:[1,78],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{20:74,33:[2,92],62:102,63:103,64:75,65:[1,43],69:104,70:76,71:77,72:[1,78],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{33:[1,105]},{33:[2,79],65:[2,79],72:[2,79],80:[2,79],81:[2,79],82:[2,79],83:[2,79],84:[2,79],85:[2,79]},{33:[2,81]},{23:[2,27],33:[2,27],54:[2,27],65:[2,27],68:[2,27],72:[2,27],75:[2,27],80:[2,27],81:[2,27],82:[2,27],83:[2,27],84:[2,27],85:[2,27]},{23:[2,28],33:[2,28],54:[2,28],65:[2,28],68:[2,28],72:[2,28],75:[2,28],80:[2,28],81:[2,28],82:[2,28],83:[2,28],84:[2,28],85:[2,28]},{23:[2,30],33:[2,30],54:[2,30],68:[2,30],71:106,72:[1,107],75:[2,30]},{23:[2,98],33:[2,98],54:[2,98],68:[2,98],72:[2,98],75:[2,98]},{23:[2,45],33:[2,45],54:[2,45],65:[2,45],68:[2,45],72:[2,45],73:[1,108],75:[2,45],80:[2,45],81:[2,45],82:[2,45],83:[2,45],84:[2,45],85:[2,45],87:[2,45]},{23:[2,44],33:[2,44],54:[2,44],65:[2,44],68:[2,44],72:[2,44],75:[2,44],80:[2,44],81:[2,44],82:[2,44],83:[2,44],84:[2,44],85:[2,44],87:[2,44]},{54:[1,109]},{54:[2,83],65:[2,83],72:[2,83],80:[2,83],81:[2,83],82:[2,83],83:[2,83],84:[2,83],85:[2,83]},{54:[2,85]},{5:[2,13],14:[2,13],15:[2,13],19:[2,13],29:[2,13],34:[2,13],39:[2,13],44:[2,13],47:[2,13],48:[2,13],51:[2,13],55:[2,13],60:[2,13]},{38:55,39:[1,57],43:56,44:[1,58],45:111,46:110,47:[2,76]},{33:[2,70],40:112,65:[2,70],72:[2,70],75:[2,70],80:[2,70],81:[2,70],82:[2,70],83:[2,70],84:[2,70],85:[2,70]},{47:[2,18]},{5:[2,14],14:[2,14],15:[2,14],19:[2,14],29:[2,14],34:[2,14],39:[2,14],44:[2,14],47:[2,14],48:[2,14],51:[2,14],55:[2,14],60:[2,14]},{33:[1,113]},{33:[2,87],65:[2,87],72:[2,87],80:[2,87],81:[2,87],82:[2,87],83:[2,87],84:[2,87],85:[2,87]},{33:[2,89]},{20:74,63:115,64:75,65:[1,43],67:114,68:[2,96],69:116,70:76,71:77,72:[1,78],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{33:[1,117]},{32:118,33:[2,62],74:119,75:[1,120]},{33:[2,59],65:[2,59],72:[2,59],75:[2,59],80:[2,59],81:[2,59],82:[2,59],83:[2,59],84:[2,59],85:[2,59]},{33:[2,61],75:[2,61]},{33:[2,68],37:121,74:122,75:[1,120]},{33:[2,65],65:[2,65],72:[2,65],75:[2,65],80:[2,65],81:[2,65],82:[2,65],83:[2,65],84:[2,65],85:[2,65]},{33:[2,67],75:[2,67]},{23:[1,123]},{23:[2,51],65:[2,51],72:[2,51],80:[2,51],81:[2,51],82:[2,51],83:[2,51],84:[2,51],85:[2,51]},{23:[2,53]},{33:[1,124]},{33:[2,91],65:[2,91],72:[2,91],80:[2,91],81:[2,91],82:[2,91],83:[2,91],84:[2,91],85:[2,91]},{33:[2,93]},{5:[2,22],14:[2,22],15:[2,22],19:[2,22],29:[2,22],34:[2,22],39:[2,22],44:[2,22],47:[2,22],48:[2,22],51:[2,22],55:[2,22],60:[2,22]},{23:[2,99],33:[2,99],54:[2,99],68:[2,99],72:[2,99],75:[2,99]},{73:[1,108]},{20:74,63:125,64:75,65:[1,43],72:[1,35],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{5:[2,23],14:[2,23],15:[2,23],19:[2,23],29:[2,23],34:[2,23],39:[2,23],44:[2,23],47:[2,23],48:[2,23],51:[2,23],55:[2,23],60:[2,23]},{47:[2,19]},{47:[2,77]},{20:74,33:[2,72],41:126,63:127,64:75,65:[1,43],69:128,70:76,71:77,72:[1,78],75:[2,72],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{5:[2,24],14:[2,24],15:[2,24],19:[2,24],29:[2,24],34:[2,24],39:[2,24],44:[2,24],47:[2,24],48:[2,24],51:[2,24],55:[2,24],60:[2,24]},{68:[1,129]},{65:[2,95],68:[2,95],72:[2,95],80:[2,95],81:[2,95],82:[2,95],83:[2,95],84:[2,95],85:[2,95]},{68:[2,97]},{5:[2,21],14:[2,21],15:[2,21],19:[2,21],29:[2,21],34:[2,21],39:[2,21],44:[2,21],47:[2,21],48:[2,21],51:[2,21],55:[2,21],60:[2,21]},{33:[1,130]},{33:[2,63]},{72:[1,132],76:131},{33:[1,133]},{33:[2,69]},{15:[2,12],18:[2,12]},{14:[2,26],15:[2,26],19:[2,26],29:[2,26],34:[2,26],47:[2,26],48:[2,26],51:[2,26],55:[2,26],60:[2,26]},{23:[2,31],33:[2,31],54:[2,31],68:[2,31],72:[2,31],75:[2,31]},{33:[2,74],42:134,74:135,75:[1,120]},{33:[2,71],65:[2,71],72:[2,71],75:[2,71],80:[2,71],81:[2,71],82:[2,71],83:[2,71],84:[2,71],85:[2,71]},{33:[2,73],75:[2,73]},{23:[2,29],33:[2,29],54:[2,29],65:[2,29],68:[2,29],72:[2,29],75:[2,29],80:[2,29],81:[2,29],82:[2,29],83:[2,29],84:[2,29],85:[2,29]},{14:[2,15],15:[2,15],19:[2,15],29:[2,15],34:[2,15],39:[2,15],44:[2,15],47:[2,15],48:[2,15],51:[2,15],55:[2,15],60:[2,15]},{72:[1,137],77:[1,136]},{72:[2,100],77:[2,100]},{14:[2,16],15:[2,16],19:[2,16],29:[2,16],34:[2,16],44:[2,16],47:[2,16],48:[2,16],51:[2,16],55:[2,16],60:[2,16]},{33:[1,138]},{33:[2,75]},{33:[2,32]},{72:[2,101],77:[2,101]},{14:[2,17],15:[2,17],19:[2,17],29:[2,17],34:[2,17],39:[2,17],44:[2,17],47:[2,17],48:[2,17],51:[2,17],55:[2,17],60:[2,17]}],defaultActions:{4:[2,1],54:[2,55],56:[2,20],60:[2,57],73:[2,81],82:[2,85],86:[2,18],90:[2,89],101:[2,53],104:[2,93],110:[2,19],111:[2,77],116:[2,97],119:[2,63],122:[2,69],135:[2,75],136:[2,32]},parseError:function(a,b){throw new Error(a)},parse:function(a){function b(){var a;return a=c.lexer.lex()||1,"number"!=typeof a&&(a=c.symbols_[a]||a),a}var c=this,d=[0],e=[null],f=[],g=this.table,h="",i=0,j=0,k=0;this.lexer.setInput(a),this.lexer.yy=this.yy,this.yy.lexer=this.lexer,this.yy.parser=this,"undefined"==typeof this.lexer.yylloc&&(this.lexer.yylloc={});var l=this.lexer.yylloc;f.push(l);var m=this.lexer.options&&this.lexer.options.ranges;"function"==typeof this.yy.parseError&&(this.parseError=this.yy.parseError);for(var n,o,p,q,r,s,t,u,v,w={};;){if(p=d[d.length-1],this.defaultActions[p]?q=this.defaultActions[p]:(null!==n&&"undefined"!=typeof n||(n=b()),q=g[p]&&g[p][n]),"undefined"==typeof q||!q.length||!q[0]){var x="";if(!k){v=[];for(s in g[p])this.terminals_[s]&&s>2&&v.push("'"+this.terminals_[s]+"'");x=this.lexer.showPosition?"Parse error on line "+(i+1)+":\n"+this.lexer.showPosition()+"\nExpecting "+v.join(", ")+", got '"+(this.terminals_[n]||n)+"'":"Parse error on line "+(i+1)+": Unexpected "+(1==n?"end of input":"'"+(this.terminals_[n]||n)+"'"),this.parseError(x,{text:this.lexer.match,token:this.terminals_[n]||n,line:this.lexer.yylineno,loc:l,expected:v})}}if(q[0]instanceof Array&&q.length>1)throw new Error("Parse Error: multiple actions possible at state: "+p+", token: "+n);switch(q[0]){case 1:d.push(n),e.push(this.lexer.yytext),f.push(this.lexer.yylloc),d.push(q[1]),n=null,o?(n=o,o=null):(j=this.lexer.yyleng,h=this.lexer.yytext,i=this.lexer.yylineno,l=this.lexer.yylloc,k>0&&k--);break;case 2:if(t=this.productions_[q[1]][1],w.$=e[e.length-t],w._$={first_line:f[f.length-(t||1)].first_line,last_line:f[f.length-1].last_line,first_column:f[f.length-(t||1)].first_column,last_column:f[f.length-1].last_column},m&&(w._$.range=[f[f.length-(t||1)].range[0],f[f.length-1].range[1]]),r=this.performAction.call(w,h,j,i,this.yy,q[1],e,f),"undefined"!=typeof r)return r;t&&(d=d.slice(0,-1*t*2),e=e.slice(0,-1*t),f=f.slice(0,-1*t)),d.push(this.productions_[q[1]][0]),e.push(w.$),f.push(w._$),u=g[d[d.length-2]][d[d.length-1]],d.push(u);break;case 3:return!0}}return!0}},c=function(){var a={EOF:1,parseError:function(a,b){if(!this.yy.parser)throw new Error(a);this.yy.parser.parseError(a,b)},setInput:function(a){return this._input=a,this._more=this._less=this.done=!1,this.yylineno=this.yyleng=0,this.yytext=this.matched=this.match="",this.conditionStack=["INITIAL"],this.yylloc={first_line:1,first_column:0,last_line:1,last_column:0},this.options.ranges&&(this.yylloc.range=[0,0]),this.offset=0,this},input:function(){var a=this._input[0];this.yytext+=a,this.yyleng++,this.offset++,this.match+=a,this.matched+=a;var b=a.match(/(?:\r\n?|\n).*/g);return b?(this.yylineno++,this.yylloc.last_line++):this.yylloc.last_column++,this.options.ranges&&this.yylloc.range[1]++,this._input=this._input.slice(1),a},unput:function(a){var b=a.length,c=a.split(/(?:\r\n?|\n)/g);this._input=a+this._input,this.yytext=this.yytext.substr(0,this.yytext.length-b-1),this.offset-=b;var d=this.match.split(/(?:\r\n?|\n)/g);this.match=this.match.substr(0,this.match.length-1),this.matched=this.matched.substr(0,this.matched.length-1),c.length-1&&(this.yylineno-=c.length-1);var e=this.yylloc.range;return this.yylloc={first_line:this.yylloc.first_line,last_line:this.yylineno+1,first_column:this.yylloc.first_column,last_column:c?(c.length===d.length?this.yylloc.first_column:0)+d[d.length-c.length].length-c[0].length:this.yylloc.first_column-b},this.options.ranges&&(this.yylloc.range=[e[0],e[0]+this.yyleng-b]),this},more:function(){return this._more=!0,this},less:function(a){this.unput(this.match.slice(a))},pastInput:function(){var a=this.matched.substr(0,this.matched.length-this.match.length);return(a.length>20?"...":"")+a.substr(-20).replace(/\n/g,"")},upcomingInput:function(){var a=this.match;return a.length<20&&(a+=this._input.substr(0,20-a.length)),(a.substr(0,20)+(a.length>20?"...":"")).replace(/\n/g,"")},showPosition:function(){var a=this.pastInput(),b=new Array(a.length+1).join("-");return a+this.upcomingInput()+"\n"+b+"^"},next:function(){if(this.done)return this.EOF;this._input||(this.done=!0);var a,b,c,d,e;this._more||(this.yytext="",this.match="");for(var f=this._currentRules(),g=0;g<f.length&&(c=this._input.match(this.rules[f[g]]),!c||b&&!(c[0].length>b[0].length)||(b=c,d=g,this.options.flex));g++);return b?(e=b[0].match(/(?:\r\n?|\n).*/g),e&&(this.yylineno+=e.length),this.yylloc={first_line:this.yylloc.last_line,last_line:this.yylineno+1,first_column:this.yylloc.last_column,last_column:e?e[e.length-1].length-e[e.length-1].match(/\r?\n?/)[0].length:this.yylloc.last_column+b[0].length},this.yytext+=b[0],this.match+=b[0],this.matches=b,this.yyleng=this.yytext.length,this.options.ranges&&(this.yylloc.range=[this.offset,this.offset+=this.yyleng]),this._more=!1,this._input=this._input.slice(b[0].length),this.matched+=b[0],a=this.performAction.call(this,this.yy,this,f[d],this.conditionStack[this.conditionStack.length-1]),this.done&&this._input&&(this.done=!1),a?a:void 0):""===this._input?this.EOF:this.parseError("Lexical error on line "+(this.yylineno+1)+". Unrecognized text.\n"+this.showPosition(),{text:"",token:null,line:this.yylineno})},lex:function(){var a=this.next();return"undefined"!=typeof a?a:this.lex()},begin:function(a){this.conditionStack.push(a)},popState:function(){return this.conditionStack.pop()},_currentRules:function(){return this.conditions[this.conditionStack[this.conditionStack.length-1]].rules},topState:function(){return this.conditionStack[this.conditionStack.length-2]},pushState:function(a){this.begin(a)}};return a.options={},a.performAction=function(a,b,c,d){function e(a,c){return b.yytext=b.yytext.substring(a,b.yyleng-c+a)}switch(c){case 0:if("\\\\"===b.yytext.slice(-2)?(e(0,1),this.begin("mu")):"\\"===b.yytext.slice(-1)?(e(0,1),this.begin("emu")):this.begin("mu"),b.yytext)return 15;break;case 1:return 15;case 2:return this.popState(),15;case 3:return this.begin("raw"),15;case 4:return this.popState(),"raw"===this.conditionStack[this.conditionStack.length-1]?15:(e(5,9),"END_RAW_BLOCK");case 5:return 15;case 6:return this.popState(),14;case 7:return 65;case 8:return 68;case 9:return 19;case 10:return this.popState(),this.begin("raw"),23;case 11:return 55;case 12:return 60;case 13:return 29;case 14:return 47;case 15:return this.popState(),44;case 16:return this.popState(),44;case 17:return 34;case 18:return 39;case 19:return 51;case 20:return 48;case 21:this.unput(b.yytext),this.popState(),this.begin("com");break;case 22:return this.popState(),14;case 23:return 48;case 24:return 73;case 25:return 72;case 26:return 72;case 27:return 87;case 28:break;case 29:return this.popState(),54;case 30:return this.popState(),33;case 31:return b.yytext=e(1,2).replace(/\\"/g,'"'),80;case 32:return b.yytext=e(1,2).replace(/\\'/g,"'"),80;case 33:return 85;case 34:return 82;case 35:return 82;case 36:return 83;case 37:return 84;case 38:return 81;case 39:return 75;case 40:return 77;case 41:return 72;case 42:return b.yytext=b.yytext.replace(/\\([\\\]])/g,"$1"),72;case 43:return"INVALID";case 44:return 5}},a.rules=[/^(?:[^\x00]*?(?=(\{\{)))/,/^(?:[^\x00]+)/,/^(?:[^\x00]{2,}?(?=(\{\{|\\\{\{|\\\\\{\{|$)))/,/^(?:\{\{\{\{(?=[^/]))/,/^(?:\{\{\{\{\/[^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=[=}\s\/.])\}\}\}\})/,/^(?:[^\x00]+?(?=(\{\{\{\{)))/,/^(?:[\s\S]*?--(~)?\}\})/,/^(?:\()/,/^(?:\))/,/^(?:\{\{\{\{)/,/^(?:\}\}\}\})/,/^(?:\{\{(~)?>)/,/^(?:\{\{(~)?#>)/,/^(?:\{\{(~)?#\*?)/,/^(?:\{\{(~)?\/)/,/^(?:\{\{(~)?\^\s*(~)?\}\})/,/^(?:\{\{(~)?\s*else\s*(~)?\}\})/,/^(?:\{\{(~)?\^)/,/^(?:\{\{(~)?\s*else\b)/,/^(?:\{\{(~)?\{)/,/^(?:\{\{(~)?&)/,/^(?:\{\{(~)?!--)/,/^(?:\{\{(~)?![\s\S]*?\}\})/,/^(?:\{\{(~)?\*?)/,/^(?:=)/,/^(?:\.\.)/,/^(?:\.(?=([=~}\s\/.)|])))/,/^(?:[\/.])/,/^(?:\s+)/,/^(?:\}(~)?\}\})/,/^(?:(~)?\}\})/,/^(?:"(\\["]|[^"])*")/,/^(?:'(\\[']|[^'])*')/,/^(?:@)/,/^(?:true(?=([~}\s)])))/,/^(?:false(?=([~}\s)])))/,/^(?:undefined(?=([~}\s)])))/,/^(?:null(?=([~}\s)])))/,/^(?:-?[0-9]+(?:\.[0-9]+)?(?=([~}\s)])))/,/^(?:as\s+\|)/,/^(?:\|)/,/^(?:([^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=([=~}\s\/.)|]))))/,/^(?:\[(\\\]|[^\]])*\])/,/^(?:.)/,/^(?:$)/],a.conditions={mu:{rules:[7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44],inclusive:!1},emu:{rules:[2],inclusive:!1},com:{rules:[6],inclusive:!1},raw:{rules:[3,4,5],inclusive:!1},INITIAL:{rules:[0,1,44],inclusive:!0}},a}();return b.lexer=c,a.prototype=b,b.Parser=a,new a}();b["default"]=c,a.exports=b["default"]},function(a,b,c){"use strict";function d(){var a=arguments.length<=0||void 0===arguments[0]?{}:arguments[0];this.options=a}function e(a,b,c){void 0===b&&(b=a.length);var d=a[b-1],e=a[b-2];return d?"ContentStatement"===d.type?(e||!c?/\r?\n\s*?$/:/(^|\r?\n)\s*?$/).test(d.original):void 0:c}function f(a,b,c){void 0===b&&(b=-1);var d=a[b+1],e=a[b+2];return d?"ContentStatement"===d.type?(e||!c?/^\s*?\r?\n/:/^\s*?(\r?\n|$)/).test(d.original):void 0:c}function g(a,b,c){var d=a[null==b?0:b+1];if(d&&"ContentStatement"===d.type&&(c||!d.rightStripped)){var e=d.value;d.value=d.value.replace(c?/^\s+/:/^[ \t]*\r?\n?/,""),d.rightStripped=d.value!==e}}function h(a,b,c){var d=a[null==b?a.length-1:b-1];if(d&&"ContentStatement"===d.type&&(c||!d.leftStripped)){var e=d.value;return d.value=d.value.replace(c?/\s+$/:/[ \t]+$/,""),d.leftStripped=d.value!==e,d.leftStripped}}var i=c(1)["default"];b.__esModule=!0;var j=c(88),k=i(j);d.prototype=new k["default"],d.prototype.Program=function(a){var b=!this.options.ignoreStandalone,c=!this.isRootSeen;this.isRootSeen=!0;for(var d=a.body,i=0,j=d.length;i<j;i++){var k=d[i],l=this.accept(k);if(l){var m=e(d,i,c),n=f(d,i,c),o=l.openStandalone&&m,p=l.closeStandalone&&n,q=l.inlineStandalone&&m&&n;l.close&&g(d,i,!0),l.open&&h(d,i,!0),b&&q&&(g(d,i),h(d,i)&&"PartialStatement"===k.type&&(k.indent=/([ \t]+$)/.exec(d[i-1].original)[1])),b&&o&&(g((k.program||k.inverse).body),h(d,i)),b&&p&&(g(d,i),h((k.inverse||k.program).body))}}return a},d.prototype.BlockStatement=d.prototype.DecoratorBlock=d.prototype.PartialBlockStatement=function(a){this.accept(a.program),this.accept(a.inverse);var b=a.program||a.inverse,c=a.program&&a.inverse,d=c,i=c;if(c&&c.chained)for(d=c.body[0].program;i.chained;)i=i.body[i.body.length-1].program;var j={open:a.openStrip.open,close:a.closeStrip.close,openStandalone:f(b.body),closeStandalone:e((d||b).body)};if(a.openStrip.close&&g(b.body,null,!0),c){var k=a.inverseStrip;k.open&&h(b.body,null,!0),k.close&&g(d.body,null,!0),a.closeStrip.open&&h(i.body,null,!0),!this.options.ignoreStandalone&&e(b.body)&&f(d.body)&&(h(b.body),g(d.body))}else a.closeStrip.open&&h(b.body,null,!0);return j},d.prototype.Decorator=d.prototype.MustacheStatement=function(a){return a.strip},d.prototype.PartialStatement=d.prototype.CommentStatement=function(a){var b=a.strip||{};return{inlineStandalone:!0,open:b.open,close:b.close}},b["default"]=d,a.exports=b["default"]},function(a,b,c){"use strict";function d(){this.parents=[]}function e(a){this.acceptRequired(a,"path"),this.acceptArray(a.params),this.acceptKey(a,"hash")}function f(a){e.call(this,a),this.acceptKey(a,"program"),this.acceptKey(a,"inverse")}function g(a){this.acceptRequired(a,"name"),this.acceptArray(a.params),this.acceptKey(a,"hash")}var h=c(1)["default"];b.__esModule=!0;var i=c(6),j=h(i);d.prototype={constructor:d,mutating:!1,acceptKey:function(a,b){var c=this.accept(a[b]);if(this.mutating){if(c&&!d.prototype[c.type])throw new j["default"]('Unexpected node type "'+c.type+'" found when accepting '+b+" on "+a.type);a[b]=c}},acceptRequired:function(a,b){if(this.acceptKey(a,b),!a[b])throw new j["default"](a.type+" requires "+b)},acceptArray:function(a){for(var b=0,c=a.length;b<c;b++)this.acceptKey(a,b),a[b]||(a.splice(b,1),b--,c--)},accept:function(a){if(a){if(!this[a.type])throw new j["default"]("Unknown type: "+a.type,a);this.current&&this.parents.unshift(this.current),this.current=a;var b=this[a.type](a);return this.current=this.parents.shift(),!this.mutating||b?b:b!==!1?a:void 0}},Program:function(a){this.acceptArray(a.body)},MustacheStatement:e,Decorator:e,BlockStatement:f,DecoratorBlock:f,PartialStatement:g,PartialBlockStatement:function(a){g.call(this,a),this.acceptKey(a,"program")},ContentStatement:function(){},CommentStatement:function(){},SubExpression:e,PathExpression:function(){},StringLiteral:function(){},NumberLiteral:function(){},BooleanLiteral:function(){},UndefinedLiteral:function(){},NullLiteral:function(){},Hash:function(a){this.acceptArray(a.pairs)},HashPair:function(a){this.acceptRequired(a,"value")}},b["default"]=d,a.exports=b["default"]},function(a,b,c){"use strict";function d(a,b){if(b=b.path?b.path.original:b,a.path.original!==b){var c={loc:a.path.loc};throw new q["default"](a.path.original+" doesn't match "+b,c)}}function e(a,b){this.source=a,this.start={line:b.first_line,column:b.first_column},this.end={line:b.last_line,column:b.last_column}}function f(a){return/^\[.*\]$/.test(a)?a.substring(1,a.length-1):a}function g(a,b){return{open:"~"===a.charAt(2),close:"~"===b.charAt(b.length-3)}}function h(a){return a.replace(/^\{\{~?!-?-?/,"").replace(/-?-?~?\}\}$/,"")}function i(a,b,c){c=this.locInfo(c);for(var d=a?"@":"",e=[],f=0,g=0,h=b.length;g<h;g++){var i=b[g].part,j=b[g].original!==i;if(d+=(b[g].separator||"")+i,j||".."!==i&&"."!==i&&"this"!==i)e.push(i);else{if(e.length>0)throw new q["default"]("Invalid path: "+d,{loc:c});".."===i&&f++}}return{type:"PathExpression",data:a,depth:f,parts:e,original:d,loc:c}}function j(a,b,c,d,e,f){var g=d.charAt(3)||d.charAt(2),h="{"!==g&&"&"!==g,i=/\*/.test(d);return{type:i?"Decorator":"MustacheStatement",path:a,params:b,hash:c,escaped:h,strip:e,loc:this.locInfo(f)}}function k(a,b,c,e){d(a,c),e=this.locInfo(e);var f={type:"Program",body:b,strip:{},loc:e};return{type:"BlockStatement",path:a.path,params:a.params,hash:a.hash,program:f,openStrip:{},inverseStrip:{},closeStrip:{},loc:e}}function l(a,b,c,e,f,g){e&&e.path&&d(a,e);var h=/\*/.test(a.open);b.blockParams=a.blockParams;var i=void 0,j=void 0;if(c){if(h)throw new q["default"]("Unexpected inverse block on decorator",c);c.chain&&(c.program.body[0].closeStrip=e.strip),j=c.strip,i=c.program}return f&&(f=i,i=b,b=f),{type:h?"DecoratorBlock":"BlockStatement",path:a.path,params:a.params,hash:a.hash,program:b,inverse:i,openStrip:a.strip,inverseStrip:j,closeStrip:e&&e.strip,loc:this.locInfo(g)}}function m(a,b){if(!b&&a.length){var c=a[0].loc,d=a[a.length-1].loc;c&&d&&(b={source:c.source,start:{line:c.start.line,column:c.start.column},end:{line:d.end.line,column:d.end.column}})}return{type:"Program",body:a,strip:{},loc:b}}function n(a,b,c,e){return d(a,c),{type:"PartialBlockStatement",name:a.path,params:a.params,hash:a.hash,program:b,openStrip:a.strip,closeStrip:c&&c.strip,loc:this.locInfo(e)}}var o=c(1)["default"];b.__esModule=!0,b.SourceLocation=e,b.id=f,b.stripFlags=g,b.stripComment=h,b.preparePath=i,b.prepareMustache=j,b.prepareRawBlock=k,b.prepareBlock=l,b.prepareProgram=m,b.preparePartialBlock=n;var p=c(6),q=o(p)},function(a,b,c){"use strict";function d(){}function e(a,b,c){if(null==a||"string"!=typeof a&&"Program"!==a.type)throw new l["default"]("You must pass a string or Handlebars AST to Handlebars.precompile. You passed "+a);b=b||{},"data"in b||(b.data=!0),b.compat&&(b.useDepths=!0);var d=c.parse(a,b),e=(new c.Compiler).compile(d,b);return(new c.JavaScriptCompiler).compile(e,b)}function f(a,b,c){function d(){var d=c.parse(a,b),e=(new c.Compiler).compile(d,b),f=(new c.JavaScriptCompiler).compile(e,b,void 0,!0);return c.template(f)}function e(a,b){return f||(f=d()),f.call(this,a,b)}if(void 0===b&&(b={}),null==a||"string"!=typeof a&&"Program"!==a.type)throw new l["default"]("You must pass a string or Handlebars AST to Handlebars.compile. You passed "+a);b=m.extend({},b),"data"in b||(b.data=!0),b.compat&&(b.useDepths=!0);var f=void 0;return e._setup=function(a){return f||(f=d()),f._setup(a)},e._child=function(a,b,c,e){return f||(f=d()),f._child(a,b,c,e)},e}function g(a,b){if(a===b)return!0;if(m.isArray(a)&&m.isArray(b)&&a.length===b.length){for(var c=0;c<a.length;c++)if(!g(a[c],b[c]))return!1;return!0}}function h(a){if(!a.path.parts){var b=a.path;a.path={type:"PathExpression",data:!1,depth:0,parts:[b.original+""],original:b.original+"",loc:b.loc}}}var i=c(74)["default"],j=c(1)["default"];b.__esModule=!0,b.Compiler=d,b.precompile=e,b.compile=f;var k=c(6),l=j(k),m=c(5),n=c(84),o=j(n),p=[].slice;d.prototype={compiler:d,equals:function(a){var b=this.opcodes.length;if(a.opcodes.length!==b)return!1;for(var c=0;c<b;c++){var d=this.opcodes[c],e=a.opcodes[c];if(d.opcode!==e.opcode||!g(d.args,e.args))return!1}b=this.children.length;for(var c=0;c<b;c++)if(!this.children[c].equals(a.children[c]))return!1;
return!0},guid:0,compile:function(a,b){return this.sourceNode=[],this.opcodes=[],this.children=[],this.options=b,this.stringParams=b.stringParams,this.trackIds=b.trackIds,b.blockParams=b.blockParams||[],b.knownHelpers=m.extend(i(null),{helperMissing:!0,blockHelperMissing:!0,each:!0,"if":!0,unless:!0,"with":!0,log:!0,lookup:!0},b.knownHelpers),this.accept(a)},compileProgram:function(a){var b=new this.compiler,c=b.compile(a,this.options),d=this.guid++;return this.usePartial=this.usePartial||c.usePartial,this.children[d]=c,this.useDepths=this.useDepths||c.useDepths,d},accept:function(a){if(!this[a.type])throw new l["default"]("Unknown type: "+a.type,a);this.sourceNode.unshift(a);var b=this[a.type](a);return this.sourceNode.shift(),b},Program:function(a){this.options.blockParams.unshift(a.blockParams);for(var b=a.body,c=b.length,d=0;d<c;d++)this.accept(b[d]);return this.options.blockParams.shift(),this.isSimple=1===c,this.blockParams=a.blockParams?a.blockParams.length:0,this},BlockStatement:function(a){h(a);var b=a.program,c=a.inverse;b=b&&this.compileProgram(b),c=c&&this.compileProgram(c);var d=this.classifySexpr(a);"helper"===d?this.helperSexpr(a,b,c):"simple"===d?(this.simpleSexpr(a),this.opcode("pushProgram",b),this.opcode("pushProgram",c),this.opcode("emptyHash"),this.opcode("blockValue",a.path.original)):(this.ambiguousSexpr(a,b,c),this.opcode("pushProgram",b),this.opcode("pushProgram",c),this.opcode("emptyHash"),this.opcode("ambiguousBlockValue")),this.opcode("append")},DecoratorBlock:function(a){var b=a.program&&this.compileProgram(a.program),c=this.setupFullMustacheParams(a,b,void 0),d=a.path;this.useDecorators=!0,this.opcode("registerDecorator",c.length,d.original)},PartialStatement:function(a){this.usePartial=!0;var b=a.program;b&&(b=this.compileProgram(a.program));var c=a.params;if(c.length>1)throw new l["default"]("Unsupported number of partial arguments: "+c.length,a);c.length||(this.options.explicitPartialContext?this.opcode("pushLiteral","undefined"):c.push({type:"PathExpression",parts:[],depth:0}));var d=a.name.original,e="SubExpression"===a.name.type;e&&this.accept(a.name),this.setupFullMustacheParams(a,b,void 0,!0);var f=a.indent||"";this.options.preventIndent&&f&&(this.opcode("appendContent",f),f=""),this.opcode("invokePartial",e,d,f),this.opcode("append")},PartialBlockStatement:function(a){this.PartialStatement(a)},MustacheStatement:function(a){this.SubExpression(a),a.escaped&&!this.options.noEscape?this.opcode("appendEscaped"):this.opcode("append")},Decorator:function(a){this.DecoratorBlock(a)},ContentStatement:function(a){a.value&&this.opcode("appendContent",a.value)},CommentStatement:function(){},SubExpression:function(a){h(a);var b=this.classifySexpr(a);"simple"===b?this.simpleSexpr(a):"helper"===b?this.helperSexpr(a):this.ambiguousSexpr(a)},ambiguousSexpr:function(a,b,c){var d=a.path,e=d.parts[0],f=null!=b||null!=c;this.opcode("getContext",d.depth),this.opcode("pushProgram",b),this.opcode("pushProgram",c),d.strict=!0,this.accept(d),this.opcode("invokeAmbiguous",e,f)},simpleSexpr:function(a){var b=a.path;b.strict=!0,this.accept(b),this.opcode("resolvePossibleLambda")},helperSexpr:function(a,b,c){var d=this.setupFullMustacheParams(a,b,c),e=a.path,f=e.parts[0];if(this.options.knownHelpers[f])this.opcode("invokeKnownHelper",d.length,f);else{if(this.options.knownHelpersOnly)throw new l["default"]("You specified knownHelpersOnly, but used the unknown helper "+f,a);e.strict=!0,e.falsy=!0,this.accept(e),this.opcode("invokeHelper",d.length,e.original,o["default"].helpers.simpleId(e))}},PathExpression:function(a){this.addDepth(a.depth),this.opcode("getContext",a.depth);var b=a.parts[0],c=o["default"].helpers.scopedId(a),d=!a.depth&&!c&&this.blockParamIndex(b);d?this.opcode("lookupBlockParam",d,a.parts):b?a.data?(this.options.data=!0,this.opcode("lookupData",a.depth,a.parts,a.strict)):this.opcode("lookupOnContext",a.parts,a.falsy,a.strict,c):this.opcode("pushContext")},StringLiteral:function(a){this.opcode("pushString",a.value)},NumberLiteral:function(a){this.opcode("pushLiteral",a.value)},BooleanLiteral:function(a){this.opcode("pushLiteral",a.value)},UndefinedLiteral:function(){this.opcode("pushLiteral","undefined")},NullLiteral:function(){this.opcode("pushLiteral","null")},Hash:function(a){var b=a.pairs,c=0,d=b.length;for(this.opcode("pushHash");c<d;c++)this.pushParam(b[c].value);for(;c--;)this.opcode("assignToHash",b[c].key);this.opcode("popHash")},opcode:function(a){this.opcodes.push({opcode:a,args:p.call(arguments,1),loc:this.sourceNode[0].loc})},addDepth:function(a){a&&(this.useDepths=!0)},classifySexpr:function(a){var b=o["default"].helpers.simpleId(a.path),c=b&&!!this.blockParamIndex(a.path.parts[0]),d=!c&&o["default"].helpers.helperExpression(a),e=!c&&(d||b);if(e&&!d){var f=a.path.parts[0],g=this.options;g.knownHelpers[f]?d=!0:g.knownHelpersOnly&&(e=!1)}return d?"helper":e?"ambiguous":"simple"},pushParams:function(a){for(var b=0,c=a.length;b<c;b++)this.pushParam(a[b])},pushParam:function(a){var b=null!=a.value?a.value:a.original||"";if(this.stringParams)b.replace&&(b=b.replace(/^(\.?\.\/)*/g,"").replace(/\//g,".")),a.depth&&this.addDepth(a.depth),this.opcode("getContext",a.depth||0),this.opcode("pushStringParam",b,a.type),"SubExpression"===a.type&&this.accept(a);else{if(this.trackIds){var c=void 0;if(!a.parts||o["default"].helpers.scopedId(a)||a.depth||(c=this.blockParamIndex(a.parts[0])),c){var d=a.parts.slice(1).join(".");this.opcode("pushId","BlockParam",c,d)}else b=a.original||b,b.replace&&(b=b.replace(/^this(?:\.|$)/,"").replace(/^\.\//,"").replace(/^\.$/,"")),this.opcode("pushId",a.type,b)}this.accept(a)}},setupFullMustacheParams:function(a,b,c,d){var e=a.params;return this.pushParams(e),this.opcode("pushProgram",b),this.opcode("pushProgram",c),a.hash?this.accept(a.hash):this.opcode("emptyHash",d),e},blockParamIndex:function(a){for(var b=0,c=this.options.blockParams.length;b<c;b++){var d=this.options.blockParams[b],e=d&&m.indexOf(d,a);if(d&&e>=0)return[b,e]}}}},function(a,b,c){"use strict";function d(a){this.value=a}function e(){}function f(a,b,c,d,e){var f=b.popStack(),g=c.length;for(a&&g--;d<g;d++)f=b.nameLookup(f,c[d],e);return a?[b.aliasable("container.strict"),"(",f,", ",b.quotedString(c[d]),", ",JSON.stringify(b.source.currentLocation)," )"]:f}var g=c(60)["default"],h=c(1)["default"];b.__esModule=!0;var i=c(4),j=c(6),k=h(j),l=c(5),m=c(92),n=h(m);e.prototype={nameLookup:function(a,b){return this.internalNameLookup(a,b)},depthedLookup:function(a){return[this.aliasable("container.lookup"),"(depths, ",JSON.stringify(a),")"]},compilerInfo:function(){var a=i.COMPILER_REVISION,b=i.REVISION_CHANGES[a];return[a,b]},appendToBuffer:function(a,b,c){return l.isArray(a)||(a=[a]),a=this.source.wrap(a,b),this.environment.isSimple?["return ",a,";"]:c?["buffer += ",a,";"]:(a.appendToBuffer=!0,a)},initializeBuffer:function(){return this.quotedString("")},internalNameLookup:function(a,b){return this.lookupPropertyFunctionIsUsed=!0,["lookupProperty(",a,",",JSON.stringify(b),")"]},lookupPropertyFunctionIsUsed:!1,compile:function(a,b,c,d){this.environment=a,this.options=b,this.stringParams=this.options.stringParams,this.trackIds=this.options.trackIds,this.precompile=!d,this.name=this.environment.name,this.isChild=!!c,this.context=c||{decorators:[],programs:[],environments:[]},this.preamble(),this.stackSlot=0,this.stackVars=[],this.aliases={},this.registers={list:[]},this.hashes=[],this.compileStack=[],this.inlineStack=[],this.blockParams=[],this.compileChildren(a,b),this.useDepths=this.useDepths||a.useDepths||a.useDecorators||this.options.compat,this.useBlockParams=this.useBlockParams||a.useBlockParams;var e=a.opcodes,f=void 0,g=void 0,h=void 0,i=void 0;for(h=0,i=e.length;h<i;h++)f=e[h],this.source.currentLocation=f.loc,g=g||f.loc,this[f.opcode].apply(this,f.args);if(this.source.currentLocation=g,this.pushSource(""),this.stackSlot||this.inlineStack.length||this.compileStack.length)throw new k["default"]("Compile completed with content left on stack");this.decorators.isEmpty()?this.decorators=void 0:(this.useDecorators=!0,this.decorators.prepend(["var decorators = container.decorators, ",this.lookupPropertyFunctionVarDeclaration(),";\n"]),this.decorators.push("return fn;"),d?this.decorators=Function.apply(this,["fn","props","container","depth0","data","blockParams","depths",this.decorators.merge()]):(this.decorators.prepend("function(fn, props, container, depth0, data, blockParams, depths) {\n"),this.decorators.push("}\n"),this.decorators=this.decorators.merge()));var j=this.createFunctionContext(d);if(this.isChild)return j;var l={compiler:this.compilerInfo(),main:j};this.decorators&&(l.main_d=this.decorators,l.useDecorators=!0);var m=this.context,n=m.programs,o=m.decorators;for(h=0,i=n.length;h<i;h++)n[h]&&(l[h]=n[h],o[h]&&(l[h+"_d"]=o[h],l.useDecorators=!0));return this.environment.usePartial&&(l.usePartial=!0),this.options.data&&(l.useData=!0),this.useDepths&&(l.useDepths=!0),this.useBlockParams&&(l.useBlockParams=!0),this.options.compat&&(l.compat=!0),d?l.compilerOptions=this.options:(l.compiler=JSON.stringify(l.compiler),this.source.currentLocation={start:{line:1,column:0}},l=this.objectLiteral(l),b.srcName?(l=l.toStringWithSourceMap({file:b.destName}),l.map=l.map&&l.map.toString()):l=l.toString()),l},preamble:function(){this.lastContext=0,this.source=new n["default"](this.options.srcName),this.decorators=new n["default"](this.options.srcName)},createFunctionContext:function(a){var b=this,c="",d=this.stackVars.concat(this.registers.list);d.length>0&&(c+=", "+d.join(", "));var e=0;g(this.aliases).forEach(function(a){var d=b.aliases[a];d.children&&d.referenceCount>1&&(c+=", alias"+ ++e+"="+a,d.children[0]="alias"+e)}),this.lookupPropertyFunctionIsUsed&&(c+=", "+this.lookupPropertyFunctionVarDeclaration());var f=["container","depth0","helpers","partials","data"];(this.useBlockParams||this.useDepths)&&f.push("blockParams"),this.useDepths&&f.push("depths");var h=this.mergeSource(c);return a?(f.push(h),Function.apply(this,f)):this.source.wrap(["function(",f.join(","),") {\n  ",h,"}"])},mergeSource:function(a){var b=this.environment.isSimple,c=!this.forceBuffer,d=void 0,e=void 0,f=void 0,g=void 0;return this.source.each(function(a){a.appendToBuffer?(f?a.prepend("  + "):f=a,g=a):(f&&(e?f.prepend("buffer += "):d=!0,g.add(";"),f=g=void 0),e=!0,b||(c=!1))}),c?f?(f.prepend("return "),g.add(";")):e||this.source.push('return "";'):(a+=", buffer = "+(d?"":this.initializeBuffer()),f?(f.prepend("return buffer + "),g.add(";")):this.source.push("return buffer;")),a&&this.source.prepend("var "+a.substring(2)+(d?"":";\n")),this.source.merge()},lookupPropertyFunctionVarDeclaration:function(){return"\n      lookupProperty = container.lookupProperty || function(parent, propertyName) {\n        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {\n          return parent[propertyName];\n        }\n        return undefined\n    }\n    ".trim()},blockValue:function(a){var b=this.aliasable("container.hooks.blockHelperMissing"),c=[this.contextName(0)];this.setupHelperArgs(a,0,c);var d=this.popStack();c.splice(1,0,d),this.push(this.source.functionCall(b,"call",c))},ambiguousBlockValue:function(){var a=this.aliasable("container.hooks.blockHelperMissing"),b=[this.contextName(0)];this.setupHelperArgs("",0,b,!0),this.flushInline();var c=this.topStack();b.splice(1,0,c),this.pushSource(["if (!",this.lastHelper,") { ",c," = ",this.source.functionCall(a,"call",b),"}"])},appendContent:function(a){this.pendingContent?a=this.pendingContent+a:this.pendingLocation=this.source.currentLocation,this.pendingContent=a},append:function(){if(this.isInline())this.replaceStack(function(a){return[" != null ? ",a,' : ""']}),this.pushSource(this.appendToBuffer(this.popStack()));else{var a=this.popStack();this.pushSource(["if (",a," != null) { ",this.appendToBuffer(a,void 0,!0)," }"]),this.environment.isSimple&&this.pushSource(["else { ",this.appendToBuffer("''",void 0,!0)," }"])}},appendEscaped:function(){this.pushSource(this.appendToBuffer([this.aliasable("container.escapeExpression"),"(",this.popStack(),")"]))},getContext:function(a){this.lastContext=a},pushContext:function(){this.pushStackLiteral(this.contextName(this.lastContext))},lookupOnContext:function(a,b,c,d){var e=0;d||!this.options.compat||this.lastContext?this.pushContext():this.push(this.depthedLookup(a[e++])),this.resolvePath("context",a,e,b,c)},lookupBlockParam:function(a,b){this.useBlockParams=!0,this.push(["blockParams[",a[0],"][",a[1],"]"]),this.resolvePath("context",b,1)},lookupData:function(a,b,c){a?this.pushStackLiteral("container.data(data, "+a+")"):this.pushStackLiteral("data"),this.resolvePath("data",b,0,!0,c)},resolvePath:function(a,b,c,d,e){var g=this;if(this.options.strict||this.options.assumeObjects)return void this.push(f(this.options.strict&&e,this,b,c,a));for(var h=b.length;c<h;c++)this.replaceStack(function(e){var f=g.nameLookup(e,b[c],a);return d?[" && ",f]:[" != null ? ",f," : ",e]})},resolvePossibleLambda:function(){this.push([this.aliasable("container.lambda"),"(",this.popStack(),", ",this.contextName(0),")"])},pushStringParam:function(a,b){this.pushContext(),this.pushString(b),"SubExpression"!==b&&("string"==typeof a?this.pushString(a):this.pushStackLiteral(a))},emptyHash:function(a){this.trackIds&&this.push("{}"),this.stringParams&&(this.push("{}"),this.push("{}")),this.pushStackLiteral(a?"undefined":"{}")},pushHash:function(){this.hash&&this.hashes.push(this.hash),this.hash={values:{},types:[],contexts:[],ids:[]}},popHash:function(){var a=this.hash;this.hash=this.hashes.pop(),this.trackIds&&this.push(this.objectLiteral(a.ids)),this.stringParams&&(this.push(this.objectLiteral(a.contexts)),this.push(this.objectLiteral(a.types))),this.push(this.objectLiteral(a.values))},pushString:function(a){this.pushStackLiteral(this.quotedString(a))},pushLiteral:function(a){this.pushStackLiteral(a)},pushProgram:function(a){null!=a?this.pushStackLiteral(this.programExpression(a)):this.pushStackLiteral(null)},registerDecorator:function(a,b){var c=this.nameLookup("decorators",b,"decorator"),d=this.setupHelperArgs(b,a);this.decorators.push(["fn = ",this.decorators.functionCall(c,"",["fn","props","container",d])," || fn;"])},invokeHelper:function(a,b,c){var d=this.popStack(),e=this.setupHelper(a,b),f=[];c&&f.push(e.name),f.push(d),this.options.strict||f.push(this.aliasable("container.hooks.helperMissing"));var g=["(",this.itemsSeparatedBy(f,"||"),")"],h=this.source.functionCall(g,"call",e.callParams);this.push(h)},itemsSeparatedBy:function(a,b){var c=[];c.push(a[0]);for(var d=1;d<a.length;d++)c.push(b,a[d]);return c},invokeKnownHelper:function(a,b){var c=this.setupHelper(a,b);this.push(this.source.functionCall(c.name,"call",c.callParams))},invokeAmbiguous:function(a,b){this.useRegister("helper");var c=this.popStack();this.emptyHash();var d=this.setupHelper(0,a,b),e=this.lastHelper=this.nameLookup("helpers",a,"helper"),f=["(","(helper = ",e," || ",c,")"];this.options.strict||(f[0]="(helper = ",f.push(" != null ? helper : ",this.aliasable("container.hooks.helperMissing"))),this.push(["(",f,d.paramsInit?["),(",d.paramsInit]:[],"),","(typeof helper === ",this.aliasable('"function"')," ? ",this.source.functionCall("helper","call",d.callParams)," : helper))"])},invokePartial:function(a,b,c){var d=[],e=this.setupParams(b,1,d);a&&(b=this.popStack(),delete e.name),c&&(e.indent=JSON.stringify(c)),e.helpers="helpers",e.partials="partials",e.decorators="container.decorators",a?d.unshift(b):d.unshift(this.nameLookup("partials",b,"partial")),this.options.compat&&(e.depths="depths"),e=this.objectLiteral(e),d.push(e),this.push(this.source.functionCall("container.invokePartial","",d))},assignToHash:function(a){var b=this.popStack(),c=void 0,d=void 0,e=void 0;this.trackIds&&(e=this.popStack()),this.stringParams&&(d=this.popStack(),c=this.popStack());var f=this.hash;c&&(f.contexts[a]=c),d&&(f.types[a]=d),e&&(f.ids[a]=e),f.values[a]=b},pushId:function(a,b,c){"BlockParam"===a?this.pushStackLiteral("blockParams["+b[0]+"].path["+b[1]+"]"+(c?" + "+JSON.stringify("."+c):"")):"PathExpression"===a?this.pushString(b):"SubExpression"===a?this.pushStackLiteral("true"):this.pushStackLiteral("null")},compiler:e,compileChildren:function(a,b){for(var c=a.children,d=void 0,e=void 0,f=0,g=c.length;f<g;f++){d=c[f],e=new this.compiler;var h=this.matchExistingProgram(d);if(null==h){this.context.programs.push("");var i=this.context.programs.length;d.index=i,d.name="program"+i,this.context.programs[i]=e.compile(d,b,this.context,!this.precompile),this.context.decorators[i]=e.decorators,this.context.environments[i]=d,this.useDepths=this.useDepths||e.useDepths,this.useBlockParams=this.useBlockParams||e.useBlockParams,d.useDepths=this.useDepths,d.useBlockParams=this.useBlockParams}else d.index=h.index,d.name="program"+h.index,this.useDepths=this.useDepths||h.useDepths,this.useBlockParams=this.useBlockParams||h.useBlockParams}},matchExistingProgram:function(a){for(var b=0,c=this.context.environments.length;b<c;b++){var d=this.context.environments[b];if(d&&d.equals(a))return d}},programExpression:function(a){var b=this.environment.children[a],c=[b.index,"data",b.blockParams];return(this.useBlockParams||this.useDepths)&&c.push("blockParams"),this.useDepths&&c.push("depths"),"container.program("+c.join(", ")+")"},useRegister:function(a){this.registers[a]||(this.registers[a]=!0,this.registers.list.push(a))},push:function(a){return a instanceof d||(a=this.source.wrap(a)),this.inlineStack.push(a),a},pushStackLiteral:function(a){this.push(new d(a))},pushSource:function(a){this.pendingContent&&(this.source.push(this.appendToBuffer(this.source.quotedString(this.pendingContent),this.pendingLocation)),this.pendingContent=void 0),a&&this.source.push(a)},replaceStack:function(a){var b=["("],c=void 0,e=void 0,f=void 0;if(!this.isInline())throw new k["default"]("replaceStack on non-inline");var g=this.popStack(!0);if(g instanceof d)c=[g.value],b=["(",c],f=!0;else{e=!0;var h=this.incrStack();b=["((",this.push(h)," = ",g,")"],c=this.topStack()}var i=a.call(this,c);f||this.popStack(),e&&this.stackSlot--,this.push(b.concat(i,")"))},incrStack:function(){return this.stackSlot++,this.stackSlot>this.stackVars.length&&this.stackVars.push("stack"+this.stackSlot),this.topStackName()},topStackName:function(){return"stack"+this.stackSlot},flushInline:function(){var a=this.inlineStack;this.inlineStack=[];for(var b=0,c=a.length;b<c;b++){var e=a[b];if(e instanceof d)this.compileStack.push(e);else{var f=this.incrStack();this.pushSource([f," = ",e,";"]),this.compileStack.push(f)}}},isInline:function(){return this.inlineStack.length},popStack:function(a){var b=this.isInline(),c=(b?this.inlineStack:this.compileStack).pop();if(!a&&c instanceof d)return c.value;if(!b){if(!this.stackSlot)throw new k["default"]("Invalid stack pop");this.stackSlot--}return c},topStack:function(){var a=this.isInline()?this.inlineStack:this.compileStack,b=a[a.length-1];return b instanceof d?b.value:b},contextName:function(a){return this.useDepths&&a?"depths["+a+"]":"depth"+a},quotedString:function(a){return this.source.quotedString(a)},objectLiteral:function(a){return this.source.objectLiteral(a)},aliasable:function(a){var b=this.aliases[a];return b?(b.referenceCount++,b):(b=this.aliases[a]=this.source.wrap(a),b.aliasable=!0,b.referenceCount=1,b)},setupHelper:function(a,b,c){var d=[],e=this.setupHelperArgs(b,a,d,c),f=this.nameLookup("helpers",b,"helper"),g=this.aliasable(this.contextName(0)+" != null ? "+this.contextName(0)+" : (container.nullContext || {})");return{params:d,paramsInit:e,name:f,callParams:[g].concat(d)}},setupParams:function(a,b,c){var d={},e=[],f=[],g=[],h=!c,i=void 0;h&&(c=[]),d.name=this.quotedString(a),d.hash=this.popStack(),this.trackIds&&(d.hashIds=this.popStack()),this.stringParams&&(d.hashTypes=this.popStack(),d.hashContexts=this.popStack());var j=this.popStack(),k=this.popStack();(k||j)&&(d.fn=k||"container.noop",d.inverse=j||"container.noop");for(var l=b;l--;)i=this.popStack(),c[l]=i,this.trackIds&&(g[l]=this.popStack()),this.stringParams&&(f[l]=this.popStack(),e[l]=this.popStack());return h&&(d.args=this.source.generateArray(c)),this.trackIds&&(d.ids=this.source.generateArray(g)),this.stringParams&&(d.types=this.source.generateArray(f),d.contexts=this.source.generateArray(e)),this.options.data&&(d.data="data"),this.useBlockParams&&(d.blockParams="blockParams"),d},setupHelperArgs:function(a,b,c,d){var e=this.setupParams(a,b,c);return e.loc=JSON.stringify(this.source.currentLocation),e=this.objectLiteral(e),d?(this.useRegister("options"),c.push("options"),["options=",e]):c?(c.push(e),""):e}},function(){for(var a="break else new var case finally return void catch for switch while continue function this with default if throw delete in try do instanceof typeof abstract enum int short boolean export interface static byte extends long super char final native synchronized class float package throws const goto private transient debugger implements protected volatile double import public let yield await null true false".split(" "),b=e.RESERVED_WORDS={},c=0,d=a.length;c<d;c++)b[a[c]]=!0}(),e.isValidJavaScriptVariableName=function(a){return!e.RESERVED_WORDS[a]&&/^[a-zA-Z_$][0-9a-zA-Z_$]*$/.test(a)},b["default"]=e,a.exports=b["default"]},function(a,b,c){"use strict";function d(a,b,c){if(g.isArray(a)){for(var d=[],e=0,f=a.length;e<f;e++)d.push(b.wrap(a[e],c));return d}return"boolean"==typeof a||"number"==typeof a?a+"":a}function e(a){this.srcFile=a,this.source=[]}var f=c(60)["default"];b.__esModule=!0;var g=c(5),h=void 0;try{}catch(i){}h||(h=function(a,b,c,d){this.src="",d&&this.add(d)},h.prototype={add:function(a){g.isArray(a)&&(a=a.join("")),this.src+=a},prepend:function(a){g.isArray(a)&&(a=a.join("")),this.src=a+this.src},toStringWithSourceMap:function(){return{code:this.toString()}},toString:function(){return this.src}}),e.prototype={isEmpty:function(){return!this.source.length},prepend:function(a,b){this.source.unshift(this.wrap(a,b))},push:function(a,b){this.source.push(this.wrap(a,b))},merge:function(){var a=this.empty();return this.each(function(b){a.add(["  ",b,"\n"])}),a},each:function(a){for(var b=0,c=this.source.length;b<c;b++)a(this.source[b])},empty:function(){var a=this.currentLocation||{start:{}};return new h(a.start.line,a.start.column,this.srcFile)},wrap:function(a){var b=arguments.length<=1||void 0===arguments[1]?this.currentLocation||{start:{}}:arguments[1];return a instanceof h?a:(a=d(a,this,b),new h(b.start.line,b.start.column,this.srcFile,a))},functionCall:function(a,b,c){return c=this.generateList(c),this.wrap([a,b?"."+b+"(":"(",c,")"])},quotedString:function(a){return'"'+(a+"").replace(/\\/g,"\\\\").replace(/"/g,'\\"').replace(/\n/g,"\\n").replace(/\r/g,"\\r").replace(/\u2028/g,"\\u2028").replace(/\u2029/g,"\\u2029")+'"'},objectLiteral:function(a){var b=this,c=[];f(a).forEach(function(e){var f=d(a[e],b);"undefined"!==f&&c.push([b.quotedString(e),":",f])});var e=this.generateList(c);return e.prepend("{"),e.add("}"),e},generateList:function(a){for(var b=this.empty(),c=0,e=a.length;c<e;c++)c&&b.add(","),b.add(d(a[c],this));return b},generateArray:function(a){var b=this.generateList(a);return b.prepend("["),b.add("]"),b}},b["default"]=e,a.exports=b["default"]}])});
function getSiteName() {
  return "ss-unbxd-ganz-prod-blue-illusion-anz23461767337513";
}
function getApiKey() {
  return "f0fbd430892f8712a86e026003eb807a";
}

(function () {
    'use strict';

if (typeof window.initUnbxdQuickView === 'function') {
    window.initUnbxdQuickView();
}

    const unbxdUserId = document.cookie.match("\\bunbxd.userId=([^;]*)\\b");
    const unbxdUid = unbxdUserId ? unbxdUserId[1] : '123456';

    let pageContext = null;
    let API_URL = null;

    /**
     * Extract product ID from the page (for PRODUCT page type)
     * Looks for Shopify product meta tag or data attributes
     */
    function extractProductId() {
        if (typeof window.productJSON !== 'undefined' && window.productJSON.id) {
            return window.productJSON.id;
        }

        if (typeof ShopifyAnalytics !== 'undefined' && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product) {
            return ShopifyAnalytics.meta.product.id;
        }

        const pdpContainer = document.getElementById('pdp_recommendations');
        if (pdpContainer && pdpContainer.dataset.productId) {
            return pdpContainer.dataset.productId;
        }

        const metaProduct = document.querySelector('meta[property="og:url"]');
        if (metaProduct) {
            const urlMatch = metaProduct.content.match(/\/products\/([^\/]+)$/);
            if (urlMatch) {
                return urlMatch[1];
            }
        }

        return null;
    }

    /**
     * Extract cart item IDs from the page (for CART page type)
     */
    function extractCartIds() {
        if (typeof fetch !== 'undefined') {
            return null;
        }
        return null;
    }

    /**
     * Find all recommendation containers on the page
     * Supports both numbered containers (pdp_recommendations_1, pdp_recommendations_2) 
     * and single containers (pdp_recommendations) for backward compatibility
     */
    function findAllContainers() {
        const containers = [];
        
        const patterns = [
            { prefix: 'pdp_recommendations', pageType: 'PRODUCT' },
            { prefix: 'cart_recommendations', pageType: 'CART' },
            { prefix: 'home_recommendations', pageType: 'HOME' },
            { prefix: 'srp_recommendations', pageType: 'HOME' }
        ];

        patterns.forEach(function(pattern) {
            let index = 1;
            while (true) {
                const numberedId = pattern.prefix + '_' + index;
                const el = document.getElementById(numberedId);
                if (el) {
                    containers.push({
                        elementId: numberedId,
                        pageType: pattern.pageType
                    });
                    index++;
                } else {
                    break;
                }
            }
            
            if (index === 1) {
                const baseEl = document.getElementById(pattern.prefix);
                if (baseEl) {
                    containers.push({
                        elementId: pattern.prefix,
                        pageType: pattern.pageType
                    });
                }
            }
        });

        return containers;
    }

    /**
     * Decide which page we're on by checking the presence of the container IDs
     * (as per theme snippet):
     * - Home:  #home_recommendations -> pageType=HOME
     * - PDP:   #pdp_recommendations -> pageType=PRODUCT (needs id parameter)
     * - Cart:  #cart_recommendations -> pageType=CART (needs id parameter)
     * Returns the first matching page type and all containers found
     */
    function detectPageContext() {
        const allContainers = findAllContainers();
        
        if (allContainers.length === 0) {
            return null;
        }

        const firstContainer = allContainers[0];
        let pageType = firstContainer.pageType;
        let productId = null;
        let cartIds = null;

        if (pageType === 'PRODUCT') {
            productId = extractProductId();
        }

        if (pageType === 'CART') {
            cartIds = extractCartIds();
        }

        return {
            pageType: pageType,
            containers: allContainers,
            productId: productId,
            cartIds: cartIds
        };
    }

    /**
     * Initialize page context and API URL after DOM is loaded
     */
    function initializePageContext() {
        pageContext = detectPageContext();

        window._unbxd_recs_containers = pageContext ? pageContext.containers : [];
        window._unbxd_recs_defaultElementId = pageContext ? pageContext.elementId : null;

        if (!pageContext) {
            API_URL = null;
            return;
        }

        const recsFields = [
            'title', 'uniqueId', 'productUrl', 'handle', 'imageUrl', 'images',
            'id', 'availability', 'available', 'tags', 'product_variants',
            'price_AUD', 'price_NZD', 'price_USD',
            'compareAtPrice_AUD', 'compareAtPrice_NZD', 'compareAtPrice_USD',
            'price', 'compareAtPrice', 'salePrice',
            'meta_badges', 'grouped_products',
            'swatch_image_url', 'product_hex',
            'meta_promotion_values',
            'meta_promotion_handles',
            'video_urls',
            'tags',
        ].join(',');

        let apiUrl = 'https://recommendations.unbxd.io/v3.0/' +
            getApiKey() +
            '/' +
            getSiteName() +
            '/recommendation?template=false&pageType=' +
            encodeURIComponent(pageContext.pageType) +
            '&uid=' +
            encodeURIComponent(unbxdUid) + '&variants=true&variants.count=100' +
            '&fields=' + encodeURIComponent(recsFields);

        if (pageContext.pageType === 'PRODUCT' && pageContext.productId) {
            apiUrl += '&id=' + encodeURIComponent(pageContext.productId);
        }

        API_URL = apiUrl;
    }

    const DEFAULT_IMAGE = 'https://libraries.unbxdapi.com/sdk-assets/defaultImage.svg';
    function getActiveCountryCodeRecs() {
        return (typeof window !== 'undefined' && window.Shopify && window.Shopify.country) ? window.Shopify.country : null;
    }
    /** Format price by Shopify country: GB=£ GBP, AU=$ AUD, NZ=$ NZD, SG=$ SGD, US=$ */
    function formatPriceRecs(price, country) {
        if (price === '' || price == null || isNaN(parseFloat(price))) return '';
        var num = parseFloat(price);
        var formatted = num.toFixed(2);
        switch (country) {
            case 'GB': return '£' + formatted + ' GBP';
            case 'AU': return '$' + formatted + ' AUD';
            case 'NZ': return '$' + formatted + ' NZD';
            case 'SG': return '$' + formatted + ' SGD';
            case 'US': return '$' + formatted;
            default: return '$' + formatted;
        }
    }
    function generateSrcsetRecs(url) {
        if (!url) return '';
        const widths = [160, 320, 480, 640, 800, 960];
        return widths.map(function (w) { return (url.indexOf('?') !== -1 ? url + '&width=' + w : url + '?width=' + w) + ' ' + w + 'w'; }).join(', ');
    }

    function generateProductHTML(value, index, analyticsData) {
        const unxTitle = value.title || '';
        const uniqueId = value.uniqueId || '';
        const productUrl = value.productUrl || ('/products/' + uniqueId);
        const productHandle = value.handle || uniqueId;
        let imgUrl = Array.isArray(value.imageUrl) ? value.imageUrl[0] : value.imageUrl;
        const images = value.images || [];
        const imgUrl2 = Array.isArray(images) && images.length > 1 ? images[images.length - 2] : null;

        if (!imgUrl) imgUrl = DEFAULT_IMAGE;

        const videoUrls = Array.isArray(value.video_urls) ? value.video_urls : [];
        const hoverVideoUrl = videoUrls.find(function(u) { return u.toLowerCase().endsWith('.mp4'); }) || '';

        if (typeof window._unbxdProductStore === 'undefined') window._unbxdProductStore = {};

        var parsedVariants = [];
        try {
            var pvRaw = value.product_variants;
            if (pvRaw && typeof pvRaw === 'string' && pvRaw !== '[]') {
                parsedVariants = JSON.parse(pvRaw);
            } else if (Array.isArray(pvRaw)) {
                parsedVariants = pvRaw;
            }
        } catch (e) { console.error('[Unbxd Recs] Error parsing product_variants:', e); }

        var storedVariants = parsedVariants.map(function (v) {
            var avail = v.v_availableForSale;
            var availBool = !(avail === false || String(avail).toLowerCase() === 'false');
            var sizePart = (v.v_Size != null) ? v.v_Size : '';
            var colorPart = (v.v_Color != null) ? v.v_Color : '';
            var label = [sizePart, colorPart].filter(Boolean).join(' / ') || 'Default Title';
            return {
                id: String(v.variantId || ''),
                v_Size: sizePart,
                v_Color: colorPart,
                title: label,
                v_availableForSale: avail,
                available: availBool,
                availability: availBool ? 'true' : 'false',
            };
        }).filter(function (v) { return !!v.id; });

        if (storedVariants.length === 0 && value.variantId) {
            var synthAvail = value.v_availableForSale;
            var synthAvailBool = !(synthAvail === false || String(synthAvail).toLowerCase() === 'false');
            var synthLabel = [value.v_Size, value.v_Color].filter(Boolean).join(' / ') || 'Default Title';
            storedVariants = [{
                id: String(value.variantId),
                v_Size: value.v_Size || '',
                v_Color: value.v_Color || '',
                title: synthLabel,
                v_availableForSale: synthAvail,
                available: synthAvailBool,
                availability: value.availability,
            }];
        }

        var hasAnyAvailable = storedVariants.some(function (v) { return v.available === true; });
        var isOutOfStock = storedVariants.length > 0 ? !hasAnyAvailable : String(value.v_availableForSale).toLowerCase() === 'false';

        const productTags = Array.isArray(value.tags) ? value.tags : (typeof value.tags === 'string' ? value.tags.split(',').map(function (t) { return t.trim(); }) : []);
        const isInStoreOnly = productTags.some(function (tag) { return tag.toLowerCase() === 'in-store only'; });
        const addToBagLabel = isOutOfStock ? 'Notify Me' : 'Add to Bag';
        const addToBagAriaLabel = isOutOfStock ? (unxTitle + ' is Sold Out') : (unxTitle + ' - Add to Bag');

        var defaultVariant = storedVariants.find(function (v) { return v.available === true; }) || storedVariants[0];
        var defaultVariantId = defaultVariant ? defaultVariant.id : (value.variantId || '');

        window._unbxdProductStore[uniqueId] = {
            id: value.id || uniqueId,
            uniqueId: uniqueId,
            title: unxTitle,
            handle: productHandle,
            imageUrl: imgUrl,
            images: images,
            available: hasAnyAvailable,
            availability: hasAnyAvailable ? 'true' : 'false',
            variants: storedVariants,
        };

        var activeCountryCode = getActiveCountryCodeRecs();
        var currencyPriceMap = {
            GB: { price: value.price_GBP, compareAt: value.compareAtPrice_GBP },
            AU: { price: value.price_AUD, compareAt: value.compareAtPrice_AUD },
            NZ: { price: value.price_NZD, compareAt: value.compareAtPrice_NZD },
            SG: { price: value.price_SGD, compareAt: value.compareAtPrice_SGD },
            US: { price: value.price_USD, compareAt: value.compareAtPrice_USD },
        };
        var currencyData = currencyPriceMap[activeCountryCode] || null;
        var displayPrice = (currencyData && currencyData.price) || value.price || '';
        var compareAtPrice = (currencyData && currencyData.compareAt) || value.compareAtPrice || value.salePrice || '';

        var displayPriceFormatted = formatPriceRecs(displayPrice, activeCountryCode);
        var compareAtPriceFormatted = formatPriceRecs(compareAtPrice, activeCountryCode);

        // Secondary hover slot — video takes priority over secondary image
        let secondaryImageUI = '';
        if (hoverVideoUrl) {
            let posterUrl = imgUrl2 ? (imgUrl2.indexOf('?') !== -1 ? imgUrl2 + '&width=600' : imgUrl2 + '?width=600') : '';
            secondaryImageUI = '<div class="product-card__image--secondary">' +
                '<div class="component-video__wrapper aspect-ratio aspect-ratio--2-3">' +
                '<video playsinline="playsinline" class="component-video__video" preload="none" autoplay="autoplay" muted="muted" loop="loop" ' +
                'aria-label="' + unxTitle + '" width="1080" height="1920" ' +
                (posterUrl ? 'poster="' + posterUrl + '" ' : '') +
                'disablepictureinpicture="true" disableremoteplayback="true" x-webkit-airplay="deny">' +
                '<source src="' + hoverVideoUrl + '" type="video/mp4">' +
                '<img alt="' + unxTitle + '" src="' + (posterUrl || '') + '">' +
                '</video>' +
                '</div></div>';
        } else if (imgUrl2 && imgUrl2 !== imgUrl) {
            secondaryImageUI = '<div class="product-card__image--secondary"><div class="component-image__wrapper aspect-ratio aspect-ratio--2-3">' +
                '<img srcset="' + generateSrcsetRecs(imgUrl2) + '" src="' + (imgUrl2.indexOf('?') !== -1 ? imgUrl2 + '&width=600' : imgUrl2 + '?width=600') + '" loading="lazy" ' +
                'sizes="(min-width: 85.5rem) calc(85.5rem / 3), (min-width: 61.875rem) calc(100vw / 3), 100vw" width="1000" height="1500" alt="' + unxTitle + '" class="component-image__image">' +
                '</div></div>';
        }

        var metaBadges = value.meta_badges || [];
        var badgesArray = Array.isArray(metaBadges) ? metaBadges : (typeof metaBadges === 'string' ? [metaBadges] : []);
        var badgesUI = badgesArray.length > 0
            ? '<div class="product-badges product-card__badges" data-product-badges="">' +
              badgesArray.map(function (badge) {
                  var slug = badge.toLowerCase().replace(/&/g, '').replace(/\s+/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '');
                  return '<div class="badge badge__' + slug + '">' + badge + '</div>';
              }).join('') +
              '</div>'
            : '';
        const hasSaleTag=productTags.some(tag => tag.toLowerCase() === 'sale') || productTags.some(tag => tag.toLowerCase() === 'outlet');
        var priceDisplay = compareAtPrice && parseFloat(compareAtPrice) > parseFloat(displayPrice)
             ? '<span class="visually-hidden">Sale price</span><span>' + displayPriceFormatted + '</span><span class="visually-hidden">Regular price</span><span class="product-card__compare-price ' + (hasSaleTag ? 'sale-price' : '') + ' ns-font-4 ns-text-striked ns-ml-2">' + compareAtPriceFormatted + '</span>'
             : '<span>' + displayPriceFormatted + '</span>';

        var groupedProducts = [];
        try {
            var gpRaw = value.grouped_products;
            if (gpRaw && typeof gpRaw === 'string' && gpRaw !== '[]') groupedProducts = JSON.parse(gpRaw);
            else if (Array.isArray(gpRaw)) groupedProducts = gpRaw;
        } catch (e) { console.error('[Unbxd Recs] Error parsing grouped_products:', e); }

        var currentProductForSwatch = {
            title: unxTitle,
            id: value.id || uniqueId,
            uniqueId: uniqueId,
            availability: value.availability,
            available: value.available,
            price: value.price || displayPrice,
            imageUrl: imgUrl,
            productUrl: productUrl,
            meta_badges: value.meta_badges || [],
            meta_promotion_values: value.meta_promotion_values || [],
            meta_promotion_handles: value.meta_promotion_handles || [],
            images: images,
            variants: storedVariants,
            handle: productHandle,
            swatch_image_url: value.swatch_image_url || '',
            product_hex: value.product_hex || [],
            video_urls: videoUrls,
        };

        groupedProducts.forEach(function(gp) {
            if (!Array.isArray(gp.video_urls)) gp.video_urls = [];
        });

        var allSwatchProducts = [currentProductForSwatch].concat(groupedProducts);
        if (typeof window._unbxdSwatchData === 'undefined') window._unbxdSwatchData = {};
        window._unbxdSwatchData[uniqueId] = allSwatchProducts;

        var swatchesUI = '';
        if (allSwatchProducts.length > 1) {
            var swatchItems = '';
            allSwatchProducts.forEach(function (sp, i) {
                var spSwatchImg = sp.swatch_image_url || '';
                var spHexArr = sp.product_hex || [];
                var spHex = Array.isArray(spHexArr) ? spHexArr[0] : spHexArr;
                var swatchStyle = spSwatchImg ? ('background-image: url(' + spSwatchImg + ');') : (spHex ? ('background-color: ' + spHex + ';') : '');
                var spTitle = sp.title || '';
                var spId = sp.uniqueId || sp.id || '';
                var activeClass = i === 0 ? ' swatch--active' : '';
                swatchItems += '<li><button type="button" class="swatch UNX-product-swatch' + activeClass + '" title="' + spTitle + '" aria-label="Switch to ' + spTitle + '" data-swatch-action="switchProduct" data-swatch-product-id="' + spId + '" data-swatch-tile-id="' + uniqueId + '" style="' + swatchStyle + '"></button></li>';
            });
            swatchesUI = '<div class="product-card__swatches swatches"><ul class="swatches__list list-none">' + swatchItems + '</ul></div>';
        }

        const metaPromotionValues = value.meta_promotion_values || [];
        const promotionArray = Array.isArray(metaPromotionValues) ? metaPromotionValues : (typeof metaPromotionValues === 'string' ? [metaPromotionValues] : []);
        const metaPromotionHandles = value.meta_promotion_handles || [];
        const promotionHandle = Array.isArray(metaPromotionHandles) ? metaPromotionHandles[0] : metaPromotionHandles;
        const promotionModifier = promotionHandle ? ' product-card__promotion--' + promotionHandle : '';
        const promotionUI = promotionArray.length > 0
            ? '<div class="product-card__promotion' + promotionModifier + ' caption">' + promotionArray.join(', ') + '</div>'
            : '';

        var innerHTML =
            '<product-card data-product-card="" class="product-card" id="' + uniqueId + '">' +
            '  <div class="product-card__top">' +
            '    ' + badgesUI +
            '    <div class="product-card__image">' +
            '      <a href="' + productUrl + '">' +
            '        <div class="component-image__wrapper aspect-ratio aspect-ratio--2-3">' +
            '          <img srcset="' + generateSrcsetRecs(imgUrl) + '" src="' + (imgUrl.indexOf('?') !== -1 ? imgUrl + '&width=600' : imgUrl + '?width=600') + '" loading="lazy" sizes="(min-width: 85.5rem) calc(85.5rem / 3), (min-width: 61.875rem) calc(100vw / 3), 100vw" width="1000" height="1500" alt="' + unxTitle + '" class="component-image__image" onerror="this.src=\'' + DEFAULT_IMAGE + '\';">' +
            '        </div>' +
            '        ' + secondaryImageUI +
            '      </a>' +
            '    </div>' +
            (isInStoreOnly ? '' : ('    <div class="product-card__actions ns-relative">' +
            '      <button type="submit" data-product-modal-trigger="' + productHandle + '" data-product-modal-type="' + (isOutOfStock ? 'notify' : 'add') + '" data-variant-id="' + defaultVariantId + '" aria-label="' + addToBagAriaLabel + '" class="product-card__add body-small">' +
            '        <span class="hide show--min-lg">' + addToBagLabel + '</span>' +
            '        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Add to Bag" class="icon icon--add hide show--max-lg">' +
            '          <path d="M5 1V3V5M5 5V9M5 5H1M5 5H9" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path>' +
            '        </svg>' +
            '      </button>' +
            '    </div>')) +
            '  </div>' +
            '  <div class="product-card__meta">' +
            '    <h4 id="product-title-' + uniqueId + '-unbxd-recs" class="product-card__title body-small">' +
            '      <a href="' + productUrl + '">' + unxTitle + '</a>' +
            '    </h4>' +
            '    <div class="product-card__price body-small">' +
            '      <a href="' + productUrl + '" aria-describedby="product-title-' + uniqueId + '-unbxd-recs">' + priceDisplay + '</a>' +
            '    </div>' +
            (isInStoreOnly ? '' : ('    <button aria-label="Add to Wishlist" data-product-modal-trigger="' + productHandle + '" data-product-modal-type="wishlist" data-wishlist-icon="' + uniqueId + '" class="product-card__wishlist btn--none">' +
            '      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Heart Icon" class="icon icon--heart">' +
            '        <path d="M3.4543 11.7241C5.60157 15.6966 9.98827 18.8966 11.9566 20C13.9249 18.8966 18.3984 15.6966 20.5457 11.7241C21.6193 9.73794 21.0825 4 15.7143 4C14.1038 4 13.245 4.96158 11.9566 6.28571C10.6683 4.96158 9.89618 4 8.28566 4C2.91748 4 2.38073 9.73794 3.4543 11.7241Z" stroke="currentColor" stroke-width="1.2" stroke-linejoin="round" vector-effect="non-scaling-stroke" class="icon--fill"></path>' +
            '      </svg>' +
            '    </button>')) +
            '  </div>' +
            swatchesUI +
            promotionUI +
            '</product-card>';

        var html =
            '<div class="_unbxd_recs-slider__item UNX-product-card" id="hz-item-' + index + '"' +
            ' data-id="' + uniqueId + '"' +
            ' data-product-id="' + uniqueId + '"' +
            ' data-prank="' + index + '"' +
            ' data-unbxdparam_experience_widget="' + (analyticsData.widgetNum ? analyticsData.widgetNum.toUpperCase() : '') + '"' +
            ' data-unbxdparam_experience_pagetype="' + (analyticsData.pageType || '') + '"' +
            ' data-unbxdparam_sku="' + uniqueId + '"' +
            ' data-unbxdparam_requestId="">' +
            innerHTML +
            '</div>';

        return html;
    }

    function generateSliderHTML(widget, analyticsData) {
        const heading = (widget.widgetTitle || '').replace(/^[^-]+-\s*/, '');
        const recommendations = widget.recommendations || [];

        if (recommendations.length === 0) {
            return '';
        }

        let productsHTML = '';
        recommendations.forEach(function (value, index) {
            productsHTML += generateProductHTML(value, index, analyticsData);
        });

        const showArrows = recommendations.length > 4;

        const prevArrowHTML = showArrows ? `
                    <button type='button' aria-label='Previous' class='slider-arrow slider-prev slick-arrow' onclick='_unbxd_recsSliderScrollPrev(event)'>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon icon--chevron-left" aria-label="Chevron Left Icon"><path d="m15 18-6-6 6-6" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" vector-effect="non-scaling-stroke"></path></svg>
                    </button>` : '';

        const nextArrowHTML = showArrows ? `
                    <button type='button' aria-label='Next' class='slider-arrow slider-next slick-arrow' onclick='_unbxd_recsSliderScrollNext(event)'>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon icon--chevron-right" aria-label="Chevron Right Icon"><path d="m9 18 6-6-6-6" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" vector-effect="non-scaling-stroke"></path></svg>
                    </button>` : '';

        const sliderHTML = `
            <div class='unbxd-recs-slider'>
                <div class='_unbxd_recs-slider-header'>
                 <h1 class='fw-400 fs-32 lh-1-1 ff-proxima-nova text-nn-purple mb-0' id='_unbxd_recs-slider-heading' tabIndex='0'>${heading}</h1>
                    <div class='_unbxd_recs-slider-controls'>
                        <a href='/collections/best-sellers' class='_unbxd_recs-slider-see-all'>See all</a>
                    </div>
                </div>
                <div class='_unbxd_recs-slider-container' id='_unbxd_recs-slider-container'>
                    ${prevArrowHTML}
                    <div class='_unbxd_recs-slider' id='_unbxd_recs-slider'>
                        ${productsHTML}
                    </div>
                    ${nextArrowHTML}
                </div>
            </div>`;

        return sliderHTML;
    }

    /**
     * Update left/right slider arrow disabled state based on scroll position.
     * @param {Element} wrapper - The .unbxd-recs-slider wrapper element
     */
    function updateRecsSliderArrowState(wrapper) {
        if (!wrapper) return;
        const slider = wrapper.querySelector('._unbxd_recs-slider');
        const prevBtn = wrapper.querySelector('.slider-prev');
        const nextBtn = wrapper.querySelector('.slider-next');
        if (!slider || !prevBtn || !nextBtn) return;

        const scrollLeft = slider.scrollLeft;
        const maxScroll = slider.scrollWidth - slider.clientWidth;
        const threshold = 2;

        const atStart = maxScroll <= 0 || scrollLeft <= threshold;
        const atEnd = maxScroll <= 0 || scrollLeft >= maxScroll - threshold;

        prevBtn.disabled = atStart;
        nextBtn.disabled = atEnd;
        prevBtn.setAttribute('aria-disabled', atStart ? 'true' : 'false');
        nextBtn.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
        prevBtn.classList.toggle('slider-arrow--disabled', atStart);
        nextBtn.classList.toggle('slider-arrow--disabled', atEnd);
    }

    window._unbxd_recsSliderScrollPrev = function (event) {
        const btn = event.currentTarget || event.target.closest('button');
        if (btn && btn.disabled) return;
        try {
            const wrapper = (btn || event.target).closest('.unbxd-recs-slider');
            const slider = wrapper ? wrapper.querySelector('._unbxd_recs-slider') : null;
            if (slider) {
                slider.scrollBy({ left: -slider.clientWidth, behavior: 'smooth' });
            }
        } catch (e) {
            console.error('[Unbxd Recs] Error scrolling slider prev:', e);
        }
    };

    window._unbxd_recsSliderScrollNext = function (event) {
        const btn = event.currentTarget || event.target.closest('button');
        if (btn && btn.disabled) return;
        try {
            const wrapper = (btn || event.target).closest('.unbxd-recs-slider');
            const slider = wrapper ? wrapper.querySelector('._unbxd_recs-slider') : null;
            if (slider) {
                slider.scrollBy({ left: slider.clientWidth, behavior: 'smooth' });
            }
        } catch (e) {
            console.error('[Unbxd Recs] Error scrolling slider next:', e);
        }
    };

    /**
     * Enable mouse drag-to-scroll on the slider track with momentum/inertia.
     * Tracks drag velocity and continues scrolling after release with friction
     * deceleration. Prevents accidental link clicks after a drag gesture.
     */
    function initDragScroll(slider) {
        if (!slider) return;

        let isDown = false;
        let startX = 0;
        let scrollLeftStart = 0;
        let hasDragged = false;

        let velX = 0;
        let lastX = 0;
        let lastTime = 0;
        let rafId = null;
        const DECEL = 0.92;
        const MAX_VEL = 40;
        const STOP_VEL = 0.4;

        function stopMomentum() {
            if (rafId) { cancelAnimationFrame(rafId); rafId = null; }
            slider.classList.remove('is-momentum');
        }

        function runMomentum() {
            velX *= DECEL;
            if (Math.abs(velX) < STOP_VEL) { stopMomentum(); return; }
            slider.scrollLeft += velX;
            rafId = requestAnimationFrame(runMomentum);
        }

        slider.addEventListener('mousedown', function (e) {
            if (e.button !== 0) return;
            stopMomentum();
            isDown = true;
            hasDragged = false;
            startX = e.pageX - slider.offsetLeft;
            scrollLeftStart = slider.scrollLeft;
            lastX = e.pageX;
            lastTime = performance.now();
            velX = 0;
            slider.classList.add('is-dragging');
            e.preventDefault();
        });

        document.addEventListener('mouseup', function () {
            if (!isDown) return;
            isDown = false;
            slider.classList.remove('is-dragging');
            if (Math.abs(velX) > STOP_VEL) {
                slider.classList.add('is-momentum');
                rafId = requestAnimationFrame(runMomentum);
            }
        });

        document.addEventListener('mousemove', function (e) {
            if (!isDown) return;
            e.preventDefault();
            const x = e.pageX - slider.offsetLeft;
            const walk = x - startX;
            if (Math.abs(walk) > 4) hasDragged = true;

            const now = performance.now();
            const dt = now - lastTime;
            if (dt > 0) {
                const raw = (lastX - e.pageX) / dt * 16;
                velX = Math.max(-MAX_VEL, Math.min(MAX_VEL, raw));
            }
            lastX = e.pageX;
            lastTime = now;

            slider.scrollLeft = scrollLeftStart - walk;
        });

        slider.addEventListener('click', function (e) {
            if (hasDragged) {
                e.preventDefault();
                e.stopPropagation();
                hasDragged = false;
            }
        }, true);
    }

    let _widgetContainerIndex = 0;

    function getElementIdForWidget(widget, widgetIndex) {
        const containers = window._unbxd_recs_containers || [];
        
        if (containers.length === 0) {
            return null;
        }

        const containerIndex = (widgetIndex !== undefined) ? widgetIndex : _widgetContainerIndex;
        
        if (containerIndex < containers.length) {
            const container = containers[containerIndex];
            if (widgetIndex === undefined) {
                _widgetContainerIndex++;
            }
            return container.elementId;
        } else {
            const lastContainer = containers[containers.length - 1];
            return lastContainer.elementId;
        }
    }

    function renderWidget(widget, analyticsData, widgetIndex) {
        try {
            const elementId = getElementIdForWidget(widget, widgetIndex);

            if (!elementId) return;

            const targetElement = document.getElementById(elementId);
            if (!targetElement) return;

            const recommendations = widget.recommendations || [];
            if (recommendations.length === 0) return;

            const sliderHTML = generateSliderHTML(widget, analyticsData);
            targetElement.innerHTML = sliderHTML;

            const wrapper = targetElement.querySelector('.unbxd-recs-slider');
            if (wrapper) {
                const slider = wrapper.querySelector('._unbxd_recs-slider');
                if (slider) {
                    const updateArrows = function () { updateRecsSliderArrowState(wrapper); };
                    slider.addEventListener('scroll', updateArrows);
                    requestAnimationFrame(function () { updateArrows(); });
                    initDragScroll(slider);
                }
            }
        } catch (e) {
            console.error('[Unbxd Recs] Error rendering widget:', e);
        }
    }

    function fetchAndRenderRecommendations() {
        if (!API_URL) return;

        fetch(API_URL)
            .then(function (response) {
                if (!response.ok) {
                    throw new Error('Network response was not ok: ' + response.status);
                }
                return response.json();
            })
            .then(function (data) {
                if (!data || !data.response || !data.response.widgets) return;

                const widgets = data.response.widgets;
                const requestId = window.unbxdRequestId ||
                    (data.recsMetaData && data.recsMetaData.requestId) ||
                    'req-' + Date.now();

                widgets.forEach(function (widget, index) {
                    const analyticsData = {
                        widgetNum: widget.widgetId || '',
                        pageType: (pageContext && pageContext.pageType) ? pageContext.pageType : 'Home',
                        requestId: requestId
                    };
                    renderWidget(widget, analyticsData, index);
                });
            })
            .catch(function (error) {
                console.error('[Unbxd Recs] Error fetching recommendations:', error);
            });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            initializePageContext();
            fetchAndRenderRecommendations();
        });
    } else {
        initializePageContext();
        fetchAndRenderRecommendations();
    }

})();


const defaultImageUrl = "/assets/placeholder.svg";

const AUTOSUGGEST_IMAGE_SIZES = [320, 480, 640, 800, 960];

function createImageDataSrcSet(image, sizes) {
  let img = Array.isArray(image) ? image[0] : String(image || "");
  let srcSet = [];
  for (var size of sizes) {
    let url = img.includes("?")
      ? `${img}&width=${size}`
      : `${img}?width=${size}`;
    srcSet.push(`${url} ${size}w`);
  }
  return srcSet.join(",");
}

function createImage(imageUrl, title, sizes) {
  let img = Array.isArray(imageUrl) ? imageUrl[0] : String(imageUrl || "");
  let srcSet = createImageDataSrcSet(img, sizes);
  return `<img class="product-media__image lazyautosizes lazyloaded" data-aspectratio="1.0" data-sizes="auto" src="${img}" alt="${title}"
      srcset="${srcSet}" width="" height="" loading="eager" sizes="(min-width: 1740px) 20vw, (min-width: 1392px) 25vw, (min-width: 1044px) 33vw, (min-width: 750px) 50vw, 100vw"
      transitiontoproduct="false" data_max_resolution="${img}" fetchpriority="auto"/>`;
}

// Prepend the Shopify region root to redirect URLs.
// Unbxd redirect values are always same-site URLs, so for absolute URLs we
// extract just the path (ignoring the stored hostname which may differ from
// the live hostname e.g. www vs non-www) and apply the region prefix.
// Truly external URLs (different TLD/domain) are returned unchanged.
function applyRegionToRedirectUrl(url) {
  if (!url) return url;
  const _shopifyRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const _rootPrefix = _shopifyRoot === '/' ? '' : _shopifyRoot.replace(/\/$/, '');

  let _path;
  if (/^https?:\/\//.test(url)) {
    try {
      const parsed = new URL(url);
      const currentHost = window.location.hostname.replace(/^www\./, '');
      const redirectHost = parsed.hostname.replace(/^www\./, '');
      // Leave truly external URLs (different domain) alone.
      if (redirectHost !== currentHost) return url;
      _path = parsed.pathname + parsed.search + parsed.hash;
    } catch (e) {
      return url;
    }
  } else {
    _path = url.startsWith('/') ? url : '/' + url;
  }

  if (!_rootPrefix) return window.location.origin + _path;
  // Avoid double-prefixing if the path already starts with the region segment.
  const _regionPath = _path.startsWith(_rootPrefix + '/') ? _path : _rootPrefix + _path;
  return window.location.origin + _regionPath;
}

function navigateWithRedirectCheck(query, apiKey, siteName, assign) {
  const q = (query || "").trim();
  const url =
    "https://search.unbxd.io/" + apiKey + "/" + siteName +
    "/search?q=" + encodeURIComponent(q) +
    "&rows=0&facet=off&indent=off&analytics=false";
  $.ajax({
    url: url,
    dataType: "jsonp",
    jsonp: "json.wrf",
    cache: true,
    timeout: 3000,
    success: function(resp) {
      const redir = resp && resp.redirect;
      assign((redir && redir.type === "url" && redir.value)
        ? applyRegionToRedirectUrl(redir.value)
        : buildSearchUrl(q));
    },
    error: function() { assign(buildSearchUrl(q)); },
  });
}

const getActiveCountryCodeAS = () => {
  return (window.Shopify && window.Shopify.country) || null;
};

/**
 * Builds the search page URL preserving the Shopify locale path prefix
 * (e.g. /en-nz, /en-us) so multi-market context is not lost on navigation.
 * Produces: https://example.com/en-nz/search?q=dress
 */
const buildSearchUrl = (query) => {
  // window.Shopify.routes.root gives the locale-aware root, e.g. '/en-nz/' or '/'
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const localePath = root.replace(/\/$/, ''); // strip trailing slash -> '/en-nz' or ''
  const trimmedQuery = query && query.trim() !== '' ? query.trim() : '';

  if (!trimmedQuery) {
    return window.location.origin + localePath + '/search';
  }

  return window.location.origin + localePath + '/search?q=' + encodeURIComponent(trimmedQuery);
};

let isMobile = {
  Android: function () {
    return navigator.userAgent.match(/Android/i);
  },
  BlackBerry: function () {
    return navigator.userAgent.match(/BlackBerry/i);
  },
  iOS: function () {
    return navigator.userAgent.match(/iPhone|iPad|iPod/i);
  },
  Opera: function () {
    return navigator.userAgent.match(/Opera Mini/i);
  },
  Windows: function () {
    return navigator.userAgent.match(/IEMobile/i);
  },
  any: function () {
    return (
      isMobile.Android() ||
      isMobile.BlackBerry() ||
      isMobile.iOS() ||
      isMobile.Opera() ||
      isMobile.Windows()
    );
  },
};

let unbxdAsInputSelector = ".modal__body input.search__input";

let PopularproductCount = 4;
let keywordSuggestionsCount = 6;
let topQueriesCount = 5;
let hardcodedTopQueries = [
  "Essentials",
  "Sale",
  "Outlet"
];
let hardcodedKeywordSuggestions = [
  "Jeans",
  "Dresses",
  "Raincoats",
  "Pants",
  "Denim",
  "Blazer",
  "Shoes",
  "Belt",
  "Monet"
];

let hardcodedPopularProducts = [];

let _popularProductsFetching = false;

/**
 * Fetches "most-loved" category products early so they are ready when the user
 * opens autosuggest with an empty query. Mutates the hardcodedPopularProducts
 * array in-place so the lib reference (set at init time) stays in sync.
 */
const fetchMostLovedProducts = () => {
  if (_popularProductsFetching || hardcodedPopularProducts.length > 0) return;
  _popularProductsFetching = true;

  const countryCode = getActiveCountryCodeAS();
  const marketFilter = countryCode
    ? "&filter=available_markets%3A%22" + countryCode + "%22"
    : "";

  const url =
    "https://search.unbxd.io/" + getApiKey() + "/" + getSiteName() + "/category" +
    "?p=category_handle_uFilter%3A%22most-loved%22" +
    "&variants=true" +
    "&variants.fields=v_availableForSale%2Cv_Size%2Cv_Color%2CvariantId" +
    "&variants.count=100" +
    "&variants.groupBy=price" +
    "&fields=title%2Cid%2CuniqueId%2Cavailable%2Cavailability%2Cprice%2Csku%2CimageUrl%2CproductUrl%2Cimages%2Cvariants%2Cprice_AUD%2Cprice_NZD%2Cprice_USD%2CcompareAtPrice_AUD%2CcompareAtPrice_NZD%2CcompareAtPrice_USD%2Chandle" +
    "&pagetype=boolean" +
    "&rows=" + PopularproductCount +
    "&start=0" +
    "&version=V2" +
    "&viewType=GRID" +
    "&facet.version=V2" +
    marketFilter;

  $.ajax({
    url: url,
    dataType: "jsonp",
    jsonp: "json.wrf",
    cache: true,
    timeout: 5000,
    success: function (resp) {
      const products = resp && resp.response && resp.response.products;
      if (products && products.length) {
        // Mutate in-place so the lib's options reference stays valid
        hardcodedPopularProducts.length = 0;
        Array.prototype.push.apply(hardcodedPopularProducts, products);
      }
      _popularProductsFetching = false;
    },
    error: function () {
      _popularProductsFetching = false;
    },
  });
};

const buildPageUrl = (path) => {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const localePath = root.replace(/\/$/, ''); // strip trailing slash -> '/en-nz' or ''
  return window.location.origin + localePath + path;
};

const getHelpBlockHtml = () => `<li class="unbxd-as-help-block-li"><div data-testid="block-component" class="search-flyout__wrapper search-flyout__wrapper--links-list unbxd-as-help-block"><h4 class="search-flyout__title"><span>Explore More</span></h4><ul class="search-flyout__links-list"><li><a rel="" data-label="" href="${buildPageUrl('/pages/store-locator')}">Store Locator</a></li><li><a rel="" data-label="" href="${buildPageUrl('/pages/returns-exchanges')}">Return & Exchange</a></li><li><a rel="" data-label="" href="${buildPageUrl('/pages/faqs')}">FAQs</a></li><li><a rel="" data-label="" href="${buildPageUrl('/pages/ledition')}">Read Our Blog</a></li><li><a rel="" data-label="" href="${buildPageUrl('/pages/about-blue-illusion')}">About Blue Illusion</a></li></ul></div></li>`;

const wrapPopularProductsRow = () => {
  if (window.innerWidth > 992) return;
  const mainContent = document.querySelector(".unbxd-as-maincontent");
  if (!mainContent) return;

  const header = mainContent.querySelector(".unbxd-as-popular-product-header");
  let row = mainContent.querySelector(".unbxd-as-popular-products-row");
  if (!row) {
    row = document.createElement("div");
    row.className = "unbxd-as-popular-products-row";
    if (header && header.parentNode === mainContent) {
      header.insertAdjacentElement("afterend", row);
    } else {
      mainContent.appendChild(row);
    }
  }

  // On every render, move any product cards outside the row back into the row.
  const productsOutsideRow = Array.from(
    mainContent.querySelectorAll(".unbxd-as-popular-product")
  ).filter(
    (product) =>
      !product.parentElement ||
      !product.parentElement.classList.contains("unbxd-as-popular-products-row")
  );
  if (!productsOutsideRow.length) return;
  productsOutsideRow.forEach((product) => row.appendChild(product));
};

/**
 * Wraps TOP_SEARCH_QUERIES pills into a flex container so they
 * flow neatly into rows regardless of screen width or text length.
 * The lib renders them as flat <li> siblings inside <ul.unbxd-as-maincontent>,
 * so we collect them after the header and move them into a wrapper <li>.
 */
const wrapTopQueryPills = () => {
  const mainContent = document.querySelector(".unbxd-as-maincontent");
  if (!mainContent) return;

  const header = mainContent.querySelector(".unbxd-as-top-queries-header");
  if (!header) return;

  let wrapper = mainContent.querySelector(".unbxd-top-queries-pills-row");
  if (!wrapper) {
    wrapper = document.createElement("li");
    wrapper.className = "unbxd-top-queries-pills-row";
    header.insertAdjacentElement("afterend", wrapper);
  }

  const pills = Array.from(
    mainContent.querySelectorAll('li.unbxd-as-keysuggestion[data-type="TOP_SEARCH_QUERIES"]')
  ).filter((pill) => pill.parentElement !== wrapper);

  pills.forEach((pill) => wrapper.appendChild(pill));
};

const ensurePopularProductsRow = () => {
  if (window.innerWidth > 992) return;
  let attempts = 0;
  const maxAttempts = 10;

  const tryWrap = () => {
    attempts += 1;
    wrapPopularProductsRow();

    const rowExists = document.querySelector(".unbxd-as-popular-products-row");
    if (rowExists || attempts >= maxAttempts) return;

    requestAnimationFrame(tryWrap);
  };

  requestAnimationFrame(tryWrap);
};

/**
 * Add "See All" button beside Popular Products header
 */
const addSeeMoreButtonToProductsHeader = () => {
  try {
    const productsHeader = document.querySelector('.unbxd-as-popular-product-header');
    if (!productsHeader) return;

    const inputValue = document.querySelector(unbxdAsInputSelector)?.value?.trim() || '';
    const existingBtn = productsHeader.querySelector('.unbxd-see-all-btn');

    if (!existingBtn) {
      // Create see all button
      const seeAllBtn = document.createElement('p');
      seeAllBtn.className = 'unbxd-see-all-btn';
      seeAllBtn.textContent = 'See All';

      // Add click handler
      seeAllBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        const currentInput = document.querySelector(unbxdAsInputSelector)?.value?.trim();
        if (!currentInput) {
          window.location.href = applyRegionToRedirectUrl('https://blueillusion.com/collections/most-loved');
          return;
        }
        navigateWithRedirectCheck(currentInput, getApiKey(), getSiteName(), function(u) { window.location.href = u; });
      });

      productsHeader.appendChild(seeAllBtn);
    } else {
      // Button exists, ensure it's visible
      existingBtn.style.display = '';
      existingBtn.style.visibility = 'visible';
      existingBtn.style.opacity = '1';
    }
  } catch (error) {
    console.error("Error adding see all button:", error);
  }
};

/**
 * Adds close button to autosuggest dropdown
 */
const addCloseButton = () => {
  const unbxdWrapper = document.querySelector(".unbxd-as-wrapper");
  if (unbxdWrapper && !unbxdWrapper.querySelector(".unbxd-as-close-btn")) {
    const closeButton = document.createElement("div");
    closeButton.className = "unbxd-as-close-btn";
    closeButton.innerHTML = `
      <button type="button" class="unbxd-close-button" aria-label="Close autosuggest" title="Close">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    `;

    unbxdWrapper.insertBefore(closeButton, unbxdWrapper.firstChild);
    closeButton
      .querySelector(".unbxd-close-button")
      .addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        hideAutosuggest();
      });
  }
};

/**
 * Aligns the autosuggest wrapper width, left, and top position with the search form.
 * Uses getBoundingClientRect so it works perfectly across all breakpoints
 * (1024, 1280, etc.) without hard-coded viewport units.
 */
const alignAutosuggestWithSearchBox = () => {
  const wrapper = document.querySelector('.unbxd-as-wrapper');
  if (!wrapper) return;

  const refEl =
    document.querySelector('.modal--search .modal__body .search__form') ||
    document.querySelector('.modal--search .container') ||
    document.querySelector('.modal__body');
  if (!refEl) return;

  const refRect = refEl.getBoundingClientRect();
  const parent = wrapper.offsetParent;
  const parentRect = parent ? parent.getBoundingClientRect() : { left: 0, top: 0 };

  const newTop = refRect.bottom - parentRect.top;
  wrapper.style.setProperty('top', newTop + 'px', 'important');
  wrapper.style.setProperty('margin-top', '0px', 'important');

  if (window.innerWidth <= 992) {
    wrapper.style.removeProperty('left');
    wrapper.style.removeProperty('width');
    wrapper.style.removeProperty('min-width');
    wrapper.style.removeProperty('max-width');
    return;
  }

  const newLeft = refRect.left - parentRect.left;
  const newWidth = refRect.width;

  wrapper.style.setProperty('left', newLeft + 'px', 'important');
  wrapper.style.setProperty('width', newWidth + 'px', 'important');
  wrapper.style.setProperty('min-width', newWidth + 'px', 'important');
  wrapper.style.setProperty('max-width', newWidth + 'px', 'important');
};

/* lock/unlock body scroll on mobile when autosuggest opens/closes */
const bodyScroll = {
  lock: () => {
      document.body.classList.add("unbxd-scroll-lock");
  },
  unlock: () => {
    document.body.classList.remove("unbxd-scroll-lock");
  },
};

/**
 * Watches the wrapper's style attribute and keeps the body scroll lock in
 * sync automatically — mirrors the ackermans pattern so every show/hide
 * path (library, close button, backdrop tap, etc.) is covered without
 * needing manual lock/unlock calls scattered through the code.
 */
let _scrollLockObserverSetup = false;
const setupScrollLockObserver = () => {
  if (_scrollLockObserverSetup) return;
  const wrapper = document.querySelector(".unbxd-as-wrapper");
  if (!wrapper) return;
  _scrollLockObserverSetup = true;
  new MutationObserver(() => {
    if (wrapper.style.display === "none") {
      bodyScroll.unlock();
    } else {
      bodyScroll.lock();
    }
  }).observe(wrapper, { attributes: true, attributeFilter: ["style"] });
};

/**
 * Hides the autosuggest dropdown
 */
const hideAutosuggest = () => {
  const unbxdWrapper = document.querySelector(".unbxd-as-wrapper");
  if (unbxdWrapper) {
    unbxdWrapper.style.display = "none";
  }

  const input = document.querySelector(unbxdAsInputSelector);
  if (input) {
    input.blur();
  }
};

let resultclassSelector="header.header"
const getUnbxdASConfig = () => {
  const countryCode = getActiveCountryCodeAS();
  const popularProductsFilter = countryCode ? `available_markets:${countryCode}` : "";

  const config = {
    siteName: getSiteName(),
    APIKey: getApiKey(),
    minChars: 0,
    loadingClass: "unbxd-as-loading",
    resultsContainerSelector: resultclassSelector,
    sideContentOn: "right",
    zIndex: 1000000,
    position: "absolute",
    carttype: "separate",
    isMobile: function () {
      return window.innerWidth <= 992 || isMobile.any();
    },
    sanitizeQueryString: function (q) {
      return q.trim();
    },
    customQueryParse: function (q) {
      const cleaned = q ? q.trim() : "";
      return cleaned === "" ? "*" : cleaned;
    },
    onItemSelect: function (data, original) {
      const _shopifyRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const _rootPrefix = _shopifyRoot === '/' ? '' : _shopifyRoot.replace(/\/$/, '');
      if (data.type === "POPULAR_PRODUCTS" || data.type ==="POPULAR_PRODUCTS_FILTERED") {
        if (original && original.productUrl) {
          const _rawUrl = original.productUrl;
          window.location.href = _rootPrefix + (_rawUrl.startsWith('/') ? _rawUrl : '/' + _rawUrl);
        }
        return false;
      }

      const self = this;
      const query = (data.value || '').trim();
      navigateWithRedirectCheck(query, self.options.APIKey, self.options.siteName, function(u) { window.location = u; });
      return false;
    },
    template: "2column",
    // The initial request uses q=*. Keep its dropdown limited to merchandising promotions.
    showOnlyPromotedSuggestionsOnEmptyQuery: true,
    mainTpl: ["promotedSuggestions", "keywordSuggestions", "topQueries"],
    sideTpl: ["popularProducts"],
    theme: "#666666",
    mobile: {
      template: "1column",
      mainTpl: ["popularProducts","promotedSuggestions","keywordSuggestions","topQueries"],
      popularProducts: {
        count: PopularproductCount,
      },
    },
    trendingSearches: {
      enabled: false,
    },
    inFields: {
      count: 0,
    },
    hardcodedTopQueries: hardcodedTopQueries,
    // hardcodedKeywordSuggestions: hardcodedKeywordSuggestions,
    // hardcodedPopularProducts: hardcodedPopularProducts,
    topQueries: {
      count: topQueriesCount,
      header: "Trending",
      sort: "unbxdAutosuggestScore desc",
    },
    promotedSuggestions: {
      count: 6,
      header: "Top Searches"
    },
    keywordSuggestions: {
      count: keywordSuggestionsCount,
      header: "Top Searches",
      sort: "frequency_unbxd_double desc",
    },
    noResultTpl: function(query) {
      var decodedQuery = decodeURIComponent(query);
      return '<div class="unbxd-as-no-results"><p>No results found for <strong>"' + decodedQuery + '"</strong></p></div>';
    },
    removeDuplicates: true,
    filtered: true,
    platform: "io",
    hideOnResize: false,
    removeOnBackButton: false,
    searchEndPoint: "https://search.unbxd.io",
    onSimpleEnter: function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();

      const self = this;
      const query = $(this.input).val().trim();
      if (!query) {
        window.location = buildSearchUrl(query);
        return;
      }
      navigateWithRedirectCheck(query, self.options.APIKey, self.options.siteName, function(u) { window.location = u; });
    },
    onShowResults: function () {
      setupScrollLockObserver();
      bodyScroll.lock();
      wrapPopularProductsRow();
      wrapTopQueryPills();
      addCloseButton();
      alignAutosuggestWithSearchBox();

      wrapPopularProductsRow();
      wrapTopQueryPills();
      addSeeMoreButtonToProductsHeader();
      addCloseButton();

      setTimeout(() => {
        wrapPopularProductsRow();
        wrapTopQueryPills();
        addSeeMoreButtonToProductsHeader();
        addCloseButton();
        alignAutosuggestWithSearchBox();
      }, 150);
      setTimeout(alignAutosuggestWithSearchBox, 400);
    },
    onRender: function() {
      wrapPopularProductsRow();
      wrapTopQueryPills();
      addSeeMoreButtonToProductsHeader();
      addCloseButton();
      alignAutosuggestWithSearchBox();

      setTimeout(() => {
        wrapPopularProductsRow();
        wrapTopQueryPills();
        addSeeMoreButtonToProductsHeader();
        addCloseButton();
        alignAutosuggestWithSearchBox();
      }, 100);
      setTimeout(() => {
        wrapPopularProductsRow();
        wrapTopQueryPills();
        addSeeMoreButtonToProductsHeader();
        addCloseButton();
        alignAutosuggestWithSearchBox();
      }, 300);
    },
    popularProducts: {
      count: PopularproductCount,
      filter: popularProductsFilter,
      price: true,
      priceFunctionOrKey: "price",
      image: true,
      imageUrlOrFunction: "imageUrl",
      header: "Best Sellers",
      name: true,
      nameFunctionOrKey: "title",
      viewMore: {
        enabled: true,
        tpl: getHelpBlockHtml(),
        redirect: function () {},
      },
      fields: [
        "doctype",
        "autosuggest",
        "price",
        "imageUrl",
        "title",
        "productUrl",
        "price_AUD",
        "price_NZD",
        "price_USD",
        "compareAtPrice_AUD",
        "compareAtPrice_NZD",
        "compareAtPrice_USD",
        "tags"
      ],
      tpl: [
         `<div class="unbxd-as-popular-product-info" href="{{regionUrl _original.productUrl}}">
           <a href="{{regionUrl _original.productUrl}}" class="unbxd-as-popular-product-image-container">
             {{{renderProductImage _original}}}
            </a>
            <h4 class="quick-search-results__title body-small">
              <a href="{{regionUrl _original.productUrl}}">{{_original.title}}</a>
            </h4>
            <p class="money body-small">{{{formatPrice _original}}}</p>
         </div>`,
      ],
    },
    hbsHelpers: function() {
      Handlebars.registerHelper("regionUrl", function(url) {
        return applyRegionToRedirectUrl(url || '');
      });
      Handlebars.registerHelper("renderProductImage", function(product) {
        let rawImage = product.imageUrl;
        let imageUrl = rawImage != undefined ? (Array.isArray(rawImage) ? rawImage[0] : String(rawImage)) : defaultImageUrl;
        let title = product.title || "";
        return new Handlebars.SafeString(createImage(imageUrl, title, AUTOSUGGEST_IMAGE_SIZES));
      });
      Handlebars.registerHelper("getImageUrl", function(product) {
        return product.imageUrl != undefined ? product.imageUrl : defaultImageUrl;
      });
      Handlebars.registerHelper("formatPrice", function(product) {
        var activeCountryCode = getActiveCountryCodeAS();
        var currencyPriceMap = {
          AU: { price: product.price_AUD, compareAt: product.compareAtPrice_AUD, currencyLabel: 'AUD' },
          NZ: { price: product.price_NZD, compareAt: product.compareAtPrice_NZD, currencyLabel: 'NZD' },
          US: { price: product.price_USD, compareAt: product.compareAtPrice_USD, currencyLabel: 'USD' },
        };
        var currencyData = currencyPriceMap[activeCountryCode] || null;
        var displayPrice = (currencyData && currencyData.price) || product.price || '';
        var compareAtPrice = (currencyData && currencyData.compareAt) || '';
        var currencyLabel = (currencyData && currencyData.currencyLabel) || '';

        if (displayPrice === '' || displayPrice == null) return '';
        var formattedPrice = parseFloat(displayPrice).toFixed(2);
        var suffix = currencyLabel ? ' ' + currencyLabel : '';
        var productTags = Array.isArray(product.tags) ? product.tags : (typeof product.tags === 'string' ? product.tags.split(',').map(t => t.trim()) : []);
        var hasSaleTag=productTags.some(tag => tag.toLowerCase() === 'sale') || productTags.some(tag => tag.toLowerCase() === 'outlet');
       

        if (compareAtPrice && parseFloat(compareAtPrice) > parseFloat(displayPrice)) {
          var formattedCompare = parseFloat(compareAtPrice).toFixed(2);
          return new Handlebars.SafeString(
            '<span class="visually-hidden">Sale price</span><span>$' + formattedPrice + suffix + '</span>'
            + '<span class="visually-hidden">Regular price</span>'
            + '<span class="product-card__compare-price ' + (hasSaleTag ? 'sale-price' : '') + ' ns-font-4 ns-text-striked ns-ml-2">$' + formattedCompare + suffix + '</span>'
          );
        }
        return new Handlebars.SafeString('<span>$' + formattedPrice + suffix + '</span>');
      });
    }
  };
  return config;
};
const initUnbxdAs = () => {
  unbxdAutoSuggestFunction(jQuery, Handlebars);

  // Lazy init: do not create autosuggest wrapper on page load.
  const initializeAutosuggestIfNeeded = function () {
    const $input = jQuery(unbxdAsInputSelector);
    if (!$input.length) return false;
    if ($input[0].auto) return true;
    $input.unbxdautocomplete(getUnbxdASConfig());
    return !!($input[0] && $input[0].auto);
  };

  // Flag to suppress the focus handler when triggerAutosuggestOnInput is
  // deliberately calling $input.focus() for side-effects only (hasFocus).
  // Without this guard, focus fires onChange AND triggerAutosuggestOnInput
  // fires it again, causing a double-render flicker on every re-open.
  var _suppressFocusHandler = false;

  // Trigger autosuggest on focus of search input
  jQuery(document).on("focus", unbxdAsInputSelector, function () {
    if (_suppressFocusHandler) return;
    if (!initializeAutosuggestIfNeeded()) return;
    var autoObj = this.auto;
    if (autoObj) {
      var originalPrevious = autoObj.previous;
      autoObj.previous = "__FORCE_REFRESH__";
      autoObj.onChange();
      autoObj.previous = originalPrevious;
      wrapPopularProductsRow();
      wrapTopQueryPills();
      addSeeMoreButtonToProductsHeader();
      setTimeout(() => {
        wrapTopQueryPills();
        addSeeMoreButtonToProductsHeader();
      }, 150);
      setTimeout(() => {
        wrapTopQueryPills();
        addSeeMoreButtonToProductsHeader();
      }, 300);
    } else {
      var $input = jQuery(this);
      $input.unbxdautocomplete(getUnbxdASConfig());
      if ($input[0] && $input[0].auto) {
        $input[0].auto.previous = "__FORCE_REFRESH__";
        $input[0].auto.onChange();
      }
    }
  });

  // Helper to trigger autosuggest on the actual input element
  var triggerAutosuggestOnInput = function () {
    if (!initializeAutosuggestIfNeeded()) return;
    var $input = jQuery(unbxdAsInputSelector);
    if (!$input.length) return;
    var inputDom = $input[0];

    var autoObj = inputDom.auto;
    if (autoObj) {
      // Set hasFocus before focusing so the library knows the field is active.
      // Suppress the focus event handler so onChange is only called once below.
      autoObj.hasFocus = true;
      _suppressFocusHandler = true;
      $input.focus();
      _suppressFocusHandler = false;

      var originalPrevious = autoObj.previous;
      autoObj.previous = "__FORCE_REFRESH__";
      autoObj.onChange();
      autoObj.previous = originalPrevious;
      ensurePopularProductsRow();
      wrapTopQueryPills();
      setTimeout(() => {
        wrapTopQueryPills();
        addSeeMoreButtonToProductsHeader();
      }, 150);
      setTimeout(() => {
        wrapTopQueryPills();
        addSeeMoreButtonToProductsHeader();
      }, 300);
    } else {
      $input.unbxdautocomplete(getUnbxdASConfig());
      setTimeout(function () {
        var a = $input[0].auto;
        if (a) {
          a.hasFocus = true;
          var op = a.previous;
          a.previous = "__FORCE_REFRESH__";
          a.onChange();
          a.previous = op;
          ensurePopularProductsRow();
          wrapTopQueryPills();
          addSeeMoreButtonToProductsHeader();
        }
      }, 150);
    }
  };

  // Handle click on input to trigger autosuggest
  jQuery(document).on("click", unbxdAsInputSelector, function () {
    console.log("Click event triggered on input");
    triggerAutosuggestOnInput();
  });

  // Suppress focus handler early via mousedown (fires before Shopify's
  // click handler opens the modal and focuses the input).
  jQuery(document).on(
    "mousedown",
    "button.modal__trigger.header__btn.header__btn--search",
    function () {
      _suppressFocusHandler = true;
    }
  );

  jQuery(document).on(
    "click",
    "button.modal__trigger.header__btn.header__btn--search",
    function () {
      console.log("Click event triggered on search button");

      setTimeout(function () {
        _suppressFocusHandler = false;
        var $input = jQuery(unbxdAsInputSelector);
        if (!$input.length || !$input.is(":visible")) return;
        triggerAutosuggestOnInput();
        setTimeout(alignAutosuggestWithSearchBox, 200);
      }, 300);
    }
  );
  // Update see all button on input changes
  jQuery(document).on('input keyup', unbxdAsInputSelector, function() {
    setTimeout(() => {
      addSeeMoreButtonToProductsHeader();
    }, 50);
    setTimeout(() => {
      addSeeMoreButtonToProductsHeader();
    }, 300);
    // Keyboard just appeared — recalc wrapper height so full content is scrollable
    setTimeout(adjustMobileAsWrapperHeight, 100);
    setTimeout(adjustMobileAsWrapperHeight, 400);
  });

  // Re-add see all button when hovering over suggestions triggers a re-render of products
  jQuery(document).on('mouseenter', '.unbxd-as-keysuggestion, .unbxd-as-topquery, .unbxd-as-promoted-suggestion', function() {
    addSeeMoreButtonToProductsHeader();
    setTimeout(addSeeMoreButtonToProductsHeader, 100);
    setTimeout(addSeeMoreButtonToProductsHeader, 300);
    setTimeout(addSeeMoreButtonToProductsHeader, 600);
  });
};

// Clamp wrapper height to visible area above the virtual keyboard.
// Android: window.innerHeight shrinks on keyboard open (resize event).
// iOS: visualViewport.height shrinks instead (visualViewport resize event).
const MOBILE_BREAKPOINT = 992;
const WRAPPER_BOTTOM_GAP = 10;

const adjustMobileAsWrapperHeight = () => {
  if (window.innerWidth > MOBILE_BREAKPOINT) return;
  const wrapper = document.querySelector('.unbxd-as-wrapper.unbxd-as-overall-autosuggest');
  if (!wrapper || wrapper.style.display === 'none') return;

  const rect = wrapper.getBoundingClientRect();
  // visualViewport.height shrinks on iOS when keyboard opens;
  // window.innerHeight shrinks on Android Chrome when keyboard opens.
  const viewportHeight = window.visualViewport
    ? window.visualViewport.height
    : window.innerHeight;

  const available = viewportHeight - rect.top - WRAPPER_BOTTOM_GAP;
  if (available > 100) {
    wrapper.style.setProperty('max-height', available + 'px', 'important');
  }
};

document.addEventListener("DOMContentLoaded", function () {
  initUnbxdAs();

  let _resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(_resizeTimer);
    _resizeTimer = setTimeout(() => {
      alignAutosuggestWithSearchBox();
      adjustMobileAsWrapperHeight();
    }, 100);
  });

  // iOS Safari: keyboard open/close fires visualViewport resize, not window resize
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', adjustMobileAsWrapperHeight);
  }

});

// Delegated click handler for see all button (fallback safety net)
jQuery(document).on('click', '.unbxd-see-all-btn', function(e) {
  e.stopPropagation();
  const inputValue = document.querySelector(unbxdAsInputSelector)?.value?.trim();
  if (!inputValue) {
    window.location.href = applyRegionToRedirectUrl('https://blueillusion.com/collections/most-loved');
    return;
  }
  navigateWithRedirectCheck(inputValue, getApiKey(), getSiteName(), function(u) { window.location.href = u; });
});

var unbxdAutoSuggestFunction = function ($, Handlebars, params) {
  window.Unbxd = window.Unbxd || {};
  Unbxd.autosuggestVersion = "1.0.1";
  if (!window.location.origin) {
    window.location.origin =
      window.location.protocol +
      "//" +
      window.location.hostname +
      (window.location.port ? ":" + window.location.port : "");
  }
  if (!Array.prototype.forEach) {
    Array.prototype.forEach = function (callback, thisArg) {
      var T, k;
      if (this == null) {
        throw new TypeError(" this is null or not defined");
      }
      var O = Object(this);
      var len = O.length >>> 0;
      if (typeof callback !== "function") {
        throw new TypeError(callback + " is not a function");
      }
      if (arguments.length > 1) {
        T = thisArg;
      }
      var k = 0;
      while (k < len) {
        var kValue;
        if (k in O) {
          kValue = O[k];
          callback.call(T, kValue, k, O);
        }
        k++;
      }
    };
  }
  if (!Array.prototype.indexOf) {
    Array.prototype.indexOf = function (searchElement, fromIndex) {
      var k;
      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }
      var O = Object(this);
      var len = O.length >>> 0;
      if (len === 0) {
        return -1;
      }
      var n = +fromIndex || 0;
      if (Math.abs(n) === Infinity) {
        n = 0;
      }
      if (n >= len) {
        return -1;
      }
      k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);
      while (k < len) {
        if (k in O && O[k] === searchElement) {
          return k;
        }
        k++;
      }
      return -1;
    };
  }
  var topQuery = "";
  var isMobile = {
    Android: function () {
      return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function () {
      return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function () {
      return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera: function () {
      return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function () {
      return navigator.userAgent.match(/IEMobile/i);
    },
    any: function () {
      return (
        isMobile.Android() ||
        isMobile.BlackBerry() ||
        isMobile.iOS() ||
        isMobile.Opera() ||
        isMobile.Windows()
      );
    },
  };
  var isDesktop = function () {
    return !(typeof this.options.isMobile === "function"
      ? this.options.isMobile()
      : isMobile.any());
  };
  var customSort = function (a, b) {
    if (a.length - b.length === 0) {
      return a.localeCompare(b);
    } else {
      return a.length - b.length;
    }
  };
  Handlebars.registerHelper("unbxdIf", function (v1, v2, options) {
    return v1 === v2 ? options.fn(this) : options.inverse(this);
  });
  Handlebars.registerHelper("safestring", function (value) {
    return new Handlebars.SafeString(value);
  });
  function autocomplete(input, options) {
    this.input = input;
    this.init(input, options);
  }
  function debounce(func, wait, immediate) {
    var timeout;
    return function () {
      var context = this,
        args = arguments;
      var later = function () {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }
  window.autoSuggestObj = $.extend(autocomplete.prototype, {
    default_options: {
      siteName: "demosite-u1407617955968",
      APIKey: "64a4a2592a648ac8415e13c561e44991",
      integrations: {},
      resultsClass: "unbxd-as-wrapper",
      minChars: 3,
      delay: 100,
      loadingClass: "unbxd-as-loading",
      mainWidth: 0,
      sideWidth: 180,
      zIndex: 1e4,
      position: "absolute",
      sideContentOn: "right",
      template: "1column",
      theme: "#ff8400",
      hideOnResize: false,
      mainTpl: [
        "inFields",
        "keywordSuggestions",
        "topQueries",
        "popularProducts",
        "promotedSuggestions",
      ],
      sideTpl: [],
      showCarts: true,
      cartType: "inline",
      onCartClick: function (obj) {},
      hbsHelpers: null,
      onSimpleEnter: null,
      onItemSelect: null,
      noResultTpl: null,
      mobile: {
        template: "1column",
        mainTpl: [
          "inFields",
          "keywordSuggestions",
          "topQueries",
          "promotedSuggestions",
          "popularProducts",
        ],
        popularProducts: { count: 2 },
      },
      trendingSearches: {
        enabled: true,
        tpl: "{{{safestring highlighted}}}",
        maxCount: 6,
        preferInputWidthTrending: true,
      },
      inFields: {
        count: 2,
        fields: { brand: 3, category: 3, color: 3 },
        header: "",
        tpl: "{{{safestring highlighted}}}",
      },
      topQueries: {
        count: 2,
        hidden: false,
        header: "",
        tpl: "{{{safestring highlighted}}}",
      },
      keywordSuggestions: {
        count: 2,
        header: "",
        tpl: "{{{safestring highlighted}}}",
      },
      promotedSuggestions: { count: 3, tpl: "{{{safestring highlighted}}}" },
      suggestionsHeader: "",
      popularProducts: {
        count: 2,
        price: true,
        priceFunctionOrKey: "price",
        name: true,
        nameFunctionOrKey: "title",
        salePrice: false,
        salePriceKey: "",
        image: true,
        imageUrlOrFunction: "imageUrl",
        currency: "Rs.",
        header: "",
        view: "list",
        tpl: [
          "{{#if ../showCarts}}",
          '{{#unbxdIf ../../cartType "inline"}}',
          '<div class="unbxd-as-popular-product-inlinecart">',
          '<div class="unbxd-as-popular-product-image-container">',
          "{{#if image}}",
          '<img src="{{image}}" alt="{{autosuggest}}"/>',
          "{{/if}}",
          "</div>",
          '<div  class="unbxd-as-popular-product-name popular-title">',
          '<div style="table-layout:fixed;width:100%;display:table;">',
          '<div style="display:table-row">',
          '<div style="display:table-cell;text-overflow:ellipsis;overflow: hidden;white-space: nowrap;">',
          "{{{safestring highlighted}}}",
          "</div>",
          "</div>",
          "</div>",
          "</div>",
          "{{#if price}}",
          '<div class="unbxd-as-popular-product-price">',
          "{{#if salePrice}}",
          '<span class="regular-price">',
          "{{currency}}{{price}}",
          "</span>",
          '<span class="unbxd-as-discount">',
          "{{currency}}{{salePrice}}",
          "</span>",
          "{{else}}",
          "{{currency}}{{price}}",
          "{{/if}}",
          "</div>",
          "{{/if}}",
          '<div class="unbxd-as-popular-product-quantity">',
          '<div class="unbxd-as-popular-product-quantity-container">',
          "<span>Qty</span>",
          '<input class="unbxd-popular-product-qty-input" value="1"/>',
          "</div>",
          "</div>",
          '<div class="unbxd-as-popular-product-cart-action">',
          '<button class="unbxd-as-popular-product-cart-button">Add to cart</button>',
          "</div>",
          "</div>",
          "{{else}}",
          '<div class="unbxd-as-popular-product-info">',
          '<div class="unbxd-as-popular-product-image-container">',
          "{{#if image}}",
          '<img src="{{image}}" alt="{{autosuggest}}"/>',
          "{{/if}}",
          "</div>",
          "<div>",
          '<div  class="unbxd-as-popular-product-name popular-title">',
          "{{{safestring highlighted}}}",
          "</div>",
          '<div class="unbxd-as-popular-product-cart">',
          '<div class="unbxd-as-popular-product-cart-action">',
          '<button class="unbxd-as-popular-product-cart-button">Add to cart</button>',
          "</div>",
          '<div class="unbxd-as-popular-product-quantity">',
          '<div class="unbxd-as-popular-product-quantity-container">',
          "<span>Qty</span>",
          '<input class="unbxd-popular-product-qty-input" value="1"/>',
          "</div>",
          "</div>",
          "{{#if price}}",
          '<div class="unbxd-as-popular-product-price">',
          "{{#if salePrice}}",
          '<span class="regular-price">',
          "{{currency}}{{price}}",
          "</span>",
          '<span class="unbxd-as-discount">',
          "{{currency}}{{salePrice}}",
          "</span>",
          "{{else}}",
          "{{currency}}{{price}}",
          "{{/if}}",
          "</div>",
          "{{/if}}",
          "</div>",
          "</div>",
          "</div>",
          "{{/unbxdIf}}",
          "{{else}}",
          '<div class="unbxd-as-popular-product-info">',
          '<div class="unbxd-as-popular-product-image-container">',
          "{{#if image}}",
          '<img src="{{image}}" alt="{{autosuggest}}"/>',
          "{{/if}}",
          "</div>",
          '<div  class="unbxd-as-popular-product-name popular-title">',
          "{{{safestring highlighted}}}",
          "</div>",
          "{{#if price}}",
          '<div class="unbxd-as-popular-product-price">',
          "{{#if salePrice}}",
          '<span class="regular-price">',
          "{{currency}}{{price}}",
          "</span>",
          '<span class="unbxd-as-discount">',
          "{{currency}}{{salePrice}}",
          "</span>",
          "{{else}}",
          "{{currency}}{{price}}",
          "{{/if}}",
          "</div>",
          "{{/if}}",
          "</div>",
          "{{/if}}",
        ].join(""),
        viewMore: { enabled: false, tpl: "", redirect: function () {} },
      },
      removeDuplicates: false,
      filtered: false,
      preferInputWidthTotalContent: false,
      platform: "com",
      sortedSuggestions: { tpl: "{{{safestring highlighted}}}" },
      removeOnBackButton: false,
      resultsContainerSelector: null,
      processResultsStyles: null,
      inputContainerSelector: "",
      getProductsInfo: function (that) {
        return that.productInfo;
      },
      searchEndPoint: "//search.unbxd.io",
    },
    productInfo: {},
    $input: null,
    $results: null,
    timeout: null,
    previous: "",
    activeRow: -1,
    activeColumn: 0,
    keyb: false,
    compiledPopularProductHeader: "",
    hasFocus: false,
    lastKeyPressCode: null,
    ajaxCall: null,
    currentResults: [],
    currentTopResults: [],
    cache: {},
    params: { query: "*", filters: {} },
    preferOneColumnFullWidth: false,
    selectedClass: "unbxd-ac-selected",
    scrollbarWidth: null,
    getPopularProductsHeader: function (ctxt) {
      var popularProductsHeader = ctxt.options.popularProducts.header;
      var ppHeader = "";
      if (typeof popularProductsHeader === "string") {
        ppHeader = popularProductsHeader;
      } else if (typeof popularProductsHeader === "function") {
        ppHeader = popularProductsHeader(ctxt);
      }
      return ppHeader;
    },
    init: function (input, options) {
      this.options = $.extend({}, this.default_options, options);
      this.setDefaultPopularProductsOptions();
      this.setDefaultOptions();
      this.getPopularProductFields();
      this.$input = $(input).attr("autocomplete", "off");
      this.$results = $("<div/>", {
        class: this.options.resultsClass + " " + "unbxd-as-overall-autosuggest",
      })
        .css(
          "position",
          this.options.position === "relative"
            ? "absolute"
            : this.options.position,
        )
        .hide();
      if (this.options.zIndex > 0)
        this.$results.css("zIndex", this.options.zIndex);
      if (
        typeof this.options.resultsContainerSelector == "string" &&
        this.options.resultsContainerSelector.length
      )
        $(this.options.resultsContainerSelector).append(this.$results);
      else $("body").append(this.$results);
      if (typeof this.options.hbsHelpers === "function")
        this.options.hbsHelpers.call(this);
      if (this.options.trendingSearches.enabled) {
        this.trendingQueries = [];
        var trendingUrl =
          (this.options.searchEndPoint
            ? this.options.searchEndPoint + "/"
            : "https://search.unbxd.io/") +
          this.options.APIKey +
          "/" +
          this.options.siteName +
          "/autosuggest?trending-queries=true&q=*";
        var that = this;
        $.ajax({ url: trendingUrl, method: "GET" })
          .done(function (data) {
            if (
              data &&
              data.response.products &&
              data.response.products.length > 0
            ) {
              var products = data.response.products.splice(
                0,
                that.options.trendingSearches.maxCount,
              );
              if (!that.clickResults) {
                that.clickResults = {};
              }
              that.clickResults.TRENDING_QUERIES = products;
              for (var i = 0; i < products.length; i++) {
                var doc = products[i];
                that.processTrendingQueries(doc);
              }
              that.$results.html("");
              var cmpld = Handlebars.compile(that.prepareTrendingQueriesHTML());
              that.$results.html(cmpld({ data1: that.trendingQueries }));
            }
          })
          .fail(function (xhr) {
            console.log("error", xhr);
          });
      }
      this.wire();
    },
    wire: function () {
      var self = this;
      this.$input.bind("keydown.auto", this.keyevents());
      this.$input.bind("select.auto", function () {
        self.log("select : setting focus");
        self.hasFocus = true;
      });
      $(".unbxd-as-wrapper").on(
        "mouseover",
        "ul.unbxd-as-maincontent",
        function (e) {
          if ($.contains(self.$results[0], e.target) && self.options.filtered) {
            $("." + self.selectedClass).removeClass(self.selectedClass);
            $(e.target).addClass(self.selectedClass);
            var $et = $(e.target),
              p = $et;
            self.hasFocus = false;
            if (e.target.tagName !== "LI") {
              p = $et.parents("li");
            }
            var dataValue = $(p).attr("data-value")
              ? $(p).attr("data-value")
              : "";
            var dataFiltername = $(p).attr("data-filtername")
              ? $(p).attr("data-filtername")
              : "";
            var dataFiltervalue = $(p).attr("data-filtervalue")
              ? $(p).attr("data-filtervalue")
              : "";
            if (
              !p ||
              p.hasClass("unbxd-as-header") ||
              p.hasClass("unbxd-as-popular-product") ||
              p.hasClass("topproducts") ||
              e.target.tagName === "INPUT"
            )
              return;
            if (dataValue) {
              var query =
                dataValue +
                (dataFiltername != ""
                  ? ":" + dataFiltername + ":" + dataFiltervalue
                  : "");
              if (self.options.filtered) {
                var ppHeader = self.getPopularProductsHeader(self);
                var cmpldHeader = Handlebars.compile(ppHeader);
                self.compiledPopularProductHeader = cmpldHeader({
                  hoverSuggestion: dataValue,
                });
              }
              var cmpld = "";
              if (
                self.options.popularProducts.viewMore &&
                self.options.popularProducts.viewMore.enabled
              ) {
                if (self.options.template === "1column") {
                  $(".unbxd-as-maincontent").addClass("unbxd-as-view-more");
                } else {
                  $(".unbxd-as-sidecontent").addClass("unbxd-as-view-more");
                }
                cmpld = Handlebars.compile(
                  self.preparefilteredPopularProducts() +
                    self.options.popularProducts.viewMore.tpl,
                );
              } else {
                cmpld = Handlebars.compile(
                  self.preparefilteredPopularProducts(),
                );
              }
              if (
                self.currentTopResults[query] &&
                self.currentTopResults[query].length > 0
              ) {
                $(".unbxd-as-sidecontent").html(
                  cmpld({
                    data: self.currentTopResults[query],
                    showCarts: self.options.showCarts,
                    cartType: self.options.cartType,
                  }),
                );
              } else {
                $(".unbxd-as-sidecontent").html(
                  cmpld({
                    data: self.currentResults.POPULAR_PRODUCTS,
                    showCarts: self.options.showCarts,
                    cartType: self.options.cartType,
                  }),
                );
              }
              self.hoveredQuery = dataValue;
            }
            if (
              self.options.popularProducts.view === "grid" &&
              self.options.popularProducts.rowCount
            ) {
              $(".unbxd-as-sidecontent")
                .find("li.unbxd-as-popular-product-grid")
                .css(
                  "width",
                  100 / self.options.popularProducts.rowCount + "%",
                );
            }
          }
        },
      );
      $(window).bind("resize", function () {
        if (self.options.hideOnResize) {
          self.hideResults();
        }
      });
      window.addEventListener("popstate", function (event) {
        if (self.options.removeOnBackButton) {
          $(".unbxd-as-wrapper").hide();
        }
      });
      $(document).bind("click.auto", function (e) {
        if (e.target == self.input) {
          self.log("clicked on input : focused");
          self.hasFocus = true;
          if (self.previous === self.$input.val())
            if (self.$results.find(".unbxd-as-trending").length) {
              self.showResults();
            } else if (
              self.$results.find(".unbxd-as-maincontent").length ||
              self.$results.find(".unbxd-as-sidecontent").length
            ) {
              self.$results.html(self.prepareHTML());
              self.showResults();
            } else {
              self.showResults();
            }
        } else if (e.target == self.$results[0]) {
          self.log("clicked on results block : selecting");
          self.hasFocus = false;
        } else if ($(e.target).hasClass("unbxd-as-view-more")) {
          self.options.popularProducts.viewMore.redirect(
            self.hoveredQuery || self.$input.val(),
          );
        } else if ($.contains(self.$results[0], e.target)) {
          self.log("clicked on element for selection", e.target.tagName);
          var $et = $(e.target),
            p = $et;
          self.hasFocus = false;
          if (e.target.tagName !== "LI") {
            p = $et.parents("li");
          }
          if (
            !p ||
            p.hasClass(".unbxd-as-header") ||
            e.target.tagName == "INPUT"
          )
            return;
          if (
            e.target.tagName == "BUTTON" &&
            $et.hasClass("unbxd-as-popular-product-cart-button") &&
            typeof self.options.onCartClick == "function"
          ) {
            self.log("BUTTON click");
            var data = p.data();
            data.quantity = parseFloat(
              p.find("input.unbxd-popular-product-qty-input").val(),
            );
            let clickAnalyticsObj = {};
            let cartAnalyticsObj = {};
            if (data.pid) {
              clickAnalyticsObj.pid = data.pid;
              cartAnalyticsObj.pid = data.pid;
            }
            if (Object.keys(clickAnalyticsObj).length) {
              self.addToAnalytics("click", clickAnalyticsObj);
            }
            self.options.onCartClick.call(
              self,
              data,
              self.currentResults.POPULAR_PRODUCTS[parseInt(data["index"])]
                ._original,
            ) && self.hideResults();
            if (data.quantity) {
              cartAnalyticsObj.qty = data.quantity;
            }
            if (Object.keys(cartAnalyticsObj).length) {
              self.addToAnalytics("addToCart", cartAnalyticsObj);
            }
            return;
          }
          self.selectItem(p.data(), e);
        } else {
          self.hasFocus = false;
          self.hideResults();
        }
      });
      if (
        self.options.trendingSearches.enabled &&
        self.clickResults &&
        self.clickResults.TRENDING_QUERIES.length
      ) {
        $(document).bind("keyup.auto", function (e) {
          if (e.target.value === "") {
            self.$results.html("");
            var cmpld = Handlebars.compile(self.prepareTrendingQueriesHTML());
            self.$results.html(cmpld({ data1: self.trendingQueries }));
            self.showResults();
          }
        });
      }
    },
    keyevents: function () {
      var self = this;
      if (params && params.selfServe) {
        self.onChange();
      } else {
        return function (e) {
          self.lastKeyPressCode = e.keyCode;
          self.lastKeyEvent = e;
          switch (e.keyCode) {
            case 38:
              e.preventDefault();
              self.moveSelect(-1);
              break;
            case 40:
              e.preventDefault();
              self.moveSelect(1);
              break;
            case 39:
              if (self.activeRow > -1) {
                e.preventDefault();
                self.moveSide(1);
              }
              break;
            case 37:
              if (self.activeRow > -1) {
                e.preventDefault();
                self.moveSide(-1);
              }
              break;
            case 9:
            case 13:
              if (self.selectCurrent(e)) {
                e.preventDefault();
              } else {
                self.hideResultsNow();
              }
              break;
            default:
              self.activeRow = -1;
              $("." + self.selectedClass).removeClass(self.selectedClass);
              self.hasFocus = true;
              if (self.timeout) clearTimeout(self.timeout);
              self.timeout = setTimeout(
                debounce(function () {
                  self.onChange();
                }, 250),
                self.options.delay,
              );
              break;
          }
        };
      }
    },
    moveSide: function (step) {
      var newcolumn = this.activeColumn;
      if (this.options.template == "2column") {
        if (this.options.sideContentOn == "left") {
          this.activeColumn == 0 && step == -1 && (newcolumn = 1);
          this.activeColumn == 1 && step == 1 && (newcolumn = 0);
        } else {
          this.activeColumn == 0 && step == 1 && (newcolumn = 1);
          this.activeColumn == 1 && step == -1 && (newcolumn = 0);
        }
        if (newcolumn != this.activeColumn) {
          this.activeColumn = newcolumn;
          this.activeRow = -1;
          this.moveSelect(1);
        }
      }
    },
    moveSelect: function (step) {
      var lis = this.$results
        .find(
          "ul." +
            (this.activeColumn
              ? "unbxd-as-sidecontent"
              : "unbxd-as-maincontent"),
        )
        .find("li:not(.unbxd-as-header)");
      if (!lis) return;
      this.activeRow += step;
      if (this.activeRow < -1)
        this.activeRow =
          (typeof lis.size === "function" ? lis.size() : lis.length) - 1;
      else if (this.activeRow == -1) this.$input.focus();
      else if (
        this.activeRow >=
        (typeof lis.size === "function" ? lis.size() : lis.length)
      ) {
        this.activeRow = -1;
        this.$input.focus();
      }
      $("." + this.selectedClass).removeClass(this.selectedClass);
      $(lis[this.activeRow]).addClass(this.selectedClass);
      if (
        this.activeRow >= 0 &&
        this.activeRow <
          (typeof lis.size === "function" ? lis.size() : lis.length)
      ) {
        this.$input.val($(lis[this.activeRow]).data("value"));
        if (this.options.filtered && this.activeColumn === 0) {
          var dataValue = $(lis[this.activeRow]).attr("data-value")
            ? $(lis[this.activeRow]).attr("data-value")
            : "";
          var dataFiltername = $(lis[this.activeRow]).attr("data-filtername")
            ? $(lis[this.activeRow]).attr("data-filtername")
            : "";
          var dataFiltervalue = $(lis[this.activeRow]).attr("data-filtervalue")
            ? $(lis[this.activeRow]).attr("data-filtervalue")
            : "";
          var query =
            dataValue +
            (dataFiltername != ""
              ? ":" + dataFiltername + ":" + dataFiltervalue
              : "");
          if (this.options.filtered) {
            var ppHeader = this.getPopularProductsHeader(this);
            var cmpldHeader = Handlebars.compile(ppHeader);
            this.compiledPopularProductHeader = cmpldHeader({
              hoverSuggestion: dataValue,
            });
          }
          var cmpld = "";
          if (
            this.options.popularProducts.viewMore &&
            this.options.popularProducts.viewMore.enabled
          ) {
            $(".unbxd-as-sidecontent").addClass("unbxd-as-view-more");
            cmpld = Handlebars.compile(
              this.preparefilteredPopularProducts() +
                this.options.popularProducts.viewMore.tpl,
            );
          } else {
            cmpld = Handlebars.compile(this.preparefilteredPopularProducts());
          }
          if (
            this.currentTopResults[query] &&
            this.currentTopResults[query].length > 0
          ) {
            $(".unbxd-as-sidecontent").html(
              cmpld({
                data: this.currentTopResults[query],
                showCarts: this.options.showCarts,
                cartType: this.options.cartType,
              }),
            );
          } else {
            $(".unbxd-as-sidecontent").html(
              cmpld({
                data: this.currentResults.POPULAR_PRODUCTS,
                showCarts: this.options.showCarts,
                cartType: this.options.cartType,
              }),
            );
          }
          if (
            this.options.popularProducts.view === "grid" &&
            this.options.popularProducts.rowCount
          ) {
            this.$results
              .find("ul li.unbxd-as-popular-product-grid")
              .css("width", 100 / this.options.popularProducts.rowCount + "%");
          }
        }
      } else if (this.activeRow == -1) {
        this.$input.val(this.previous);
        if (this.options.filtered) {
          var cmpld = "";
          if (
            this.options.popularProducts.viewMore &&
            this.options.popularProducts.viewMore.enabled
          ) {
            $(".unbxd-as-sidecontent").addClass("unbxd-as-view-more");
            cmpld = Handlebars.compile(
              this.preparefilteredPopularProducts() +
                this.options.popularProducts.viewMore.tpl,
            );
          } else {
            cmpld = Handlebars.compile(this.preparefilteredPopularProducts());
          }
          if (
            this.currentTopResults[this.previous] &&
            this.currentTopResults[this.previous].length > 0
          )
            $(".unbxd-as-sidecontent").html(
              cmpld({
                data: this.currentTopResults[this.previous],
                showCarts: this.options.showCarts,
                cartType: this.options.cartType,
              }),
            );
          else
            $(".unbxd-as-sidecontent").html(
              cmpld({
                data: this.currentResults.POPULAR_PRODUCTS,
                showCarts: this.options.showCarts,
                cartType: this.options.cartType,
              }),
            );
          if (
            this.options.popularProducts.view === "grid" &&
            this.options.popularProducts.rowCount
          ) {
            this.$results
              .find("ul li.unbxd-as-popular-product-grid")
              .css("width", 100 / this.options.popularProducts.rowCount + "%");
          }
        }
      }
    },
    selectCurrent: function (e) {
      var li = this.$results.find("li." + this.selectedClass),
        self = this;
      if (li.length) {
        this.selectItem(li.data(), e);
        return true;
      } else {
        if (
          typeof this.options.onSimpleEnter == "function" &&
          (this.lastKeyPressCode == 10 || this.lastKeyPressCode == 13)
        ) {
          this.lastKeyEvent.preventDefault();
          self.options.onSimpleEnter.call(self, e);
        }
        return false;
      }
    },
    selectItem: function (data, e) {
      if (!("value" in data)) return;
      this.log("selected Item : ", data);
      var v = $.trim(data["value"]),
        prev = this.previous;
      this.previous = v;
      this.input.lastSelected = data;
      this.$results.html("");
      this.$input.val(v);
      this.hideResultsNow(this);
      var autosuggestParamsObj = {
        unbxdprank: parseInt(data.index, 10) + 1 || 0,
        internal_query: prev ? prev : "*",
      };
      if (data.type) {
        if (data.type === "TRENDING_QUERIES") {
          autosuggestParamsObj.autosuggest_type = "TOP_SEARCH_QUERIES";
        } else {
          autosuggestParamsObj.autosuggest_type = data.type;
        }
      }
      if (data.value) {
        if (
          data.type !== "POPULAR_PRODUCTS" &&
          data.type !== "POPULAR_PRODUCTS_FILTERED"
        ) {
          autosuggestParamsObj.autosuggest_suggestion = data.value;
        }
      }
      if (data.filtervalue) {
        autosuggestParamsObj.field_value = data.filtervalue;
      }
      if (data.filtername) {
        autosuggestParamsObj.field_name = data.filtername;
      }
      if (data.source) {
        autosuggestParamsObj.src_field = data.source;
      }
      if (data.pid) {
        autosuggestParamsObj.pid = data.pid;
      }
      if (data.src) {
        autosuggestParamsObj.src_query = data.src;
      }
      var analyticsObj = {
        query: data.value,
        autosuggestParams: autosuggestParamsObj,
      };
      if (data.type === "TRENDING_QUERIES") {
        if (analyticsObj.misc) {
          analyticsObj.misc.unxAsType = "TRENDING_QUERIES";
        } else {
          analyticsObj.misc = { unxAsType: "TRENDING_QUERIES" };
        }
      }
      this.addToAnalytics("search", analyticsObj);
      if (
        data.type === "POPULAR_PRODUCTS" ||
        data.type === "POPULAR_PRODUCTS_FILTERED"
      ) {
        let clickAnalyticsObj = {};
        if (data.pid) {
          clickAnalyticsObj.pid = data.pid;
        }
        if (Object.keys(clickAnalyticsObj).length) {
          this.addToAnalytics("click", { pid: data.pid });
        }
      }
      if (
        typeof this.options.onItemSelect === "function" &&
        data.type === "TRENDING_QUERIES"
      ) {
        this.options.onItemSelect.call(
          this,
          data,
          this.clickResults["TRENDING_QUERIES"][parseInt(data["index"])],
        );
      } else if (
        typeof this.options.onItemSelect == "function" &&
        data.type !== "POPULAR_PRODUCTS_FILTERED"
      ) {
        if (data.sorted) {
          this.options.onItemSelect.call(
            this,
            data,
            this.currentResults["SORTED_SUGGESTIONS"][parseInt(data["index"])]
              ._original,
            e,
          );
        } else {
          this.options.onItemSelect.call(
            this,
            data,
            this.currentResults[data.type][parseInt(data["index"])]._original,
            e,
          );
        }
      } else if (data.type === "POPULAR_PRODUCTS_FILTERED") {
        this.options.onItemSelect.call(
          this,
          data,
          this.currentTopResults[data.src][parseInt(data["index"])]._original,
          e,
        );
      }
    },
    addToAnalytics: function (type, obj) {
      if (
        "Unbxd" in window &&
        "track" in window.Unbxd &&
        typeof window.Unbxd.track == "function"
      ) {
        this.log("Pushing data to analytics", type, obj);
        Unbxd.track(type, obj);
      }
      if (type !== "search") return;
      if ("classical" in this.options.integrations) {
        this.trackclassical(type, obj);
      }
      if ("universal" in this.options.integrations) {
        this.trackuniversal(type, obj);
      }
    },
    getEventAction: function (autosuggestType) {
      var types = {
        IN_FIELD: "Scope_Click",
        POPULAR_PRODUCTS: "Pop_Click",
        KEYWORD_SUGGESTION: "TQ_Click",
        TOP_SEARCH_QUERIES: "TQ_Click",
        POPULAR_PRODUCTS_FILTERED: "Filtered_Pop_Click",
        PROMOTED_SUGGESTION: "TQ_Click",
      };
      return types[autosuggestType];
    },
    getEventLabel: function (autosuggest) {
      var params = autosuggest.autosuggestParams;
      var value = params.autosuggest_suggestion;
      var index = params.unbxdprank;
      var filter =
        params.field_name && params.field_value
          ? params.field_name + ":" + params.field_value
          : undefined;
      var types = {
        IN_FIELD: value + (filter ? "&filter=" + filter : "") + "-" + index,
        POPULAR_PRODUCTS: value + "-" + index,
        KEYWORD_SUGGESTION: value + "-" + index,
        TOP_SEARCH_QUERIES: value + "-" + index,
        POPULAR_PRODUCTS_FILTERED: value + "-" + index,
        PROMOTED_SUGGESTION: value + "-" + index,
      };
      return types[params.autosuggest_type];
    },
    trackclassical: function (type, obj) {
      var key = this.options.integrations["classical"],
        eventAction = this.getEventAction(
          obj.autosuggestParams.autosuggest_type,
        ),
        eventLabel = this.getEventLabel(obj),
        value = 1;
      if (key) {
        if (key === true) key = "_gaq";
        if (window[key])
          window[key].push([
            "_trackEvent",
            "U_Autocomplete",
            eventAction,
            eventLabel,
            value,
            true,
          ]);
      }
    },
    trackuniversal: function (type, obj) {
      var key = this.options.integrations["universal"],
        eventAction = this.getEventAction(
          obj.autosuggestParams.autosuggest_type,
        ),
        eventLabel = this.getEventLabel(obj),
        value = 1;
      if (key) {
        if (key === true) key = "ga";
        if (window[key])
          window[key](
            "send",
            "event",
            "U_Autocomplete",
            eventAction,
            eventLabel,
            value,
            { nonInteraction: 1 },
          );
      }
    },
    showResults: function () {
      if (this.options.width) {
        this.options.mainWidth = this.options.width;
      }
      var posSelector = this.options.inputContainerSelector
        ? $(this.options.inputContainerSelector)
        : this.$input;
      var pos = posSelector.offset();
      var totalWidth = "";
      var mwidth = "";
      if (this.options.platform == "io") {
        totalWidth = this.options.preferInputWidthTotalContent
          ? posSelector.outerWidth()
          : this.options.sideContentOn && this.options.sideContentOn === "left"
            ? pos.left + posSelector.outerWidth()
            : document.body.clientWidth - pos.left;
        if (totalWidth > document.body.clientWidth) {
          totalWidth = document.body.clientWidth;
        }
        if (totalWidth > 788 && totalWidth < 2e3) {
          totalWidth = this.options.totalWidthPercent
            ? (this.options.totalWidthPercent * totalWidth) / 100
            : (70 * totalWidth) / 100;
        } else if (totalWidth > 2e3) {
          totalWidth = (45 * totalWidth) / 100;
        }
        if (
          (this.options.isMobile && this.options.isMobile()) ||
          isMobile.any()
        ) {
          this.options.template = this.options.mobile.template;
          this.options.mainTpl = this.options.mobile.mainTpl;
          this.options.popularProducts.count =
            this.options.mobile.popularProducts.count;
        } else {
          this.options.template = this.options.desktop.template.column;
          this.options.mainTpl = this.options.desktop.mainTpl;
          this.options.popularProducts.count =
            this.options.desktop.popularProducts.count;
        }
        if (this.options.template == "1column") {
          var preferInputWidthMainContent =
            this.options.preferInputWidthMainContent;
          if (isDesktop.call(this)) {
            preferInputWidthMainContent =
              this.options.desktop.template[
                this.options.desktop.template.column
              ].preferInputWidthMainContent;
            $(".unbxd-as-popular-product-info").addClass(
              "unbxd-1column-popular-product-desktop",
            );
          }
          mwidth = preferInputWidthMainContent
            ? posSelector.outerWidth()
            : (60 * totalWidth) / 100;
        } else {
          mwidth = this.options.mainWidthPercent
            ? (this.options.mainWidthPercent * totalWidth) / 100
            : (30 * totalWidth) / 100;
        }
      }
      var iWidth =
          this.options.mainWidth > 0
            ? this.options.mainWidth
            : totalWidth
              ? mwidth
              : posSelector.innerWidth(),
        bt = parseInt(posSelector.css("border-top-width"), 10),
        bb = parseInt(posSelector.css("border-bottom-width"), 10),
        bl = parseInt(posSelector.css("border-left-width"), 10),
        br = parseInt(posSelector.css("border-right-width"), 10),
        pb = parseInt(posSelector.css("padding-bottom"), 10),
        fwidth = parseInt(iWidth) - 2 + bl + br,
        fpos = {
          top:
            pos.top +
            (isNaN(bt) ? 0 : bt + bb) +
            posSelector.innerHeight() +
            "px",
          left: pos.left + "px",
        };
      var trendingWidth = this.options.trendingSearches.preferInputWidthTrending
        ? posSelector.outerWidth()
        : fwidth;
      this.$results.find("ul.unbxd-as-maincontent").css("width", fwidth + "px");
      this.$results
        .find("ul.unbxd-as-maincontent")
        .css("box-sizing", "border-box");
      this.$results
        .find("ul.unbxd-as-maincontent.unbxd-as-trending")
        .css("width", trendingWidth + "px");
      if (this.scrollbarWidth == null) {
        this.setScrollWidth();
      }
      if (this.options.template == "2column") {
        var swidth =
          this.options.sideWidth !== this.default_options.sideWidth
            ? this.options.sideWidth
            : totalWidth
              ? totalWidth - fwidth
              : this.options.sideWidth;
        this.$results
          .find("ul.unbxd-as-sidecontent")
          .css("width", swidth + "px");
        this.$results
          .find("ul.unbxd-as-sidecontent")
          .css("box-sizing", "border-box");
        this.$results.removeClass("unbxd-as-extra-left unbxd-as-extra-right");
        this.$results.addClass("unbxd-as-extra-" + this.options.sideContentOn);
        if (
          this.$results.find("ul.unbxd-as-sidecontent").length > 0 &&
          this.options.sideContentOn == "left"
        ) {
          var lwidth =
            pos.left + posSelector.outerWidth() > document.body.clientWidth
              ? document.body.clientWidth
              : pos.left + posSelector.outerWidth();
          fpos.left = lwidth - fwidth - swidth;
          if (fpos.left < 0) {
            fpos.left = 0;
          }
          if (this.$results.find("ul.unbxd-as-maincontent").length == 0) {
            fpos.left = fpos.left + fwidth;
          }
          fpos.left = fpos.left + "px";
        }
        if (
          this.options.popularProducts.view === "grid" &&
          this.options.popularProducts.rowCount
        ) {
          this.$results
            .find("ul li.unbxd-as-popular-product-grid")
            .css("width", 100 / this.options.popularProducts.rowCount + "%");
        }
      }
      if (this.options.showCarts)
        this.$results
          .find(".unbxd-as-popular-product-cart-button")
          .css("background-color", this.options.theme);
      if (typeof this.options.processResultsStyles == "function") {
        fpos = this.options.processResultsStyles.call(this, fpos);
      }
      this.$results.css(fpos).show();
      if (this.options.onShowResults) {
        this.options.onShowResults();
      }
    },
    setScrollWidth: function () {
      var scrollDiv = document.createElement("div");
      scrollDiv.setAttribute(
        "style",
        "width: 100px;height: 100px;overflow: scroll;position: absolute;top: -9999px;",
      );
      document.body.appendChild(scrollDiv);
      this.scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
    },
    hideResults: function () {
      if (this.options.onHideResults) {
        this.options.onHideResults();
      }
      if (this.timeout) clearTimeout(this.timeout);
      var self = this;
      this.timeout = setTimeout(function () {
        self.hideResultsNow();
      }, 200);
    },
    hideResultsNow: function () {
      this.log("hideResultsNow");
      if (this.timeout) clearTimeout(this.timeout);
      this.$input.removeClass(this.options.loadingClass);
      if (this.$results.is(":visible")) {
        this.$results.hide();
      }
      if (this.ajaxCall) this.ajaxCall.abort();
    },
    addFilter: function (field, value) {
      if (!(field in this.params.filters)) this.params.filters[field] = {};
      this.params.filters[field][value] = field;
      return this;
    },
    removeFilter: function (field, value) {
      if (value in this.params.filters[field])
        delete this.params.filters[field][value];
      if (Object.keys(this.params.filters[field]).length == 0)
        delete this.params.filters[field];
      return this;
    },
    clearFilters: function () {
      this.params.filters = {};
      return this;
    },
    onChange: function () {
      if (
        this.lastKeyPressCode == 46 ||
        (this.lastKeyPressCode > 8 && this.lastKeyPressCode < 32)
      ) {
        if (
          this.lastKeyPressCode == 27 &&
          typeof this.input.lastSelected == "object"
        ) {
          this.$input.val(this.input.lastSelected.value);
        }
        return this.$results.hide();
      }
      var v = "";
      if (params && params.selfServe) {
        v = "*";
      } else {
        v = this.$input.val();
      }
      if (v == this.previous) return;
      this.params.q = v;
      this.previous = v;
      this.currentResults = {
        KEYWORD_SUGGESTION: [],
        TOP_SEARCH_QUERIES: [],
        POPULAR_PRODUCTS: [],
        IN_FIELD: [],
        SORTED_SUGGESTIONS: [],
        PROMOTED_SUGGESTION: [],
      };
      if (this.inCache(v)) {
        this.log("picked from cache : " + v);
        this.currentResults = this.getFromCache(v);
        this.productInfo.popularProductsCount =
          this.currentResults.POPULAR_PRODUCTS.length;
        if (this.options.filtered) {
          var ppHeader = this.getPopularProductsHeader(this);
          var cmpldHeader = Handlebars.compile(ppHeader);
          this.compiledPopularProductHeader = cmpldHeader({
            hoverSuggestion: v,
          });
        }
        this.$results.html(this.prepareHTML());
        this.showResults();
      } else {
        if (this.ajaxCall) this.ajaxCall.abort();
        if (v.length >= this.options.minChars) {
          this.$input.addClass(this.options.loadingClass);
          this.requestData(v);
        } else {
          this.$input.removeClass(this.options.loadingClass);
          if (
            !(
              this.options.trendingSearches.enabled &&
              this.clickResults &&
              this.clickResults.TRENDING_QUERIES.length > 0 &&
              v === ""
            )
          ) {
            this.$results.hide();
          }
        }
      }
    },
    getClass: function (object) {
      return Object.prototype.toString
        .call(object)
        .match(/^\[object\s(.*)\]$/)[1];
    },
    requestData: function (q) {
      var self = this,
        url = self.autosuggestUrl();
      this.log("requestData", url);
      var params = this.getAjaxParams();
      params.url = url;
      params.cache = true;
      this.ajaxCall = $.ajax(params)
        .done(function (d) {
          self.receiveData(d);
        })
        .fail(function (f) {
          self.$input.removeClass(self.options.loadingClass);
          if (f.statusText !== "abort") {
            self.$results.hide();
          }
        });
    },
    getHostDomainName: function () {
      if (this.options.platform === "com") {
        return "//search.unbxdapi.com/";
      } else {
        return this.options.searchEndPoint + "/";
      }
    },
    getAjaxParams: function () {
      var params = {};
      if (this.options.platform === "io") {
        params = { dataType: "json", method: "get" };
      } else {
        params = { dataType: "jsonp", jsonp: "json.wrf" };
      }
      return params;
    },
    autosuggestUrl: function () {
      var host_path = this.getHostNPath();
      var query = this.params.q;
      if (
        this.options.customQueryParse &&
        typeof this.options.customQueryParse === "function"
      ) {
        query = this.options.customQueryParse(this.params.q);
      }
      var url = "q=" + encodeURIComponent(query);
      if (this.options.maxSuggestions) {
        url +=
          "&inFields.count=" +
          this.options.maxSuggestions +
          "&topQueries.count=" +
          this.options.maxSuggestions +
          "&keywordSuggestions.count=" +
          this.options.maxSuggestions +
          "&popularProducts.count=" +
          this.options.popularProducts.count +
          "&promotedSuggestion.count=" +
          this.options.maxSuggestions +
          "&indent=off";
      } else {
        url +=
          "&inFields.count=" +
          this.options.inFields.count +
          "&topQueries.count=" +
          this.options.topQueries.count +
          "&keywordSuggestions.count=" +
          this.options.keywordSuggestions.count +
          "&popularProducts.count=" +
          this.options.popularProducts.count +
          "&promotedSuggestion.count=" +
          this.options.promotedSuggestions.count +
          "&indent=off";
      }
      if (this.options.popularProducts.fields.length > 0) {
        var popularProductFields =
          this.options.popularProducts.fields.join(",");
        url = url + "&popularProducts.fields=" + popularProductFields;
      }
      if (this.options.popularProducts && this.options.popularProducts.filter) {
        url = url + "&popularProducts.filter=" + this.options.popularProducts.filter;
      }
      if (this.options.removeDuplicates) {
        url = url + "&variants=true";
      }
      if (this.options.topQueries && this.options.topQueries.sort) {
        url += "&topQueries.sort=" + this.options.topQueries.sort;
      }
      if (this.options.keywordSuggestions && this.options.keywordSuggestions.sort) {
        url += "&keywordSuggestions.sort=" + this.options.keywordSuggestions.sort;
      }
      for (var x in this.params.filters) {
        if (this.params.filters.hasOwnProperty(x)) {
          var a = [];
          for (var y in this.params.filters[x]) {
            if (this.params.filters[x].hasOwnProperty(y)) {
              a.push(
                (
                  x +
                  ':"' +
                  encodeURIComponent(y.replace(/(^")|("$)/g, "")) +
                  '"'
                ).replace(/\"{2,}/g, '"'),
              );
            }
          }
          url += "&filter=" + a.join(" OR ");
        }
      }
      var extraParams = this.options.extraParams || {};
      var extraParamsKeys = Object.keys(extraParams);
      if (extraParamsKeys.length) {
        extraParamsKeys.forEach((key) => {
          url = url + "&" + key + "=" + extraParams[key];
        });
      }
      return host_path + "?" + url;
    },
    getHostNPath: function () {
      return (
        this.getHostDomainName() +
        this.options.APIKey +
        "/" +
        this.options.siteName +
        "/autosuggest"
      );
    },
    receiveData: function (data) {
      if (data) {
        this.$input.removeClass(this.options.loadingClass);
        this.$results.html("");
        if (
          (!this.hasFocus && (params ? !params.selfServe : true)) ||
          data.response.numberOfProducts == 0 ||
          "error" in data
        ) {
          if (!this.options.noResultTpl) {
            return this.hideResultsNow(this);
          }
        }
        this.processData(data);
        this.addToCache(this.params.q, this.currentResults);
        this.$results.html(this.prepareHTML());
        this.showResults();
      } else {
        this.hideResultsNow(this);
      }
    },
    max_suggest: function (data) {
      var infield_result = 0,
        topquery_result = 0,
        keyword_result = 0,
        promoted_result = 0;
      var infield_sugg = Math.floor(this.options.maxSuggestions * 0.2);
      var keyword_sugg = Math.floor(this.options.maxSuggestions * 0.3);
      var topquery_sugg = Math.ceil(this.options.maxSuggestions * 0.3);
      var promoted_sugg = Math.floor(this.options.maxSuggestions * 0.2);
      var keyword_rem = 0,
        topquery_rem = 0,
        promoted_rem = 0;
      for (var x = 0; x < data.response.products.length; x++) {
        if (data.response.products[x].doctype == "IN_FIELD") {
          infield_result++;
        } else if (data.response.products[x].doctype == "KEYWORD_SUGGESTION") {
          keyword_result++;
        } else if (data.response.products[x].doctype == "TOP_SEARCH_QUERIES") {
          topquery_result++;
        } else if (data.response.products[x].doctype == "PROMOTED_SUGGESTION") {
          promoted_result++;
        }
      }
      if (infield_result < infield_sugg) {
        var infield_rem = infield_sugg - infield_result;
        while (infield_rem > 0) {
          if (keyword_result > keyword_sugg) {
            if (keyword_result - keyword_sugg >= infield_rem) {
              keyword_sugg = keyword_sugg + infield_rem;
              infield_rem = 0;
            } else {
              infield_rem = infield_rem - keyword_result + keyword_sugg;
              keyword_sugg = keyword_result;
            }
          } else if (topquery_result > topquery_sugg) {
            if (topquery_result - topquery_sugg >= infield_rem) {
              topquery_sugg = topquery_sugg + infield_rem;
              infield_rem = 0;
            } else {
              infield_rem = infield_rem - topquery_result + topquery_sugg;
              topquery_sugg = topquery_result;
            }
          } else if (promoted_result > promoted_sugg) {
            if (promoted_result - promoted_sugg >= infield_rem) {
              promoted_sugg = promoted_sugg + infield_rem;
              infield_rem = 0;
            } else {
              infield_rem = infield_rem - promoted_result + promoted_sugg;
              promoted_sugg = promoted_result;
            }
          } else infield_rem = 0;
        }
        infield_sugg = infield_result;
      }
      if (topquery_result < topquery_sugg) {
        var topquery_rem = topquery_sugg - topquery_result;
        while (topquery_rem > 0 && keyword_result > keyword_sugg) {
          if (keyword_result > keyword_sugg) {
            if (keyword_result - keyword_sugg >= topquery_rem) {
              keyword_sugg = keyword_sugg + topquery_rem;
              topquery_rem = 0;
            } else {
              topquery_rem = topquery_rem - keyword_result + keyword_sugg;
              keyword_sugg = keyword_result;
            }
          } else if (promoted_result > promoted_sugg) {
            if (promoted_result - promoted_sugg >= topquery_rem) {
              promoted_sugg = promoted_sugg + topquery_rem;
              topquery_rem = 0;
            } else {
              topquery_rem = topquery_rem - promoted_result + promoted_sugg;
              promoted_sugg = promoted_result;
            }
          }
        }
        topquery_sugg = topquery_result;
      }
      if (keyword_result < keyword_sugg) {
        keyword_rem = keyword_sugg - keyword_result;
        while (keyword_rem > 0 && topquery_result > topquery_sugg) {
          if (topquery_result > topquery_sugg) {
            if (topquery_result - topquery_sugg >= keyword_rem) {
              topquery_sugg = topquery_sugg + keyword_rem;
              keyword_rem = 0;
            } else {
              keyword_rem = keyword_rem - topquery_result + topquery_sugg;
              topquery_sugg = topquery_result;
            }
          } else if (promoted_result > promoted_sugg) {
            if (promoted_result - promoted_sugg >= keyword_rem) {
              promoted_sugg = promoted_sugg + keyword_rem;
              keyword_rem = 0;
            } else {
              keyword_rem = keyword_rem - promoted_result + promoted_sugg;
              promoted_sugg = promoted_result;
            }
          }
        }
        keyword_sugg = keyword_result;
      }
      if (promoted_result < promoted_sugg) {
        promoted_rem = promoted_sugg - promoted_result;
        while (promoted_rem > 0) {
          if (topquery_result > topquery_sugg) {
            if (topquery_result - topquery_sugg >= promoted_rem) {
              topquery_sugg = topquery_sugg + promoted_rem;
              promoted_rem = 0;
            } else {
              promoted_rem = promoted_rem - topquery_result + topquery_sugg;
              topquery_sugg = topquery_result;
            }
          } else if (keyword_result > keyword_sugg) {
            if (keyword_result - keyword_sugg >= promoted_rem) {
              keyword_sugg = keyword_sugg + promoted_rem;
              promoted_rem = 0;
            } else {
              promoted_rem = promoted_rem - keyword_result + keyword_sugg;
              keyword_sugg = keyword_result;
            }
          } else promoted_rem = 0;
        }
        promoted_sugg = promoted_result;
      }
      var count = {};
      count["infields"] = infield_sugg;
      count["topquery"] = topquery_sugg;
      count["promoted"] = promoted_sugg;
      count["keyword"] = keyword_sugg;
      count["key_rem"] = keyword_rem;
      count["top_rem"] = topquery_rem;
      count["promo_rem"] = promoted_rem;
      return count;
    },
    isUnique: function (autosuggest, arr) {
      try {
        autosuggest = autosuggest.toLowerCase();
        var unique = true;
        for (var k = 0; k < arr.length; k++) {
          var suggestion = arr[k];
          if (
            Math.abs(suggestion.length - autosuggest.length) < 3 &&
            (suggestion.indexOf(autosuggest) != -1 ||
              autosuggest.indexOf(suggestion) != -1)
          ) {
            unique = false;
            break;
          }
        }
        if (unique) arr.push(autosuggest);
        return unique;
      } catch (e) {
        return true;
      }
    },
    isTempUnique: function (autosuggest, arr) {
      autosuggest = autosuggest.toLowerCase();
      return arr.indexOf(autosuggest) === -1 ? arr.push(autosuggest) : false;
    },
    getfilteredPopularProducts: function () {
      var query = this.params.q;
      if (
        this.options.customQueryParse &&
        typeof this.options.customQueryParse === "function"
      ) {
        query = this.options.customQueryParse(this.params.q);
      }
      var self = this,
        urlPath =
          this.getHostDomainName() +
          this.options.APIKey +
          "/" +
          this.options.siteName +
          "/search",
        defaultSearchParams =
          "indent=off&facet=off&analytics=false&redirect=false",
        url =
          urlPath +
          "?q=" +
          encodeURIComponent(query) +
          "&rows=" +
          this.options.popularProducts.count +
          "&" +
          defaultSearchParams;
      if (self.options.popularProducts.fields.length > 0) {
        var popularProductFields =
          "&fields=" + self.options.popularProducts.fields.join(",");
        url = url + popularProductFields;
      }
      if (self.options.removeDuplicates) {
        url = url + "&variants=true";
      }
      var extraParams = self.options.extraParams || {};
      var extraParamsKeys = Object.keys(extraParams);
      if (extraParamsKeys.length) {
        extraParamsKeys.forEach((key) => {
          url = url + "&" + key + "=" + extraParams[key];
        });
      }
      if (self.options.popularProducts && self.options.popularProducts.filter) {
        url = url + "&filter=" + self.options.popularProducts.filter;
      }
      let filteredExtraParamsString = "";
      var filteredExtraParams =
        (self.options.popularProducts &&
          self.options.popularProducts.filteredExtraParams) ||
        {};
      var filteredExtraParamsKeys = Object.keys(filteredExtraParams);
      if (filteredExtraParamsKeys.length) {
        filteredExtraParamsKeys.forEach((key) => {
          filteredExtraParamsString =
            filteredExtraParamsString +
            "&" +
            key +
            "=" +
            filteredExtraParams[key];
        });
      }
      if (self.options.popularProducts && self.options.popularProducts.filter) {
        filteredExtraParamsString =
          filteredExtraParamsString +
          "&filter=" +
          self.options.popularProducts.filter;
      }
      var params = this.getAjaxParams();
      params.url = url;
      params.cache = true;
      $.ajax(params).done(function (d) {
        var query = self.params.q;
        self.processfilteredPopularProducts(query, d);
      });
      for (var i in this.currentResults) {
        if (i != "POPULAR_PRODUCTS" && this.currentResults.hasOwnProperty(i)) {
          for (var j in this.currentResults[i]) {
            if (this.currentResults[i].hasOwnProperty(j)) {
              (function (suggestionValue, filterName, filterValue) {
                var itemUrl;
                if (filterName) {
                  itemUrl =
                    urlPath +
                    "?q=" +
                    encodeURIComponent(suggestionValue) +
                    "&filter=" +
                    filterName +
                    ':"' +
                    encodeURIComponent(filterValue) +
                    '"&rows=' +
                    self.options.popularProducts.count +
                    popularProductFields +
                    "&" +
                    defaultSearchParams +
                    filteredExtraParamsString;
                } else {
                  itemUrl =
                    urlPath +
                    "?q=" +
                    encodeURIComponent(suggestionValue) +
                    "&rows=" +
                    self.options.popularProducts.count +
                    popularProductFields +
                    "&" +
                    defaultSearchParams +
                    filteredExtraParamsString;
                }
                var itemParams = self.getAjaxParams();
                itemParams.url = itemUrl;
                itemParams.cache = true;
                $.ajax(itemParams).done(function (d) {
                  var cacheKey = filterName
                    ? suggestionValue + ":" + filterName + ":" + filterValue
                    : suggestionValue;
                  self.processfilteredPopularProducts(cacheKey, d);
                });
              })(
                self.currentResults[i][j]["autosuggest"],
                self.currentResults[i][j]["filtername"] || "",
                self.currentResults[i][j]["filtervalue"] || ""
              );
            }
          }
        }
      }
    },
    processfilteredPopularProducts: function (query, d) {
      this.currentTopResults[query] = [];
      if (
        d.hasOwnProperty("response") &&
        d.response.hasOwnProperty("products") &&
        d.response.products.length
      ) {
        for (var k = 0; k < d.response.products.length; k++) {
          var doc = d.response.products[k];
          var o = {
            _original: doc,
            type: "POPULAR_PRODUCTS_FILTERED",
            src: query,
            pid: doc.uniqueId || "",
          };
          if (
            this.options.popularProducts.name &&
            this.options.popularProducts.nameFunctionOrKey
          ) {
            o.autosuggest = doc[this.options.popularProducts.nameFunctionOrKey];
          } else if (
            this.options.popularProducts.autosuggestName &&
            doc[this.options.popularProducts.autosuggestName]
          ) {
            o.autosuggest = doc[this.options.popularProducts.autosuggestName];
          } else if (
            this.options.popularProducts.title &&
            doc[this.options.popularProducts.title]
          ) {
            o.autosuggest = doc[this.options.popularProducts.title];
          } else if (doc.title) {
            o.autosuggest = doc.title;
          } else {
            o.autosuggest = "";
          }
          o.highlighted = this.highlightStr(o.autosuggest);
          if (this.options.popularProducts.price) {
            if (
              typeof this.options.popularProducts.priceFunctionOrKey ===
              "function"
            ) {
              o.price = this.options.popularProducts.priceFunctionOrKey(doc);
            } else if (
              typeof this.options.popularProducts.priceFunctionOrKey ===
                "string" &&
              this.options.popularProducts.priceFunctionOrKey
            ) {
              o.price =
                this.options.popularProducts.priceFunctionOrKey in doc
                  ? doc[this.options.popularProducts.priceFunctionOrKey]
                  : null;
            } else {
              o.price = "price" in doc ? doc["price"] : null;
            }
            if (this.options.popularProducts.currency)
              o.currency = this.options.popularProducts.currency;
          }
          if (
            this.options.popularProducts.salePrice &&
            this.options.popularProducts.salePriceKey
          ) {
            o.salePrice =
              this.options.popularProducts.salePriceKey in doc
                ? doc[this.options.popularProducts.salePriceKey]
                : null;
          }
          if (this.options.popularProducts.image) {
            if (
              typeof this.options.popularProducts.imageUrlOrFunction ===
              "function"
            ) {
              o.image = this.options.popularProducts.imageUrlOrFunction(doc);
            } else if (
              typeof this.options.popularProducts.imageUrlOrFunction ===
                "string" &&
              this.options.popularProducts.imageUrlOrFunction
            ) {
              o.image =
                this.options.popularProducts.imageUrlOrFunction in doc
                  ? doc[this.options.popularProducts.imageUrlOrFunction]
                  : null;
            }
          }
          this.currentTopResults[query].push(o);
        }
      }
    },
    processTopSearchQuery: function (doc) {
      var o = {
        autosuggest: doc.autosuggest,
        highlighted: this.highlightStr(doc.autosuggest),
        type: "TOP_SEARCH_QUERIES",
        _original: doc.doctype,
      };
      this.currentResults.TOP_SEARCH_QUERIES.push(o);
    },
    processTrendingQueries: function (doc) {
      var o = {
        autosuggest: doc.autosuggest,
        highlighted: this.highlightStr(doc.autosuggest),
        type: "TRENDING_QUERIES",
        _original: doc,
        source: doc.unbxdAutosuggestSrc || "",
      };
      this.trendingQueries.push(o);
    },
    processKeywordSuggestion: function (doc) {
      var o = {
        autosuggest: doc.autosuggest,
        highlighted: this.highlightStr(doc.autosuggest),
        type: "KEYWORD_SUGGESTION",
        _original: doc,
        source: doc.unbxdAutosuggestSrc || "",
      };
      this.currentResults.KEYWORD_SUGGESTION.push(o);
    },
    processPromotedSuggestion: function (doc) {
      var o = {
        autosuggest: doc.autosuggest,
        highlighted: this.highlightStr(doc.autosuggest),
        type: "PROMOTED_SUGGESTION",
        _original: doc,
        source: doc.unbxdAutosuggestSrc || "",
      };
      this.currentResults.PROMOTED_SUGGESTION.push(o);
    },
    setDefaultPopularProductsOptions: function () {
      if (!this.options.popularProducts.autosuggestName) {
        this.options.popularProducts.autosuggestName = "title";
      }
      if (!this.options.popularProducts.title) {
        this.options.popularProducts.title = "autosuggest";
      }
      if (!this.options.popularProducts.fields) {
        this.options.popularProducts.fields = [];
      }
      if (
        !this.options.popularProducts.rowCount &&
        this.options.platform === "io"
      ) {
        this.options.popularProducts.rowCount =
          this.options.popularProducts.count / 2;
      }
    },
    setDefaultOptions: function () {
      if (!this.options.inFields.type) {
        this.options.inFields.type = "separate";
      }
      if (!this.options.inFields.noOfInfields) {
        this.options.inFields.noOfInfields = 3;
      }
      if (!this.options.inFields.showDefault) {
        this.options.inFields.showDefault = false;
      }
      if (!this.options.desktop) {
        this.options.desktop = {
          template: {
            column: this.options.template,
            "1column": {
              preferInputWidthMainContent:
                this.options.preferOneColumnFullWidth,
            },
            "2column": {
              preferInputWidthMainContent:
                this.options.preferInputWidthMainContent,
            },
          },
          mainTpl: this.options.mainTpl,
          popularProducts: { count: this.options.popularProducts.count },
        };
      }
    },
    getPopularProductFields: function () {
      var popularProductsFields = ["doctype"];
      this.options.popularProducts.fields.push(
        this.options.popularProducts.title,
      );
      if (
        this.options.popularProducts.price &&
        typeof this.options.popularProducts.priceFunctionOrKey == "string" &&
        this.options.popularProducts.priceFunctionOrKey
      ) {
        popularProductsFields.push(
          this.options.popularProducts.priceFunctionOrKey,
        );
      }
      if (this.options.popularProducts.image) {
        if (
          typeof this.options.popularProducts.imageUrlOrFunction == "string" &&
          this.options.popularProducts.imageUrlOrFunction
        ) {
          popularProductsFields.push(
            this.options.popularProducts.imageUrlOrFunction,
          );
        }
      }
      if (this.options.popularProducts.fields.length > 0) {
        this.options.popularProducts.fields = popularProductsFields.concat(
          this.options.popularProducts.fields,
        );
      } else {
        this.options.popularProducts.fields = popularProductsFields;
      }
      var ppHeader = this.getPopularProductsHeader(this);
      this.compiledPopularProductHeader = ppHeader;
    },
    processPopularProducts: function (doc) {
      var o = {
        type: doc.doctype,
        pid: doc.uniqueId.replace("popularProduct_", ""),
        _original: doc,
      };
      if (this.options.popularProducts.name) {
        o.autosuggest = doc[this.options.popularProducts.nameFunctionOrKey]
          ? doc[this.options.popularProducts.nameFunctionOrKey]
          : doc[this.options.popularProducts.title]
            ? doc[this.options.popularProducts.title]
            : "";
      } else {
        o.autosuggest = "";
      }
      o.highlighted = this.highlightStr(o.autosuggest);
      if (this.options.popularProducts.price) {
        if (
          typeof this.options.popularProducts.priceFunctionOrKey == "function"
        ) {
          o.price = this.options.popularProducts.priceFunctionOrKey(doc);
        } else if (
          typeof this.options.popularProducts.priceFunctionOrKey == "string" &&
          this.options.popularProducts.priceFunctionOrKey
        ) {
          o.price =
            this.options.popularProducts.priceFunctionOrKey in doc
              ? doc[this.options.popularProducts.priceFunctionOrKey]
              : null;
        } else {
          o.price = "price" in doc ? doc["price"] : null;
        }
      }
      if (
        this.options.popularProducts.salePrice &&
        this.options.popularProducts.salePriceKey
      ) {
        o.salePrice =
          this.options.popularProducts.salePriceKey in doc
            ? doc[this.options.popularProducts.salePriceKey]
            : null;
      }
      if (this.options.popularProducts.currency) {
        o.currency = this.options.popularProducts.currency;
      }
      if (this.options.popularProducts.image) {
        if (
          typeof this.options.popularProducts.imageUrlOrFunction == "function"
        ) {
          o.image = this.options.popularProducts.imageUrlOrFunction(doc);
        } else if (
          typeof this.options.popularProducts.imageUrlOrFunction == "string" &&
          this.options.popularProducts.imageUrlOrFunction
        ) {
          o.image =
            this.options.popularProducts.imageUrlOrFunction in doc
              ? doc[this.options.popularProducts.imageUrlOrFunction]
              : null;
        }
      }
      this.currentResults.POPULAR_PRODUCTS.push(o);
      this.productInfo.popularProductsCount =
        this.currentResults.POPULAR_PRODUCTS.length;
      if (this.options.filtered) {
        var ppHeader = this.getPopularProductsHeader(this);
        var cmpldHeader = Handlebars.compile(ppHeader);
        this.compiledPopularProductHeader = cmpldHeader({
          hoverSuggestion: this.params.q,
        });
      }
    },
    processInFields: function (doc) {
      var ins = {},
        asrc = " " + doc.unbxdAutosuggestSrc + " ",
        highlightedtext = this.highlightStr(doc.autosuggest);
      if (this.options.inFields.showDefault) {
        var that = this;
        Object.keys(doc).forEach(function (item) {
          if (item.length >= 3 && item.substring(item.length - 3) === "_in") {
            var a = item.split("_in")[0];
            ins[a] = doc[a + "_in"].slice(
              0,
              parseInt(that.options.inFields.noOfInfields),
            );
          }
        });
      } else {
        for (var a in this.options.inFields.fields) {
          if (
            a + "_in" in doc &&
            doc[a + "_in"].length &&
            asrc.indexOf(" " + a + " ") == -1
          ) {
            ins[a] = doc[a + "_in"].slice(
              0,
              parseInt(this.options.inFields.fields[a]),
            );
            if (this.options.inFields.removeDuplicateKeyword) {
              var ind = ins[a].indexOf(doc.autosuggest.trim());
              if (ind >= 0) {
                ins[a].splice(ind, 1);
              }
            }
          }
        }
      }
      var sortedInfields = [];
      if (this.options.sortByLength) {
        var k = 0;
        for (var i in ins) {
          for (var j = 0; j < ins[i].length; j++) {
            sortedInfields[k] = { filterName: i, filterValue: ins[i][j] };
            k++;
          }
        }
        sortedInfields.sort(function (a, b) {
          return customSort(a.filterValue, b.filterValue);
        });
      }
      if (!$.isEmptyObject(ins)) {
        this.currentResults.IN_FIELD.push({
          autosuggest: doc.autosuggest,
          highlighted: highlightedtext,
          type: "keyword",
          source: doc.unbxdAutosuggestSrc,
        });
        var that = this;
        if (this.options.sortByLength) {
          for (var i = 0; i < sortedInfields.length; i++) {
            if (sortedInfields[i].filterValue !== "") {
              this.currentResults.IN_FIELD.push({
                autosuggest: doc.autosuggest,
                highlighted:
                  this.options.inFields.type === "separate"
                    ? that.prepareinFieldsKeyword(sortedInfields[i].filterValue)
                    : that.highlightStr(doc.autosuggest) +
                      " in " +
                      that.prepareinFieldsKeyword(
                        sortedInfields[i].filterValue,
                      ),
                type: doc.doctype,
                filtername: sortedInfields[i].filterName,
                filtervalue: sortedInfields[i].filterValue,
                _original: doc,
                source: doc.unbxdAutosuggestSrc,
              });
            }
          }
        } else {
          for (var a in ins) {
            for (var b = 0; b < ins[a].length; b++) {
              if (ins[a][b] !== "") {
                this.currentResults.IN_FIELD.push({
                  autosuggest: doc.autosuggest,
                  highlighted:
                    this.options.inFields.type === "separate"
                      ? that.prepareinFieldsKeyword(ins[a][b])
                      : that.highlightStr(doc.autosuggest) +
                        " in " +
                        that.prepareinFieldsKeyword(ins[a][b]),
                  type: doc.doctype,
                  filtername: a,
                  filtervalue: ins[a][b],
                  _original: doc,
                  source: doc.unbxdAutosuggestSrc,
                });
              }
            }
          }
        }
      } else {
        this.currentResults.KEYWORD_SUGGESTION.push({
          autosuggest: doc.autosuggest,
          highlighted: highlightedtext,
          type: "KEYWORD_SUGGESTION",
          source: doc.unbxdAutosuggestSrc,
        });
      }
    },
    sortSuggestionsBylength: function () {
      this.currentResults.SORTED_SUGGESTIONS =
        this.currentResults.KEYWORD_SUGGESTION.concat(
          this.currentResults.TOP_SEARCH_QUERIES,
          this.currentResults.PROMOTED_SUGGESTION,
        );
      this.currentResults.SORTED_SUGGESTIONS.sort(function (a, b) {
        return customSort(a.autosuggest, b.autosuggest);
      });
      this.currentResults.IN_FIELD.sort(function (a, b) {
        return customSort(a.autosuggest, b.autosuggest);
      });
    },
    processData: function (data) {
      var count;
      if (this.options.maxSuggestions) {
        count = this.max_suggest(data);
      }
      this.currentResults = {
        KEYWORD_SUGGESTION: [],
        TOP_SEARCH_QUERIES: [],
        POPULAR_PRODUCTS: [],
        IN_FIELD: [],
        SORTED_SUGGESTIONS: [],
        PROMOTED_SUGGESTION: [],
      };
      this.clickResults = { TRENDING_QUERIES: [] };
      var infieldsCount = 0;
      var key_count = 0,
        uniqueInfields = [],
        uniqueSuggestions = [];
      var apiTopQueryCount = 0;
      if (this.options.hardcodedTopQueries && this.options.hardcodedTopQueries.length > 0) {
        for (var hq = 0; hq < this.options.hardcodedTopQueries.length; hq++) {
          var hqText = this.options.hardcodedTopQueries[hq];
          if (this.isUnique(hqText, uniqueSuggestions)) {
            this.currentResults.TOP_SEARCH_QUERIES.push({
              autosuggest: hqText,
              highlighted: hqText,
              type: "TOP_SEARCH_QUERIES",
              _original: "TOP_SEARCH_QUERIES",
            });
          }
        }
      }
      if (
        this.params.q === "" &&
        this.options.hardcodedKeywordSuggestions &&
        this.options.hardcodedKeywordSuggestions.length > 0
      ) {
        var maxKw = (this.options.keywordSuggestions && this.options.keywordSuggestions.count) || 6;
        for (var hk = 0; hk < this.options.hardcodedKeywordSuggestions.length && this.currentResults.KEYWORD_SUGGESTION.length < maxKw; hk++) {
          var hkText = this.options.hardcodedKeywordSuggestions[hk];
          if (this.isUnique(hkText, uniqueSuggestions)) {
            this.currentResults.KEYWORD_SUGGESTION.push({
              autosuggest: hkText,
              highlighted: hkText,
              type: "KEYWORD_SUGGESTION",
              source: "hardcoded",
            });
          }
        }
      }
      if (
        this.params.q === "" &&
        this.options.hardcodedPopularProducts &&
        this.options.hardcodedPopularProducts.length > 0
      ) {
        var maxPP = (this.options.popularProducts && this.options.popularProducts.count) || 4;
        for (var hp = 0; hp < this.options.hardcodedPopularProducts.length && this.currentResults.POPULAR_PRODUCTS.length < maxPP; hp++) {
          var hpDoc = this.options.hardcodedPopularProducts[hp];
          if (!hpDoc.doctype) {
            hpDoc = Object.assign({}, hpDoc, { doctype: "POPULAR_PRODUCTS" });
          }
          this.processPopularProducts(hpDoc);
        }
      }
      for (var x = 0; x < data.response.products.length; x++) {
        var doc = data.response.products[x],
          o = {};
        if (this.options.maxSuggestions) {
          if (
            "TOP_SEARCH_QUERIES" == doc.doctype &&
            count["topquery"] > apiTopQueryCount &&
            this.isUnique(doc.autosuggest, uniqueSuggestions)
          ) {
            this.processTopSearchQuery(doc);
            apiTopQueryCount++;
          } else if (
            "IN_FIELD" == doc.doctype &&
            count["infields"] + count["key_rem"] + count["top_rem"] >
              infieldsCount &&
            this.isUnique(doc.autosuggest, uniqueInfields) &&
            this.isUnique(doc.autosuggest, uniqueSuggestions)
          ) {
            if (count["infields"] > infieldsCount) {
              infieldsCount++;
              this.processInFields(doc);
            } else if (
              count["key_rem"] + count["top_rem"] >
                this.currentResults.KEYWORD_SUGGESTION.length &&
              this.isUnique(doc.autosuggest, uniqueSuggestions)
            ) {
              this.processKeywordSuggestion(doc);
            }
          } else if (
            "KEYWORD_SUGGESTION" == doc.doctype &&
            count["keyword"] > this.currentResults.KEYWORD_SUGGESTION.length &&
            this.isUnique(doc.autosuggest, uniqueInfields)
          ) {
            this.processKeywordSuggestion(doc);
          } else if (
            "POPULAR_PRODUCTS" == doc.doctype &&
            this.options.popularProducts.count >
              this.currentResults.POPULAR_PRODUCTS.length
          ) {
            this.processPopularProducts(doc);
          } else if (
            "PROMOTED_SUGGESTION" == doc.doctype &&
            count["promoted"] >
              this.currentResults.PROMOTED_SUGGESTION.length &&
            this.isUnique(doc.autosuggest, uniqueSuggestions)
          ) {
            this.processPromotedSuggestion(doc);
          }
        } else {
          if (
            "TOP_SEARCH_QUERIES" == doc.doctype &&
            this.options.topQueries.count > apiTopQueryCount &&
            this.isUnique(doc.autosuggest, uniqueSuggestions)
          ) {
            this.processTopSearchQuery(doc);
            apiTopQueryCount++;
          } else if (
            "IN_FIELD" == doc.doctype &&
            this.options.inFields.count > infieldsCount &&
            this.isTempUnique(doc.autosuggest, uniqueInfields) &&
            this.isUnique(doc.autosuggest, uniqueSuggestions)
          ) {
            this.processInFields(doc);
          } else if (
            "KEYWORD_SUGGESTION" == doc.doctype &&
            this.options.keywordSuggestions.count >
              this.currentResults.KEYWORD_SUGGESTION.length &&
            this.isUnique(doc.autosuggest, uniqueSuggestions)
          ) {
            this.processKeywordSuggestion(doc);
          } else if (
            "POPULAR_PRODUCTS" == doc.doctype &&
            this.options.popularProducts.count >
              this.currentResults.POPULAR_PRODUCTS.length
          ) {
            this.processPopularProducts(doc);
          } else if (
            "PROMOTED_SUGGESTION" == doc.doctype &&
            this.options.promotedSuggestions.count >
              this.currentResults.PROMOTED_SUGGESTION.length &&
            this.isUnique(doc.autosuggest, uniqueSuggestions)
          ) {
            this.processPromotedSuggestion(doc);
          }
        }
      }
      if (
        this.options.showOnlyPromotedSuggestionsOnEmptyQuery &&
        ["", "*"].indexOf((this.params.q || "").trim()) !== -1
      ) {
        this.currentResults.KEYWORD_SUGGESTION = [];
        this.currentResults.IN_FIELD = [];
        this.currentResults.SORTED_SUGGESTIONS = [];
      }
      if (this.options.filtered) {
        this.getfilteredPopularProducts();
      }
      if (this.options.sortByLength) {
        this.sortSuggestionsBylength();
      }
      var outLength =
        this.currentResults.POPULAR_PRODUCTS.length +
        this.currentResults.IN_FIELD.length;
      if (this.options.sortSuggestionsOnLength) {
        for (var doc_type in this.currentResults) {
          if (doc_type.toLowerCase() != "in_field") {
            this.currentResults[doc_type].sort(function (x, y) {
              return x.autosuggest.length > y.autosuggest.length ? 1 : -1;
            });
          }
        }
      }
    },
    escapeStr: function (str) {
      return str.replace(/([\\{}()|.?*+\-\^$\[\]])/g, "\\$1");
    },
    highlightStr: function (str) {
      return str;
    },
    prepareinFieldsKeyword: function (str) {
      if (
        this.options.customInfieldsFilter &&
        typeof this.options.customInfieldsFilter === "function"
      ) {
        str = this.options.customInfieldsFilter(str);
      }
      return '<span class="unbxd-as-suggestions-infields">' + str + "</span>";
    },
    prepareinFieldsHTML: function () {
      if (this.options.inFields.type === "inline") {
        return (
          "{{#if data.IN_FIELD}}" +
          (this.options.inFields.header
            ? '<li class="unbxd-as-header">' +
              this.options.inFields.header +
              "</li>"
            : "") +
          "{{#each data.IN_FIELD}}" +
          '{{#unbxdIf type "keyword"}}' +
          "{{else}}" +
          '<li data-index="{{@index}}" data-type="{{type}}" data-value="{{autosuggest}}" data-filtername="{{filtername}}" data-filtervalue="{{filtervalue}}"  data-source="{{source}}">' +
          (this.options.inFields.tpl
            ? this.options.inFields.tpl
            : this.default_options.inFields.tpl) +
          "</li>" +
          "{{/unbxdIf}}" +
          "{{/each}}" +
          "{{/if}}"
        );
      } else {
        return (
          "{{#if data.IN_FIELD}}" +
          (this.options.inFields.header
            ? '<li class="unbxd-as-header">' +
              this.options.inFields.header +
              "</li>"
            : "") +
          "{{#each data.IN_FIELD}}" +
          '{{#unbxdIf type "keyword"}}' +
          '<li class="unbxd-as-keysuggestion" data-index="{{@index}}" data-value="{{autosuggest}}" data-type="IN_FIELD" data-source="{{source}}">' +
          (this.options.inFields.tpl
            ? this.options.inFields.tpl
            : this.default_options.inFields.tpl) +
          "</li>" +
          "{{else}}" +
          '<li class="unbxd-as-insuggestion" style="color:' +
          this.options.theme +
          ';" data-index="{{@index}}" data-type="{{type}}" data-value="{{autosuggest}}" data-filtername="{{filtername}}" data-filtervalue="{{filtervalue}}"  data-source="{{source}}">' +
          "in " +
          (this.options.inFields.tpl
            ? this.options.inFields.tpl
            : this.default_options.inFields.tpl) +
          "</li>" +
          "{{/unbxdIf}}" +
          "{{/each}}" +
          "{{/if}}"
        );
      }
    },
    preparekeywordSuggestionsHTML: function () {
      return (
        "{{#if data.KEYWORD_SUGGESTION}}" +
        (this.options.keywordSuggestions.header
          ? "{{#unless data.PROMOTED_SUGGESTION}}" +
            '<li class="unbxd-as-header">' +
            this.options.keywordSuggestions.header +
            "</li>" +
            "{{/unless}}"
          : "") +
        "{{#each data.KEYWORD_SUGGESTION}}" +
        '<li class="unbxd-as-keysuggestion" data-value="{{autosuggest}}" data-index="{{@index}}" data-type="{{type}}"  data-source="{{source}}">' +
        (this.options.keywordSuggestions.tpl
          ? this.options.keywordSuggestions.tpl
          : this.default_options.keywordSuggestions.tpl) +
        "</li>" +
        "{{/each}}" +
        "{{/if}}"
      );
    },
    prepareTrendingQueriesHTML: function () {
      return (
        '<ul class="unbxd-as-maincontent unbxd-as-suggestions-overall unbxd-as-trending">' +
        (this.options.trendingSearches.header
          ? '<li class="unbxd-as-header">' +
            this.options.trendingSearches.header +
            "</li>"
          : "") +
        "{{#each data1}}" +
        '<li class="unbxd-as-keysuggestion" data-value="{{autosuggest}}" data-index="{{@index}}" data-type="{{type}}"  data-source="{{source}}">' +
        (this.options.trendingSearches.tpl
          ? this.options.trendingSearches.tpl
          : this.default_options.trendingSearches.tpl) +
        "</li>" +
        "{{/each}}" +
        "</ul>"
      );
    },
    preparepromotedSuggestionsHTML: function () {
      return (
        "{{#if data.PROMOTED_SUGGESTION}}" +
        (this.options.promotedSuggestions.header
          ? '<li class="unbxd-as-header">' +
            this.options.promotedSuggestions.header +
            "</li>"
          : "") +
        "{{#each data.PROMOTED_SUGGESTION}}" +
        '<li class="unbxd-as-keysuggestion" data-value="{{autosuggest}}" data-index="{{@index}}" data-type="{{type}}"  data-source="{{source}}">' +
        (this.options.promotedSuggestions.tpl
          ? this.options.promotedSuggestions.tpl
          : this.default_options.promotedSuggestions.tpl) +
        "</li>" +
        "{{/each}}" +
        "{{/if}}"
      );
    },
    preparetopQueriesHTML: function () {
      return (
        "{{#if data.TOP_SEARCH_QUERIES}}" +
        (this.options.topQueries.header
          ? '<li class="unbxd-as-header unbxd-as-top-queries-header">' +
            this.options.topQueries.header +
            "</li>"
          : "") +
        "{{#each data.TOP_SEARCH_QUERIES}}" +
        '<li class="unbxd-as-keysuggestion" data-type="{{type}}" data-index="{{@index}}" data-value="{{autosuggest}}">' +
        (this.options.topQueries.tpl
          ? this.options.topQueries.tpl
          : this.default_options.topQueries.tpl) +
        "</li>" +
        "{{/each}}" +
        "{{/if}}"
      );
    },
    preparefilteredPopularProducts: function () {
      return (
        (this.compiledPopularProductHeader
          ? '<li class="unbxd-as-header unbxd-as-popular-product-header">' +
            this.compiledPopularProductHeader +
            "</li>"
          : "") +
        "{{#data}}" +
        '<li class="unbxd-as-popular-product ' +
        (this.options.popularProducts.view === "grid"
          ? "unbxd-as-popular-product-grid"
          : "") +
        '" data-value="{{autosuggest}}" data-index="{{@index}}" data-type="{{type}}" data-pid="{{pid}}" data-src="{{src}}">' +
        (this.options.popularProducts.tpl
          ? this.options.popularProducts.tpl
          : this.default_options.popularProducts.tpl) +
        "</li>" +
        "{{/data}}"
      );
    },
    preparepopularProductsHTML: function () {
      return (
        "{{#if data.POPULAR_PRODUCTS}}" +
        (this.compiledPopularProductHeader
          ? '<li class="unbxd-as-header unbxd-as-popular-product-header">' +
            this.compiledPopularProductHeader +
            "</li>"
          : "") +
        "{{#data.POPULAR_PRODUCTS}}" +
        '<li class="unbxd-as-popular-product ' +
        (this.options.popularProducts.view === "grid"
          ? "unbxd-as-popular-product-grid"
          : "") +
        '" data-value="{{autosuggest}}" data-index="{{@index}}" data-type="{{type}}" data-pid="{{pid}}" >' +
        (this.options.popularProducts.tpl
          ? this.options.popularProducts.tpl
          : this.default_options.popularProducts.tpl) +
        "</li>" +
        "{{/data.POPULAR_PRODUCTS}}" +
        "{{/if}}"
      );
    },
    standardizeKeys: function (key) {
      if (key === "inFields") {
        key = "IN_FIELD";
      } else if (key === "popularProducts") {
        key = "POPULAR_PRODUCTS";
      } else if (key === "topQueries") {
        key = "TOP_SEARCH_QUERIES";
      } else if (key === "promotedSuggestions") {
        key = "PROMOTED_SUGGESTION";
      } else key = "KEYWORD_SUGGESTION";
      return key;
    },
    prepareSortedSuggestionsHTML: function () {
      return (
        "{{#if data.SORTED_SUGGESTIONS}}" +
        "{{#each data.SORTED_SUGGESTIONS}}" +
        '<li class="unbxd-as-sorted-suggestion" data-type="{{type}}" data-index="{{@index}}" data-value="{{autosuggest}}" data-sorted="true">' +
        (this.options.sortedSuggestions.tpl
          ? this.options.sortedSuggestions.tpl
          : this.default_options.sortedSuggestions.tpl) +
        "</li>" +
        "{{/each}}" +
        "{{/if}}"
      );
    },
    preprocessHTML: function () {
      if (
        (this.options.isMobile && this.options.isMobile()) ||
        isMobile.any()
      ) {
        this.options.template = this.options.mobile.template;
        this.options.mainTpl = this.options.mobile.mainTpl;
        this.options.popularProducts.count =
          this.options.mobile.popularProducts.count;
      }
    },
    prepareHTML: function () {
      this.preprocessHTML();
      var html = "";
      if (
        this.options.template === "1column" &&
        this.options.popularProducts.viewMore &&
        this.options.popularProducts.viewMore.enabled
      ) {
        html +=
          '<ul class="unbxd-as-maincontent unbxd-as-suggestions-overall unbxd-as-view-more">';
      } else {
        html +=
          '<ul class="unbxd-as-maincontent unbxd-as-suggestions-overall">';
      }
      var mobileHtml =
        '<ul class="unbxd-as-maincontent unbxd-as-suggestions-overall unbxd-as-mobile-view">';
      var sideHtml = "";
      var mainHtml = "";
      var noResults = false;
      var self = this,
        mainlen = 0,
        sidelen = 0;
      if (this.options.template === "1column") {
        if (
          this.options.suggestionsHeader &&
          (self.currentResults["IN_FIELD"].length ||
            self.currentResults["KEYWORD_SUGGESTION"].length ||
            self.currentResults["TOP_SEARCH_QUERIES"].length)
        ) {
          mainHtml =
            mainHtml +
            '<li class="unbxd-as-header unbxd-as-suggestions-header">' +
            this.options.suggestionsHeader +
            "</li>";
        }
      }
      if (
        !self.currentResults["IN_FIELD"].length &&
        !self.currentResults["KEYWORD_SUGGESTION"].length &&
        !self.currentResults["POPULAR_PRODUCTS"].length &&
        !self.currentResults["TOP_SEARCH_QUERIES"].length &&
        !self.currentResults["PROMOTED_SUGGESTION"].length &&
        this.options.noResultTpl
      ) {
        noResults = true;
        if (typeof this.options.noResultTpl === "function") {
          html =
            html +
            "<li>" +
            this.options.noResultTpl.call(
              self,
              encodeURIComponent(self.params.q),
            ) +
            "</li></ul>";
        } else if (typeof this.options.noResultTpl == "string") {
          html = html + "<li>" + this.options.noResultTpl + "</li></ul>";
        }
      }
      this.options.mainTpl.forEach(function (key) {
        key = self.standardizeKeys(key);
        mainlen = mainlen + self.currentResults[key].length;
      });
      this.options.sideTpl.forEach(function (key) {
        if (key === "inFields") {
          key = "IN_FIELD";
        } else if (key === "popularProducts") {
          key = "POPULAR_PRODUCTS";
        } else if (key === "topQueries") {
          key = "TOP_SEARCH_QUERIES";
        } else if (key === "promotedSuggestions") {
          key = "PROMOTED_SUGGESTION";
        } else key = "KEYWORD_SUGGESTION";
        sidelen = sidelen + self.currentResults[key].length;
      });
      if (
        this.options.template === "2column" &&
        !this.options.sideTpl.length &&
        !this.options.mainTpl
      ) {
        this.options.sideTpl = ["keywordSuggestions", "topQueries"];
        this.options.mainTpl = ["inFields", "popularProducts"];
      }
      if (this.options.template === "2column") {
        if (mainlen == 0 && sidelen != 0) {
          html = '<ul class="unbxd-as-sidecontent">';
          this.options.sideTpl.forEach(function (key) {
            if (
              self.options.sortByLength &&
              (key == "topQueries" ||
                key == "keywordSuggestions" ||
                key == "promotedSuggestions")
            ) {
              return;
            }
            key = "prepare" + key + "HTML";
            html = html + self[key]();
          });
          if (
            this.options.popularProducts.viewMore &&
            this.options.popularProducts.viewMore.enabled
          ) {
            html = html + this.options.popularProducts.viewMore.tpl;
          }
          html = html + "</ul>";
        } else {
          if (mainlen > 0 && sidelen != 0) {
            if (
              this.options.popularProducts.viewMore &&
              this.options.popularProducts.viewMore.enabled
            ) {
              sideHtml = '<ul class="unbxd-as-sidecontent unbxd-as-view-more">';
            } else {
              sideHtml = '<ul class="unbxd-as-sidecontent">';
            }
            this.options.sideTpl.forEach(function (key) {
              if (
                self.options.sortByLength &&
                (key == "topQueries" ||
                  key == "keywordSuggestions" ||
                  key == "promotedSuggestions")
              ) {
                return;
              }
              key = "prepare" + key + "HTML";
              sideHtml = sideHtml + self[key]();
            });
            if (
              this.options.popularProducts.viewMore &&
              this.options.popularProducts.viewMore.enabled
            ) {
              sideHtml = sideHtml + this.options.popularProducts.viewMore.tpl;
            }
            sideHtml = sideHtml + "</ul>";
            mainHtml =
              mainHtml +
              '<ul class="unbxd-as-maincontent unbxd-as-suggestions-overall">';
            if (this.options.suggestionsHeader) {
              mainHtml =
                mainHtml +
                '<li class="unbxd-as-header unbxd-as-suggestions-header">' +
                this.options.suggestionsHeader +
                "</li>";
            }
          }
        }
      }
      if (!noResults && mainlen > 0) {
        if (this.options.sortByLength) {
          if (sidelen === 0) {
            mainHtml =
              mainHtml +
              '<ul class="unbxd-as-maincontent">' +
              self["prepareSortedSuggestionsHTML"]();
          } else {
            mainHtml = mainHtml + self["prepareSortedSuggestionsHTML"]();
          }
        } else {
          // When sidelen === 0, items go directly into the outer html container
          // (adding an inner <ul> here creates an invalid <ul>-inside-<ul> nesting)
        }
        this.options.mainTpl.forEach(function (key) {
          if (
            self.currentResults[self.standardizeKeys(key)].length &&
            topQuery === ""
          ) {
            topQuery =
              self.currentResults[self.standardizeKeys(key)][0]["autosuggest"];
          }
          if (
            self.options.sortByLength &&
            (key == "topQueries" ||
              key == "keywordSuggestions" ||
              key == "promotedSuggestions")
          ) {
            return;
          }
          key = "prepare" + key + "HTML";
          mainHtml = mainHtml + self[key]();
        });
        if (
          this.options.popularProducts.viewMore &&
          this.options.popularProducts.viewMore.enabled
        ) {
          mainHtml = mainHtml + this.options.popularProducts.viewMore.tpl;
        }
        mainHtml = mainHtml + "</ul>";
        if (this.options.isMobile && this.options.isMobile()) {
          html = mobileHtml + mainHtml;
        } else if (isMobile.any()) {
          html = mobileHtml + mainHtml;
        } else if (this.options.template === "1column") {
          html = html + mainHtml + "</ul>";
        } else if (this.options.sideContentOn === "right") {
          if (mainlen > 0 && sidelen === 0) {
            // mainHtml's trailing </ul> closes the outer html's <ul>; no extra </ul> needed
            html = html + mainHtml;
          } else {
            html = mainHtml + sideHtml;
          }
        } else {
          html = sideHtml + mainHtml;
        }
      }
      var cmpld = Handlebars.compile(html);
      this.log(
        "prepraing html :-> template : " +
          this.options.template +
          " ,carts : " +
          this.options.showCarts +
          " ,cartType : " +
          this.options.cartType,
      );
      this.log("html data : ", this.currentResults);
      return cmpld({
        data: this.currentResults,
        showCarts: this.options.showCarts,
        cartType: this.options.cartType,
      });
    },
    addToCache: function (q, processedData) {
      if (!(q in this.cache)) this.cache[q] = $.extend({}, processedData);
    },
    inCache: function (q) {
      return q in this.cache && this.cache.hasOwnProperty(q);
    },
    getFromCache: function (q) {
      return this.cache[q];
    },
    destroy: function (self) {
      self.$input.unbind(".auto");
      self.input.lastSelected = null;
      self.$input.removeAttr("autocomplete", "off");
      self.$results.remove();
      self.$input.removeData("autocomplete");
    },
    setOption: function (name, value) {
      var a = name.split(".");
      if (a.length > 1) {
        var o = this.options;
        for (var i = 0; i < a.length - 1; i++) {
          if (!(a[i] in o)) o[a[i]] = {};
          o = o[a[i]];
        }
        o[a[a.length - 1]] = value;
      } else this.options[name] = value;
      this.previous = "";
      this.$results.html("");
      this.cache = {};
      this.cache.length = 0;
    },
    log: function () {},
  });
  $.fn.unbxdautocomplete = function (options) {
    return this.each(function () {
      var self = this;
      try {
        this.auto = new autocomplete(this, options);
      } catch (e) {}
    });
  };
};

(function () {
    function initUnbxdQuickView() {
        if (window.__unbxdQuickViewInitialized) return;
        window.__unbxdQuickViewInitialized = true;

    // Modal string config matching the theme's product-modal
    const MODAL_STRINGS = JSON.stringify({
        addToCart: "Add to Bag",
        addToWishlist: "Add to Wishlist",
        addedToWishlist: "Added to Wishlist",
        optionSelector: "Select an option",
        optionSelectPrompt: "Select an option",
        outOfStock: "Out of stock",
        notifyMe: "Notify Me",
        notifyMeButtonLabel: "Notify when available",
        notifyMeButtonPrompt: "Enter details"
    });

    function buildVariantLabel(variant, fallbackProductTitle) {
        if (!variant) return fallbackProductTitle || '';
        let size = variant.v_Size || variant.size || variant.option1 || '';
        let color = variant.v_Color || variant.color || variant.option2 || '';
        if (size && color) return size + ' / ' + color;
        if (size) return size;
        if (color) return color;
        return variant.title || variant.public_title || variant.name || fallbackProductTitle || '';
    }

    function normalizeVariantForQuickView(variant, fallbackProductTitle) {
        let variantId = variant && (variant.id || variant.variantId || variant.v_variantId || variant.uniqueId || '');
        let variantLabel = buildVariantLabel(variant, fallbackProductTitle);
        let variantAvailable = variant ? variant.available : undefined;
        if (typeof variantAvailable !== 'boolean') {
            variantAvailable = !(variant.availability === false || String(variant.availability).toLowerCase() === 'false');
        }
        return {
            id: variantId,
            title: variantLabel,
            name: variantLabel,
            available: variantAvailable,
            v_availableForSale: variant.v_availableForSale,
            featured_image: null,
        };
    }

    function normalizeProductForQuickView(rawProduct, fallbackHandle) {
        if (!rawProduct) return null;
        let imageUrl = rawProduct.imageUrl
            || rawProduct.unxImageUrl
            || (Array.isArray(rawProduct.images) && rawProduct.images.length ? rawProduct.images[0] : '');
        let productTitle = rawProduct.title || rawProduct.unxTitle || '';
        let normalizedVariants = Array.isArray(rawProduct.variants)
            ? rawProduct.variants.map(function (variant) {
                return normalizeVariantForQuickView(variant, productTitle);
            }).filter(function (variant) {
                return !!variant.id;
            })
            : [];
        let available = rawProduct.available;
        if (typeof available !== 'boolean') {
            available = !(rawProduct.availability === false || String(rawProduct.availability).toLowerCase() === 'false');
        }
        if (typeof rawProduct.available !== 'boolean' && normalizedVariants.length) {
            available = normalizedVariants.some(function (variant) { return variant.available; });
        }
        return {
            id: rawProduct.id || rawProduct.uniqueId || '',
            title: productTitle,
            handle: rawProduct.handle || fallbackHandle || rawProduct.uniqueId || '',
            available: available,
            featured_image: imageUrl,
            images: Array.isArray(rawProduct.images) ? rawProduct.images : (imageUrl ? [imageUrl] : []),
            variants: normalizedVariants,
        };
    }

    // Generate responsive srcset for images
    function generateSrcset(url) {
        if (!url) return '';
        const widths = [320, 480, 640, 800, 960];
        return widths.map(function (w) {
            return url + (url.includes('?') ? '&' : '?') + 'width=' + w + ' ' + w + 'w';
        }).join(', ');
    }

    // Chevron down SVG (matches theme)
    let CHEVRON_DOWN_SVG = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon icon--chevron-down" aria-label="Chevron Down Icon"><path d="m18 9-6 6-6-6" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" vector-effect="non-scaling-stroke"></path></svg>';

    // Build variant option selectors HTML — radio button list matching production ui.html
    // Each radio = one full variant (e.g. "XS / BRICK RED"), name="id" so checked radio is the variant ID
    // Color is handled by swatches separately (skip for now)
    function buildVariantSelectors(product, isWishlist, isNotifyMode) {
        if (!product.variants || product.variants.length === 0) return '';
        if (product.variants.length === 1) return '';

        let firstVariant = product.variants[0];
        // All modes: user must pick a size first
        let toggleLabel = 'Select your size';

        let listItems = '';
        product.variants.forEach(function (variant, idx) {
            let variantId = variant.id || variant.variantId || variant.v_variantId || '';
            if (!variantId) return;
            let variantLabel = buildVariantLabel(variant, product.title || '');
            let isAvailable = !(variant.v_availableForSale === false || String(variant.v_availableForSale).toLowerCase() === 'false');
            // No variant pre-checked — user must select
            let checkedAttr = '';
            let isNotifyOption = !isWishlist && !isAvailable;
            let disabledAttr = isNotifyOption ? ' disabled=""' : '';

            // data-product-option: "add" for available (or "wishlist"), "notify" for unavailable
            let optionAction = isWishlist ? 'wishlist' : (isAvailable ? 'add' : 'notify');
            // Helper text: "Add to Bag" / "Add to Wishlist" for available, "Notify Me" for unavailable
            let helperText = isWishlist
                ? 'Add to Wishlist'
                : (isAvailable ? 'Add to Bag' : 'Notify Me');

            listItems += '<li>' +
                '<input type="radio" value="' + variantId + '" name="id" id="option-' + variantId + '" class="visually-hidden"' + checkedAttr + disabledAttr + '>' +
                '<label for="option-' + variantId + '" class="product-modal__option" data-product-option="' + optionAction + '" data-label="' + variantLabel + '">' +
                '<span>' + variantLabel + '</span>' +
                '<span class="helper-text" data-helper-text="">' + helperText + '</span>' +
                '</label>' +
                '</li>';
        });

        return '<div class="product-modal__options-wrapper">' +
            '<div class="product-modal__options" data-product-options-wrapper="" aria-expanded="false">' +
            '<button class="btn-none product-modal__options-toggle" data-options-toggle="">' +
            '<span data-options-toggle-label="">' + toggleLabel + '</span>' + CHEVRON_DOWN_SVG +
            '</button>' +
            '<ul class="list-none product-modal__options-list">' + listItems + '</ul>' +
            '</div>' +
            '</div>';
    }

    // Build the inner modal HTML for a product
    // Matches production ui.html exactly: image + form (variant radios + footer button) + notify form + success message
    // No title or price displayed inside the modal (matches native theme)
    function buildModalHTML(product, modalType) {
        let isWishlist = modalType === 'wishlist';
        let isNotifyMode = modalType === 'notify';
        let featuredImage = product.featured_image || (product.images && product.images[0]) || '';
        let firstVariant = product.variants && product.variants[0];
        let variantId = firstVariant ? firstVariant.id : '';
        let variantLabel = firstVariant ? buildVariantLabel(firstVariant, product.title || '') : '';
        let hasMultipleVariants = product.variants && product.variants.length > 1;
        let isSingleDefault = product.variants && product.variants.length === 1 && product.variants[0].title === 'Default Title';
        let isProductAvailable = product.available !== false;
       

        // Variant selectors (radio buttons) — only for multi-variant or non-default single variant
        let variantSelectorsHTML = buildVariantSelectors(product, isWishlist, isNotifyMode);

        // Hidden variant input only needed when there are NO radio buttons (single default variant)
        let variantInputHTML = (variantSelectorsHTML === '')
            ? '<input type="hidden" value="' + variantId + '" name="id">'
            : '';

        // Image — matches: <div class="product-modal__image" data-product-image="">
        let imageHTML = '<div class="product-modal__image" data-product-image="">' +
            '<div class="component-image__wrapper aspect-ratio aspect-ratio--2-3">' +
            '<img class="component-image__image" ' +
            'srcset="' + generateSrcset(featuredImage) + '" ' +
            'src="' + featuredImage + '" ' +
            'loading="eager" fetchpriority="auto" decoding="async" sizes="" ' +
            'width="1000" height="1500" ' +
            'alt="' + (product.title || '') + '">' +
            '</div></div>';

        // Footer button — matches production ui.html:
        // Single variant: show CTA directly; multiple variants: require size selection first
        let formAction = isWishlist ? '' : '/cart/add';
        let isSingleVariant = product.variants && product.variants.length <= 1;
        let buttonText, buttonClass, submitDisabledAttr;
        if (isSingleVariant) {
            let singleVariantAvailable = firstVariant ? firstVariant.available !== false : isProductAvailable;
            if (isWishlist) {
                buttonText = 'Add to Wishlist';
                buttonClass = 'btn';
                submitDisabledAttr = '';
            } else if (singleVariantAvailable) {
                buttonText = 'Add to Bag';
                buttonClass = 'btn';
                submitDisabledAttr = '';
            } else {
                buttonText = 'Out of stock';
                buttonClass = 'btn btn--tertiary';
                submitDisabledAttr = ' disabled=""';
            }
        } else {
            buttonText = 'Select a size';
            buttonClass = 'btn btn--tertiary';
            submitDisabledAttr = ' disabled=""';
        }

        // Add to Cart / Wishlist form — matches: <form method="post" action="/cart/add" ...>
        let formHTML = '<form method="post" action="' + formAction + '" ' +
            'id="product_form_' + product.id + '" accept-charset="UTF-8" ' +
            'class="shopify-product-form" enctype="multipart/form-data" ' +
            'data-product-form="" data-product-handle="' + (product.handle || '') + '">' +
            '<input type="hidden" name="form_type" value="product">' +
            '<input type="hidden" name="utf8" value="✓">' +
            variantInputHTML +
            variantSelectorsHTML +
            '<div class="product-modal__footer">' +
            '<button class="' + buttonClass + '" type="submit" data-submit-button=""' + submitDisabledAttr + '>' + buttonText + '</button>' +
            '</div>' +
            '<input type="hidden" name="product-id" value="' + product.id + '">' +
            '</form>';

        // Notify when available form — matches: <form ... class="product-modal__bis" data-notify-form="">
        let bisHTML = '<form method="post" action="" class="product-modal__bis" data-notify-form="">' +
            '<h3>Notify when available</h3>' +
            '<p class="body-small bis__text">Enter your details and we\'ll notify you when this item is back in stock.</p>' +
            '<p class="body-small bis__details">' + (product.title || '') + '</p>' +
            '<input type="hidden" name="a" value="RVwmQH">' +
            '<input type="hidden" name="variant" value="' + variantId + '">' +
            '<input type="hidden" name="platform" value="shopify">' +
            '<button class="btn-none product-modal__options-toggle" data-notify-form-toggle="">' +
            '<span data-notify-form-toggle-label="">' + variantLabel + '</span>' + CHEVRON_DOWN_SVG +
            '</button>' +
            '<div class="form__group">' +
            '<input type="email" name="email" id="notify-email-' + product.id + '" placeholder="Email Address" aria-label="Email Address" required="">' +
            '</div>' +
            '<div class="bis__disclaimer"><div class="form__inline-input">' +
            '<label for="bisDisclaimer" class="visually-hidden">Sign up for our newsletter and receive updates about our new arrivals, events and special offers. By clicking submit you agree to our <a href="" target="_blank">privacy policy</a>.</label>' +
            '<input type="checkbox" id="bisDisclaimer" required="" value="accepts_marketing">' +
            '<label aria-hidden="true">Sign up for our newsletter and receive updates about our new arrivals, events and special offers. By clicking submit you agree to our <a href="" target="_blank">privacy policy</a>.</label>' +
            '</div></div>' +
            '<button type="submit" class="btn btn--block btn--tertiary" data-notify-form-submit="">Enter details</button>' +
            '</form>';

        // Success message — matches: <div class="bis__success-message" data-notify-form-success="" aria-hidden="true">
        let bisSuccessHTML = '<div class="bis__success-message" data-notify-form-success="" aria-hidden="true">' +
            '<p class="hero-3">Merci beaucoup!</p>' +
            '<p>Your details have been received.<br> We\'ll notify you once this item is available.</p>' +
            '</div>';

        return imageHTML + formHTML + bisHTML + bisSuccessHTML;
    }

    // Open the Quick View modal with product data
    function openQuickViewModal(product, modalType) {
        let modal = document.getElementById('modal-product');

        // If modal doesn't exist on the page, create one
        if (!modal) {
            modal = document.createElement('div');
            modal.className = 'modal modal--product-modal modal--sm';
            modal.id = 'modal-product';
            modal.setAttribute('data-modal-product', '');
            modal.setAttribute('data-test-quick-view-modal', '');
            modal.setAttribute('role', 'dialog');
            modal.setAttribute('aria-label', 'Product Quick View');
            modal.setAttribute('aria-modal', 'true');
            modal.innerHTML = '<div class="modal__dialog">' +
                '<button type="button" class="btn-none modal__close-button" data-modal-close="modal-product" data-test-modal-close="">' +
                '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon icon--cross" aria-label="Cross Icon">' +
                '<path d="m18 18-6.06-6m0 0L6 6.12M11.94 12 18 6m-6.06 6L6 17.88" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" vector-effect="non-scaling-stroke"></path>' +
                '</svg></button>' +
                '<div class="product-modal" data-product-modal=""></div>' +
                '</div>';
            document.body.appendChild(modal);
        }

        // Find the product-modal container inside the dialog
        let productModalContainer = modal.querySelector('[data-product-modal]');
        if (!productModalContainer) return;

        // Remove placeholder class so theme CSS shows action button / footer
        productModalContainer.classList.remove('product-modal--placeholder');

        // Determine state: "add", "wishlist", "unavailable", or "notify"
        let isWishlist = modalType === 'wishlist';
        let isSingleVariant = product.variants && product.variants.length <= 1;
        let modalState = 'add';
        if (isWishlist) {
            modalState = 'wishlist';
        } else if (modalType === 'notify' || product.available === false) {
            // Single variant OOS: go directly to 'notify' state to show the BIS form
            modalState = isSingleVariant ? 'notify' : 'unavailable';
        }

        // Check if theme's <product-modal> custom element is registered
        let isCustomElementDefined = customElements.get('product-modal');

        if (isCustomElementDefined) {
            // Theme has the <product-modal> web component - use it
            let productModalEl = document.createElement('product-modal');
            productModalEl.setAttribute('strings', MODAL_STRINGS);
            productModalEl.setAttribute('state', modalState);
            productModalEl.setAttribute('product', JSON.stringify(product));
            productModalEl.innerHTML = buildModalHTML(product, modalType);
            productModalContainer.innerHTML = '';
            productModalContainer.appendChild(productModalEl);
        } else {
            // Theme's web component not available - render manually
            productModalContainer.innerHTML = buildModalHTML(product, modalType);
        }

        // Show the modal
        modal.classList.add('modal--visible');
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';

        // Bind variant selection change within the modal
        bindVariantSelectors(modal, product);
    }

    // Bind radio-button variant selectors + options toggle dropdown
    function bindVariantSelectors(modal, product) {
        // --- Options toggle (expand/collapse the dropdown) ---
        let toggleBtn = modal.querySelector('[data-options-toggle]');
        let notifyToggleBtn = modal.querySelector('[data-notify-form-toggle]');
        let optionsWrapper = modal.querySelector('[data-product-options-wrapper]');
        let productModalEl = modal.querySelector('product-modal');
        let isWishlistMode = productModalEl && productModalEl.getAttribute('state') === 'wishlist';
        if (toggleBtn && optionsWrapper) {
            toggleBtn.addEventListener('click', function (e) {
                e.preventDefault();
                let isExpanded = optionsWrapper.getAttribute('aria-expanded') === 'true';
                optionsWrapper.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
            });
        }
        if (notifyToggleBtn && productModalEl) {
            notifyToggleBtn.addEventListener('click', function (e) {
                e.preventDefault();
                productModalEl.setAttribute('state', 'unavailable');
            });
        }

        // --- Radio button change handler ---
        let radios = modal.querySelectorAll('input[type="radio"][name="id"]');
        let optionsList = modal.querySelector('.product-modal__options-list');

        function applyVariantState(variant, forceNotify) {
            if (!variant) return;
            let variantAvailable = variant.available !== false;
            let shouldShowNotify = !isWishlistMode && (forceNotify || !variantAvailable);

            // Update toggle labels to show selected variant title
            let labelText = variant.title || variant.name || '';
            let toggleLabel = modal.querySelector('[data-options-toggle-label]');
            if (toggleLabel) {
                toggleLabel.textContent = labelText;
            }
            let notifyToggleLabel = modal.querySelector('[data-notify-form-toggle-label]');
            if (notifyToggleLabel) {
                notifyToggleLabel.textContent = labelText;
            }

            // Update notify form hidden variant input
            let notifyVariant = modal.querySelector('[data-notify-form] input[name="variant"]');
            if (notifyVariant) notifyVariant.value = variant.id;

            // Update image if variant has a featured image
            if (variant.featured_image) {
                let img = modal.querySelector('.product-modal__image img');
                if (img) {
                    img.src = variant.featured_image.src;
                    img.srcset = generateSrcset(variant.featured_image.src);
                }
            }

            // Update submit button + BIS form visibility based on variant availability
            let submitBtn = modal.querySelector('[data-submit-button]');
            let bisForm = modal.querySelector('[data-notify-form]');
            if (submitBtn) {
                if (isWishlistMode) {
                    submitBtn.disabled = false;
                    submitBtn.textContent = 'Add to Wishlist';
                    submitBtn.className = 'btn';
                    if (productModalEl) {
                        productModalEl.setAttribute('state', 'wishlist');
                    }
                    if (bisForm) {
                        bisForm.style.display = '';
                    }
                } else if (shouldShowNotify) {
                    submitBtn.disabled = true;
                    submitBtn.textContent = 'Out of stock';
                    submitBtn.className = 'btn btn--tertiary';
                    if (productModalEl) {
                        productModalEl.setAttribute('state', 'notify');
                    }
                } else {
                    submitBtn.disabled = false;
                    submitBtn.textContent = 'Add to Bag';
                    submitBtn.className = 'btn';
                    if (productModalEl) {
                        productModalEl.setAttribute('state', 'add');
                    }
                    if (bisForm) {
                        bisForm.style.display = '';
                    }
                }
            }

            // Collapse dropdown after selection
            if (optionsWrapper) {
                optionsWrapper.setAttribute('aria-expanded', 'false');
            }
        }

        // Available variants (radio-enabled)
        radios.forEach(function (radio) {
            radio.addEventListener('change', function () {
                let selectedId = this.value;
                let variant = product.variants.find(function (v) { return String(v.id) === String(selectedId); });
                applyVariantState(variant);
            });
        });

        // Unavailable variants are disabled radios, so we handle label-click explicitly.
        if (optionsList) {
            optionsList.addEventListener('click', function (e) {
                let notifyLabel = e.target.closest('.product-modal__option[data-product-option="notify"]');
                if (!notifyLabel) return;

                e.preventDefault();
                let inputId = notifyLabel.getAttribute('for');
                if (!inputId) return;
                let inputEl = modal.querySelector('#' + inputId);
                if (!inputEl) return;

                let variant = product.variants.find(function (v) { return String(v.id) === String(inputEl.value); });
                applyVariantState(variant, true);
            });
        }

        // No initial variant state applied — user must pick a size for all modes.
    }

    // Close modal
    function closeQuickViewModal() {
        const modal = document.getElementById('modal-product');
        if (modal) {
            modal.classList.remove('modal--visible');
            modal.setAttribute('aria-hidden', 'true');
            document.body.style.overflow = '';
            // Clear recs variant fallback so it doesn't bleed into a later SRP open
            modal.removeAttribute('data-recs-variant-id');
        }
    }

    // Delegated click handler for Quick View triggers in Unbxd search results
    document.addEventListener('click', function (e) {
        const trigger = e.target.closest('[data-product-modal-trigger]');
        if (!trigger) return;

        // Only handle clicks within Unbxd search/browse results container
        const isInUnbxdResults = trigger.closest('.results-grid') || trigger.closest('[data-id]');
        if (!isInUnbxdResults) return;

        e.preventDefault();
        e.stopPropagation();

        const handle = trigger.getAttribute('data-product-modal-trigger');
        if (!handle) return;

        const modalType = trigger.getAttribute('data-product-modal-type') || 'add';

        // Look up product from global store by tile's data-id (uniqueId)
        const productTile = trigger.closest('.results-grid__tile') || trigger.closest('._unbxd_recs-slider__item');
        const uniqueId = productTile ? productTile.getAttribute('data-id') : '';
        const rawProduct = uniqueId ? window._unbxdProductStore[uniqueId] : null;
        const product = normalizeProductForQuickView(rawProduct, handle);
        if (!product) {
            console.error('Quick View: product not found in _unbxdProductStore for id:', uniqueId);
            return;
        }
        openQuickViewModal(product, modalType);

        // For recs products: stash the API-provided variantId on the modal as a fallback so
        // the submit handler can use it when the product has no variants array.
        // This does NOT affect SRP — SRP tiles have no data-variant-id attribute.
        const recsVariantId = trigger.getAttribute('data-variant-id');
        if (recsVariantId) {
            const modal = document.getElementById('modal-product');
            if (modal) modal.setAttribute('data-recs-variant-id', recsVariantId);
        }
    });

    // Close modal handlers
    document.addEventListener('click', function (e) {
        // Close button click
        if (e.target.closest('[data-modal-close="modal-product"]')) {
            e.preventDefault();
            closeQuickViewModal();
            return;
        }
        // Click on backdrop (outside modal dialog).
        // No modal--visible guard here: the theme's own handler may remove that class before
        // this listener fires, leaving overflow:hidden stranded on the body. We always call
        // closeQuickViewModal() when the backdrop itself is the click target so the cleanup
        // (overflow restore, aria-hidden) always runs regardless of handler order.
        const modal = document.getElementById('modal-product');
        if (modal && e.target === modal) {
            closeQuickViewModal();
        }
    });

    // Close on Escape key
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
            closeQuickViewModal();
        }
    });

    // ---- Add to Cart / Wishlist form submission ----
    document.addEventListener('submit', function (e) {
        let form = e.target.closest('#modal-product .shopify-product-form');
        if (!form) return;

        // Only intercept if it's inside our quick view modal
        let modal = document.getElementById('modal-product');
        if (!modal || !modal.contains(form)) return;

        e.preventDefault();

        // Get variant ID from checked radio or hidden input
        let checkedRadio = form.querySelector('input[type="radio"][name="id"]:checked');
        let hiddenInput = form.querySelector('input[type="hidden"][name="id"]');
        let variantId = checkedRadio ? checkedRadio.value : (hiddenInput ? hiddenInput.value : '');

        // Fallback for recs products whose API response had no variants array:
        // the variantId was stashed on the modal when the card button was clicked.
        if (!variantId) {
            variantId = modal.getAttribute('data-recs-variant-id') || '';
        }

        if (!variantId) {
            alert('Please select an option');
            return;
        }

        let submitBtn = form.querySelector('[data-submit-button]');
        let originalText = submitBtn ? submitBtn.textContent : '';
        let isWishlist = form.getAttribute('data-product-handle') && submitBtn && originalText.toLowerCase().indexOf('wishlist') !== -1;

        if (submitBtn) {
            submitBtn.disabled = true;
            submitBtn.textContent = isWishlist ? 'Adding...' : 'Adding...';
        }

        if (isWishlist) {
            // ---- Wishlist: Swym _swat.addToWishList ----
            let productHandle = form.getAttribute('data-product-handle') || '';
            let productIdField = form.querySelector('input[name="product-id"]');
            let productId = productIdField ? productIdField.value : '';

            // Build Swym product object
            let swymProduct = {
                epi: parseInt(variantId),
                empi: parseInt(productId),
                du: window.location.origin + '/products/' + productHandle,
            };

            if (window._swat && typeof window._swat.addToWishList === 'function') {
                window._swat.addToWishList(
                    swymProduct,
                    function onSuccess() {
                        if (submitBtn) {
                            submitBtn.textContent = 'Added to Wishlist';
                        }
                        // Update wishlist icon on the product card if present
                        let wishlistIcon = document.querySelector('[data-wishlist-icon="' + productId + '"]');
                        if (wishlistIcon) {
                            wishlistIcon.classList.add('is-wishlisted');
                        }
                        setTimeout(function () {
                            closeQuickViewModal();
                            if (submitBtn) {
                                submitBtn.disabled = false;
                                submitBtn.textContent = originalText;
                            }
                        }, 1000);
                    },
                    function onError(err) {
                        console.error('Swym wishlist error:', err);
                        if (submitBtn) {
                            submitBtn.textContent = 'Error - try again';
                            setTimeout(function () {
                                submitBtn.disabled = false;
                                submitBtn.textContent = originalText;
                            }, 2000);
                        }
                    }
                );
            } else {
                console.warn('Swym (_swat) not available, falling back to page navigation');
                window.location.href = '/products/' + productHandle;
            }
        } else {
            // ---- Add to Cart: sideCart.handleAddToCartEvent ----
            if (window.sideCart && typeof window.sideCart.handleAddToCartEvent === 'function') {
                try {
                    window.sideCart.handleAddToCartEvent({
                        id: parseInt(variantId),
                        quantity: 1,
                        properties: {}
                    }, true);

                    if (submitBtn) {
                        submitBtn.textContent = 'Added!';
                    }
                    setTimeout(function () {
                        closeQuickViewModal();
                        if (submitBtn) {
                            submitBtn.disabled = false;
                            submitBtn.textContent = originalText;
                        }
                    }, 1000);
                } catch (err) {
                    console.error('sideCart add to cart error:', err);
                    if (submitBtn) {
                        submitBtn.textContent = 'Error - try again';
                        setTimeout(function () {
                            submitBtn.disabled = false;
                            submitBtn.textContent = originalText;
                        }, 2000);
                    }
                }
            } else if (submitBtn) {
                console.error('sideCart not available for add to cart');
                submitBtn.textContent = 'Error - try again';
                setTimeout(function () {
                    submitBtn.disabled = false;
                    submitBtn.textContent = originalText;
                }, 2000);
            }
        }
    });

    // ---- Notify Me (Back in Stock): Klaviyo API ----
    // Klaviyo public key from theme (hidden input name="a" value="RVwmQH")
    let KLAVIYO_COMPANY_ID = 'RVwmQH';

    document.addEventListener('submit', function (e) {
        let bisForm = e.target.closest('#modal-product [data-notify-form]');
        if (!bisForm) return;

        let modal = document.getElementById('modal-product');
        if (!modal || !modal.contains(bisForm)) return;

        e.preventDefault();

        let emailInput = bisForm.querySelector('input[name="email"]');
        let variantInput = bisForm.querySelector('input[name="variant"]');
        let email = emailInput ? emailInput.value.trim() : '';
        let variantId = variantInput ? variantInput.value : '';

        if (!email) {
            alert('Please enter your email address');
            return;
        }

        let submitBtn = bisForm.querySelector('[data-notify-form-submit]');
        let originalText = submitBtn ? submitBtn.textContent : '';
        if (submitBtn) {
            submitBtn.disabled = true;
            submitBtn.textContent = 'Submitting...';
        }

        // Klaviyo Back in Stock Subscriptions API
        fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + KLAVIYO_COMPANY_ID, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'revision': '2024-10-15'
            },
            body: JSON.stringify({
                data: {
                    type: 'back-in-stock-subscription',
                    attributes: {
                        channels: ['EMAIL'],
                        profile: {
                            data: {
                                type: 'profile',
                                attributes: {
                                    email: email
                                }
                            }
                        }
                    },
                    relationships: {
                        variant: {
                            data: {
                                type: 'catalog-variant',
                                id: '$shopify:::$default:::' + variantId
                            }
                        }
                    }
                }
            })
        })
        .then(function (res) {
            if (res.ok || res.status === 202) {
                // Success — show success message
                let successMsg = modal.querySelector('[data-notify-form-success]');
                if (successMsg) {
                    successMsg.setAttribute('aria-hidden', 'false');
                }
                bisForm.style.display = 'none';
            } else {
                return res.json().then(function (data) {
                    throw new Error((data.errors && data.errors[0] && data.errors[0].detail) || 'Subscription failed');
                });
            }
        })
        .catch(function (err) {
            console.error('Klaviyo BIS error:', err);
            if (submitBtn) {
                submitBtn.textContent = 'Error - try again';
                setTimeout(function () {
                    submitBtn.disabled = false;
                    submitBtn.textContent = originalText;
                }, 2000);
            }
        });
    });

    // ============================================================
    // Product Swatch Click — switch product card (search + recs)
    // ============================================================
    const SHOPIFY_PLACEHOLDER_IMAGE_URL = '/assets/placeholder.svg';
    function getActiveCountryCodeQuickView() {
        return (typeof window !== 'undefined' && window.Shopify && window.Shopify.country) ? window.Shopify.country : null;
    }
    function formatPriceForSwatch(price, country) {
        if (price === '' || price == null || isNaN(parseFloat(price))) return '';
        const num = parseFloat(price).toFixed(2);
        switch (country) {
            case 'GB': return '£' + num + ' GBP';
            case 'AU': return '$' + num + ' AUD';
            case 'NZ': return '$' + num + ' NZD';
            case 'SG': return '$' + num + ' SGD';
            case 'US': return '$' + num;
            default: return '$' + num;
        }
    }
     function updateProductCardFromSwatch(tile, product) {
        const activeCountryCode = getActiveCountryCodeQuickView();
        const currencyPriceMap = {
            GB: { price: product.price_GBP, compareAt: product.compareAtPrice_GBP },
            AU: { price: product.price_AUD, compareAt: product.compareAtPrice_AUD },
            NZ: { price: product.price_NZD, compareAt: product.compareAtPrice_NZD },
            SG: { price: product.price_SGD, compareAt: product.compareAtPrice_SGD },
            US: { price: product.price_USD, compareAt: product.compareAtPrice_USD },
        };
        const currencyData = currencyPriceMap[activeCountryCode] || null;
        const displayPrice = (currencyData && currencyData.price) != null ? currencyData.price : product.price;
        const compareAtPrice = (currencyData && currencyData.compareAt) != null ? currencyData.compareAt : null;
        const displayPriceFormatted = formatPriceForSwatch(displayPrice, activeCountryCode);
        const compareAtPriceFormatted = formatPriceForSwatch(compareAtPrice, activeCountryCode);

        const imgUrl = Array.isArray(product.imageUrl) ? product.imageUrl[0] : product.imageUrl;
        const images = product.images || [];
        const imgUrl2 = images.length > 0 ? images[0] : null;
        const productUrl = product.productUrl || ('/products/' + (product.handle || product.uniqueId || product.id));
        const productHandle = product.handle || product.uniqueId || product.id;
        const productTitle = product.title || '';
        const isOutOfStock = product.availability === false
            || String(product.availability).toLowerCase() === 'false'
            || product.available === false;
        const videoUrls = Array.isArray(product.video_urls) ? product.video_urls : [];
        const hoverVideoUrl = videoUrls.find(function(u) { return u.toLowerCase().endsWith('.mp4'); }) || '';
        const defaultImage = SHOPIFY_PLACEHOLDER_IMAGE_URL;

        function generateSrcsetSwatch(url) {
            if (!url) return '';
            const widths = [160, 320, 480, 640, 800, 960];
            return widths.map(function (w) { return (url + (url.indexOf('?') !== -1 ? '&' : '?') + 'width=' + w) + ' ' + w + 'w'; }).join(', ');
        }

        const primaryImg = tile.querySelector('.product-card__image .component-image__image');
        if (primaryImg) {
            primaryImg.src = (imgUrl ? (imgUrl.indexOf('?') !== -1 ? imgUrl + '&width=600' : imgUrl + '?width=600') : defaultImage);
            primaryImg.srcset = generateSrcsetSwatch(imgUrl);
            primaryImg.alt = productTitle;
            primaryImg.onerror = function () { this.src = defaultImage; };
        }

        const secondaryContainer = tile.querySelector('.product-card__image--secondary');
        const imageLink = tile.querySelector('.product-card__image a');
        if (secondaryContainer) {
            const oldVideo = secondaryContainer.querySelector('video');
            if (oldVideo) { try { oldVideo.pause(); oldVideo.src = ''; } catch(e) {} }
            secondaryContainer.remove();
        }
        if (hoverVideoUrl) {
            const posterUrl = imgUrl2 ? (imgUrl2.indexOf('?') !== -1 ? imgUrl2 + '&width=600' : imgUrl2 + '?width=600') : '';
            const videoHTML = '<div class="product-card__image--secondary">' +
                '<div class="component-video__wrapper aspect-ratio aspect-ratio--2-3">' +
                '<video playsinline="playsinline" class="component-video__video" preload="none" autoplay="autoplay" muted="muted" loop="loop" ' +
                'aria-label="' + productTitle + '" width="1080" height="1920" ' +
                (posterUrl ? 'poster="' + posterUrl + '" ' : '') +
                'disablepictureinpicture="true" disableremoteplayback="true" x-webkit-airplay="deny">' +
                '<source src="' + hoverVideoUrl + '" type="video/mp4">' +
                '<img alt="' + productTitle + '" src="' + (posterUrl || '') + '">' +
                '</video>' +
                '</div></div>';
            if (imageLink) {
                imageLink.insertAdjacentHTML('beforeend', videoHTML);
            }
            const freshVideo = tile.querySelector('.product-card__image--secondary video');
            if (freshVideo) { freshVideo.load(); freshVideo.play().catch(function() {}); }
        } else if (imgUrl2 && imgUrl2 !== imgUrl) {
            const imgSecondaryHTML = '<div class="product-card__image--secondary">' +
                '<div class="component-image__wrapper aspect-ratio aspect-ratio--2-3">' +
                '<img srcset="' + generateSrcsetSwatch(imgUrl2) + '" src="' + (imgUrl2.indexOf('?') !== -1 ? imgUrl2 + '&width=600' : imgUrl2 + '?width=600') + '" loading="lazy" ' +
                'sizes="(min-width: 85.5rem) calc(85.5rem / 3), (min-width: 61.875rem) calc(100vw / 3), 100vw" width="1000" height="1500" alt="' + productTitle + '" class="component-image__image">' +
                '</div></div>';
            if (imageLink) {
                imageLink.insertAdjacentHTML('beforeend', imgSecondaryHTML);
            }
        }

        tile.querySelectorAll('.product-card__image > a, .product-card__title a, .product-card__price a').forEach(function (a) {
            a.href = productUrl;
        });

        const titleEl = tile.querySelector('.product-card__title a');
        if (titleEl) titleEl.textContent = productTitle;

        const priceDisplay = compareAtPrice != null && compareAtPrice !== '' && parseFloat(compareAtPrice) > parseFloat(displayPrice)
            ? '<span class="visually-hidden">Sale price</span><span>' + displayPriceFormatted + '</span><span class="visually-hidden">Regular price</span><span class="product-card__compare-price ns-font-4 ns-text-striked ns-ml-2">' + compareAtPriceFormatted + '</span>'
            : '<span>' + displayPriceFormatted + '</span>';
        const priceLink = tile.querySelector('.product-card__price a');
        if (priceLink) priceLink.innerHTML = priceDisplay;

        const existingBadges = tile.querySelector('.product-badges');
        const metaBadges = product.meta_badges || [];
        const badgesArray = Array.isArray(metaBadges) ? metaBadges : (typeof metaBadges === 'string' ? [metaBadges] : []);
        if (badgesArray.length > 0) {
            const badgesHTML = badgesArray.map(function (badge) {
                const badgeSlug = badge.toLowerCase().replace(/&/g, '').replace(/\s+/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '');
                return '<div class="badge badge__' + badgeSlug + '">' + badge + '</div>';
            }).join('');
            if (existingBadges) {
                existingBadges.innerHTML = badgesHTML;
            } else {
                const cardTop = tile.querySelector('.product-card__top');
                if (cardTop) {
                    cardTop.insertAdjacentHTML('afterbegin', '<div class="product-badges product-card__badges" data-product-badges="">' + badgesHTML + '</div>');
                }
            }
        } else if (existingBadges) {
            existingBadges.remove();
        }

        const existingPromotion = tile.querySelector('.product-card__promotion');
        const metaPromotionValues = product.meta_promotion_values || [];
        const promotionArray = Array.isArray(metaPromotionValues) ? metaPromotionValues : (typeof metaPromotionValues === 'string' ? [metaPromotionValues] : []);
        const metaPromotionHandles = product.meta_promotion_handles || [];
        const promotionHandle = Array.isArray(metaPromotionHandles) ? metaPromotionHandles[0] : metaPromotionHandles;
        const promotionModifier = promotionHandle ? ' product-card__promotion--' + promotionHandle : '';
        if (promotionArray.length > 0) {
            const promotionText = promotionArray.join(', ');
            if (existingPromotion) {
                existingPromotion.className = 'product-card__promotion' + promotionModifier + ' caption';
                existingPromotion.textContent = promotionText;
            } else {
                const productCard = tile.querySelector('product-card') || tile;
                productCard.insertAdjacentHTML('beforeend', '<div class="product-card__promotion' + promotionModifier + ' caption">' + promotionText + '</div>');
            }
        } else if (existingPromotion) {
            existingPromotion.remove();
        }

        const addToBagBtn = tile.querySelector('.product-card__add');
        if (addToBagBtn) {
            const addToBagLabel = isOutOfStock ? 'Notify Me' : 'Add to Bag';
            addToBagBtn.setAttribute('data-product-modal-trigger', productHandle);
            addToBagBtn.setAttribute('data-product-modal-type', isOutOfStock ? 'notify' : 'add');
            addToBagBtn.setAttribute('aria-label', isOutOfStock ? (productTitle + ' is Sold Out') : (productTitle + ' - Add to Bag'));
            const spanLabel = addToBagBtn.querySelector('.hide.show--min-lg');
            if (spanLabel) spanLabel.textContent = addToBagLabel;
        }

        const wishlistBtn = tile.querySelector('.product-card__wishlist');
        if (wishlistBtn) {
            wishlistBtn.setAttribute('data-product-modal-trigger', productHandle);
            wishlistBtn.setAttribute('data-wishlist-icon', product.uniqueId || product.id);
        }

        const newId = product.uniqueId || product.id;
        window._unbxdProductStore[newId] = {
            id: product.id || newId,
            uniqueId: newId,
            title: productTitle,
            handle: productHandle,
            imageUrl: imgUrl,
            images: images,
            available: product.available,
            availability: product.availability,
            variants: (product.variants || []).map(function (v) {
                return {
                    id: v.id || v.variantId || v.v_variantId || '',
                    v_Size: v.v_Size || '',
                    v_Color: v.v_Color || '',
                    title: v.title || '',
                    v_availableForSale: v.v_availableForSale,
                    available: v.available,
                    availability: v.availability,
                };
            }),
        };

        tile.setAttribute('data-id', newId);
        const productCardEl = tile.querySelector('product-card');
        if (productCardEl) productCardEl.id = newId;

        const titleH4 = tile.querySelector('.product-card__title');
        if (titleH4) titleH4.id = 'product-title-' + newId + '-unbxd';
        if (priceLink) priceLink.setAttribute('aria-describedby', 'product-title-' + newId + '-unbxd');
    }

    document.addEventListener('click', function (e) {
        const swatchBtn = e.target.closest('[data-swatch-action="switchProduct"]');
        if (!swatchBtn) return;
        e.preventDefault();
        e.stopPropagation();
        if (swatchBtn.classList.contains('swatch--active')) return;
        const productId = swatchBtn.dataset.swatchProductId;
        const tileId = swatchBtn.dataset.swatchTileId;
        const tile = swatchBtn.closest('.results-grid__tile') || swatchBtn.closest('._unbxd_recs-slider__item');
        if (!tile) return;
        const allProducts = window._unbxdSwatchData && window._unbxdSwatchData[tileId];
        if (!allProducts) return;
        const product = allProducts.find(function (p) { return String(p.uniqueId || p.id) === String(productId); });
        if (!product) return;
        tile.querySelectorAll('.UNX-product-swatch').forEach(function (s) { s.classList.remove('swatch--active'); });
        swatchBtn.classList.add('swatch--active');
        updateProductCardFromSwatch(tile, product);
    });
    }

    window.initUnbxdQuickView = initUnbxdQuickView;

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initUnbxdQuickView);
    } else {
        initUnbxdQuickView();
    }
})();

